export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date */
  Date: any;
  /** DateTime */
  DateTime: string;
  /** Must be a valid email address */
  Email: any;
  /** An alpha-numeric string that represents a fee category. */
  FeeCategoryCode: any;
  /** An integer that represents a Group Coordinator's free place ratio for tour products or insurance. */
  FreePlaceRatio: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { [key: string]: any };
  /** Trip component line item code */
  LineItemCode: any;
  /** A date and time without timezone information. Represents a 'wall clock' datetime in local time (e.g., flight times shown in airport local time). Format: ISO 8601 without timezone (e.g., '2024-01-15T14:30:00') */
  LocalDateTime: any;
  /** Mongodb ObjectId */
  ObjectId: string;
  /** Percent value */
  Percentage: any;
  /** Phone number */
  PhoneNumber: any;
  /** A component that differentiates different events happening on the same date. I.E 2 different departures on the same date for the same tour. */
  Series: any;
  /** A time of day without a date */
  Time: any;
  /** An alpha-numeric string that represents a tour cabin. */
  TourCabinCode: any;
};

export type AchPaymentMethod = {
  __typename?: 'ACHPaymentMethod';
  accountNumberMask: Scalars['String'];
  address?: Maybe<Address>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  processorPaymentMethodId?: Maybe<Scalars['Int']>;
  routingNumber: Scalars['String'];
};

export type AcceptFlightShopPriceChangeResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightBookingResult | FlightBookingResultInvalidStateError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AcceptGcDepartureTermsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDeparture | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTermError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AcceptTripTermsResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTermError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddAudienceOfferCodeResult = Audience | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddAudienceOfferCodesResult = Audience | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Add promos to a campaign */
export type AddCampaignPromosInput = {
  appendToExisting?: InputMaybe<Scalars['Boolean']>;
  offerCodes: Array<Scalars['String']>;
};

export type AddCampaignPromosResult = BusinessNotSpecifiedError | Campaign | DuplicateUniqueKeyError | InvalidCampaignError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftBookingPaymentScheduleResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidPaymentError | InvalidPaymentScheduleError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderAdjustmentInput = {
  /** The dollar amount to adjust the trip by. */
  amount: Scalars['Float'];
  /** Specific line item the adjustment targets. If not provided, the adjustment will target the trip in total. */
  targetLineItem?: InputMaybe<Scalars['ObjectId']>;
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId'];
};

export type AddDraftOrderAdjustmentResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidAdjustmentError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderCampaignResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidCampaignError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidPromoError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderExcursionInput = {
  /** Excursion lineItemCode to add. */
  extensionExcursionLineItemCodes: Array<Scalars['LineItemCode']>;
  /** Excursion lineItemCode to add. */
  mainTourExcursionLineItemCodes: Array<Scalars['LineItemCode']>;
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId'];
};

export type AddDraftOrderExcursionsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderExtendedStayInput = {
  /** Extended stay end date */
  endDate: Scalars['Date'];
  /** Extended stay start date */
  startDate: Scalars['Date'];
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId'];
};

export type AddDraftOrderExtensionResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderFeeInput = {
  /** The fee amount. Will override the results of buildPrice(). */
  overrideAmount?: InputMaybe<Scalars['Float']>;
  /** The line item the fee should target. */
  targetLineItemId?: InputMaybe<Scalars['ObjectId']>;
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId'];
};

export type AddDraftOrderFeeResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderInboundAirportTransferResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderInsuranceAddonInput = {
  /** lineItemCode for the insurance plan addon. */
  insuranceAddonLineItemCode: Scalars['LineItemCode'];
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId'];
};

export type AddDraftOrderInsuranceAddonResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderInsuranceExtensionInput = {
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId'];
};

export type AddDraftOrderInsuranceExtensionResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderInsuranceResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidInsurancePlanError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderOutboundAirportTransferResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderPostStayResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderPreStayResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderPrivateGroupResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderPromoResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidPromoError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftOrderTravelCompanionRequestsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | InvalidTravelCompanionRequestError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddDraftQuoteTripInput = {
  /** The DraftOrder _id */
  _id: Scalars['ObjectId'];
  /** The Customer ID for the Trip being added to the Draft Quote, if one exists */
  customerId?: InputMaybe<Scalars['ObjectId']>;
  /** The customer's home gateway code */
  gatewayCode?: InputMaybe<Scalars['String']>;
};

export type AddDraftQuoteTripResult = BusinessNotSpecifiedError | CustomerUnavailableError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidFlightPackageError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddEmployeesToRoleInput = {
  employeeIds: Array<Scalars['ObjectId']>;
};

export type AddEmployeesToRoleResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Role | ValidationError;

export type AddFlightShopInput = {
  addCollectCommissionPercentage: Scalars['Float'];
  businessCode: BusinessCode;
  includedPercentage: Scalars['Float'];
  maxIncludedAmount?: InputMaybe<Array<MoneyInput>>;
  packageCeilingPercentage: Scalars['Float'];
  roundingAmount: Array<MoneyInput>;
  serviceLevel: ServiceLevel;
};

export type AddFlightShopResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightShop | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AddInboundAirportTransferInput = {
  /** The airline code for the traveler's flight. */
  airlineCode?: InputMaybe<Scalars['String']>;
  /** The type of inbound airport transfer (MAIN_TOUR or EXTENSION). */
  airportTransferTourType: AirportTransferTourType;
  /** The arrival time (at the arrival airport) of the traveler's flight. */
  arrivalTime: Scalars['Time'];
  /** The traveler's departure airport code. */
  departureGatewayCode: Scalars['String'];
  /** The flight number of the traveler's flight. */
  flightNumber: Scalars['String'];
  /** The line item code of the inbound airport transfer. */
  lineItemCode: Scalars['LineItemCode'];
  /** The local departure date and time (at the departure airport) of the traveler's flight. */
  localDepartureDate: Scalars['LocalDateTime'];
  /** The alphanumeric code identifying the flight booking. */
  pnrLocator?: InputMaybe<Scalars['String']>;
};

export type AddOutboundAirportTransferInput = {
  /** The airline code for the traveler's flight. */
  airlineCode?: InputMaybe<Scalars['String']>;
  /** The type of outbound airport transfer (MAIN_TOUR or EXTENSION). */
  airportTransferTourType: AirportTransferTourType;
  /** The traveler's arrival airport code. */
  arrivalGatewayCode: Scalars['String'];
  /** The departure time (at the departure airport) of the traveler's flight. */
  departureTime: Scalars['Time'];
  /** The flight number of the traveler's flight. */
  flightNumber: Scalars['String'];
  /** The line item code of the outbound airport transfer. */
  lineItemCode: Scalars['LineItemCode'];
  /** The local arrival date and time (at the arrival airport) of the traveler's flight. */
  localArrivalDate: Scalars['LocalDateTime'];
  /** The alphanumeric code identifying the flight booking. */
  pnrLocator?: InputMaybe<Scalars['String']>;
};

/** The input for adding a payment method to a customer */
export type AddPaymentMethodToCustomerInput = {
  businessCode: BusinessCode;
  customerId: Scalars['ObjectId'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
};

export type AddPaymentMethodToCustomerResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPaymentError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | SavedPaymentMethod | ValidationError;

/** Add additional targets to a promo */
export type AddPrivateGroupInput = {
  basePrice: Array<MoneyInput>;
  rollsUpToTarget?: InputMaybe<Scalars['Boolean']>;
};

export type AddPrivateGroupResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPrivateGroupError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

/** Add promo codes to a promo */
export type AddPromoCodesInput = {
  promoCodes: Array<Scalars['String']>;
};

export type AddPromoCodesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type AddPromoCustomersInput = {
  customerIds: Array<Scalars['ObjectId']>;
};

export type AddPromoCustomersResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

/** Add gc departure to a promo */
export type AddPromoGcDepartureInput = {
  gcDepartureIds: Array<Scalars['ObjectId']>;
};

export type AddPromoGcDeparturesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

/** Add additional targets to a promo */
export type AddPromoTargetsInput = {
  targets: Array<CreatePromoTargetInput>;
};

export type AddPromoTargetsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

/** Add an airport transfer to a tour */
export type AddTourAirportTransferInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice: Array<MoneyInput>;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  internalName: Scalars['String'];
  timeRange: TimeRangeInput;
  windowType: AirportTransferWindowType;
};

export type AddTourAirportTransferResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type AddTourExcursionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

/** Add an airport transfer to a tour extension */
export type AddTourExtensionAirportTransferInput = {
  /** Days before departure when transfers will still be auto-confirmed. Only valid for STANDARD window types. */
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  /** Base price for the airport transfer in multiple currencies. */
  basePrice: Array<MoneyInput>;
  /** Transfer direction (INBOUND for arrival, OUTBOUND for departure). */
  direction: AirportTransferDirection;
  /** The IATA airport code for the transfer gateway. */
  gatewayCode: Scalars['String'];
  /** Internal display name for the airport transfer. */
  internalName: Scalars['String'];
  /** Time window during which the transfer is available. */
  timeRange: TimeRangeInput;
  /** Type of transfer window (standard or non-standard). */
  windowType: AirportTransferWindowType;
};

export type AddTourExtensionAirportTransferResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | TourExtension | ValidationError;

export type AddTourExtensionExcursionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | TourExtension | ValidationError;

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
};

/** Non standard increases or reductions to a trip balance */
export type Adjustment = TripComponent & {
  __typename?: 'Adjustment';
  _id: Scalars['ObjectId'];
  adjustmentCode: Scalars['String'];
  businessCode?: Maybe<BusinessCode>;
  displayName: Scalars['String'];
  isEligibleForRolloverOnRebooking: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  isRefundable: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  meta?: Maybe<AdjustmentMetadata>;
  persistsOnCancelAndRebook: Scalars['Boolean'];
  rollsUpToTarget: Scalars['Boolean'];
  status: TripComponentStatus;
  type: TripComponentType;
};

/** An adjustment to apply to a trip when cancelling a booking */
export type AdjustmentInput = {
  /** The adjustment line item code */
  lineItemCode: Scalars['LineItemCode'];
  /** The dollar price to adjust the trip by. */
  price: Scalars['Float'];
};

export type AdjustmentLineItem = LineItem & {
  __typename?: 'AdjustmentLineItem';
  _id: Scalars['ObjectId'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  displayName?: Maybe<Scalars['String']>;
  isEligibleForRolloverOnRebooking: Scalars['Boolean'];
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  meta?: Maybe<AdjustmentLineItemMetadata>;
  persistsOnCancelAndRebook: Scalars['Boolean'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

/** Additional settings for this adjustment line item */
export type AdjustmentLineItemMetadata = {
  __typename?: 'AdjustmentLineItemMetadata';
  /** Incentives metadata from Talon One associated with this adjustment line item */
  incentives?: Maybe<IncentivesAdjustmentMetadata>;
  isCompanionDiscount: Scalars['Boolean'];
  isFreePlace: Scalars['Boolean'];
  isStaffOnTour: Scalars['Boolean'];
};

/** Additional settings for this adjustment */
export type AdjustmentMetadata = {
  __typename?: 'AdjustmentMetadata';
  isCompanionDiscount: Scalars['Boolean'];
  isFreePlace: Scalars['Boolean'];
  isStaffOnTour: Scalars['Boolean'];
};

/** A paginated result of Discounts */
export type AdjustmentPaginatedResult = {
  __typename?: 'AdjustmentPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Adjustment>;
};

export enum AdjustmentSortField {
  AdjustmentCode = 'adjustmentCode',
  DisplayName = 'displayName',
  LineItemCode = 'lineItemCode'
}

/** Generate a magic link, and send to a customer or tour director */
export type AdminCreateMagicLinkInput = {
  email: Scalars['String'];
  isTourDirector?: InputMaybe<Scalars['Boolean']>;
  returnURL: Scalars['String'];
};

export type AdminCreateMagicLinkResult = AdminMagicLinkResult | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidMagicLinkError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type AdminMagicLinkResult = {
  __typename?: 'AdminMagicLinkResult';
  returnLink: Scalars['String'];
};

export type AffirmPaymentMethod = {
  __typename?: 'AffirmPaymentMethod';
  /** The CHECKOUT_TOKEN from affirm for this loan */
  checkoutToken: Scalars['String'];
  /** The loan id from affirm */
  transactionId: Scalars['String'];
};

export type AffirmPaymentMethodInput = {
  /** The CHECKOUT_TOKEN from affirm for this loan */
  affirmCheckoutToken: Scalars['String'];
};

/** Aircraft equipment type with human-readable name and specifications */
export type AircraftEquipmentType = {
  __typename?: 'AircraftEquipmentType';
  _id: Scalars['ObjectId'];
  /** Aircraft body type: 'N' (narrow-body) or 'W' (wide-body) */
  bodyType: Scalars['String'];
  /** GDS equipment type code (e.g., '738', '320', '789') */
  code: Scalars['String'];
  /** Human-readable aircraft name (e.g., 'Boeing 737-800', 'Airbus A320') */
  name: Scalars['String'];
  /** Maximum passenger capacity */
  passengerCapacityMax: Scalars['Int'];
  /** Minimum passenger capacity */
  passengerCapacityMin: Scalars['Int'];
  /** Propulsion type (e.g., 'JET', 'TURB', 'PIST', 'HELI') */
  propulsionType: Scalars['String'];
};

/** Airline company that provides air transportation services for passengers */
export type Airline = {
  __typename?: 'Airline';
  _id: Scalars['ObjectId'];
  code: Scalars['String'];
  iataCode?: Maybe<Scalars['String']>;
  icaoCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

/** Airport transfers are for LO1 flights where the customer has purchased a transfer to/from the airport */
export type AirportTransfer = {
  __typename?: 'AirportTransfer';
  airline: Scalars['String'];
  arrivalDate: Scalars['Date'];
  arrivalTime: Scalars['Time'];
  departureDate: Scalars['Date'];
  departureTime: Scalars['Time'];
  flightNumber: Scalars['String'];
  gatewayCodeFrom: Scalars['String'];
  gatewayCodeTo: Scalars['String'];
  gatewayFrom?: Maybe<Gateway>;
  gatewayTo?: Maybe<Gateway>;
  pnrLocator?: Maybe<Scalars['String']>;
};

/** Direction of airport transfer service */
export enum AirportTransferDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type AirportTransferInput = {
  airline: Scalars['String'];
  arrivalDate: Scalars['Date'];
  arrivalTime: Scalars['Time'];
  departureDate: Scalars['Date'];
  departureTime: Scalars['Time'];
  flightNumber: Scalars['String'];
  gatewayCodeFrom: Scalars['String'];
  gatewayCodeTo: Scalars['String'];
  pnrLocator?: InputMaybe<Scalars['String']>;
};

/** Indicates whether the airport transfer is for the main tour or an extension */
export enum AirportTransferTourType {
  Extension = 'EXTENSION',
  MainTour = 'MAIN_TOUR'
}

/** Type of time window for the airport transfer */
export enum AirportTransferWindowType {
  NonStandard = 'NON_STANDARD',
  Standard = 'STANDARD'
}

/** Represents a grouping of money unique by currency code */
export type Amount = {
  __typename?: 'Amount';
  cad?: Maybe<Money>;
  currencies: Array<CurrencyCode>;
  usd?: Maybe<Money>;
  value: Array<Money>;
};

export type AnonymizeCustomerResult = BusinessNotSpecifiedError | Customer | CustomerHasFutureBookingsError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Input for answering a free text question */
export type AnswerFreeTextQuestionInput = {
  additionalComments?: InputMaybe<Scalars['String']>;
  questionId: Scalars['ObjectId'];
  value?: InputMaybe<Scalars['String']>;
};

/** Input for answering a matrix question */
export type AnswerMatrixQuestionInput = {
  questionId: Scalars['ObjectId'];
  rows: Array<AnswerMatrixRowInput>;
};

/** Input for answering a matrix row */
export type AnswerMatrixRowInput = {
  additionalComments?: InputMaybe<Scalars['String']>;
  choiceId: Scalars['ObjectId'];
  rowId: Scalars['ObjectId'];
};

/** Input for answering a multiple choice question */
export type AnswerMultipleChoiceQuestionInput = {
  additionalComments?: InputMaybe<Scalars['String']>;
  choiceId: Scalars['ObjectId'];
  questionId: Scalars['ObjectId'];
};

/** API Key used for auth with x-api-key header */
export type ApiKey = {
  __typename?: 'ApiKey';
  _id: Scalars['ObjectId'];
  description: Scalars['String'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  isEnabled: Scalars['Boolean'];
  isExpired: Scalars['Boolean'];
  name: Scalars['String'];
  roleIds: Array<Scalars['ObjectId']>;
};

/** API Keys only return the generated key at creation. It will never be available again after */
export type ApiKeyResult = {
  __typename?: 'ApiKeyResult';
  /** The created API key */
  apiKey: ApiKey;
  /** The generated token to use with a basic auth header */
  token: Scalars['String'];
};

/** The promotions that have been applied to a trip. */
export type AppliedPromo = {
  __typename?: 'AppliedPromo';
  autoApplied: Scalars['Boolean'];
  campaignCode?: Maybe<Scalars['String']>;
  lineItemCode: Scalars['LineItemCode'];
  offerCode: Scalars['String'];
  promoCode: Scalars['String'];
};

/** An applied promo with the number of times it has been applied to the trip. */
export type AppliedPromoWithCount = {
  __typename?: 'AppliedPromoWithCount';
  appliedPromo: AppliedPromo;
  /** The number of times the promo has been applied to the trip */
  count: Scalars['Int'];
};

export type ApplyGcDeparturePrivateGroupFeeResult = ApplyGcDeparturePrivateGroupFeeSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidFeeError | InvalidGcDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type ApplyGcDeparturePrivateGroupFeeSuccess = {
  __typename?: 'ApplyGCDeparturePrivateGroupFeeSuccess';
  data: Array<Booking>;
};

export type ApplyTravelBankRewardsToBookingTripInput = {
  amountToRedeem: MoneyInput;
  bookingId: Scalars['ObjectId'];
  customerId: Scalars['ObjectId'];
};

export type ApplyTravelBankRewardsToBookingTripResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | IncentivesError | IncentivesIntegrationDisabledError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Represents an asset, most commonly images */
export type Asset = {
  __typename?: 'Asset';
  _id: Scalars['ObjectId'];
  filename: Scalars['String'];
  folderId?: Maybe<Scalars['ObjectId']>;
  key: Scalars['String'];
  location: Scalars['String'];
  mimetype: Scalars['String'];
  size: Scalars['Int'];
  tags: Array<Scalars['String']>;
};

/** Filters for asset query */
export type AssetFilterInput = {
  businessCode?: InputMaybe<BusinessCode>;
  folderId?: InputMaybe<Scalars['ObjectId']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** A paginated set of Assets */
export type AssetPaginatedResult = {
  __typename?: 'AssetPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Asset>;
};

/** A room with assigned roommates (or a single) */
export type AssignedRoom = {
  __typename?: 'AssignedRoom';
  bedCode: Scalars['String'];
  trips: Array<BookingTrip>;
};

/** An audience for marketing and promotional campaigns */
export type Audience = {
  __typename?: 'Audience';
  _id: Scalars['ObjectId'];
  businessCode: BusinessCode;
  name: Scalars['String'];
  nbMembers: Scalars['Int'];
  offerCodes: Array<Scalars['String']>;
  promos: Array<Promo>;
};

export type AudienceMember = {
  _id: Scalars['ObjectId'];
  audienceId: Scalars['ObjectId'];
};

/** A paginated result of audience members. */
export type AudienceMemberPaginatedResult = {
  __typename?: 'AudienceMemberPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<AudienceMember>;
  totalCount: Scalars['Int'];
};

export type AudiencePaginatedResult = {
  __typename?: 'AudiencePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Audience>;
};

/** The user that made the change. */
export type AuditIdentity = {
  __typename?: 'AuditIdentity';
  _id: Scalars['String'];
  type: Scalars['String'];
  /** The user that made the change. Returns null if the user is not found or the type is not a system user. */
  user?: Maybe<User>;
};

/** A booked order */
export type Booking = Order & {
  __typename?: 'Booking';
  _id: Scalars['ObjectId'];
  /** The active payment plan attached to the order. */
  activePaymentSchedule?: Maybe<PaymentSchedule>;
  /** The authorized saved payment methods for all travelers regardless of trip status that can be used to pay for this order. Staff-only. */
  allTravelersSavedPaymentMethods: Array<SavedPaymentMethod>;
  /** The amount paid on the booking. */
  amountPaid: Money;
  /** The payment methods available when enrolling the booking on autopay. */
  autopayPaymentMethods: Array<BookingAllowedPaymentMethodType>;
  /** The available balance for each payment method. */
  availablePaymentBalanceByPaymentMethod?: Maybe<Array<PaymentBalanceByPaymentMethod>>;
  /** The remaining balance of the booking. */
  balance: Money;
  /** Where the order was booked. */
  bookingMethod: BookingMethod;
  businessCode: BusinessCode;
  /** Maximum age travelers can be to travel with this business */
  businessMaximumAgeForTraveler?: Maybe<Scalars['Int']>;
  /** Minimum age travelers must be to travel with this business */
  businessMinimumAgeForTraveler?: Maybe<Scalars['Int']>;
  /** Whether the order allows room combinations where there are fewer sellable spots than bed capacity. */
  canBookPartialRooms: Scalars['Boolean'];
  canEnrollInAutopay: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The currency code of the order. */
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  /** The customer who initiated the booking. */
  customerId?: Maybe<Scalars['ObjectId']>;
  /** The date the booking was made. */
  dateBooked: Scalars['DateTime'];
  departure?: Maybe<Departure>;
  /** The departure id of the order. */
  departureId: Scalars['ObjectId'];
  /** The extended date the final payment is due for the order. */
  extendedFinalPaymentDate?: Maybe<Scalars['Date']>;
  /** The possible room combinations for the order given the number of trips opted in, the extension's rooms, and the primary trip's room offers. */
  extensionRoomingCombinations: RoomingCombinations;
  /** The date the final installment for app is due for the order. */
  finalInstallmentDate: Scalars['Date'];
  /** The date the final payment is due for the order. */
  finalPaymentDate: Scalars['Date'];
  /** Travelers grouped by shared flight routing and dates (one-way, roundtrip, or open-jaw) from open flight line items. */
  flightRoutingGroups: Array<FlightRoutingGroup>;
  /** Flight shopping availability and window information. Provides status, start date, and deadline date even when flight shopping is not currently allowed, as long as the booking is structurally eligible. */
  flightShoppingStatus: FlightShoppingStatus;
  gcDeparture?: Maybe<GcDeparture>;
  /** The id of the gc departure associated with the order. */
  gcDepartureId?: Maybe<Scalars['ObjectId']>;
  /** The total amount of the booking. This includes all line items and fees. */
  grandTotal: Money;
  /** Sum of all line item prices without discounts applied */
  grandTotalBeforeDiscount: Money;
  /** Sum of all line items excluding flights */
  grandTotalWithoutFlights: Money;
  /** Whether or not the booking has a positive balance. */
  hasBalanceRemaining: Scalars['Boolean'];
  /** Whether or not the order has an automatic payment plan that has been COMPLETED. */
  hasCompletePaymentPlan: Scalars['Boolean'];
  /** Whether a payment is required to meet the booking's minimum balance. */
  hasNotPaidMinimumAmountDue: Scalars['Boolean'];
  /** Whether or not the order has an automatic payment plan that is ACTIVE or PENDING. */
  hasOpenPaymentPlan: Scalars['Boolean'];
  /** Available offers for inbound airport transfers for the order. */
  inboundAirportTransferOffers: Array<TourAirportTransferOffer>;
  /** Sum of all insuranceTotal on open trips */
  insuranceTotal: Money;
  /** Whether or not the order has automatic payment plan that is ACTIVE, PENDING, or COMPLETED. */
  isEnrolledInAutopay: Scalars['Boolean'];
  /** Indicates if the final payment date has been extended. */
  isFinalPaymentDateExtended: Scalars['Boolean'];
  /**
   * Whether flight shopping is allowed for this booking.
   * @deprecated Use flightShoppingStatus.isAllowed instead.
   */
  isFlightShoppingAllowed: Scalars['Boolean'];
  /** Whether or not the booking is within the risk free period window. */
  isWithinRiskFreePeriodWindow: Scalars['Boolean'];
  lastSuccsessfulAutopayTransactionDate?: Maybe<Scalars['DateTime']>;
  /** The latest date the final installment for app is due for the order. */
  latestFinalInstallmentDate: Scalars['Date'];
  /** The latest date the final payment is due for the order. */
  latestFinalPaymentDate: Scalars['Date'];
  /** The maximum points the current customer can redeem. */
  maxRedeemableReferralTravelBankPoints?: Maybe<Scalars['Float']>;
  /** The minimum amount owed today on the booking. */
  minimumAmountDue: Money;
  /** The minimum amount due today to enroll in an automatic payment plan. */
  minimumAmountDueToEnrollInPaymentPlan: Money;
  opportunityId?: Maybe<Scalars['String']>;
  /** Available offers for outbound airport transfers for the order. */
  outboundAirportTransferOffers: Array<TourAirportTransferOffer>;
  /** Effective final payment date respective of customer's payment plan (Automatic or Manual) */
  paidInFullByDate: Scalars['Date'];
  paymentOptions: Array<BookingPaymentOption>;
  /** The payment plans attached to the order. */
  paymentSchedules: Array<PaymentSchedule>;
  /** How the quote was started. */
  quoteMethod?: Maybe<QuoteMethod>;
  /** The order that this order was rebooked from. */
  rebookedFromOrder?: Maybe<Order>;
  /** The order id that this order was rebooked from. */
  rebookedFromOrderId?: Maybe<Scalars['ObjectId']>;
  /** Whether the multi traveler rooms available for the order requires a roommate request. */
  requiresRoommateRequest: Scalars['Boolean'];
  /** The risk free period end date. */
  riskFreePeriodEndDate?: Maybe<Scalars['Date']>;
  /** The possible room combinations for the order given the number of trips, the departure's rooms, and the primary trip's room offers. */
  roomingCombinations: RoomingCombinations;
  /**
   * The saved payment methods for the primary trip's customer that can be used to pay for this order.
   * @deprecated Returns all saved payment methods for the primary trip's customer. If authenticated as a customer, it is favorable to use customer.savedPaymentMethods instead.
   */
  savedPaymentMethods: Array<SavedPaymentMethod>;
  /** The stage of the order. */
  stage: OrderStage;
  /** Sum of all discount line items */
  totalDiscount: Money;
  tourLineItemCode?: Maybe<Scalars['LineItemCode']>;
  /** The transactions applied to the order, sorted by ascending transaction date. */
  transactions: Array<PaymentTransaction>;
  /** The transferable and non transferable payment amounts for each payment method used in confirmed or pending transactions. */
  transferableAmounts: TransferableAmount;
  trips: Array<BookingTrip>;
  /** The trips of the booked order sorted by primary trip first. */
  tripsSortedByPrimary: Array<BookingTrip>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The version of the order. */
  versionId: Scalars['Int'];
};


/** A booked order */
export type BookingAllTravelersSavedPaymentMethodsArgs = {
  includeUnauthorized?: InputMaybe<Scalars['Boolean']>;
};


/** A booked order */
export type BookingMaxRedeemableReferralTravelBankPointsArgs = {
  customerId?: InputMaybe<Scalars['ObjectId']>;
};


/** A booked order */
export type BookingSavedPaymentMethodsArgs = {
  includeUnauthorized?: InputMaybe<Scalars['Boolean']>;
};

/** The type of payment methods allowed for a Booking */
export enum BookingAllowedPaymentMethodType {
  Ach = 'ACH',
  CreditCard = 'CREDIT_CARD',
  DebitCard = 'DEBIT_CARD'
}

export type BookingAutopayPaymentOption = {
  __typename?: 'BookingAutopayPaymentOption';
  allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>;
  earliestPaymentScheduleStartDate: Scalars['Date'];
  latestPaymentScheduleStartDate: Scalars['Date'];
  type: BookingPaymentOptionType;
};

export type BookingManualPaymentOption = {
  __typename?: 'BookingManualPaymentOption';
  allowedPaymentMethods: Array<BookingAllowedPaymentMethodType>;
  type: BookingPaymentOptionType;
};

export enum BookingMethod {
  Mobile = 'MOBILE',
  Offline = 'OFFLINE',
  Web = 'WEB'
}

export type BookingPaginatedResult = {
  __typename?: 'BookingPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Booking>;
};

export type BookingPaymentOption = BookingAutopayPaymentOption | BookingManualPaymentOption;

/** The type of payment options for a Booking */
export enum BookingPaymentOptionType {
  AutoPay = 'AUTO_PAY',
  Manual = 'MANUAL'
}

export enum BookingSortField {
  BusinessCode = 'businessCode',
  DateBooked = 'dateBooked'
}

/** Represents a trip on a booking order */
export type BookingTrip = Trip & {
  __typename?: 'BookingTrip';
  _id: Scalars['ObjectId'];
  /** The address for the trip. */
  address?: Maybe<Address>;
  /** The age of the traveler at departure date, inclusive of any pre-extension */
  ageAtDeparture?: Maybe<Scalars['Int']>;
  /** The applied promos with the number of times they have been applied to the trip. */
  appliedPromosWithCount: Array<AppliedPromoWithCount>;
  /** The exclusivities of promos that can be added to the trip. */
  availablePromoExclusivities: Array<PromoExclusivity>;
  booking?: Maybe<Booking>;
  businessCode?: Maybe<BusinessCode>;
  /** Whether the trip is within the cutoff date range for reviews */
  canBeReviewed?: Maybe<Scalars['Boolean']>;
  /** The estimated cancellation fee and effective DPD for the trip. */
  cancellationFeeEstimation?: Maybe<CancellationFeeEstimation>;
  cancellationMeta?: Maybe<TripCancellationMeta>;
  checklistItems: Array<TripChecklistItem>;
  /** Offers that can be applied to the trip but are not specific to a single component. Flight package offers are not included. */
  conditionalOffers: Array<ConditionalOffer>;
  /** The currency code of the trip. */
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  /** The customer id of the trip. */
  customerId?: Maybe<Scalars['ObjectId']>;
  /** The customer's loyalty level for the business matching this trip's order */
  customerLoyaltyLevel?: Maybe<LoyaltyLevel>;
  customerType: TripCustomerType;
  dateBooked: Scalars['DateTime'];
  /** Offers for departing flights that can be added to the trip. */
  departingFlightOffers: Array<FlightOffer>;
  departure?: Maybe<Departure>;
  /** The trip's actual departure date, inclusive of any departing flight */
  departureDate: Scalars['Date'];
  /** The net deposit amount for the trip. */
  depositAmount: Money;
  eTicketRelease?: Maybe<ReleaseDetails>;
  /** Checklist item for whether or not the trip has confirmed emergency contacts */
  emergencyContactChecklistItem?: Maybe<EmergencyContactChecklistItem>;
  /** The emergency contacts for the trip. */
  emergencyContacts?: Maybe<Array<EmergencyContact>>;
  emergencyContactsSelfServiceDeadline?: Maybe<Scalars['DateTime']>;
  /** The trip's actual end date, inclusive of any returning flight */
  endDate: Scalars['Date'];
  /** The fee amount that will be applied if the trip is rebooked */
  estimatedRebookingFeePrice?: Maybe<Money>;
  evaluation?: Maybe<CustomerEvaluation>;
  evaluationRelease?: Maybe<ReleaseDetails>;
  /** Offers for excursions that can be added to the trip. Includes extension excursions if the trip is booked on the extension. */
  excursionOffers: Array<DepartureExcursionOffer>;
  /** The departure excursions and extension excursions for the open excursion line items on this trip */
  excursions: Array<DepartureExcursion>;
  /** Sum of all open excursion line items */
  excursionsTotal: Money;
  /** The departure extension for the open extension line item on this trip */
  extension?: Maybe<DepartureExtension>;
  /** Offer for an extension that can be added to the trip. */
  extensionOffer?: Maybe<DepartureExtensionOffer>;
  /** The departure room for the open extension room line item on this trip */
  extensionRoom?: Maybe<DepartureRoom>;
  extensionRoommateTrips?: Maybe<Array<Trip>>;
  extensionRoommates?: Maybe<Array<Customer>>;
  /** The total fees amount for the trip. */
  feesTotal: Money;
  /** @deprecated Use grossFlightPackagePrice instead */
  flightPackagePrice?: Maybe<Money>;
  flights?: Maybe<TripFlights>;
  flightsRelease?: Maybe<ReleaseDetails>;
  grandTotal: Money;
  /** The total flight package price for the trip. */
  grossFlightPackagePrice?: Maybe<Money>;
  /** The total tour price with flights and private group if applicable. */
  grossTourTotalWithFlights: Money;
  hasAddress: Scalars['Boolean'];
  hasConfirmedDocumentInformation: Scalars['Boolean'];
  hasConfirmedExcursions: Scalars['Boolean'];
  hasConfirmedTSAInformation: Scalars['Boolean'];
  hasConfirmedTravelerInformation: Scalars['Boolean'];
  hasDepartingFlightDeviation: Scalars['Boolean'];
  hasEmergencyContacts: Scalars['Boolean'];
  /** Whether the trip has an open line item for an extension */
  hasExtension: Scalars['Boolean'];
  hasInsurance: Scalars['Boolean'];
  hasReturningFlightDeviation: Scalars['Boolean'];
  /** Whether the trip has any service recoveries */
  hasServiceRecoveries: Scalars['Boolean'];
  hasSignedTerms: Scalars['Boolean'];
  hasTsaInformation: Scalars['Boolean'];
  /** Checklist item for whether or not the trip has health notes */
  healthNotesChecklistItem?: Maybe<HealthNotesChecklistItem>;
  healthNotesSelfServiceDeadline?: Maybe<Scalars['DateTime']>;
  hotels?: Maybe<Array<TripHotel>>;
  /** Available inbound airport transfer offers for the trip, based on the active departure extension when applicable, otherwise on the main tour. */
  inboundAirportTransferOffers: Array<TourAirportTransferOffer>;
  /** The travel companion requests from other trips on the same departure that request this trip. */
  incomingTravelCompanionRequests: Array<TravelCompanionRequest>;
  /** The insurance eligibility status for this trip */
  insuranceEligibilityStatus: InsuranceEligibilityStatus;
  /** Public offers to be used by non staff. Returns all purchasable plan upgrades if the trip is within the free look period */
  insurancePlanOffers: Array<InsurancePlanOffer>;
  /** Insurance offers to be used by staff. Same as insurancePlanOffers, but returns all purchasable plans if the trip is within the free look period */
  insurancePlanOffersInternal: Array<InsurancePlanOffer>;
  /** The total insurance amount for the trip after adjustments. */
  insuranceTotal?: Maybe<Money>;
  /** Whether the trip is cancelled. */
  isCancelled: Scalars['Boolean'];
  /** Whether the trip is confirmed. */
  isConfirmed: Scalars['Boolean'];
  isEligibleToSubmitTravelCompanionRequests?: Maybe<Scalars['Boolean']>;
  /** Whether the trip is eligible for an inbound airport transfer */
  isInboundAirportTransferEligible: Scalars['Boolean'];
  isLandOnly: Scalars['Boolean'];
  /** Whether or not lost baggage service is available for this booking based on booking date and departure date. */
  isLostBaggageServiceAvailable?: Maybe<Scalars['Boolean']>;
  /** Whether the trip is open. */
  isOpen: Scalars['Boolean'];
  /** Whether the trip is eligible for an outbound airport transfer */
  isOutboundAirportTransferEligible: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  /** Whether the proof of insurance document is available for this traveler */
  isProofOfInsuranceDocumentAvailable: Scalars['Boolean'];
  /** Whether the trip is quoted. */
  isQuoted: Scalars['Boolean'];
  /** Whether the trip is rebooked. */
  isRebooked: Scalars['Boolean'];
  /** Whether the trip is requested. */
  isRequested: Scalars['Boolean'];
  isTravelReady: Scalars['Boolean'];
  /** Whether the trip is waitlisted. */
  isWaitlisted: Scalars['Boolean'];
  /** The latest inbound airport transfer line item for the trip with status REBOOKED, PENDING_CANCELLATION, or CANCELLED. */
  latestRemovedInboundAirportTransferLineItem?: Maybe<TourAirportTransferLineItem>;
  /** The latest outbound airport transfer line item for the trip with status REBOOKED, PENDING_CANCELLATION, or CANCELLED. */
  latestRemovedOutboundAirportTransferLineItem?: Maybe<TourAirportTransferLineItem>;
  /** The line items that compose the trip. */
  lineItems: Array<LineItem>;
  /** The REBOOKED + OPEN line items if the trip is rebooked, the CANCELLED + OPEN line items with PARENT_TRIP_CANCELLED cancellation metadata if the trip is cancelled, or the open line items in all other cases.  */
  lineItemsMatchingTripStatus: Array<LineItem>;
  locator: Scalars['String'];
  /** The maximum number of extension roommate requests that can be made for the trip. */
  maximumExtensionRoommateRequests: Scalars['Int'];
  /** The maximum number of main tour roommate requests that can be made for the trip. */
  maximumRoommateRequests: Scalars['Int'];
  openAdjustmentLineItems: Array<AdjustmentLineItem>;
  openAirportTransferLineItems: Array<TourAirportTransferLineItem>;
  openDepartingFlightLineItem?: Maybe<FlightPackageLineItem>;
  openExcursionLineItems: Array<TourExcursionLineItem>;
  openExtensionLineItem?: Maybe<TourExtensionLineItem>;
  openExtensionRoomLineItem?: Maybe<TourRoomLineItem>;
  openFeeLineItems: Array<FeeLineItem>;
  openFlightShopLineItem?: Maybe<FlightShopLineItem>;
  /** The open inbound airport transfer line item for the trip. */
  openInboundAirportTransferLineItem?: Maybe<TourAirportTransferLineItem>;
  openInsuranceAddonLineItems: Array<InsuranceAddonLineItem>;
  openInsuranceLineItem?: Maybe<InsuranceLineItem>;
  /** The line items that compose the trip which are not CANCELLED or REBOOKED */
  openLineItems: Array<LineItem>;
  /** The open outbound airport transfer line item for the trip. */
  openOutboundAirportTransferLineItem?: Maybe<TourAirportTransferLineItem>;
  openPostStayLineItem?: Maybe<ExtendedStayLineItem>;
  openPreStayLineItem?: Maybe<ExtendedStayLineItem>;
  openPrivateGroupLineItem?: Maybe<PrivateGroupLineItem>;
  openPromoLineItems: Array<PromoLineItem>;
  openReturningFlightLineItem?: Maybe<FlightPackageLineItem>;
  openRoomLineItem?: Maybe<TourRoomLineItem>;
  orderId: Scalars['ObjectId'];
  /** Available outbound airport transfer offers for the trip, based on the active departure extension when applicable, otherwise on the main tour. */
  outboundAirportTransferOffers: Array<TourAirportTransferOffer>;
  /** Checklist item for whether or not the trip has passport information */
  passportInformationChecklistItem?: Maybe<PassportInformationChecklistItem>;
  passportInformationSelfServiceDeadline?: Maybe<Scalars['DateTime']>;
  /** The total persisting adjustments amount for the trip. */
  persistingAdjustmentsTotal: Money;
  /** The trip ID for the trip that this trip was rebooked from. */
  rebookedFromTripId?: Maybe<Scalars['ObjectId']>;
  rebookingMeta?: Maybe<TripRebookingMeta>;
  requestedRoommates?: Maybe<Array<Scalars['String']>>;
  /** @deprecated Use travelCompanionRequests instead */
  requestedTravelCompanions?: Maybe<Array<Scalars['String']>>;
  /** Offers for returning flights that can be added to the trip. */
  returningFlightOffers: Array<FlightOffer>;
  review?: Maybe<Review>;
  /** The departure room for the open room line item on this trip */
  room?: Maybe<DepartureRoom>;
  /** Offers for rooms that can be added to the trip. Includes extension rooms if the trip is booked on the extension. */
  roomOffers: Array<DepartureRoomOffer>;
  /** Checklist item for whether or not the trip has roommates. Returns null if the room does not require a roommate request. */
  roommateChecklistItem?: Maybe<RoommateChecklistItem>;
  roommateTrips?: Maybe<Array<Trip>>;
  roommates?: Maybe<Array<Customer>>;
  serviceRecoveries: Array<ServiceRecovery>;
  signedTerms?: Maybe<Term>;
  /** The status of the trip */
  status: TripStatus;
  termsAcceptedAt?: Maybe<Scalars['DateTime']>;
  termsSignature?: Maybe<TermsSignature>;
  /** Checklist item for whether or not the trip has signed terms */
  termsSignatureChecklistItem?: Maybe<TermsSignatureChecklistItem>;
  timingStatus: TripTimingStatus;
  /** The date the trip departs for tour, inclusive of any pre-Extension */
  tourDepartureDate: Scalars['Date'];
  /** The date the trip ends, inclusive of any post-Extension */
  tourEndDate: Scalars['Date'];
  tourLineItem?: Maybe<TourLineItem>;
  /** The travel companion requests for the trip. */
  travelCompanionRequests: Array<TravelCompanionRequest>;
  travelerNotes?: Maybe<TravelerNotes>;
  /** Checklist item for whether or not the trip has confirmed TSA identifiers */
  tsaIdentifiersChecklistItem?: Maybe<TsaIdentifiersChecklistItem>;
  tsaIdentifiersSelfServiceDeadline?: Maybe<Scalars['DateTime']>;
  /** The TSA information for the trip. */
  tsaInformation?: Maybe<TsaInformation>;
};

/** A paginated result of Booking Trips */
export type BookingTripPaginatedResult = {
  __typename?: 'BookingTripPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<BookingTrip>;
  totalCount: Scalars['Int'];
};

/** Estimated summary for travelers being canceled in a booking trips. */
export type BookingTripsCancellationEstimatedSummary = {
  __typename?: 'BookingTripsCancellationEstimatedSummary';
  /** Default insurance adjustment line item code. */
  defaultInsuranceAdjustmentLineItemCode: Scalars['LineItemCode'];
  /** Total cancellation fee for all travelers being canceled. */
  totalCancellationFee: Money;
  /** Total amount eligible for refund for all travelers being canceled. */
  totalEligibleRefund: Money;
  /** Total insurance adjustment amount for all travelers being canceled. */
  totalInsuranceAdjustment: Money;
  /** Total of any non-refundable fees or adjustments for all travelers being canceled. */
  totalNonRefundable: Money;
  /** Estimated cancellation fees for each trip being canceled. */
  tripsCancellationFee: Array<TripCancellationFee>;
  /** Trips with non-refundable fees and adjustments for all travelers being canceled.  */
  tripsWithNonRefundableFeesAndAdjustments: Array<TripCancellationCharge>;
};

export type BulkCreateAudienceMembersInput = {
  customerId?: InputMaybe<Scalars['ObjectId']>;
  email?: InputMaybe<Scalars['Email']>;
};

export type BulkCreateAudienceMembersResult = BulkCreateAudienceMembersSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidAudienceMemberError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateAudienceMembersSuccess = {
  __typename?: 'BulkCreateAudienceMembersSuccess';
  data: Array<AudienceMember>;
};

export type BulkCreateCategoriesResult = BulkCreateCategoriesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateCategoriesResults = {
  __typename?: 'BulkCreateCategoriesResults';
  /** Successfully created categories */
  categories: Array<Category>;
  /** Errors that occurred during the creation */
  errors: Array<BulkCreateCategoryErrorResult>;
};

export type BulkCreateCategoryErrorResult = {
  __typename?: 'BulkCreateCategoryErrorResult';
  /** The input that caused the error */
  input: BulkCreateCategoryInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateCategoryInput = {
  businessCode: BusinessCode;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type BulkCreateCategoryInputObject = {
  __typename?: 'BulkCreateCategoryInputObject';
  businessCode: BusinessCode;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type BulkCreateDepartureErrorResult = {
  __typename?: 'BulkCreateDepartureErrorResult';
  /** The input that caused the error */
  input: BulkCreateDepartureInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateDepartureExcursionErrorResult = {
  __typename?: 'BulkCreateDepartureExcursionErrorResult';
  /** The input that caused the error */
  input: BulkCreateDepartureExcursionInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateDepartureExcursionInput = {
  businessCode: BusinessCode;
  capacity?: InputMaybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  matchCode: Scalars['String'];
  minNbTravelersRequired?: InputMaybe<Scalars['Int']>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureExcursionInputObject = {
  __typename?: 'BulkCreateDepartureExcursionInputObject';
  businessCode: BusinessCode;
  capacity?: Maybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  matchCode: Scalars['String'];
  minNbTravelersRequired?: Maybe<Scalars['Int']>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureExcursionsResult = BulkCreateDepartureExcursionsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDepartureExcursionsResults = {
  __typename?: 'BulkCreateDepartureExcursionsResults';
  /** Successfully created departures */
  departures: Array<Departure>;
  /** Errors that occurred during creation */
  errors: Array<BulkCreateDepartureExcursionErrorResult>;
};

export type BulkCreateDepartureExtensionErrorResult = {
  __typename?: 'BulkCreateDepartureExtensionErrorResult';
  /** The input that caused the error */
  input: BulkCreateDepartureExtensionInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateDepartureExtensionExcursionErrorResult = {
  __typename?: 'BulkCreateDepartureExtensionExcursionErrorResult';
  /** The input that caused the error */
  input: BulkCreateDepartureExtensionExcursionInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateDepartureExtensionExcursionInput = {
  businessCode: BusinessCode;
  capacity?: InputMaybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  extensionTourCode: Scalars['String'];
  matchCode: Scalars['String'];
  minNbTravelersRequired?: InputMaybe<Scalars['Int']>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureExtensionExcursionInputObject = {
  __typename?: 'BulkCreateDepartureExtensionExcursionInputObject';
  businessCode: BusinessCode;
  capacity?: Maybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  extensionTourCode: Scalars['String'];
  matchCode: Scalars['String'];
  minNbTravelersRequired?: Maybe<Scalars['Int']>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureExtensionExcursionsResult = BulkCreateDepartureExtensionExcursionsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDepartureExtensionExcursionsResults = {
  __typename?: 'BulkCreateDepartureExtensionExcursionsResults';
  /** Successfully created departures */
  departures: Array<Departure>;
  /** Errors that occurred during creation */
  errors: Array<BulkCreateDepartureExtensionExcursionErrorResult>;
};

export type BulkCreateDepartureExtensionInput = {
  businessCode: BusinessCode;
  capacity?: InputMaybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  extensionTourCode: Scalars['String'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureExtensionInputObject = {
  __typename?: 'BulkCreateDepartureExtensionInputObject';
  businessCode: BusinessCode;
  capacity?: Maybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  extensionTourCode: Scalars['String'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureExtensionRoomErrorResult = {
  __typename?: 'BulkCreateDepartureExtensionRoomErrorResult';
  /** The input that caused the error */
  input: BulkCreateDepartureExtensionRoomInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateDepartureExtensionRoomInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']>;
  capacity?: InputMaybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  /** Extension tour code of the departure */
  extensionTourCode: Scalars['String'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  /** Tour code of the departure */
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureExtensionRoomInputObject = {
  __typename?: 'BulkCreateDepartureExtensionRoomInputObject';
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: Maybe<Scalars['TourCabinCode']>;
  capacity?: Maybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  extensionTourCode: Scalars['String'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureExtensionRoomsResult = BulkCreateDepartureExtensionRoomsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDepartureExtensionRoomsResults = {
  __typename?: 'BulkCreateDepartureExtensionRoomsResults';
  /** Departures with successfully created rooms */
  departures: Array<Departure>;
  /** Errors that occurred during creation */
  errors: Array<BulkCreateDepartureExtensionRoomErrorResult>;
};

export type BulkCreateDepartureExtensionsResult = BulkCreateDepartureExtensionsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDepartureExtensionsResults = {
  __typename?: 'BulkCreateDepartureExtensionsResults';
  /** Successfully created departures */
  departures: Array<Departure>;
  /** Errors that occurred during creation */
  errors: Array<BulkCreateDepartureExtensionErrorResult>;
};

export type BulkCreateDepartureInput = {
  addonPrice?: InputMaybe<Array<MoneyInput>>;
  businessCode: BusinessCode;
  departureDate: Scalars['Date'];
  exclusivityType: DepartureExclusivityType;
  extensionTourCode?: InputMaybe<Scalars['String']>;
  maxTravelerAge?: InputMaybe<Scalars['Int']>;
  minTravelerAge?: InputMaybe<Scalars['Int']>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  status: DepartureStatus;
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureInputObject = {
  __typename?: 'BulkCreateDepartureInputObject';
  businessCode: BusinessCode;
  departureDate: Scalars['Date'];
  exclusivityType: DepartureExclusivityType;
  extensionTourCode?: Maybe<Scalars['String']>;
  maxTravelerAge?: Maybe<Scalars['Int']>;
  minTravelerAge?: Maybe<Scalars['Int']>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  status: DepartureStatus;
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureNotesErrorResult = {
  __typename?: 'BulkCreateDepartureNotesErrorResult';
  /** The input that caused the error */
  input: BulkCreateDepartureNotesInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateDepartureNotesInput = {
  businessCode: BusinessCode;
  departureDate: Scalars['Date'];
  note: Scalars['String'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureNotesInputObject = {
  __typename?: 'BulkCreateDepartureNotesInputObject';
  businessCode: BusinessCode;
  departureDate: Scalars['Date'];
  note: Scalars['String'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureNotesResult = BulkCreateDepartureNotesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDepartureNotesResults = {
  __typename?: 'BulkCreateDepartureNotesResults';
  /** Departures with successfully created notes */
  departures: Array<Departure>;
  /** Errors that occurred during creation */
  errors: Array<BulkCreateDepartureNotesErrorResult>;
};

export type BulkCreateDepartureRoomErrorResult = {
  __typename?: 'BulkCreateDepartureRoomErrorResult';
  /** The input that caused the error */
  input: BulkCreateDepartureRoomInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateDepartureRoomInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']>;
  capacity?: InputMaybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureRoomInputObject = {
  __typename?: 'BulkCreateDepartureRoomInputObject';
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: Maybe<Scalars['TourCabinCode']>;
  capacity?: Maybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkCreateDepartureRoomsResult = BulkCreateDepartureRoomsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDepartureRoomsResults = {
  __typename?: 'BulkCreateDepartureRoomsResults';
  /** Successfully created departures */
  departures: Array<Departure>;
  /** Errors that occurred during creation */
  errors: Array<BulkCreateDepartureRoomErrorResult>;
};

export type BulkCreateDeparturesResult = BulkCreateDeparturesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateDeparturesResults = {
  __typename?: 'BulkCreateDeparturesResults';
  /** Successfully created departures */
  departures: Array<Departure>;
  /** Errors that occurred during the creation */
  errors: Array<BulkCreateDepartureErrorResult>;
};

export type BulkCreateExtendedStayErrorResult = {
  __typename?: 'BulkCreateExtendedStayErrorResult';
  /** The input that caused the error */
  input: CreateExtendedStayInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateExtendedStaysResult = BulkCreateExtendedStaysResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateExtendedStaysResults = {
  __typename?: 'BulkCreateExtendedStaysResults';
  /** Errors that occurred during creation */
  errors: Array<BulkCreateExtendedStayErrorResult>;
  /** Successfully created extended stays */
  extendedStays: Array<ExtendedStay>;
};

export type BulkCreateFlightPackagesErrorResult = {
  __typename?: 'BulkCreateFlightPackagesErrorResult';
  /** The input that caused the error */
  input: BulkFlightPackageInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateFlightPackagesInput = {
  businessCode: BusinessCode;
  flightPackages: Array<BulkFlightPackageInput>;
};

export type BulkCreateFlightPackagesResult = BulkCreateFlightPackagesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidFlightPackageError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateFlightPackagesResults = {
  __typename?: 'BulkCreateFlightPackagesResults';
  /** Errors that occurred during creation */
  errors: Array<BulkCreateFlightPackagesErrorResult>;
  /** Successfully created flight packages */
  flightPackages: Array<FlightPackage>;
};

export type BulkCreateGcDepartureMeetingRsvpInput = {
  email?: InputMaybe<Scalars['Email']>;
  firstName: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  lastName: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
};

export type BulkCreateGcDepartureMeetingRsvPsInput = {
  ignoreRsvpPeriod?: InputMaybe<Scalars['Boolean']>;
  meetingId: Scalars['ObjectId'];
  response: GcDepartureMeetingRsvpResponse;
  rsvps: Array<BulkCreateGcDepartureMeetingRsvpInput>;
};

export type BulkCreateGcDepartureMeetingRsvPsResult = BulkCreateGcDepartureMeetingRsvPsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidGcDepartureMeetingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateGcDepartureMeetingRsvPsSuccess = {
  __typename?: 'BulkCreateGCDepartureMeetingRSVPsSuccess';
  data: Array<GcDepartureMeetingRsvp>;
};

/** Input for creating a gc departure prospect */
export type BulkCreateGcDepartureProspectsInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gcDepartureId: Scalars['ObjectId'];
  lastName?: InputMaybe<Scalars['String']>;
  levelOfInterest?: InputMaybe<GcDepartureProspectLevelOfInterest>;
  notes?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type BulkCreateGcDepartureProspectsResult = BulkCreateGcDepartureProspectsSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidGcDepartureError | InvalidGcDepartureProspectError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateGcDepartureProspectsSuccess = {
  __typename?: 'BulkCreateGCDepartureProspectsSuccess';
  data: Array<GcDepartureProspect>;
};

export type BulkCreatePrivateGroupsErrorResult = {
  __typename?: 'BulkCreatePrivateGroupsErrorResult';
  /** The input that caused the error */
  input: BulkCreatePrivateGroupsInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreatePrivateGroupsInput = {
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  priceYear: Scalars['Int'];
  rollsUpToTarget?: Scalars['Boolean'];
  tourCode: Scalars['String'];
};

export type BulkCreatePrivateGroupsInputObject = {
  __typename?: 'BulkCreatePrivateGroupsInputObject';
  businessCode: BusinessCode;
  priceYear: Scalars['Int'];
  rollsUpToTarget: Scalars['Boolean'];
  tourCode: Scalars['String'];
};

export type BulkCreatePrivateGroupsResult = BulkCreatePrivateGroupsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidPrivateGroupError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreatePrivateGroupsResults = {
  __typename?: 'BulkCreatePrivateGroupsResults';
  /** Errors that occurred during the creation */
  errors: Array<BulkCreatePrivateGroupsErrorResult>;
  /** Successfully updated tours */
  tours: Array<Tour>;
};

export type BulkCreatePromoErrorResult = {
  __typename?: 'BulkCreatePromoErrorResult';
  /** The input that caused the error */
  input: CreatePromoInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreatePromoTargetErrorResult = {
  __typename?: 'BulkCreatePromoTargetErrorResult';
  /** The input that caused the error */
  input: BulkCreatePromoTargetInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreatePromoTargetInput = {
  amount: Array<MoneyInput>;
  businessCode: BusinessCode;
  componentType: TripComponentType;
  departureDateFrom?: InputMaybe<Scalars['Date']>;
  departureDateTo?: InputMaybe<Scalars['Date']>;
  lineItemCode?: InputMaybe<Scalars['LineItemCode']>;
  offerCode: Scalars['String'];
  requiredComponent?: InputMaybe<PromoTargetRequiredComponentInput>;
  series?: InputMaybe<Scalars['Series']>;
};

export type BulkCreatePromoTargetInputObject = {
  __typename?: 'BulkCreatePromoTargetInputObject';
  businessCode: BusinessCode;
  offerCode: Scalars['String'];
};

export type BulkCreatePromoTargetsResult = BulkCreatePromoTargetsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPromoError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreatePromoTargetsResults = {
  __typename?: 'BulkCreatePromoTargetsResults';
  /** Errors that occurred during creation */
  errors: Array<BulkCreatePromoTargetErrorResult>;
  /** Successfully updated promos with targets */
  promos: Array<Promo>;
};

export type BulkCreatePromosResult = BulkCreatePromosResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPromoError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreatePromosResults = {
  __typename?: 'BulkCreatePromosResults';
  /** Errors that occurred during creation */
  errors: Array<BulkCreatePromoErrorResult>;
  /** Successfully created promos */
  promos: Array<Promo>;
};

export type BulkCreateTagsErrorResult = {
  __typename?: 'BulkCreateTagsErrorResult';
  /** The input that caused the error */
  input: BulkCreateTagsInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateTagsInput = {
  businessCode: BusinessCode;
  category: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  tag: Scalars['String'];
};

export type BulkCreateTagsInputObject = {
  __typename?: 'BulkCreateTagsInputObject';
  businessCode: BusinessCode;
  category: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  tag: Scalars['String'];
};

export type BulkCreateTagsResult = BulkCreateTagsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateTagsResults = {
  __typename?: 'BulkCreateTagsResults';
  /** Errors that occurred during the creation */
  errors: Array<BulkCreateTagsErrorResult>;
  /** Successfully created tags */
  tags: Array<Tag>;
};

export type BulkCreateTourAirportTransfersErrorResult = {
  __typename?: 'BulkCreateTourAirportTransfersErrorResult';
  /** The input that caused the error */
  input: BulkCreateTourAirportTransfersInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateTourAirportTransfersInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  internalName: Scalars['String'];
  priceYear: Scalars['Int'];
  /** Time range for the airport transfer */
  timeRange: TimeRangeInput;
  tourCode: Scalars['String'];
  windowType: AirportTransferWindowType;
};

export type BulkCreateTourAirportTransfersInputObject = {
  __typename?: 'BulkCreateTourAirportTransfersInputObject';
  autoApproveDeadlineDpd?: Maybe<Scalars['Int']>;
  businessCode: BusinessCode;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  internalName: Scalars['String'];
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
  windowType: AirportTransferWindowType;
};

export type BulkCreateTourAirportTransfersResult = BulkCreateTourAirportTransfersResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidAirportTransferError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateTourAirportTransfersResults = {
  __typename?: 'BulkCreateTourAirportTransfersResults';
  /** Errors that occurred during the creation */
  errors: Array<BulkCreateTourAirportTransfersErrorResult>;
  /** Successfully created tours */
  tours: Array<Tour>;
};

export type BulkCreateTourExtensionAirportTransfersErrorResult = {
  __typename?: 'BulkCreateTourExtensionAirportTransfersErrorResult';
  /** The input that caused the error */
  input: BulkCreateTourExtensionAirportTransfersInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkCreateTourExtensionAirportTransfersInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  internalName: Scalars['String'];
  priceYear: Scalars['Int'];
  /** Time range for the airport transfer */
  timeRange: TimeRangeInput;
  tourCode: Scalars['String'];
  windowType: AirportTransferWindowType;
};

export type BulkCreateTourExtensionAirportTransfersInputObject = {
  __typename?: 'BulkCreateTourExtensionAirportTransfersInputObject';
  autoApproveDeadlineDpd?: Maybe<Scalars['Int']>;
  businessCode: BusinessCode;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  internalName: Scalars['String'];
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
  windowType: AirportTransferWindowType;
};

export type BulkCreateTourExtensionAirportTransfersResult = BulkCreateTourExtensionAirportTransfersResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidAirportTransferError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkCreateTourExtensionAirportTransfersResults = {
  __typename?: 'BulkCreateTourExtensionAirportTransfersResults';
  /** Errors that occurred during the creation */
  errors: Array<BulkCreateTourExtensionAirportTransfersErrorResult>;
  /** Successfully updated tour extensions */
  tourExtensions: Array<TourExtension>;
};

export type BulkDeleteGcDepartureMeetingRsvPsError = {
  __typename?: 'BulkDeleteGCDepartureMeetingRSVPsError';
  /** ID of the RSVP that caused the error */
  _id: Scalars['ObjectId'];
  message: Scalars['String'];
};

export type BulkDeleteGcDepartureMeetingRsvPsInput = {
  /** List of RSVP IDs to delete. Cannot exceed 500 items. Secondary RSVPs of any primary in the list are deleted automatically. */
  rsvpIds: Array<Scalars['ObjectId']>;
};

export type BulkDeleteGcDepartureMeetingRsvPsResult = BulkDeleteGcDepartureMeetingRsvPsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidGcDepartureMeetingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkDeleteGcDepartureMeetingRsvPsResults = {
  __typename?: 'BulkDeleteGCDepartureMeetingRSVPsResults';
  /** List of errors encountered during the deletion */
  errors: Array<BulkDeleteGcDepartureMeetingRsvPsError>;
  /** Number of RSVPs successfully deleted */
  nbRecordsDeleted: Scalars['Int'];
};

export type BulkFlightPackageInput = {
  arrivalGatewayCode: Scalars['String'];
  basePrice: Array<MoneyInput>;
  departureGatewayCode: Scalars['String'];
  isCustomGateway: Scalars['Boolean'];
};

export type BulkFlightPackageInputObject = {
  __typename?: 'BulkFlightPackageInputObject';
  arrivalGatewayCode: Scalars['String'];
  departureGatewayCode: Scalars['String'];
  isCustomGateway: Scalars['Boolean'];
};

export type BulkRemoveAudienceMembersError = {
  __typename?: 'BulkRemoveAudienceMembersError';
  _id: Scalars['ObjectId'];
  message: Scalars['String'];
};

export type BulkRemoveAudienceMembersInput = {
  /** List of audience member IDs to remove. Cannot exceed 1000 items */
  memberIds: Array<Scalars['ObjectId']>;
};

export type BulkRemoveAudienceMembersResult = BulkRemoveAudienceMembersResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkRemoveAudienceMembersResults = {
  __typename?: 'BulkRemoveAudienceMembersResults';
  /** List of errors encountered during the removal */
  errors: Array<BulkRemoveAudienceMembersError>;
  /** Number of audience members successfully removed */
  nbRecordsDeleted: Scalars['Int'];
};

export type BulkUpdateBookingExcursionsErrorResult = {
  __typename?: 'BulkUpdateBookingExcursionsErrorResult';
  /** ID of the order that caused the error */
  _id: Scalars['ObjectId'];
  message: Scalars['String'];
};

export type BulkUpdateBookingExcursionsInput = {
  /** The business reason for the cancellation. */
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  /** Extension excursion lineItemCodes to update. */
  extensionExcursionLineItemCodes: Array<Scalars['LineItemCode']>;
  /** Main tour excursion lineItemCodes to update. */
  mainTourExcursionLineItemCodes: Array<Scalars['LineItemCode']>;
  /** The new status to set for the excursions. */
  status: BulkUpdateLineItemStatus;
  /** The tripIds to update the excursions for. */
  tripIds: Array<Scalars['ObjectId']>;
};

export type BulkUpdateBookingExcursionsResult = BulkUpdateBookingExcursionsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateBookingExcursionsResults = {
  __typename?: 'BulkUpdateBookingExcursionsResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateBookingExcursionsErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateBookingExtensionsErrorResult = {
  __typename?: 'BulkUpdateBookingExtensionsErrorResult';
  /** ID of the order that caused the error */
  _id: Scalars['ObjectId'];
  message: Scalars['String'];
};

export type BulkUpdateBookingExtensionsInput = {
  /** The business reason for the cancellation. */
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  /** Extension lineItemCodes to update. */
  extensionLineItemCodes: Array<Scalars['LineItemCode']>;
  /** The new status to set for the extensions. */
  status: BulkUpdateLineItemStatus;
  /** The tripIds to update the extensions for. */
  tripIds: Array<Scalars['ObjectId']>;
};

export type BulkUpdateBookingExtensionsResult = BulkUpdateBookingExtensionsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateBookingExtensionsResults = {
  __typename?: 'BulkUpdateBookingExtensionsResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateBookingExtensionsErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateDepartureErrorResult = {
  __typename?: 'BulkUpdateDepartureErrorResult';
  /** The input that caused the error */
  input: BulkUpdateDepartureInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateDepartureExcursionErrorResult = {
  __typename?: 'BulkUpdateDepartureExcursionErrorResult';
  /** The input that caused the error */
  input: BulkUpdateDepartureExcursionInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateDepartureExcursionInput = {
  autoApproveDeadline?: InputMaybe<Scalars['Date']>;
  businessCode: BusinessCode;
  /** Required when setting status to CANCELLED or PENDING_CANCELLATION */
  cancellationReason?: InputMaybe<DepartureItemCancellationReason>;
  capacity?: InputMaybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  matchCode: Scalars['String'];
  minNbTravelersRequired?: InputMaybe<Scalars['Int']>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  status?: InputMaybe<DepartureStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureExcursionInputObject = {
  __typename?: 'BulkUpdateDepartureExcursionInputObject';
  autoApproveDeadline?: Maybe<Scalars['Date']>;
  businessCode: BusinessCode;
  cancellationReason?: Maybe<DepartureItemCancellationReason>;
  capacity?: Maybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  matchCode: Scalars['String'];
  minNbTravelersRequired?: Maybe<Scalars['Int']>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  status?: Maybe<DepartureStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureExcursionsResult = BulkUpdateDepartureExcursionsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureExcursionsResults = {
  __typename?: 'BulkUpdateDepartureExcursionsResults';
  /** Successfully updated departures */
  departures: Array<Departure>;
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateDepartureExcursionErrorResult>;
};

export type BulkUpdateDepartureExtensionErrorResult = {
  __typename?: 'BulkUpdateDepartureExtensionErrorResult';
  /** The input that caused the error */
  input: BulkUpdateDepartureExtensionInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateDepartureExtensionExcursionErrorResult = {
  __typename?: 'BulkUpdateDepartureExtensionExcursionErrorResult';
  /** The input that caused the error */
  input: BulkUpdateDepartureExtensionExcursionInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateDepartureExtensionExcursionInput = {
  autoApproveDeadline?: InputMaybe<Scalars['Date']>;
  businessCode: BusinessCode;
  /** Required when setting status to CANCELLED or PENDING_CANCELLATION */
  cancellationReason?: InputMaybe<DepartureItemCancellationReason>;
  capacity?: InputMaybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  /** Extension tour code of the departure */
  extensionTourCode: Scalars['String'];
  matchCode: Scalars['String'];
  minNbTravelersRequired?: InputMaybe<Scalars['Int']>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  status?: InputMaybe<DepartureStatus>;
  /** Tour code of the departure */
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureExtensionExcursionInputObject = {
  __typename?: 'BulkUpdateDepartureExtensionExcursionInputObject';
  autoApproveDeadline?: Maybe<Scalars['Date']>;
  businessCode: BusinessCode;
  cancellationReason?: Maybe<DepartureItemCancellationReason>;
  capacity?: Maybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  extensionTourCode: Scalars['String'];
  matchCode: Scalars['String'];
  minNbTravelersRequired?: Maybe<Scalars['Int']>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  status?: Maybe<DepartureStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureExtensionExcursionsResult = BulkUpdateDepartureExtensionExcursionsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureExtensionExcursionsResults = {
  __typename?: 'BulkUpdateDepartureExtensionExcursionsResults';
  /** Successfully updated departures */
  departures: Array<Departure>;
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateDepartureExtensionExcursionErrorResult>;
};

export type BulkUpdateDepartureExtensionInput = {
  autoApproveDeadline?: InputMaybe<Scalars['Date']>;
  businessCode: BusinessCode;
  /** Required when setting status to CANCELLED or PENDING_CANCELLATION */
  cancellationReason?: InputMaybe<DepartureItemCancellationReason>;
  capacity?: InputMaybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  endGatewayCode?: InputMaybe<Scalars['String']>;
  /** Extension tour code of the departure */
  extensionTourCode: Scalars['String'];
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']>;
  postStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  preStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  startGatewayCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DepartureStatus>;
  /** Tour code of the departure */
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureExtensionInputObject = {
  __typename?: 'BulkUpdateDepartureExtensionInputObject';
  autoApproveDeadline?: Maybe<Scalars['Date']>;
  businessCode: BusinessCode;
  cancellationReason?: Maybe<DepartureItemCancellationReason>;
  capacity?: Maybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  endGatewayCode?: Maybe<Scalars['String']>;
  extensionTourCode: Scalars['String'];
  isFlightShoppingAllowed?: Maybe<Scalars['Boolean']>;
  postStayCityCodes?: Maybe<Array<Scalars['String']>>;
  preStayCityCodes?: Maybe<Array<Scalars['String']>>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  startGatewayCode?: Maybe<Scalars['String']>;
  status?: Maybe<DepartureStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureExtensionRoomErrorResult = {
  __typename?: 'BulkUpdateDepartureExtensionRoomErrorResult';
  /** The input that caused the error */
  input: BulkUpdateDepartureExtensionRoomInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateDepartureExtensionRoomInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']>;
  /** Required when setting status to CANCELLED or PENDING_CANCELLATION */
  cancellationReason?: InputMaybe<DepartureItemCancellationReason>;
  capacity?: InputMaybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  /** Extension tour code of the departure */
  extensionTourCode: Scalars['String'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  status?: InputMaybe<DepartureStatus>;
  /** Tour code of the departure */
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureExtensionRoomInputObject = {
  __typename?: 'BulkUpdateDepartureExtensionRoomInputObject';
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: Maybe<Scalars['TourCabinCode']>;
  cancellationReason?: Maybe<DepartureItemCancellationReason>;
  capacity?: Maybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  extensionTourCode: Scalars['String'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  status?: Maybe<DepartureStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureExtensionRoomsResult = BulkUpdateDepartureExtensionRoomsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureExtensionRoomsResults = {
  __typename?: 'BulkUpdateDepartureExtensionRoomsResults';
  /** Successfully updated departures */
  departures: Array<Departure>;
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateDepartureExtensionRoomErrorResult>;
};

export type BulkUpdateDepartureExtensionsResult = BulkUpdateDepartureExtensionsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureExtensionsResults = {
  __typename?: 'BulkUpdateDepartureExtensionsResults';
  /** Successfully updated departures */
  departures: Array<Departure>;
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateDepartureExtensionErrorResult>;
};

export type BulkUpdateDepartureInput = {
  addonPrice?: InputMaybe<Array<MoneyInput>>;
  autoApproveDeadline?: InputMaybe<Scalars['Date']>;
  businessCode: BusinessCode;
  /** Required when setting status to CANCELLED or PENDING_CANCELLATION */
  cancellationReason?: InputMaybe<DepartureItemCancellationReason>;
  capacity?: InputMaybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  endGatewayCode?: InputMaybe<Scalars['String']>;
  exclusivityType?: InputMaybe<DepartureExclusivityType>;
  finalInstallmentDeadline?: InputMaybe<Scalars['Date']>;
  finalPaymentDeadline?: InputMaybe<Scalars['Date']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']>;
  isPostStayAllowed?: InputMaybe<Scalars['Boolean']>;
  isPreStayAllowed?: InputMaybe<Scalars['Boolean']>;
  isWaitlistAllowed?: InputMaybe<Scalars['Boolean']>;
  maxTravelerAge?: InputMaybe<Scalars['Int']>;
  minTravelerAge?: InputMaybe<Scalars['Int']>;
  postStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  preStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  priceYear: Scalars['Int'];
  reservedCapacity?: InputMaybe<Scalars['Int']>;
  series: Scalars['Series'];
  startGatewayCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DepartureStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureInputObject = {
  __typename?: 'BulkUpdateDepartureInputObject';
  autoApproveDeadline?: Maybe<Scalars['Date']>;
  businessCode: BusinessCode;
  cancellationReason?: Maybe<DepartureItemCancellationReason>;
  capacity?: Maybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  endGatewayCode?: Maybe<Scalars['String']>;
  exclusivityType?: Maybe<DepartureExclusivityType>;
  finalInstallmentDeadline?: Maybe<Scalars['Date']>;
  finalPaymentDeadline?: Maybe<Scalars['Date']>;
  isFlightShoppingAllowed?: Maybe<Scalars['Boolean']>;
  isPostStayAllowed?: Maybe<Scalars['Boolean']>;
  isPreStayAllowed?: Maybe<Scalars['Boolean']>;
  isWaitlistAllowed?: Maybe<Scalars['Boolean']>;
  maxTravelerAge?: Maybe<Scalars['Int']>;
  minTravelerAge?: Maybe<Scalars['Int']>;
  postStayCityCodes?: Maybe<Array<Scalars['String']>>;
  preStayCityCodes?: Maybe<Array<Scalars['String']>>;
  priceYear: Scalars['Int'];
  reservedCapacity?: Maybe<Scalars['Int']>;
  series: Scalars['Series'];
  startGatewayCode?: Maybe<Scalars['String']>;
  status?: Maybe<DepartureStatus>;
  tagIds?: Maybe<Array<Scalars['ObjectId']>>;
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureOwnerErrorResult = {
  __typename?: 'BulkUpdateDepartureOwnerErrorResult';
  /** The input that caused the error */
  input: BulkUpdateDepartureOwnerInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateDepartureOwnerInput = {
  businessCode: BusinessCode;
  departureDate: Scalars['Date'];
  ownerEmail?: InputMaybe<Scalars['Email']>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureOwnerInputObject = {
  __typename?: 'BulkUpdateDepartureOwnerInputObject';
  businessCode: BusinessCode;
  departureDate: Scalars['Date'];
  ownerEmail?: Maybe<Scalars['Email']>;
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureOwnersResult = BulkUpdateDepartureOwnersResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureOwnersResults = {
  __typename?: 'BulkUpdateDepartureOwnersResults';
  /** Successfully updated departures */
  departures: Array<Departure>;
  /** Errors that occurred during update */
  errors: Array<BulkUpdateDepartureOwnerErrorResult>;
};

export type BulkUpdateDepartureRoomErrorResult = {
  __typename?: 'BulkUpdateDepartureRoomErrorResult';
  /** The input that caused the error */
  input: BulkUpdateDepartureRoomInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateDepartureRoomInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']>;
  /** Required when setting status to CANCELLED or PENDING_CANCELLATION */
  cancellationReason?: InputMaybe<DepartureItemCancellationReason>;
  capacity?: InputMaybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  status?: InputMaybe<DepartureStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureRoomInputObject = {
  __typename?: 'BulkUpdateDepartureRoomInputObject';
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: Maybe<Scalars['TourCabinCode']>;
  cancellationReason?: Maybe<DepartureItemCancellationReason>;
  capacity?: Maybe<Scalars['Int']>;
  departureDate: Scalars['Date'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  status?: Maybe<DepartureStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureRoomsResult = BulkUpdateDepartureRoomsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureRoomsResults = {
  __typename?: 'BulkUpdateDepartureRoomsResults';
  /** Successfully updated departures */
  departures: Array<Departure>;
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateDepartureRoomErrorResult>;
};

export type BulkUpdateDepartureTagErrorResult = {
  __typename?: 'BulkUpdateDepartureTagErrorResult';
  /** The input that caused the error */
  input: BulkUpdateDepartureTagsInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateDepartureTagsInput = {
  action: TagAction;
  businessCode: BusinessCode;
  categoryName: Scalars['String'];
  departureDate: Scalars['Date'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tagName: Scalars['String'];
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureTagsInputObject = {
  __typename?: 'BulkUpdateDepartureTagsInputObject';
  action: TagAction;
  businessCode: BusinessCode;
  categoryName: Scalars['String'];
  departureDate: Scalars['Date'];
  priceYear: Scalars['Int'];
  series: Scalars['Series'];
  tagName: Scalars['String'];
  tourCode: Scalars['String'];
};

export type BulkUpdateDepartureTagsResult = BulkUpdateDepartureTagsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDepartureTagsResults = {
  __typename?: 'BulkUpdateDepartureTagsResults';
  /** Successfully updated departures */
  departures: Array<Departure>;
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateDepartureTagErrorResult>;
};

export type BulkUpdateDeparturesResult = BulkUpdateDeparturesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateDeparturesResults = {
  __typename?: 'BulkUpdateDeparturesResults';
  /** Successfully updated departures */
  departures: Array<Departure>;
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateDepartureErrorResult>;
};

export type BulkUpdateExtendedStayPriceRulesInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cityCode: Scalars['String'];
  priceRules: Array<PriceRuleInput>;
};

export type BulkUpdateExtendedStayPriceRulesResult = BulkUpdateExtendedStayPriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateExtendedStayPriceRulesSuccess = {
  __typename?: 'BulkUpdateExtendedStayPriceRulesSuccess';
  data: Array<ExtendedStay>;
};

export type BulkUpdateFeePriceRulesInput = {
  businessCode: BusinessCode;
  categoryCode: Scalars['FeeCategoryCode'];
  priceRules: Array<PriceRuleInput>;
  typeCode: FeeTypeCode;
};

export type BulkUpdateFeePriceRulesResult = BulkUpdateFeePriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateFeePriceRulesSuccess = {
  __typename?: 'BulkUpdateFeePriceRulesSuccess';
  data: Array<Fee>;
};

export type BulkUpdateFlightPackagePriceRulesErrorResult = {
  __typename?: 'BulkUpdateFlightPackagePriceRulesErrorResult';
  /** The input that caused the error */
  input: BulkUpdateFlightPackagePriceRulesInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateFlightPackagePriceRulesInput = {
  arrivalGatewayCode: Scalars['String'];
  businessCode: BusinessCode;
  departureGatewayCode: Scalars['String'];
  priceRules: Array<PriceRuleInput>;
};

export type BulkUpdateFlightPackagePriceRulesInputObject = {
  __typename?: 'BulkUpdateFlightPackagePriceRulesInputObject';
  arrivalGatewayCode: Scalars['String'];
  businessCode: BusinessCode;
  departureGatewayCode: Scalars['String'];
};

export type BulkUpdateFlightPackagePriceRulesResult = BulkUpdateFlightPackagePriceRulesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateFlightPackagePriceRulesResults = {
  __typename?: 'BulkUpdateFlightPackagePriceRulesResults';
  /** Errors that occurred during update */
  errors: Array<BulkUpdateFlightPackagePriceRulesErrorResult>;
  /** Successfully updated flight packages */
  flightPackages: Array<FlightPackage>;
};

export type BulkUpdateFlightPackageStatusesInput = {
  /** List of flight package IDs to update. Cannot exceed 500 items */
  flightPackageIds: Array<Scalars['ObjectId']>;
  /** The new status for the flight packages */
  status: TripComponentStatus;
};

export type BulkUpdateFlightPackageStatusesResult = BulkUpdateFlightPackageStatusesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateFlightPackageStatusesResults = {
  __typename?: 'BulkUpdateFlightPackageStatusesResults';
  /** List of errors encountered during the update */
  errors: Array<BulkUpdateFlightPackegeStatusesError>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateFlightPackagesError = {
  __typename?: 'BulkUpdateFlightPackagesError';
  arrivalGatewayCode: Scalars['String'];
  departureGatewayCode: Scalars['String'];
  lineItemCode: Scalars['LineItemCode'];
  message: Scalars['String'];
};

export type BulkUpdateFlightPackagesInput = {
  arrivalGatewayCode: Scalars['String'];
  basePrice?: InputMaybe<Array<MoneyInput>>;
  businessCode: BusinessCode;
  departureGatewayCode: Scalars['String'];
  isCustomGateway?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type BulkUpdateFlightPackagesResult = BulkUpdateFlightPackagesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidFlightPackageError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateFlightPackagesResults = {
  __typename?: 'BulkUpdateFlightPackagesResults';
  /** List of errors encountered during the update */
  errors: Array<BulkUpdateFlightPackagesError>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateFlightPackegeStatusesError = {
  __typename?: 'BulkUpdateFlightPackegeStatusesError';
  /** ID of the flight package that caused the error */
  _id: Scalars['ObjectId'];
  lineItemCode: Scalars['LineItemCode'];
  message: Scalars['String'];
};

export type BulkUpdateGcDepartureMeetingRsvPsAttendedError = {
  __typename?: 'BulkUpdateGCDepartureMeetingRSVPsAttendedError';
  /** ID of the RSVP that caused the error */
  _id: Scalars['ObjectId'];
  message: Scalars['String'];
};

export type BulkUpdateGcDepartureMeetingRsvPsAttendedInput = {
  /** The value to set for the attended field on each RSVP */
  attended: Scalars['Boolean'];
  /** List of RSVP IDs to update. Cannot exceed 500 items */
  rsvpIds: Array<Scalars['ObjectId']>;
};

export type BulkUpdateGcDepartureMeetingRsvPsAttendedResult = BulkUpdateGcDepartureMeetingRsvPsAttendedResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidGcDepartureMeetingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateGcDepartureMeetingRsvPsAttendedResults = {
  __typename?: 'BulkUpdateGCDepartureMeetingRSVPsAttendedResults';
  /** List of errors encountered during the update */
  errors: Array<BulkUpdateGcDepartureMeetingRsvPsAttendedError>;
  /** Number of RSVPs updated with the attended status */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateInsurancePlanAddonPriceRulesInput = {
  addonPlanCode: Scalars['String'];
  businessCode: BusinessCode;
  planCode: Scalars['String'];
  priceRules: Array<PriceRuleInput>;
};

export type BulkUpdateInsurancePlanAddonPriceRulesResult = BulkUpdateInsurancePlanAddonPriceRulesSuccess | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateInsurancePlanAddonPriceRulesSuccess = {
  __typename?: 'BulkUpdateInsurancePlanAddonPriceRulesSuccess';
  data: Array<InsurancePlan>;
};

export type BulkUpdateInsurancePlanPriceRulesErrorResult = {
  __typename?: 'BulkUpdateInsurancePlanPriceRulesErrorResult';
  /** The input that caused the error */
  input: BulkUpdateInsurancePlanPriceRulesInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateInsurancePlanPriceRulesInput = {
  businessCode: BusinessCode;
  planCode: Scalars['String'];
  priceRules: Array<PriceRuleInput>;
};

export type BulkUpdateInsurancePlanPriceRulesInputObject = {
  __typename?: 'BulkUpdateInsurancePlanPriceRulesInputObject';
  businessCode: BusinessCode;
  planCode: Scalars['String'];
};

export type BulkUpdateInsurancePlanPriceRulesResult = BulkUpdateInsurancePlanPriceRulesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateInsurancePlanPriceRulesResults = {
  __typename?: 'BulkUpdateInsurancePlanPriceRulesResults';
  /** Errors that occurred during update */
  errors: Array<BulkUpdateInsurancePlanPriceRulesErrorResult>;
  /** Successfully updated insurance plans */
  insurancePlans: Array<InsurancePlan>;
};

export enum BulkUpdateLineItemStatus {
  /** The line item is cancelled */
  Cancelled = 'CANCELLED',
  /** The line item is confirmed */
  Confirmed = 'CONFIRMED',
  /** The line item is requested */
  Requested = 'REQUESTED'
}

export type BulkUpdatePlaceErrorResult = {
  __typename?: 'BulkUpdatePlaceErrorResult';
  /** The input that caused the error */
  input: BulkUpdatePlaceInputObject;
  /** Error message */
  message: Scalars['String'];
};

/** Input for updating an existing place */
export type BulkUpdatePlaceInput = {
  /** The ID of the place to update */
  _id: Scalars['ObjectId'];
  /** Optional ISO 3166-1 alpha-2 code for the country. If the place type is not COUNTRY, this field is ignored. */
  alpha2Code?: InputMaybe<Scalars['String']>;
  /** Optional ISO 3166-1 alpha-3 code for the country. If the place type is not COUNTRY, this field is ignored. */
  alpha3Code?: InputMaybe<Scalars['String']>;
  /** Optional Google Place ID for the place */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** The name of the place */
  name?: InputMaybe<Scalars['String']>;
  /** The unique code for the place, which must be alphanumeric and can contain hyphens and underscores only. */
  placeCode?: InputMaybe<Scalars['String']>;
};

export type BulkUpdatePlaceInputObject = {
  __typename?: 'BulkUpdatePlaceInputObject';
  _id: Scalars['ObjectId'];
  alpha2Code?: Maybe<Scalars['String']>;
  alpha3Code?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  placeCode?: Maybe<Scalars['String']>;
};

export type BulkUpdatePlacesResult = BulkUpdatePlacesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPlaceError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdatePlacesResults = {
  __typename?: 'BulkUpdatePlacesResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdatePlaceErrorResult>;
  /** Successfully updated places */
  places: Array<Place>;
};

export type BulkUpdatePrivateGroupPriceRulesErrorResult = {
  __typename?: 'BulkUpdatePrivateGroupPriceRulesErrorResult';
  /** The input that caused the error */
  input: BulkUpdatePrivateGroupPriceRulesInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdatePrivateGroupPriceRulesInput = {
  businessCode: BusinessCode;
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdatePrivateGroupPriceRulesInputObject = {
  __typename?: 'BulkUpdatePrivateGroupPriceRulesInputObject';
  businessCode: BusinessCode;
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdatePrivateGroupPriceRulesResult = BulkUpdatePrivateGroupPriceRulesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidPrivateGroupError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdatePrivateGroupPriceRulesResults = {
  __typename?: 'BulkUpdatePrivateGroupPriceRulesResults';
  /** Errors that occurred during update */
  errors: Array<BulkUpdatePrivateGroupPriceRulesErrorResult>;
  /** Successfully updated tours */
  tours: Array<Tour>;
};

export type BulkUpdatePrivateGroupsErrorResult = {
  __typename?: 'BulkUpdatePrivateGroupsErrorResult';
  /** The input that caused the error */
  input: BulkUpdatePrivateGroupsInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdatePrivateGroupsInput = {
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  priceYear: Scalars['Int'];
  rollsUpToTarget?: Scalars['Boolean'];
  status?: InputMaybe<TripComponentStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdatePrivateGroupsInputObject = {
  __typename?: 'BulkUpdatePrivateGroupsInputObject';
  businessCode: BusinessCode;
  priceYear: Scalars['Int'];
  rollsUpToTarget: Scalars['Boolean'];
  status?: Maybe<TripComponentStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdatePrivateGroupsResult = BulkUpdatePrivateGroupsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidPrivateGroupError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdatePrivateGroupsResults = {
  __typename?: 'BulkUpdatePrivateGroupsResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdatePrivateGroupsErrorResult>;
  /** Successfully updated tours */
  tours: Array<Tour>;
};

export type BulkUpdatePromoErrorResult = {
  __typename?: 'BulkUpdatePromoErrorResult';
  /** The input that caused the error */
  input: BulkUpdatePromoInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdatePromoInput = {
  businessCode: BusinessCode;
  displayName?: InputMaybe<Scalars['String']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']>;
  exclusivity?: InputMaybe<PromoExclusivity>;
  isGroupsOnly?: InputMaybe<Scalars['Boolean']>;
  isHiddenFromSales?: InputMaybe<Scalars['Boolean']>;
  isIndiesOnly?: InputMaybe<Scalars['Boolean']>;
  isShareable?: InputMaybe<Scalars['Boolean']>;
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  offerCode: Scalars['String'];
  promoCategory?: InputMaybe<PromoCategory>;
  status?: InputMaybe<TripComponentStatus>;
};

export type BulkUpdatePromoInputObject = {
  __typename?: 'BulkUpdatePromoInputObject';
  businessCode: BusinessCode;
  offerCode: Scalars['String'];
};

export type BulkUpdatePromosResult = BulkUpdatePromosResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPromoError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdatePromosResults = {
  __typename?: 'BulkUpdatePromosResults';
  /** Errors that occurred during update */
  errors: Array<BulkUpdatePromoErrorResult>;
  /** Successfully updated promos */
  promos: Array<Promo>;
};

export type BulkUpdateTourAirportTransferErrorResult = {
  __typename?: 'BulkUpdateTourAirportTransferErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourAirportTransferInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourAirportTransferInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  businessCode: BusinessCode;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  internalName?: InputMaybe<Scalars['String']>;
  priceYear: Scalars['Int'];
  status?: InputMaybe<TripComponentStatus>;
  /** The time range used to identify the airport transfer */
  timeRange: TimeRangeInput;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourAirportTransferInputObject = {
  __typename?: 'BulkUpdateTourAirportTransferInputObject';
  autoApproveDeadlineDpd?: Maybe<Scalars['Int']>;
  businessCode: BusinessCode;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  internalName?: Maybe<Scalars['String']>;
  priceYear: Scalars['Int'];
  status?: Maybe<TripComponentStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourAirportTransfersPriceRulesErrorResult = {
  __typename?: 'BulkUpdateTourAirportTransfersPriceRulesErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourAirportTransfersPriceRulesInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourAirportTransfersPriceRulesInput = {
  businessCode: BusinessCode;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int'];
  /** The time range used to identify the airport transfer */
  timeRange: TimeRangeInput;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourAirportTransfersPriceRulesInputObject = {
  __typename?: 'BulkUpdateTourAirportTransfersPriceRulesInputObject';
  businessCode: BusinessCode;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourAirportTransfersPriceRulesResult = BulkUpdateTourAirportTransfersPriceRulesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourAirportTransfersPriceRulesResults = {
  __typename?: 'BulkUpdateTourAirportTransfersPriceRulesResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourAirportTransfersPriceRulesErrorResult>;
  /** Successfully updated tours */
  tours: Array<Tour>;
};

export type BulkUpdateTourAirportTransfersResult = BulkUpdateTourAirportTransfersResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidAirportTransferError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourAirportTransfersResults = {
  __typename?: 'BulkUpdateTourAirportTransfersResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourAirportTransferErrorResult>;
  /** Successfully updated tours */
  tours: Array<Tour>;
};

export type BulkUpdateTourErrorResult = {
  __typename?: 'BulkUpdateTourErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExcursionErrorResult = {
  __typename?: 'BulkUpdateTourExcursionErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourExcursionInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExcursionInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  businessCode: BusinessCode;
  matchCode: Scalars['String'];
  /** The minimum number of travelers required for this excursion to be confirmed. */
  minNbTravelersRequired?: InputMaybe<Scalars['Int']>;
  priceYear: Scalars['Int'];
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type BulkUpdateTourExcursionInputObject = {
  __typename?: 'BulkUpdateTourExcursionInputObject';
  autoApproveDeadlineDpd?: Maybe<Scalars['Int']>;
  businessCode: BusinessCode;
  matchCode: Scalars['String'];
  minNbTravelersRequired?: Maybe<Scalars['Int']>;
  priceYear: Scalars['Int'];
  status?: Maybe<TripComponentStatus>;
  tagIds?: Maybe<Array<Scalars['ObjectId']>>;
};

export type BulkUpdateTourExcursionPlacesByCodeErrorResult = {
  __typename?: 'BulkUpdateTourExcursionPlacesByCodeErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourExcursionPlacesByCodeInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExcursionPlacesByCodeInput = {
  action: TourTagAction;
  businessCode: BusinessCode;
  matchCode: Scalars['String'];
  placeCode: Scalars['String'];
  priceYear: Scalars['Int'];
};

export type BulkUpdateTourExcursionPlacesByCodeInputObject = {
  __typename?: 'BulkUpdateTourExcursionPlacesByCodeInputObject';
  action: TourTagAction;
  businessCode: BusinessCode;
  matchCode: Scalars['String'];
  placeCode: Scalars['String'];
  priceYear: Scalars['Int'];
};

export type BulkUpdateTourExcursionPlacesByCodeResult = BulkUpdateTourExcursionPlacesByCodeResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExcursionPlacesByCodeResults = {
  __typename?: 'BulkUpdateTourExcursionPlacesByCodeResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExcursionPlacesByCodeErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateTourExcursionPlacesErrorResult = {
  __typename?: 'BulkUpdateTourExcursionPlacesErrorResult';
  /** ID of the tour excursion that caused the error */
  _id: Scalars['ObjectId'];
  lineItemCode: Scalars['LineItemCode'];
  message: Scalars['String'];
};

export type BulkUpdateTourExcursionPlacesInput = {
  /** List of place IDs to add to the tour excursion. */
  additions: Array<Scalars['ObjectId']>;
  /** List of place IDs to remove from the tour excursion. */
  deletions: Array<Scalars['ObjectId']>;
  /** List of tour excursion IDs of to update. Cannot exceed 500 items */
  excursionIds: Array<Scalars['ObjectId']>;
};

export type BulkUpdateTourExcursionPlacesResult = BulkUpdateTourExcursionPlacesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExcursionPlacesResults = {
  __typename?: 'BulkUpdateTourExcursionPlacesResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExcursionPlacesErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateTourExcursionPriceRulesErrorResult = {
  __typename?: 'BulkUpdateTourExcursionPriceRulesErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourExcursionPriceRulesInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExcursionPriceRulesInput = {
  businessCode: BusinessCode;
  matchCode: Scalars['String'];
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int'];
};

export type BulkUpdateTourExcursionPriceRulesInputObject = {
  __typename?: 'BulkUpdateTourExcursionPriceRulesInputObject';
  businessCode: BusinessCode;
  matchCode: Scalars['String'];
  priceYear: Scalars['Int'];
};

export type BulkUpdateTourExcursionPriceRulesResult = BulkUpdateTourExcursionPriceRulesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExcursionPriceRulesResults = {
  __typename?: 'BulkUpdateTourExcursionPriceRulesResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExcursionPriceRulesErrorResult>;
  /** Successfully updated tour excursions */
  tourExcursions: Array<TourExcursion>;
};

export type BulkUpdateTourExcursionTagErrorResult = {
  __typename?: 'BulkUpdateTourExcursionTagErrorResult';
  /** ID of the tour excursion that caused the error */
  _id: Scalars['ObjectId'];
  lineItemCode: Scalars['LineItemCode'];
  message: Scalars['String'];
};

export type BulkUpdateTourExcursionTagsByNameErrorResult = {
  __typename?: 'BulkUpdateTourExcursionTagsByNameErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourExcursionTagsByNameInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExcursionTagsByNameInput = {
  action: TourTagAction;
  businessCode: BusinessCode;
  categoryName: Scalars['String'];
  matchCode: Scalars['String'];
  priceYear: Scalars['Int'];
  tagName: Scalars['String'];
};

export type BulkUpdateTourExcursionTagsByNameInputObject = {
  __typename?: 'BulkUpdateTourExcursionTagsByNameInputObject';
  action: TourTagAction;
  businessCode: BusinessCode;
  categoryName: Scalars['String'];
  matchCode: Scalars['String'];
  priceYear: Scalars['Int'];
  tagName: Scalars['String'];
};

export type BulkUpdateTourExcursionTagsByNameResult = BulkUpdateTourExcursionTagsByNameResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExcursionTagsByNameResults = {
  __typename?: 'BulkUpdateTourExcursionTagsByNameResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExcursionTagsByNameErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateTourExcursionTagsInput = {
  /** List of tag IDs to add to the tour excursions. */
  additions: Array<Scalars['ObjectId']>;
  /** List of tag IDs to remove from the tour excursions. */
  deletions: Array<Scalars['ObjectId']>;
  /** List of tour excursion IDs to update. Cannot exceed 500 items */
  excursionIds: Array<Scalars['ObjectId']>;
};

export type BulkUpdateTourExcursionTagsResult = BulkUpdateTourExcursionTagsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExcursionTagsResults = {
  __typename?: 'BulkUpdateTourExcursionTagsResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExcursionTagErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateTourExcursionsResult = BulkUpdateTourExcursionsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExcursionsResults = {
  __typename?: 'BulkUpdateTourExcursionsResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExcursionErrorResult>;
  /** Successfully updated tour excursions */
  tourExcursions: Array<TourExcursion>;
};

export type BulkUpdateTourExtensionAirportTransferErrorResult = {
  __typename?: 'BulkUpdateTourExtensionAirportTransferErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourExtensionAirportTransferInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExtensionAirportTransferInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  businessCode: BusinessCode;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  internalName?: InputMaybe<Scalars['String']>;
  priceYear: Scalars['Int'];
  status?: InputMaybe<TripComponentStatus>;
  /** The time range used to identify the airport transfer */
  timeRange: TimeRangeInput;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionAirportTransferInputObject = {
  __typename?: 'BulkUpdateTourExtensionAirportTransferInputObject';
  autoApproveDeadlineDpd?: Maybe<Scalars['Int']>;
  businessCode: BusinessCode;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  internalName?: Maybe<Scalars['String']>;
  priceYear: Scalars['Int'];
  status?: Maybe<TripComponentStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionAirportTransfersPriceRulesErrorResult = {
  __typename?: 'BulkUpdateTourExtensionAirportTransfersPriceRulesErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourExtensionAirportTransfersPriceRulesInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExtensionAirportTransfersPriceRulesInput = {
  businessCode: BusinessCode;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int'];
  /** The time range used to identify the airport transfer */
  timeRange: TimeRangeInput;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionAirportTransfersPriceRulesInputObject = {
  __typename?: 'BulkUpdateTourExtensionAirportTransfersPriceRulesInputObject';
  businessCode: BusinessCode;
  direction: AirportTransferDirection;
  gatewayCode: Scalars['String'];
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionAirportTransfersPriceRulesResult = BulkUpdateTourExtensionAirportTransfersPriceRulesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionAirportTransfersPriceRulesResults = {
  __typename?: 'BulkUpdateTourExtensionAirportTransfersPriceRulesResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExtensionAirportTransfersPriceRulesErrorResult>;
  /** Successfully updated tour extensions */
  tourExtensions: Array<TourExtension>;
};

export type BulkUpdateTourExtensionAirportTransfersResult = BulkUpdateTourExtensionAirportTransfersResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidAirportTransferError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionAirportTransfersResults = {
  __typename?: 'BulkUpdateTourExtensionAirportTransfersResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExtensionAirportTransferErrorResult>;
  /** Successfully updated tour extensions */
  tourExtensions: Array<TourExtension>;
};

export type BulkUpdateTourExtensionErrorResult = {
  __typename?: 'BulkUpdateTourExtensionErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourExtensionInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExtensionInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  businessCode: BusinessCode;
  /** The default capacity that will set for Departures created from this Tour Extension. */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']>;
  isPreExtension?: InputMaybe<Scalars['Boolean']>;
  minimumCapacity?: InputMaybe<Scalars['Int']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  postStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  preStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  priceYear: Scalars['Int'];
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionInputObject = {
  __typename?: 'BulkUpdateTourExtensionInputObject';
  autoApproveDeadlineDpd?: Maybe<Scalars['Int']>;
  businessCode: BusinessCode;
  defaultCapacity?: Maybe<Scalars['Int']>;
  isFlightShoppingAllowed?: Maybe<Scalars['Boolean']>;
  isPreExtension?: Maybe<Scalars['Boolean']>;
  minimumCapacity?: Maybe<Scalars['Int']>;
  placeIds?: Maybe<Array<Scalars['ObjectId']>>;
  postStayCityCodes?: Maybe<Array<Scalars['String']>>;
  preStayCityCodes?: Maybe<Array<Scalars['String']>>;
  priceYear: Scalars['Int'];
  status?: Maybe<TripComponentStatus>;
  tagIds?: Maybe<Array<Scalars['ObjectId']>>;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionPlacesByCodeErrorResult = {
  __typename?: 'BulkUpdateTourExtensionPlacesByCodeErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourExtensionPlacesByCodeInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExtensionPlacesByCodeInput = {
  action: TourTagAction;
  businessCode: BusinessCode;
  placeCode: Scalars['String'];
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionPlacesByCodeInputObject = {
  __typename?: 'BulkUpdateTourExtensionPlacesByCodeInputObject';
  action: TourTagAction;
  businessCode: BusinessCode;
  placeCode: Scalars['String'];
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionPlacesByCodeResult = BulkUpdateTourExtensionPlacesByCodeResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionPlacesByCodeResults = {
  __typename?: 'BulkUpdateTourExtensionPlacesByCodeResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExtensionPlacesByCodeErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateTourExtensionPlacesErrorResult = {
  __typename?: 'BulkUpdateTourExtensionPlacesErrorResult';
  /** ID of the tour extension that caused the error */
  _id: Scalars['ObjectId'];
  lineItemCode: Scalars['LineItemCode'];
  message: Scalars['String'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionPlacesInput = {
  /** List of place IDs to add to the tour extension. */
  additions: Array<Scalars['ObjectId']>;
  /** List of place IDs to remove from the tour extension. */
  deletions: Array<Scalars['ObjectId']>;
  /** List of tour extension IDs of to update. Cannot exceed 500 items */
  extensionIds: Array<Scalars['ObjectId']>;
};

export type BulkUpdateTourExtensionPlacesResult = BulkUpdateTourExtensionPlacesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionPlacesResults = {
  __typename?: 'BulkUpdateTourExtensionPlacesResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExtensionPlacesErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateTourExtensionPriceRulesErrorResult = {
  __typename?: 'BulkUpdateTourExtensionPriceRulesErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourExtensionPriceRulesInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExtensionPriceRulesInput = {
  businessCode: BusinessCode;
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionPriceRulesInputObject = {
  __typename?: 'BulkUpdateTourExtensionPriceRulesInputObject';
  businessCode: BusinessCode;
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionPriceRulesResult = BulkUpdateTourExtensionPriceRulesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionPriceRulesResults = {
  __typename?: 'BulkUpdateTourExtensionPriceRulesResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExtensionPriceRulesErrorResult>;
  /** Successfully updated tour extensions */
  tourExtensions: Array<TourExtension>;
};

export type BulkUpdateTourExtensionRoomErrorResult = {
  __typename?: 'BulkUpdateTourExtensionRoomErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourExtensionRoomInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExtensionRoomInput = {
  basePrice?: InputMaybe<Array<MoneyInput>>;
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']>;
  /** The capacity that will set for Departure Rooms created from this Tour Extension Room. */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  /**
   * Whether or not roommate matching is needed for this room
   * @deprecated Use requiresCompleteRoommates instead.
   */
  enableRoommateMatching?: InputMaybe<Scalars['Boolean']>;
  priceYear: Scalars['Int'];
  /** Whether or not this room must have complete roommates */
  requiresCompleteRoommates?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TripComponentStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionRoomInputObject = {
  __typename?: 'BulkUpdateTourExtensionRoomInputObject';
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: Maybe<Scalars['TourCabinCode']>;
  defaultCapacity?: Maybe<Scalars['Int']>;
  enableRoommateMatching?: Maybe<Scalars['Boolean']>;
  priceYear: Scalars['Int'];
  requiresCompleteRoommates?: Maybe<Scalars['Boolean']>;
  status?: Maybe<TripComponentStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionRoomPriceRulesErrorResult = {
  __typename?: 'BulkUpdateTourExtensionRoomPriceRulesErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourExtensionRoomPriceRulesInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExtensionRoomPriceRulesInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']>;
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionRoomPriceRulesInputObject = {
  __typename?: 'BulkUpdateTourExtensionRoomPriceRulesInputObject';
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: Maybe<Scalars['TourCabinCode']>;
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionRoomPriceRulesResult = BulkUpdateTourExtensionRoomPriceRulesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionRoomPriceRulesResults = {
  __typename?: 'BulkUpdateTourExtensionRoomPriceRulesResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExtensionRoomPriceRulesErrorResult>;
  /** Successfully updated tour extensions */
  tourExtensions: Array<TourExtension>;
};

export type BulkUpdateTourExtensionRoomsResult = BulkUpdateTourExtensionRoomsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionRoomsResults = {
  __typename?: 'BulkUpdateTourExtensionRoomsResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExtensionRoomErrorResult>;
  /** Successfully updated tour extensions */
  tourExtensions: Array<TourExtension>;
};

export type BulkUpdateTourExtensionTagErrorResult = {
  __typename?: 'BulkUpdateTourExtensionTagErrorResult';
  /** ID of the tour extension that caused the error */
  _id: Scalars['ObjectId'];
  lineItemCode: Scalars['LineItemCode'];
  message: Scalars['String'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionTagsByNameErrorResult = {
  __typename?: 'BulkUpdateTourExtensionTagsByNameErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourExtensionTagsByNameInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourExtensionTagsByNameInput = {
  action: TourTagAction;
  businessCode: BusinessCode;
  categoryName: Scalars['String'];
  priceYear: Scalars['Int'];
  tagName: Scalars['String'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionTagsByNameInputObject = {
  __typename?: 'BulkUpdateTourExtensionTagsByNameInputObject';
  action: TourTagAction;
  businessCode: BusinessCode;
  categoryName: Scalars['String'];
  priceYear: Scalars['Int'];
  tagName: Scalars['String'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourExtensionTagsByNameResult = BulkUpdateTourExtensionTagsByNameResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionTagsByNameResults = {
  __typename?: 'BulkUpdateTourExtensionTagsByNameResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExtensionTagsByNameErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateTourExtensionTagsInput = {
  /** List of tag IDs to add to the tour extensions. */
  additions: Array<Scalars['ObjectId']>;
  /** List of tag IDs to remove from the tour extensions. */
  deletions: Array<Scalars['ObjectId']>;
  /** List of tour extension IDs to update. Cannot exceed 500 items */
  extensionIds: Array<Scalars['ObjectId']>;
};

export type BulkUpdateTourExtensionTagsResult = BulkUpdateTourExtensionTagsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionTagsResults = {
  __typename?: 'BulkUpdateTourExtensionTagsResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExtensionTagErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateTourExtensionsResult = BulkUpdateTourExtensionsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourExtensionsResults = {
  __typename?: 'BulkUpdateTourExtensionsResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourExtensionErrorResult>;
  /** Successfully updated tour extensions */
  tourExtensions: Array<TourExtension>;
};

export type BulkUpdateTourInput = {
  activityLevel?: InputMaybe<Scalars['Int']>;
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  businessCode: BusinessCode;
  classLevel?: InputMaybe<Scalars['Int']>;
  /** The default capacity that will set for Departures created from this Tour. */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  deposit?: InputMaybe<Array<MoneyInput>>;
  depositForAutomaticPlan?: InputMaybe<Array<MoneyInput>>;
  depositForLateAdd?: InputMaybe<Array<MoneyInput>>;
  feeCategoryCode?: InputMaybe<Scalars['FeeCategoryCode']>;
  finalInstallmentDeadlineDpd?: InputMaybe<Scalars['Int']>;
  finalPaymentDeadlineDpd?: InputMaybe<Scalars['Int']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']>;
  isNonRevenueTour?: InputMaybe<Scalars['Boolean']>;
  isPassportRequired?: InputMaybe<Scalars['Boolean']>;
  isPostStayAllowed?: InputMaybe<Scalars['Boolean']>;
  isPreStayAllowed?: InputMaybe<Scalars['Boolean']>;
  isVisaRequired?: InputMaybe<Scalars['Boolean']>;
  isWaitlistAllowed?: InputMaybe<Scalars['Boolean']>;
  maxNbTripsPerSelfServiceOrder?: InputMaybe<Scalars['Int']>;
  maxTravelerAge?: InputMaybe<Scalars['Int']>;
  minTravelerAge?: InputMaybe<Scalars['Int']>;
  minimumCapacity?: InputMaybe<Scalars['Int']>;
  nbDepartureFlightDays?: InputMaybe<Scalars['Int']>;
  nbReturningFlightDays?: InputMaybe<Scalars['Int']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  postStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  preStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  priceYear: Scalars['Int'];
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourInputObject = {
  __typename?: 'BulkUpdateTourInputObject';
  activityLevel?: Maybe<Scalars['Int']>;
  autoApproveDeadlineDpd?: Maybe<Scalars['Int']>;
  businessCode: BusinessCode;
  classLevel?: Maybe<Scalars['Int']>;
  defaultCapacity?: Maybe<Scalars['Int']>;
  feeCategoryCode?: Maybe<Scalars['FeeCategoryCode']>;
  finalInstallmentDeadlineDpd?: Maybe<Scalars['Int']>;
  finalPaymentDeadlineDpd?: Maybe<Scalars['Int']>;
  isFlightShoppingAllowed?: Maybe<Scalars['Boolean']>;
  isNonRevenueTour?: Maybe<Scalars['Boolean']>;
  isPassportRequired?: Maybe<Scalars['Boolean']>;
  isPostStayAllowed?: Maybe<Scalars['Boolean']>;
  isPreStayAllowed?: Maybe<Scalars['Boolean']>;
  isVisaRequired?: Maybe<Scalars['Boolean']>;
  isWaitlistAllowed?: Maybe<Scalars['Boolean']>;
  maxNbTripsPerSelfServiceOrder?: Maybe<Scalars['Int']>;
  maxTravelerAge?: Maybe<Scalars['Int']>;
  minTravelerAge?: Maybe<Scalars['Int']>;
  minimumCapacity?: Maybe<Scalars['Int']>;
  nbDepartureFlightDays?: Maybe<Scalars['Int']>;
  nbReturningFlightDays?: Maybe<Scalars['Int']>;
  placeIds?: Maybe<Array<Scalars['ObjectId']>>;
  postStayCityCodes?: Maybe<Array<Scalars['String']>>;
  preStayCityCodes?: Maybe<Array<Scalars['String']>>;
  priceYear: Scalars['Int'];
  status?: Maybe<TripComponentStatus>;
  tagIds?: Maybe<Array<Scalars['ObjectId']>>;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourPlacesByCodeErrorResult = {
  __typename?: 'BulkUpdateTourPlacesByCodeErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourPlacesByCodeInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourPlacesByCodeInput = {
  action: TourTagAction;
  businessCode: BusinessCode;
  placeCode: Scalars['String'];
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourPlacesByCodeInputObject = {
  __typename?: 'BulkUpdateTourPlacesByCodeInputObject';
  action: TourTagAction;
  businessCode: BusinessCode;
  placeCode: Scalars['String'];
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourPlacesByCodeResult = BulkUpdateTourPlacesByCodeResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourPlacesByCodeResults = {
  __typename?: 'BulkUpdateTourPlacesByCodeResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourPlacesByCodeErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateTourPlacesErrorResult = {
  __typename?: 'BulkUpdateTourPlacesErrorResult';
  /** ID of the tour that caused the error */
  _id: Scalars['ObjectId'];
  lineItemCode: Scalars['LineItemCode'];
  message: Scalars['String'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourPlacesInput = {
  /** List of place IDs to add to the tour. */
  additions: Array<Scalars['ObjectId']>;
  /** List of place IDs to remove from the tour. */
  deletions: Array<Scalars['ObjectId']>;
  /** List of tour IDs of to update. Cannot exceed 500 items */
  tourIds: Array<Scalars['ObjectId']>;
};

export type BulkUpdateTourPlacesResult = BulkUpdateTourPlacesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourPlacesResults = {
  __typename?: 'BulkUpdateTourPlacesResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourPlacesErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateTourPriceRulesErrorResult = {
  __typename?: 'BulkUpdateTourPriceRulesErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourPriceRulesInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourPriceRulesInput = {
  businessCode: BusinessCode;
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourPriceRulesInputObject = {
  __typename?: 'BulkUpdateTourPriceRulesInputObject';
  businessCode: BusinessCode;
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourPriceRulesResult = BulkUpdateTourPriceRulesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourPriceRulesResults = {
  __typename?: 'BulkUpdateTourPriceRulesResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourPriceRulesErrorResult>;
  /** Successfully updated tours */
  tours: Array<Tour>;
};

export type BulkUpdateTourRoomErrorResult = {
  __typename?: 'BulkUpdateTourRoomErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourRoomInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourRoomInput = {
  basePrice?: InputMaybe<Array<MoneyInput>>;
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']>;
  /** The capacity that will set for Departure Rooms created from this Tour Room.  */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  /**
   * Whether or not roommate matching is needed for this room
   * @deprecated Use requiresCompleteRoommates instead.
   */
  enableRoommateMatching?: InputMaybe<Scalars['Boolean']>;
  priceYear: Scalars['Int'];
  /** Whether or not this room must have complete roommates */
  requiresCompleteRoommates?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TripComponentStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourRoomInputObject = {
  __typename?: 'BulkUpdateTourRoomInputObject';
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: Maybe<Scalars['TourCabinCode']>;
  defaultCapacity?: Maybe<Scalars['Int']>;
  enableRoommateMatching?: Maybe<Scalars['Boolean']>;
  priceYear: Scalars['Int'];
  requiresCompleteRoommates?: Maybe<Scalars['Boolean']>;
  status?: Maybe<TripComponentStatus>;
  tourCode: Scalars['String'];
};

export type BulkUpdateTourRoomPriceRulesErrorResult = {
  __typename?: 'BulkUpdateTourRoomPriceRulesErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourRoomPriceRulesInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourRoomPriceRulesInput = {
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']>;
  priceRules: Array<PriceRuleInput>;
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourRoomPriceRulesInputObject = {
  __typename?: 'BulkUpdateTourRoomPriceRulesInputObject';
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cabinCode?: Maybe<Scalars['TourCabinCode']>;
  priceYear: Scalars['Int'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourRoomPriceRulesResult = BulkUpdateTourRoomPriceRulesResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourRoomPriceRulesResults = {
  __typename?: 'BulkUpdateTourRoomPriceRulesResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourRoomPriceRulesErrorResult>;
  /** Successfully updated tours */
  tours: Array<Tour>;
};

export type BulkUpdateTourRoomsResult = BulkUpdateTourRoomsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourRoomsResults = {
  __typename?: 'BulkUpdateTourRoomsResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourRoomErrorResult>;
  /** Successfully updated tours */
  tours: Array<Tour>;
};

export type BulkUpdateTourTagErrorResult = {
  __typename?: 'BulkUpdateTourTagErrorResult';
  /** ID of the tour that caused the error */
  _id: Scalars['ObjectId'];
  lineItemCode: Scalars['LineItemCode'];
  message: Scalars['String'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourTagsByNameErrorResult = {
  __typename?: 'BulkUpdateTourTagsByNameErrorResult';
  /** The input that caused the error */
  input: BulkUpdateTourTagsByNameInputObject;
  /** Error message */
  message: Scalars['String'];
};

export type BulkUpdateTourTagsByNameInput = {
  action: TourTagAction;
  businessCode: BusinessCode;
  categoryName: Scalars['String'];
  priceYear: Scalars['Int'];
  tagName: Scalars['String'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourTagsByNameInputObject = {
  __typename?: 'BulkUpdateTourTagsByNameInputObject';
  action: TourTagAction;
  businessCode: BusinessCode;
  categoryName: Scalars['String'];
  priceYear: Scalars['Int'];
  tagName: Scalars['String'];
  tourCode: Scalars['String'];
};

export type BulkUpdateTourTagsByNameResult = BulkUpdateTourTagsByNameResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourTagsByNameResults = {
  __typename?: 'BulkUpdateTourTagsByNameResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourTagsByNameErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateTourTagsInput = {
  /** List of tag IDs to add to the tours. */
  additions: Array<Scalars['ObjectId']>;
  /** List of tag IDs to remove from the tours. */
  deletions: Array<Scalars['ObjectId']>;
  /** List of tour IDs to update. Cannot exceed 500 items */
  tourIds: Array<Scalars['ObjectId']>;
};

export type BulkUpdateTourTagsResult = BulkUpdateTourTagsResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateTourTagsResults = {
  __typename?: 'BulkUpdateTourTagsResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourTagErrorResult>;
  /** Number of records updated */
  nbRecordsUpdated: Scalars['Int'];
};

export type BulkUpdateToursResult = BulkUpdateToursResults | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type BulkUpdateToursResults = {
  __typename?: 'BulkUpdateToursResults';
  /** Errors that occurred during the update */
  errors: Array<BulkUpdateTourErrorResult>;
  /** Successfully updated tours */
  tours: Array<Tour>;
};

/** Represents a business tenant */
export type Business = {
  __typename?: 'Business';
  /** The unique identifier of the business */
  _id: Scalars['ObjectId'];
  code: BusinessCode;
  name: Scalars['String'];
  priceYears: Array<PriceYear>;
  settings: BusinessSettings;
};

export enum BusinessCode {
  Adv = 'ADV',
  Gat = 'GAT',
  Ub = 'UB'
}

/** The CurrentUser is not authorized to perform the requested action */
export type BusinessNotSpecifiedError = DomainError & {
  __typename?: 'BusinessNotSpecifiedError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Object that represents settings specific to a business */
export type BusinessSettings = {
  __typename?: 'BusinessSettings';
  /** Settings for chat functionality and availability */
  chat: ChatSettings;
  /** Customer-specific settings for the business */
  customer: CustomerSettings;
  /** Settings for departure management and timing */
  departures: DepartureSettings;
  /** Settings for customer and tour director evaluations */
  evaluations: EvaluationSettings;
  /** Settings for fee calculation and cancellation policies */
  fees: FeeSettings;
  /** Settings for flight shopping and management */
  flights: FlightSettings;
  /** Settings specific to group coordinator departures */
  gcDepartures: GcDepartureSettings;
  /** Settings for group trip checklist requirements and deadlines */
  groupTripChecklists: GroupTripChecklistSettings;
  /** Settings for travel insurance options and availability */
  insurance: InsuranceSettings;
  /** Settings related to third-party APIs and integrations */
  integrations?: Maybe<IntegrationSettings>;
  /** Settings related to order management and payment processing */
  orders: OrderSettings;
  /** Settings for promotions and service recovery */
  promos: PromoSettings;
  /** Settings for customer reviews and moderation */
  reviews: ReviewSettings;
  /** Settings for support ticket integration and management */
  supportTickets: SupportTicketSettings;
  /** Settings for tour search functionality and filtering */
  tourSearch: TourSearchSettings;
  /** Settings for trip checklist requirements and deadlines */
  tripChecklists: TripChecklistSettings;
  /** Settings for TSA identifier requirements */
  tsa: TsaSettings;
};

export enum CabinClass {
  Business = 'BUSINESS',
  Economy = 'ECONOMY',
  First = 'FIRST',
  PremiumEconomy = 'PREMIUM_ECONOMY'
}

export type CalculatePaymentScheduleInput = {
  frequency: PaymentScheduleFrequency;
  /** An initial amount paid that will discount the payments in the schedule. */
  initialPayment?: InputMaybe<MoneyInput>;
  /** The date of the first scheduled payment. Defaults to the earliest allowed first payment date. */
  startDate?: InputMaybe<Scalars['Date']>;
};

export type CalculatePaymentScheduleResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPaymentScheduleError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | PaymentSchedule | ValidationError;

/** A collection of promotions that are conditionally applied. */
export type Campaign = {
  __typename?: 'Campaign';
  _id: Scalars['ObjectId'];
  campaignCode: Scalars['String'];
  displayName: Scalars['String'];
  /** The date when the promo is applicable and can be used */
  effectiveFrom: Scalars['DateTime'];
  /** The date when the promo expires and is no longer valid. */
  effectiveTo: Scalars['DateTime'];
  isValid: Scalars['Boolean'];
  /** The number of promos associated with the campaign. */
  nbPromos?: Maybe<Scalars['Int']>;
  promoIds: Array<Scalars['ObjectId']>;
  status: CampaignStatus;
};

/** A paginated result of campaigns. */
export type CampaignPaginatedResult = {
  __typename?: 'CampaignPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Campaign>;
};

export enum CampaignStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type CancelDraftBookingInput = {
  /** The draft booking ID */
  _id: Scalars['ObjectId'];
  /** The business reason for the cancellation */
  cancellationCategory: TripCancellationCategory;
  /** A free-text reason for the cancellation */
  cancellationReason: Scalars['String'];
  /** Whether or not to waive the cancellation fee */
  waiveFee?: InputMaybe<Scalars['Boolean']>;
};

export type CancelDraftBookingPaymentScheduleResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidPaymentError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CancelDraftBookingResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CancelDraftBookingTripsInput = {
  /** The draft booking ID */
  _id: Scalars['ObjectId'];
  /** List of cancellation adjustments associated with the specified tripIds. If provided, these adjustments will be applied to the corresponding trips and will remain as confirmed line items after cancellation. */
  cancellationAdjustments?: InputMaybe<Array<CancellationAdjustmentInput>>;
  /** The business reason for the cancellation */
  cancellationCategory: TripCancellationCategory;
  /** A free-text reason for the cancellation */
  cancellationReason: Scalars['String'];
  /** The new primary trip ID, if the primary trip is being cancelled but not all trips are being cancelled */
  newPrimaryTripId?: InputMaybe<Scalars['ObjectId']>;
  /** The trip IDs to cancel */
  tripIds: Array<Scalars['ObjectId']>;
  /** Whether or not to waive the cancellation fee */
  waiveFee?: InputMaybe<Scalars['Boolean']>;
};

export type CancelDraftBookingTripsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CancelGcDepartureInput = {
  /** The ID of the GC Departure to cancel */
  _id: Scalars['ObjectId'];
  /** The business reason for cancelling the GC Departure */
  cancellationCategory: GcDepartureCancellationCategory;
  /** The reason for cancelling the GC Departure */
  reason: Scalars['String'];
};

export type CancelGcDepartureMeetingInput = {
  _id: Scalars['ObjectId'];
};

export type CancelGcDepartureMeetingResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDepartureMeeting | InvalidDateError | InvalidDateRangeError | InvalidGcDepartureMeetingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CancelGcDepartureResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDeparture | InvalidDateError | InvalidDateRangeError | InvalidGcDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Adjustments to apply to cancelled trip */
export type CancellationAdjustmentInput = {
  /** List of adjustments associated with the specified tripId. These adjustments will be applied to the corresponding trip and will remain as confirmed line items after cancellation. */
  adjustments: Array<AdjustmentInput>;
  /** The trip ID to apply the adjustment to */
  tripId: Scalars['ObjectId'];
};

export type CancellationFeeEstimation = {
  __typename?: 'CancellationFeeEstimation';
  /** Computed effective cancellation DPD for a trip */
  effectiveDpd: Scalars['Int'];
  /** The trip from the rebooking chain used to calculate the effective cancellation DPD */
  lowestDpdRebookingChainTrip?: Maybe<Trip>;
  /** The estimated price to cancel a trip */
  price: Money;
  /** Whether the lowest DPD was used in the rebooking chain when calculating the effective cancellation DPD */
  useLowestDpdInRebookingChain: Scalars['Boolean'];
};

export enum CardBrand {
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  Mastercard = 'MASTERCARD',
  Unknown = 'UNKNOWN',
  Visa = 'VISA'
}

export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  address?: Maybe<Address>;
  cardBrand: CardBrand;
  cardNumberMask: Scalars['String'];
  cardType: CardType;
  expirationMonth: Scalars['Int'];
  expirationYear: Scalars['Int'];
  firstName: Scalars['String'];
  isExpired: Scalars['Boolean'];
  lastName: Scalars['String'];
  processorPaymentMethodId?: Maybe<Scalars['Int']>;
};

export enum CardType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Unknown = 'UNKNOWN'
}

/** A category organizes tags into a hierarchy */
export type Category = {
  __typename?: 'Category';
  _id: Scalars['ObjectId'];
  businessCode?: Maybe<BusinessCode>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tags: Array<Tag>;
};

/** A paginated set of Categories */
export type CategoryPaginatedResult = {
  __typename?: 'CategoryPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Category>;
};

/** Inputs necessary to change the expiration date of a voucher */
export type ChangeVoucherExpirationInput = {
  _id: Scalars['ObjectId'];
  expirationDate: Scalars['Date'];
};

export type ChangeVoucherExpirationResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** Chat Settings */
export type ChatSettings = {
  __typename?: 'ChatSettings';
  /** The DPD in which the chat is open for the departure, checks if the channel exists and if today is within the chat open range */
  availabilityDpd?: Maybe<Scalars['Int']>;
  /** The DPD in which the tour director is available for the customer to send a direct message */
  tourDirectorDirectMessageDpd?: Maybe<Scalars['Int']>;
};

export enum CheckListItemImportanceLevel {
  HighlyRecommended = 'HIGHLY_RECOMMENDED',
  Recommended = 'RECOMMENDED',
  Required = 'REQUIRED'
}

export type CheckPaymentMethod = {
  __typename?: 'CheckPaymentMethod';
  checkNumber?: Maybe<Scalars['String']>;
  isFromLockbox: Scalars['Boolean'];
};

export type CheckPaymentMethodInput = {
  /** The 3-6 digit number to identify the check */
  checkNumber?: InputMaybe<Scalars['String']>;
  /** Date we received the check */
  checkReceivedDate?: InputMaybe<Scalars['Date']>;
  /** Was this check processed via lockbox */
  isFromLockBox?: InputMaybe<Scalars['Boolean']>;
};

export type CheckTripChecklistItemResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTripChecklistItemTemplateError | NotAuthorizedError | NotFoundError | TripChecklistItemState | ValidationError;

export type City = Place & {
  __typename?: 'City';
  _id: Scalars['ObjectId'];
  /** Ancestry of the place with resolved ancestors (e.g. parent places, grandparent places, etc.). Avoid using with nested place queries as it can lead to performance issues. */
  ancestry: Array<PlaceWithAncestry>;
  monthlyWeathers: Array<MonthlyWeather>;
  name: Scalars['String'];
  parentIds: Array<Scalars['ObjectId']>;
  /** Parent places of the place, e.g. country for a city, continent for a country, etc. */
  parents: Array<Place>;
  /** The place code is a unique identifier for the place, used for global identification. */
  placeCode: Scalars['String'];
  type: PlaceType;
};

export type ClaimExperimentalLeadResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ExperimentalLead | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type ConditionalOffer = {
  __typename?: 'ConditionalOffer';
  /** The application status of the promo target. */
  applicationStatus: PromoTargetApplicationStatus;
  /** The Promo Target that the trip is eligible for. */
  target: PromoTarget;
};

export type ConfirmGcDepartureResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDeparture | InvalidDateError | InvalidDateRangeError | InvalidGcDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type ConnectReferralInput = {
  advocateCustomerId: Scalars['ObjectId'];
  businessCode: BusinessCode;
  friendCustomerId: Scalars['ObjectId'];
};

export type ConnectReferralPayload = {
  __typename?: 'ConnectReferralPayload';
  advocateCustomerId: Scalars['ObjectId'];
  friendBookingId?: Maybe<Scalars['ObjectId']>;
  friendCustomerId: Scalars['ObjectId'];
  friendHasBooking: Scalars['Boolean'];
  friendRewardBalance?: Maybe<Money>;
};

export type ConnectReferralResult = BusinessNotSpecifiedError | ConnectReferralPayload | DuplicateUniqueKeyError | IncentivesError | IncentivesIntegrationDisabledError | InvalidDateError | InvalidDateRangeError | InvalidReferralError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type ContactInfoContent = {
  __typename?: 'ContactInfoContent';
  address: ContactInfoContentAddress;
  groupSales?: Maybe<ContactInfoContentDepartment>;
  groupService?: Maybe<ContactInfoContentDepartment>;
  id: Scalars['String'];
  indiesSales?: Maybe<ContactInfoContentDepartment>;
  indiesService?: Maybe<ContactInfoContentDepartment>;
  onTourSupport?: Maybe<ContactInfoContentDepartment>;
};

export type ContactInfoContentAddress = {
  __typename?: 'ContactInfoContentAddress';
  addressName?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** Contact information for a specific department. Null for workHours just indicates that work hours have not been configured. */
export type ContactInfoContentDepartment = {
  __typename?: 'ContactInfoContentDepartment';
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberFormatted?: Maybe<Scalars['String']>;
  schedulingLink?: Maybe<ContentLink>;
  title?: Maybe<Scalars['String']>;
  workHoursFriday?: Maybe<ContactInfoContentWorkHours>;
  workHoursMonday?: Maybe<ContactInfoContentWorkHours>;
  workHoursSaturday?: Maybe<ContactInfoContentWorkHours>;
  workHoursSunday?: Maybe<ContactInfoContentWorkHours>;
  workHoursThursday?: Maybe<ContactInfoContentWorkHours>;
  workHoursTuesday?: Maybe<ContactInfoContentWorkHours>;
  workHoursWednesday?: Maybe<ContactInfoContentWorkHours>;
};

export type ContactInfoContentWorkHours = {
  __typename?: 'ContactInfoContentWorkHours';
  endTime?: Maybe<Scalars['String']>;
  /** Override startTime and endTime to indicate that office is closed. */
  isClosed?: Maybe<Scalars['Boolean']>;
  startTime?: Maybe<Scalars['String']>;
};

/** Ancestor stories of content. Useful for generating breadcrumbs. */
export type ContentAncestor = {
  __typename?: 'ContentAncestor';
  fullSlug: Scalars['String'];
  name: Scalars['String'];
};

export type ContentAsset = {
  __typename?: 'ContentAsset';
  alt?: Maybe<Scalars['String']>;
  copyright?: Maybe<Scalars['String']>;
  fieldType?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  focus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Storyblok link type */
export type ContentLink = {
  __typename?: 'ContentLink';
  cachedUrl?: Maybe<Scalars['String']>;
  fieldType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  linkType?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Blok containing text and a link */
export type ContentTextLink = {
  __typename?: 'ContentTextLink';
  link?: Maybe<ContentLink>;
  text?: Maybe<Scalars['String']>;
};

export type Continent = Place & {
  __typename?: 'Continent';
  _id: Scalars['ObjectId'];
  /** Direct child places of this continent. */
  children: Array<Place>;
  name: Scalars['String'];
  /** The place code is a unique identifier for the place, used for global identification. */
  placeCode: Scalars['String'];
  type: PlaceType;
};

/** Geographic coordinate with latitude and longitude */
export type Coordinate = {
  __typename?: 'Coordinate';
  /** Latitude in decimal degrees */
  latitude: Scalars['Float'];
  /** Longitude in decimal degrees */
  longitude: Scalars['Float'];
};

export type Country = Place & {
  __typename?: 'Country';
  _id: Scalars['ObjectId'];
  /** Two-letter country code as defined in ISO 3166 */
  alpha2Code: Scalars['String'];
  /** Three-letter country code as defined in ISO 3166 */
  alpha3Code: Scalars['String'];
  /** Ancestry of the place, resolved ancestors (e.g. parent places, grandparent places, etc.). Avoid using with nested place queries as it can lead to performance issues. */
  ancestry: Array<PlaceWithAncestry>;
  /** Geographic location of the country */
  location: Coordinate;
  name: Scalars['String'];
  parentIds: Array<Scalars['ObjectId']>;
  /** Parent places of the place, e.g. country for a city, continent for a country, etc. */
  parents: Array<Place>;
  /** The place code is a unique identifier for the place, used for global identification. */
  placeCode: Scalars['String'];
  type: PlaceType;
  /** Viewport bounds that frame the country */
  viewport: Viewport;
};

export type CountryRegion = Place & {
  __typename?: 'CountryRegion';
  _id: Scalars['ObjectId'];
  /** Ancestry of the place, resolved ancestors (e.g. parent places, grandparent places, etc.). Avoid using with nested place queries as it can lead to performance issues. */
  ancestry: Array<PlaceWithAncestry>;
  name: Scalars['String'];
  parentIds: Array<Scalars['ObjectId']>;
  /** Parent places of the place, e.g. country for a city, continent for a country, etc. */
  parents: Array<Place>;
  /** The place code is a unique identifier for the place, used for global identification. */
  placeCode: Scalars['String'];
  type: PlaceType;
};

export type CreateAdjustmentInput = {
  adjustmentCode: Scalars['String'];
  businessCode: BusinessCode;
  displayName: Scalars['String'];
  isEligibleForRolloverOnRebooking?: InputMaybe<Scalars['Boolean']>;
  isRefundable?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<CreateAdjustmentMetaInput>;
  persistsOnCancelAndRebook?: InputMaybe<Scalars['Boolean']>;
  rollsUpToTarget?: InputMaybe<Scalars['Boolean']>;
  tagIds?: Array<Scalars['ObjectId']>;
};

export type CreateAdjustmentMetaInput = {
  isCompanionDiscount: Scalars['Boolean'];
  isFreePlace: Scalars['Boolean'];
  isStaffOnTour: Scalars['Boolean'];
};

export type CreateAdjustmentResult = Adjustment | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateApiKeyInput = {
  description: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  roleIds: Array<Scalars['ObjectId']>;
};

export type CreateApiKeyResult = ApiKeyResult | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateAudienceInput = {
  businessCode: BusinessCode;
  name: Scalars['String'];
};

export type CreateAudienceResult = Audience | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidAudienceError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateCampaignInput = {
  businessCode: BusinessCode;
  campaignCode: Scalars['String'];
  displayName: Scalars['String'];
  effectiveFrom: Scalars['DateTime'];
  effectiveTo: Scalars['DateTime'];
  promoIds: Array<Scalars['ObjectId']>;
};

export type CreateCampaignResult = BusinessNotSpecifiedError | Campaign | DuplicateUniqueKeyError | InvalidCampaignError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Create a new category */
export type CreateCategoryInput = {
  businessCode: BusinessCode;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type CreateCategoryResult = BusinessNotSpecifiedError | Category | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Create a new customer */
export type CreateCustomerInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
};

export type CreateCustomerResult = BusinessNotSpecifiedError | Customer | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateDepartureExcursionInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  lineItemCode: Scalars['LineItemCode'];
};

export type CreateDepartureExcursionResult = BusinessNotSpecifiedError | DepartureExcursion | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateDepartureExtensionExcursionInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  lineItemCode: Scalars['LineItemCode'];
};

export type CreateDepartureExtensionExcursionResult = BusinessNotSpecifiedError | DepartureExcursion | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateDepartureExtensionInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  lineItemCode: Scalars['LineItemCode'];
};

export type CreateDepartureExtensionResult = BusinessNotSpecifiedError | DepartureExtension | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateDepartureExtensionRoomInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  lineItemCode: Scalars['LineItemCode'];
};

export type CreateDepartureExtensionRoomResult = BusinessNotSpecifiedError | DepartureRoom | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateDepartureRoomInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  lineItemCode: Scalars['LineItemCode'];
};

export type CreateDepartureRoomResult = BusinessNotSpecifiedError | DepartureRoom | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateDraftOrderResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Create a draft term */
export type CreateDraftTermInput = {
  businessCode: BusinessCode;
  certificationText?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['JSON']>;
  market: TermMarket;
  termType: TermType;
};

export type CreateDraftTermResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Term | ValidationError;

export type CreateExperimentalLeadInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId: Scalars['ObjectId'];
  description?: InputMaybe<Scalars['String']>;
  experimentName?: InputMaybe<Scalars['String']>;
  interactionDate?: InputMaybe<Scalars['DateTime']>;
  location?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  talkingPoints?: InputMaybe<Array<TalkingPointInput>>;
  tourCode?: InputMaybe<Scalars['String']>;
};

export type CreateExperimentalLeadResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ExperimentalLead | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateExtendedStayInput = {
  basePrice: Array<MoneyInput>;
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cityCode: Scalars['String'];
};

export type CreateExtendedStayInputObject = {
  __typename?: 'CreateExtendedStayInputObject';
  bedCode: TourBedCode;
  businessCode: BusinessCode;
  cityCode: Scalars['String'];
};

export type CreateExtendedStayResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ExtendedStay | InvalidDateError | InvalidDateRangeError | InvalidExtendedStayError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Create a new fee */
export type CreateFeeInput = {
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  categoryCode: Scalars['FeeCategoryCode'];
  isRefundable?: InputMaybe<Scalars['Boolean']>;
  persistsOnRebooking?: Scalars['Boolean'];
  rollsUpToTarget?: InputMaybe<Scalars['Boolean']>;
  typeCode: FeeTypeCode;
};

export type CreateFeeResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | Fee | InvalidDateError | InvalidDateRangeError | InvalidFeeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateFlightPackageInput = {
  arrivalGatewayCode: Scalars['String'];
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  departureGatewayCode: Scalars['String'];
  isCustomGateway: Scalars['Boolean'];
};

export type CreateFlightPackageResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightPackage | InvalidDateError | InvalidDateRangeError | InvalidFlightPackageError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Input for creating a GC Departure */
export type CreateGcDepartureInput = {
  companionDiscountRate: Scalars['Float'];
  departureId: Scalars['ObjectId'];
  expectedVolume?: InputMaybe<Scalars['Int']>;
  freeInsuranceRatio: Scalars['FreePlaceRatio'];
  freePlaceRatio: Scalars['FreePlaceRatio'];
  groupCoordinatorCustomerId: Scalars['ObjectId'];
  groupSizeEstimate?: InputMaybe<Scalars['Int']>;
  includePrivateGroupFee?: InputMaybe<Scalars['Boolean']>;
  lineItemRules?: InputMaybe<Array<CreateGcDepartureLineItemRuleInput>>;
  micrositeUrl?: InputMaybe<Scalars['String']>;
  opportunityId?: InputMaybe<Scalars['String']>;
  primaryCurrencyCode: CurrencyCode;
  recruitmentMeetingDate?: InputMaybe<Scalars['Date']>;
  stipendRate: Scalars['Float'];
};

/** The input for creating a GC Departure Line Item Rule */
export type CreateGcDepartureLineItemRuleInput = {
  level: GcDepartureRuleLevel;
  lineItemCode: Scalars['LineItemCode'];
  lineItemType: GcDepartureRuleLineItemType;
};

export type CreateGcDepartureMeetingInput = {
  allowsLateRSVP?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  gcDepartureId: Scalars['ObjectId'];
  location?: InputMaybe<Scalars['String']>;
  meetingDateEnd: Scalars['DateTime'];
  meetingDateStart: Scalars['DateTime'];
  rsvpDueDate: Scalars['Date'];
  style: MeetingStyle;
  timezone: Scalars['String'];
  virtualMeetingLink?: InputMaybe<Scalars['String']>;
};

export type CreateGcDepartureMeetingRsvpInput = {
  email?: InputMaybe<Scalars['Email']>;
  firstName: Scalars['String'];
  ignoreRsvpPeriod?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  meetingId: Scalars['ObjectId'];
  notes?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  response: GcDepartureMeetingRsvpResponse;
};

export type CreateGcDepartureMeetingRsvpResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDepartureMeetingRsvp | InvalidDateError | InvalidDateRangeError | InvalidGcDepartureMeetingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateGcDepartureMeetingResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDepartureMeeting | InvalidDateError | InvalidDateRangeError | InvalidGcDepartureMeetingError | InvalidTimeRangeError | InvalidTimezoneError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateGcDepartureResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDeparture | InvalidDateError | InvalidDateRangeError | InvalidGcDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateInsuranceExtensionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsuranceExtension | InvalidDateError | InvalidDateRangeError | InvalidInsurancePlanError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateInsurancePlanAddonInput = {
  basePrice: Array<MoneyInput>;
  includedWithinDays?: InputMaybe<Scalars['Int']>;
  /** A code specific to this insurance plan addon */
  insurancePlanAddonCode: Scalars['String'];
  internalName: Scalars['String'];
  preventPurchaseAfterDays?: InputMaybe<Scalars['Int']>;
};

export type CreateInsurancePlanAddonResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePlanAddon | InvalidDateError | InvalidDateRangeError | InvalidInsurancePlanError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateInsurancePlanInput = {
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  effectiveFrom: Scalars['DateTime'];
  effectiveTo: Scalars['DateTime'];
  internalName: Scalars['String'];
  isEligibleForRolloverOnRebooking?: InputMaybe<Scalars['Boolean']>;
  planCode: Scalars['String'];
  policyId: Scalars['ObjectId'];
  /** The insurance plan will become available starting from the specified number of days after the booking date */
  purchasableAfterDays?: InputMaybe<Scalars['Int']>;
  /** The insurance plan will be available during the quote process and for the specified number of days after booking */
  purchasableWithinDays?: InputMaybe<Scalars['Int']>;
};

export type CreateInsurancePlanResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePlan | InvalidDateError | InvalidDateRangeError | InvalidInsurancePlanError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateInsurancePolicyInput = {
  businessCode: BusinessCode;
  coversPreExistingConditions?: InputMaybe<Scalars['Boolean']>;
  friendlyName?: InputMaybe<Scalars['String']>;
  internalName?: InputMaybe<Scalars['String']>;
  providerName: Scalars['String'];
};

export type CreateInsurancePolicyResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePolicy | InvalidDateError | InvalidDateRangeError | InvalidInsurancePolicyError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateInsurancePolicyRevisionInput = {
  carrier?: InputMaybe<Scalars['String']>;
  /** Co-pay amount for the insurance plan */
  copay?: InputMaybe<MoneyInput>;
  /** Deductible amount for the insurance plan */
  deductible?: InputMaybe<MoneyInput>;
  effectiveFrom: Scalars['DateTime'];
  effectiveTo: Scalars['DateTime'];
  /** Maximum coverage for emergency medical evacuation and return of mortal remains */
  emergencyMedicalMaximum?: InputMaybe<MoneyInput>;
  freeLookPeriodDays: Scalars['Int'];
  grossWrittenPremium?: InputMaybe<MoneyInput>;
  /** Maximum coverage amount for medical expenses */
  medicalMaximum?: InputMaybe<MoneyInput>;
  policyNumber: Scalars['String'];
  programCode?: InputMaybe<Scalars['String']>;
  /** Maximum coverage amount for travel delay expenses */
  travelDelayMaximum?: InputMaybe<MoneyInput>;
};

export type CreateInsurancePolicyRevisionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsuranceRevision | InvalidDateError | InvalidDateRangeError | InvalidInsurancePolicyError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreateNoteInput = {
  content: Scalars['String'];
  /** The id of the entity this note applies to */
  targetId: Scalars['ObjectId'];
};

export type CreateNoteResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Note | ValidationError;

export type CreateOAuthClientInput = {
  clientName: Scalars['String'];
  redirectUris: Array<Scalars['String']>;
  scope: Scalars['String'];
  tokenEndpointAuthMethod?: InputMaybe<TokenEndpointAuthMethod>;
};

export type CreateOAuthClientResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | OAuthClientWithSecret | ValidationError;

/** Input for creating a new place */
export type CreatePlaceInput = {
  /** Optional ISO 3166-1 alpha-2 code for the country. If the place type is not COUNTRY, this field is ignored. */
  alpha2Code?: InputMaybe<Scalars['String']>;
  /** Optional ISO 3166-1 alpha-3 code for the country. If the place type is not COUNTRY, this field is ignored. */
  alpha3Code?: InputMaybe<Scalars['String']>;
  /** Optional Google Place ID for the place */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** Optional location for the place */
  location?: InputMaybe<CreatePlaceLocationInput>;
  /** The name of the place */
  name: Scalars['String'];
  /** Optional parent place IDs for hierarchical structure */
  parentIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** A unique code for the place, must be alphanumeric and can contain hyphens and underscores only. */
  placeCode: Scalars['String'];
  /** The type of place (e.g., country, city, continent, etc.) */
  type: PlaceType;
  /** Optional viewport for the place */
  viewport?: InputMaybe<CreatePlaceViewportInput>;
};

/** Input for creating a new coordinate on a place */
export type CreatePlaceLocationInput = {
  /** Latitude in decimal degrees */
  latitude: Scalars['Float'];
  /** Longitude in decimal degrees */
  longitude: Scalars['Float'];
};

export type CreatePlaceResult = BusinessNotSpecifiedError | CreatePlaceSuccess | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPlaceError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type CreatePlaceSuccess = {
  __typename?: 'CreatePlaceSuccess';
  data: Place;
};

/** Input for creating a new viewport on a place */
export type CreatePlaceViewportInput = {
  /** North-east coordinate */
  high: CreatePlaceLocationInput;
  /** South-west coordinate */
  low: CreatePlaceLocationInput;
};

export type CreatePromoInput = {
  businessCode: BusinessCode;
  customerIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  displayName: Scalars['String'];
  effectiveFrom: Scalars['DateTime'];
  effectiveTo: Scalars['DateTime'];
  exclusivity: PromoExclusivity;
  gcDepartureIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  isGroupsOnly?: Scalars['Boolean'];
  isHiddenFromSales?: Scalars['Boolean'];
  isIndiesOnly?: Scalars['Boolean'];
  isShareable?: Scalars['Boolean'];
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  offerCode: Scalars['String'];
  promoCategory?: InputMaybe<PromoCategory>;
  promoCodes: Array<Scalars['String']>;
};

export type CreatePromoInputObject = {
  __typename?: 'CreatePromoInputObject';
  businessCode: BusinessCode;
  displayName: Scalars['String'];
  offerCode: Scalars['String'];
  promoCodes: Array<Scalars['String']>;
};

export type CreatePromoResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPromoError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

/** Create a new promo target */
export type CreatePromoTargetInput = {
  amount: Array<MoneyInput>;
  componentType: TripComponentType;
  departureDateFrom?: InputMaybe<Scalars['Date']>;
  departureDateTo?: InputMaybe<Scalars['Date']>;
  lineItemCode?: InputMaybe<Scalars['LineItemCode']>;
  requiredComponent?: InputMaybe<PromoTargetRequiredComponentInput>;
  series?: InputMaybe<Scalars['Series']>;
};

/** Written review from the Customer */
export type CreateReviewDetailInput = {
  author?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

/** Create a new review */
export type CreateReviewInput = {
  detail?: InputMaybe<CreateReviewDetailInput>;
  rating: Scalars['Int'];
  tripId: Scalars['ObjectId'];
};

export type CreateReviewResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidRatingError | InvalidReviewError | InvalidReviewResponseError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Review | ValidationError;

export type CreateRoleInput = {
  businessCode?: InputMaybe<BusinessCode>;
  name: Scalars['String'];
  permissionKeys: Array<PermissionKey>;
};

export type CreateRoleResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Role | ValidationError;

/** Create a saved place */
export type CreateSavedPlaceInput = {
  /** Business code associated with the saved place */
  businessCode: BusinessCode;
  /** Google Place ID for the location */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** Geographic location of the place */
  location?: InputMaybe<CreateSavedPlaceLocationInput>;
  /** Display name of the place */
  name?: InputMaybe<Scalars['String']>;
  /** Place ID for the location */
  placeId?: InputMaybe<Scalars['ObjectId']>;
  /** An array of types that apply to this place. Example: [locality, political] */
  types?: InputMaybe<Array<Scalars['String']>>;
  /** Whether the user has visited the place */
  userHasVisited?: InputMaybe<Scalars['Boolean']>;
  /** Whether the user wants to visit the place */
  userWantsToVisit?: InputMaybe<Scalars['Boolean']>;
  /** Viewport bounds that frame the place */
  viewport?: InputMaybe<CreateSavedPlaceViewportInput>;
};

/** Coordinates for the saved place location */
export type CreateSavedPlaceLocationInput = {
  /** Latitude in decimal degrees */
  latitude: Scalars['Float'];
  /** Longitude in decimal degrees */
  longitude: Scalars['Float'];
};

/** Viewport bounds for the saved place */
export type CreateSavedPlaceViewportInput = {
  /** North-east coordinate */
  high: CreateSavedPlaceLocationInput;
  /** South-west coordinate */
  low: CreateSavedPlaceLocationInput;
};

export type CreateServiceRecoveryPromoInput = {
  amount: Scalars['Float'];
  businessCode: BusinessCode;
  expiryDate: Scalars['DateTime'];
  notes?: InputMaybe<Scalars['String']>;
  offerCode: Scalars['String'];
  recoveryReason: Scalars['String'];
  tripId: Scalars['ObjectId'];
};

export type CreateServiceRecoveryPromoResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPromoError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ServiceRecovery | ValidationError;

export type CreateSupportTicketResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | SupportTicketError | SupportTicketSuccess | ValidationError;

/** Create a new tag */
export type CreateTagInput = {
  categoryId: Scalars['ObjectId'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateTagResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Tag | ValidationError;

export type CreateTourExcursionInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  matchCode: Scalars['String'];
  minNbTravelersRequired: Scalars['Int'];
  placeIds?: Array<Scalars['ObjectId']>;
  priceYear: Scalars['Int'];
  tagIds?: Array<Scalars['ObjectId']>;
};

export type CreateTourExcursionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | TourExcursion | ValidationError;

export type CreateTourExtensionInput = {
  autoApproveDeadlineDpd: Scalars['Int'];
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  /** The default capacity that will set for departures created from this Extension. */
  defaultCapacity: Scalars['Int'];
  isFlightShoppingAllowed?: Scalars['Boolean'];
  isPreExtension?: Scalars['Boolean'];
  minimumCapacity?: Scalars['Int'];
  placeIds?: Array<Scalars['ObjectId']>;
  postStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  preStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  priceYear: Scalars['Int'];
  rooms?: Array<CreateTourRoomInput>;
  tagIds?: Array<Scalars['ObjectId']>;
  /** The extension tour code. */
  tourCode: Scalars['String'];
};

export type CreateTourExtensionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | TourExtension | ValidationError;

export type CreateTourExtensionRoomInput = {
  basePrice: Array<MoneyInput>;
  bedCode: TourBedCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']>;
  /** The default capacity that will set for Departure Rooms created from this Tour Room. Defaults to the Tour Extension capacity */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  /**
   * Whether or not roommate matching is needed for this room
   * @deprecated Use requiresCompleteRoommates instead.
   */
  enableRoommateMatching?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not this room must have complete roommates */
  requiresCompleteRoommates?: Scalars['Boolean'];
};

export type CreateTourExtensionRoomResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | TourRoom | ValidationError;

/** Create a new tour in a specific tour year */
export type CreateTourInput = {
  activityLevel?: Scalars['Int'];
  autoApproveDeadlineDpd: Scalars['Int'];
  basePrice: Array<MoneyInput>;
  businessCode: BusinessCode;
  classLevel?: Scalars['Int'];
  defaultCapacity: Scalars['Int'];
  deposit: Array<MoneyInput>;
  depositForAutomaticPlan: Array<MoneyInput>;
  depositForLateAdd: Array<MoneyInput>;
  feeCategoryCode: Scalars['FeeCategoryCode'];
  finalInstallmentDeadlineDpd: Scalars['Int'];
  finalPaymentDeadlineDpd: Scalars['Int'];
  isFlightShoppingAllowed: Scalars['Boolean'];
  isNonRevenueTour: Scalars['Boolean'];
  isPassportRequired: Scalars['Boolean'];
  isPostStayAllowed: Scalars['Boolean'];
  isPreStayAllowed: Scalars['Boolean'];
  isVisaRequired: Scalars['Boolean'];
  isWaitlistAllowed: Scalars['Boolean'];
  maxNbTripsPerSelfServiceOrder: Scalars['Int'];
  maxTravelerAge?: InputMaybe<Scalars['Int']>;
  minTravelerAge?: InputMaybe<Scalars['Int']>;
  minimumCapacity?: Scalars['Int'];
  nbDepartureFlightDays: Scalars['Int'];
  nbReturningFlightDays: Scalars['Int'];
  placeIds?: Array<Scalars['ObjectId']>;
  postStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  preStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  priceYear: Scalars['Int'];
  rooms?: Array<CreateTourRoomInput>;
  tagIds?: Array<Scalars['ObjectId']>;
  tourCode: Scalars['String'];
};

export type CreateTourResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type CreateTourRoomInput = {
  basePrice: Array<MoneyInput>;
  bedCode: TourBedCode;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']>;
  /** The default capacity that will set for Departure Rooms created from this Tour Room. Defaults to the Tour capacity. */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  /**
   * Whether or not roommate matching is needed for this room
   * @deprecated Use requiresCompleteRoommates instead.
   */
  enableRoommateMatching?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not this room must have complete roommates */
  requiresCompleteRoommates?: Scalars['Boolean'];
};

export type CreateTourRoomResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | TourRoom | ValidationError;

export type CreateTripChecklistItemTemplateInput = {
  businessCode: BusinessCode;
  description: Scalars['String'];
  dpd: Scalars['Int'];
  effectiveFrom: Scalars['Date'];
  effectiveTo: Scalars['Date'];
  excludeTourCodes?: InputMaybe<Array<Scalars['String']>>;
  importanceLevel: CheckListItemImportanceLevel;
  includeTourCodes?: InputMaybe<Array<Scalars['String']>>;
  internalName: Scalars['String'];
  title: Scalars['String'];
};

export type CreateTripChecklistItemTemplateResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTripChecklistItemTemplateError | NotAuthorizedError | NotFoundError | TripChecklistItemTemplate | ValidationError;

/** Inputs necessary to create a voucher that originates from a booking */
export type CreateVoucherFromBookingInput = {
  bookingId: Scalars['ObjectId'];
  customerId: Scalars['ObjectId'];
  expirationDate: Scalars['Date'];
  initialAmount: MoneyInput;
  isRefundable: Scalars['Boolean'];
  /** @deprecated Use voucherReason instead */
  reason?: InputMaybe<CreditReasonCode>;
  voucherReason?: InputMaybe<VoucherReason>;
};

export type CreateVoucherFromBookingResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidMoneyError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** Create a voucher that originates from a different system and non WOJO EF Product */
export type CreateVoucherFromExternalInput = {
  businessCode: BusinessCode;
  customerId: Scalars['ObjectId'];
  expirationDate: Scalars['Date'];
  initialAmount: MoneyInput;
  isRefundable: Scalars['Boolean'];
  transferBusinessUnit: Scalars['String'];
};

export type CreateVoucherFromExternalResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** Creates a new wishlist item */
export type CreateWishlistItemInput = {
  businessCode: BusinessCode;
  customerId: Scalars['ObjectId'];
  tourCode: Scalars['String'];
};

export type CreateWishlistItemResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError | WishlistItem;

/** A transaction that debits a payment method */
export type CreditPaymentTransaction = PaymentTransaction & {
  __typename?: 'CreditPaymentTransaction';
  _id: Scalars['ObjectId'];
  amount: Money;
  /** The customer of this transaction. */
  customerId: Scalars['ObjectId'];
  displayStatus: PaymentTransactionDisplayStatus;
  /** Audit history of status and reconciliation changes for this transaction. */
  history: Array<PaymentTransactionHistoryEntry>;
  /** The user who initiated the transaction */
  initiatedBy?: Maybe<User>;
  /** The order ID on which this transaction was made */
  orderId?: Maybe<Scalars['ObjectId']>;
  paymentMethod: TransactionPaymentMethod;
  paymentSysResponseCode?: Maybe<Scalars['String']>;
  paymentSysResponseMessage?: Maybe<Scalars['String']>;
  processorTransactionId?: Maybe<Scalars['Int']>;
  reasonCode: CreditReasonCode;
  reconciledBy?: Maybe<Employee>;
  referenceNumber?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['Date']>;
  /** The status of this transaction. */
  status: PaymentTransactionStatus;
  transactionDate: Scalars['DateTime'];
};

/** The reason code for a credit transaction */
export enum CreditReasonCode {
  /** The transaction was cancelled */
  Cancellation = 'CANCELLATION',
  /** Funds were returned for an unspecified reason */
  Optional = 'OPTIONAL',
  /** The customer overpaid. */
  Overpayment = 'OVERPAYMENT',
  /** The amount was transferred to another order. */
  Transfer = 'TRANSFER',
  /** The amount was converted into a voucher. */
  Voucher = 'VOUCHER'
}

export enum CurrencyCode {
  Cad = 'CAD',
  Usd = 'USD'
}

/** An Abe customer and its associated data */
export type Customer = User & {
  __typename?: 'Customer';
  _id: Scalars['ObjectId'];
  address?: Maybe<Address>;
  bio?: Maybe<Scalars['String']>;
  /** Get a customer's booked trips by business code */
  bookingTrips: Array<BookingTrip>;
  /**
   * Whether the customer is eligible to see referrals for the given business. Returns `false` when the customer is a Group Coordinator on any GC Departure for the business (hidden in every brand), or when the business has configured `referralLookbackYears` and the customer has a non-cancelled GM trip whose departure date falls within the rolling `today - referralLookbackYears` window (a value of 0 restricts only future-booked GMs). Returns `true` otherwise, including when the business has not configured `referralLookbackYears` (no GM-based restriction).
   * @deprecated This field will be removed in favor utilizing audience segmentation platforms.
   */
  canSeeReferrals?: Maybe<Scalars['Boolean']>;
  /** Get a customer's canceled trips by business code */
  cancelledTrips: Array<BookingTrip>;
  /** Get the chat user ID for the customer for the given business code */
  chatUserId?: Maybe<Scalars['String']>;
  /** Get GC Departures for Group Coordinators */
  confirmedGCDepartures: Array<GcDeparture>;
  /** Get a customer's pre-2018 confirmed trips by business code */
  confirmedOldTrips: Array<OldTrip>;
  /** Get a customer's confirmed trips by business code */
  confirmedTrips: Array<BookingTrip>;
  customerId: Scalars['ObjectId'];
  email?: Maybe<Scalars['Email']>;
  /** The customer's Facebook URL */
  facebookUrl?: Maybe<Scalars['String']>;
  facebookUsername?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** The customer's GC staff contact for the given business code */
  gcStaffContacts?: Maybe<GcStaffContact>;
  /** ID used for resolving in the global rewards system. Currently Phoenix CustomerNumber */
  globalRewardsId?: Maybe<Scalars['String']>;
  /** Check if the customer has any GC Departures */
  hasGCDepartures: Scalars['Boolean'];
  /** Check if the customer has any GM trips for the given business code */
  hasGroupMemberTrips: Scalars['Boolean'];
  /** Whether the customer has any reward-redeemable booking trip on a booking for the given business: an open trip on a booking with a balance due that is departing in the future, excluding trips pending rebooking. */
  hasRewardRedeemableBookingTrip: Scalars['Boolean'];
  /** The customer's loyalty program profiles with balances and associated referral programs. */
  incentivesPrograms?: Maybe<CustomerIncentives>;
  /** The customer's Instagram URL */
  instagramUrl?: Maybe<Scalars['String']>;
  instagramUsername?: Maybe<Scalars['String']>;
  /** Whether or not customer is banned */
  isBanned?: Maybe<Scalars['Boolean']>;
  /** Whether the customer is eligible to refer. A customer is eligible when they have a valid (non-empty) indiesReferralCode. */
  isEligibleToRefer: Scalars['Boolean'];
  isPrivate?: Maybe<Scalars['Boolean']>;
  /** Whether or not customer is a VIP */
  isVip: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  legacyIds?: Maybe<LegacyCustomerIds>;
  /** Get the loyalty level for the customer */
  loyaltyLevel?: Maybe<LoyaltyLevel>;
  /** Get the loyalty levels for the customer */
  loyaltyLevels?: Maybe<Array<LoyaltyLevel>>;
  /**
   * Get a customer's on hold trips by business code
   * @deprecated No longer a valid status
   */
  onHoldTrips: Array<BookingTrip>;
  /** Get past GC Departure Prospects for Group Coordinators */
  pastGCDepartureProspects: Array<GcDepartureProspect>;
  /** Get past Group Members for Group Coordinator */
  pastGroupMembers: Array<GcPastGroupMember>;
  /** Get a customer's pending rebooking trips by business code */
  pendingRebookingTrips: Array<BookingTrip>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  /** The customer's profile image asset */
  profileImageAsset?: Maybe<Asset>;
  /** Get a customer's rebooked trips by business code */
  rebookedTrips: Array<BookingTrip>;
  /**
   * The customer's incentives information. This data may be stale/cached and should not be used when consistency with the live data is explicitly required.
   * @deprecated Use incentivesPrograms instead
   */
  referralProgram?: Maybe<ReferralProgram>;
  /** Get a customer's requested trips by business code */
  requestedTrips: Array<BookingTrip>;
  /** Bookings eligible for reward redemption for a customer by business code */
  rewardRedeemableBookings: Array<Booking>;
  /** Get a customer's saved payment methods (optionally) by business code */
  savedPaymentMethods: Array<SavedPaymentMethod>;
  /** Get a customer's saved places */
  savedPlaces: Array<SavedPlace>;
  /** The customer's Snapchat URL */
  snapchatUrl?: Maybe<Scalars['String']>;
  snapchatUsername?: Maybe<Scalars['String']>;
  /** The customer's TikTok URL */
  tiktokUrl?: Maybe<Scalars['String']>;
  tiktokUsername?: Maybe<Scalars['String']>;
  /** Get a customer's vouchers */
  vouchers: Array<Voucher>;
  /** Get a customer's waitlisted trips by business code */
  waitlistedTrips: Array<BookingTrip>;
  /** Get a customer's wishlist items (optionally) by business code */
  wishlist: Array<WishlistItem>;
  /** The customer's X URL */
  xUrl?: Maybe<Scalars['String']>;
  xUsername?: Maybe<Scalars['String']>;
};


/** An Abe customer and its associated data */
export type CustomerBookingTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerCanSeeReferralsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerCancelledTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerChatUserIdArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerConfirmedGcDeparturesArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerConfirmedOldTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerConfirmedTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerGcStaffContactsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerHasGcDeparturesArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerHasGroupMemberTripsArgs = {
  filter: FilterCustomerTripsInput;
};


/** An Abe customer and its associated data */
export type CustomerHasRewardRedeemableBookingTripArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerLoyaltyLevelArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerOnHoldTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerPastGcDepartureProspectsArgs = {
  businessCodes?: InputMaybe<Array<BusinessCode>>;
};


/** An Abe customer and its associated data */
export type CustomerPastGroupMembersArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerPendingRebookingTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerRebookedTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerRequestedTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerRewardRedeemableBookingsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerSavedPaymentMethodsArgs = {
  businessCode?: InputMaybe<BusinessCode>;
  currencyCode?: InputMaybe<CurrencyCode>;
  includeUnauthorized?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isValid?: InputMaybe<Scalars['Boolean']>;
};


/** An Abe customer and its associated data */
export type CustomerSavedPlacesArgs = {
  businessCode?: InputMaybe<BusinessCode>;
  types?: InputMaybe<Array<Scalars['String']>>;
};


/** An Abe customer and its associated data */
export type CustomerWaitlistedTripsArgs = {
  businessCode: BusinessCode;
};


/** An Abe customer and its associated data */
export type CustomerWishlistArgs = {
  businessCode?: InputMaybe<BusinessCode>;
};

/** A customer audience member */
export type CustomerAudienceMember = AudienceMember & {
  __typename?: 'CustomerAudienceMember';
  _id: Scalars['ObjectId'];
  audienceId: Scalars['ObjectId'];
  customerId: Scalars['ObjectId'];
};

export type CustomerCredentialOptions = {
  __typename?: 'CustomerCredentialOptions';
  hasEmail: Scalars['Boolean'];
  hasPassword: Scalars['Boolean'];
  /** Indicates if the customer is banned */
  isBanned: Scalars['Boolean'];
};

/** Customer evaluation type */
export type CustomerEvaluation = Evaluation & {
  __typename?: 'CustomerEvaluation';
  _id: Scalars['ObjectId'];
  /** The date that the evaluation is available */
  availabilityDate: Scalars['DateTime'];
  businessCode?: Maybe<BusinessCode>;
  /** The date that the evaluation is due */
  deadlineDate: Scalars['DateTime'];
  /** The departure ID of the departure that this evaluation belong to */
  departureId: Scalars['ObjectId'];
  evaluationType: EvaluationType;
  /** The date that the evaluation was finalized */
  finalizationDate?: Maybe<Scalars['DateTime']>;
  hasAnsweredQuestions: Scalars['Boolean'];
  /** Whether the evaluation has been started */
  hasBeenStarted: Scalars['Boolean'];
  /** The NPS score of the evaluation */
  npsScore?: Maybe<Scalars['Int']>;
  questions: Array<EvaluationQuestion>;
  /** The date that the evaluation was submitted */
  submissionDate?: Maybe<Scalars['DateTime']>;
  templateId: Scalars['ObjectId'];
  /** The trip ID of the booking trip that this evaluation belong to */
  tripId: Scalars['ObjectId'];
  userId: Scalars['ObjectId'];
};

export type CustomerEvaluationDateTimeRangeInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type CustomerEvaluationFinalizationDateFilterInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  hasFinalizationDate?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

/** A paginated result of Customer Evaluations */
export type CustomerEvaluationPaginatedResult = {
  __typename?: 'CustomerEvaluationPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<CustomerEvaluation>;
};

/** Customer evaluation settings */
export type CustomerEvaluationSettings = {
  __typename?: 'CustomerEvaluationSettings';
  /** List component types to make customer eval questions for. */
  componentTypeCodes: Array<Scalars['String']>;
  /** boolean to determine if all questions should be generated at once */
  generateAllQuestionsAtOnce: Scalars['Boolean'];
  /** the number of days before a departure or before a departure end that eval availabilityDate should be set */
  nbDaysUntilEvaluationAvailable?: Maybe<Scalars['Int']>;
  /** the number of days after a departure that an eval is due */
  nbDaysUntilEvaluationDue?: Maybe<Scalars['Int']>;
  /** number of days before the departure that the preDepartureEnd questions should be generated */
  nbPreDepartureEndQuestionDays?: Maybe<Scalars['Int']>;
  /** number of days before the departure that the preDeparture questions should be generated */
  nbPreDepartureQuestionDays?: Maybe<Scalars['Int']>;
  /** boolean to determine if an eval should be generated before the departure, otherwise will generate x days before departure end */
  shouldGeneratePreDeparture: Scalars['Boolean'];
};

export enum CustomerEvaluationSortField {
  AvailabilityDate = 'availabilityDate'
}

export type CustomerEvaluationSubmissionDateFilterInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  hasSubmissionDate?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

/** Error returned when attempting to delete a customer's data while they still have future booked trips */
export type CustomerHasFutureBookingsError = DomainError & {
  __typename?: 'CustomerHasFutureBookingsError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type CustomerIncentives = {
  __typename?: 'CustomerIncentives';
  /** The aggregate balance of the customer's incentive programs */
  balance: Scalars['Float'];
  /** The customer id that this information is associated with */
  customerId: Scalars['ObjectId'];
  /** The customer's Indies referral profile with balance and referral code */
  indiesReferralProfile: ReferralProfile;
  /** The aggregate pending balance of the customer's incentive programs */
  pendingBalance: Scalars['Float'];
  /** Details about unused incentive rewards, including next available (advocate) and next expiring (friend) rewards. Always null for cached responses. */
  unusedIncentiveInfo?: Maybe<UnusedIncentiveInfo>;
};

/** Customer merge error */
export type CustomerMergeError = DomainError & {
  __typename?: 'CustomerMergeError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type CustomerPaginatedResult = {
  __typename?: 'CustomerPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Customer>;
};

/** Customer specific settings */
export type CustomerSettings = {
  __typename?: 'CustomerSettings';
  /** The name to use when anonymizing customer data for deletion requests */
  dataDeletionRequestName: Scalars['String'];
};

export type CustomerSignupResult = {
  __typename?: 'CustomerSignupResult';
  customer: Customer;
  token: Scalars['String'];
  tokenExpiresAt: Scalars['DateTime'];
};

/** Used when a customer is banned, but named generically to avoid exposing 'banned' in the UI. */
export type CustomerUnavailableError = DomainError & {
  __typename?: 'CustomerUnavailableError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type DateOnlyRangeInput = {
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
};

export type DateRangeInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

/** A range of DateTimes */
export type DateTimeRange = {
  __typename?: 'DateTimeRange';
  /** The duration of the date time range as a Duration object */
  duration: Duration;
  from: Scalars['DateTime'];
  isPast: Scalars['Boolean'];
  to: Scalars['DateTime'];
};

export type DeauthorizePaymentMethodResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPaymentError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | SavedPaymentMethod | ValidationError;

/** A transaction that debits a payment method */
export type DebitPaymentTransaction = PaymentTransaction & {
  __typename?: 'DebitPaymentTransaction';
  _id: Scalars['ObjectId'];
  amount: Money;
  /** The customer of this transaction. */
  customerId: Scalars['ObjectId'];
  displayStatus: PaymentTransactionDisplayStatus;
  /** Audit history of status and reconciliation changes for this transaction. */
  history: Array<PaymentTransactionHistoryEntry>;
  /** The user who initiated the transaction */
  initiatedBy?: Maybe<User>;
  /** The order ID on which this transaction was made */
  orderId?: Maybe<Scalars['ObjectId']>;
  paymentMethod: TransactionPaymentMethod;
  paymentScheduleId?: Maybe<Scalars['ObjectId']>;
  paymentSysResponseCode?: Maybe<Scalars['String']>;
  paymentSysResponseMessage?: Maybe<Scalars['String']>;
  processorTransactionId?: Maybe<Scalars['Int']>;
  reconciledBy?: Maybe<Employee>;
  referenceNumber?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['Date']>;
  /** The status of this transaction. */
  status: PaymentTransactionStatus;
  transactionDate: Scalars['DateTime'];
};

export type DeclineFlightShopPriceChangeResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightBookingResult | FlightBookingResultInvalidStateError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type DeleteAudienceResult = Audience | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidAudienceError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type DeleteCategoryResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | SuccessResult | ValidationError;

export type DeleteGcDepartureMeetingRsvpInput = {
  _id: Scalars['ObjectId'];
};

export type DeleteGcDepartureMeetingRsvpResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDepartureMeetingRsvp | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type DeleteGcDepartureProspectResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDepartureProspectRemovedResult | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type DeleteOAuthClientResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | OAuthClient | ValidationError;

export type DeleteReviewImageResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Review | ValidationError;

export type DeleteTagResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | SuccessResult | ValidationError;

export type DeleteWishlistItemResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError | WishlistItemRemovedResult;

/** Departure of a tour */
export type Departure = {
  __typename?: 'Departure';
  _id: Scalars['ObjectId'];
  /** The sellable extension for a departure if it has one. Otherwise Null. */
  activeExtension?: Maybe<DepartureExtension>;
  activeExtensionContent?: Maybe<TourExtensionContent>;
  addonPrice: Amount;
  autoApproveDeadline: Scalars['Date'];
  /** The base price of the departure. This is not the actual price the departure is sold for. */
  basePrice: Amount;
  /** All trips that count as a spot booked (CONFIRMED, REQUESTED, WAITLISTED). */
  bookedTrips: Array<BookingTrip>;
  /** All booking trips. */
  bookingTrips: Array<BookingTrip>;
  bookings: Array<Booking>;
  cancellationMeta?: Maybe<DepartureItemCancellationMeta>;
  capacity: Scalars['Int'];
  /** Id to use to create a unique chat channel for the departure. Falls back to the legacy id for older departures. */
  chatChannelId: Scalars['String'];
  /** The date the chat channel opens for the departure */
  chatChannelOpenDate?: Maybe<Scalars['Date']>;
  /** Confirmed GC departures associated with the departure */
  confirmedGcDepartures?: Maybe<Array<GcDeparture>>;
  confirmedRooming?: Maybe<DepartureRooming>;
  confirmedTrips: Array<BookingTrip>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The identity of the user who created the record */
  createdBy?: Maybe<AuditIdentity>;
  /** Returns the prices for the available custom departing flight packages based on the base tour's start gateway code. */
  customDepartingFlightPrices: Array<DepartureFlightPackagePrice>;
  /** Returns the prices for available custom returning flight packages based on the base tour's end gateway code. */
  customReturningFlightPrices: Array<DepartureFlightPackagePrice>;
  customerEvaluations?: Maybe<Array<CustomerEvaluation>>;
  /** Returns the prices for all available departing flight packages based on the base tour's start gateway code. */
  departingFlightPrices: Array<DepartureFlightPackagePrice>;
  departureDate: Scalars['Date'];
  departureDateWithExtension: Scalars['Date'];
  /** Flight manifest showing traveler arrivals and departures organized by category, date, and gateway */
  departureFlightManifest?: Maybe<DepartureFlightManifest>;
  /** Departure itinerary associated with the departure */
  departureItinerary?: Maybe<DepartureItinerary>;
  /** Document metadata */
  documentMetadata?: Maybe<Array<DocumentMetadata>>;
  dpd: Scalars['Int'];
  /** Includes the date at which eTicket information is released, and whether or not it is already released */
  eTicketsRelease?: Maybe<ReleaseDetails>;
  endDate: Scalars['Date'];
  endDateWithExtension: Scalars['Date'];
  endGateway?: Maybe<Gateway>;
  endGatewayCode: Scalars['String'];
  exclusivityType: DepartureExclusivityType;
  excursions: Array<DepartureExcursion>;
  extendedFamilyCode: Scalars['String'];
  /** All extensions for a departure regardless of status. At most one can be active. */
  extensions: Array<DepartureExtension>;
  familyCode: Scalars['String'];
  finalInstallmentDeadline: Scalars['Date'];
  finalPaymentDeadline: Scalars['Date'];
  /** Includes the date at which flights are released, and whether or not they are already released */
  flightsRelease?: Maybe<ReleaseDetails>;
  /**
   * The date that flight line items go on request
   * @deprecated Use flightsRequestDeadlineDate which has no timestamp
   */
  flightsRequestDeadline?: Maybe<Scalars['DateTime']>;
  /** The date that flight line items go on request */
  flightsRequestDeadlineDate?: Maybe<Scalars['Date']>;
  /**
   * The deadline for customers to request flights
   * @deprecated Use flightsRequestMessagingDeadlineDate which has no timestamp
   */
  flightsRequestMessagingDeadline?: Maybe<Scalars['DateTime']>;
  /** The deadline for customers to request flights */
  flightsRequestMessagingDeadlineDate?: Maybe<Scalars['Date']>;
  /** GC departures associated with the departure */
  gcDeparture?: Maybe<Array<GcDeparture>>;
  /** Whether the departure has any confirmed GC departures */
  hasConfirmedGcDepartures: Scalars['Boolean'];
  hasRoomsWithCabinCodes: Scalars['Boolean'];
  hasSpotsLeft: Scalars['Boolean'];
  /** @deprecated No longer used */
  hasUnmatchedRoommates: Scalars['Boolean'];
  hotelsRelease?: Maybe<ReleaseDetails>;
  /** @deprecated Use hotelsRequestDeadlineDate which has no timestamp */
  hotelsRequestDeadline?: Maybe<Scalars['DateTime']>;
  hotelsRequestDeadlineDate?: Maybe<Scalars['Date']>;
  /** Whether the chat is open for the departure, checks if the channel exists and if today is within the chat open range */
  isChatChannelOpen: Scalars['Boolean'];
  isFlightShoppingAllowed: Scalars['Boolean'];
  /** Whether or not lost baggage service is available for this departure based on departure date. */
  isLostBaggageServiceAvailable?: Maybe<Scalars['Boolean']>;
  isPastAutoApproveDeadline: Scalars['Boolean'];
  isPostStayAllowed: Scalars['Boolean'];
  isPreStayAllowed: Scalars['Boolean'];
  /** Whether or not status is purchasable status. */
  isPurchasable: Scalars['Boolean'];
  /** Whether the tour director is available for the customer to send a direct message */
  isTourDirectorAvailableToDirectMessage: Scalars['Boolean'];
  /** Whether the tour director for the departure should be visible to the user */
  isTourDirectorReleasedToTraveler?: Maybe<Scalars['Boolean']>;
  isWaitlistAllowed: Scalars['Boolean'];
  /** Price with fees and promos optionally applied */
  leadInPrice: Array<LeadInPrice>;
  lineItemCode: Scalars['LineItemCode'];
  maxTravelerAge?: Maybe<Scalars['Int']>;
  minTravelerAge?: Maybe<Scalars['Int']>;
  nbSpotsBooked: Scalars['Int'];
  nbSpotsLeft: Scalars['Int'];
  /** @deprecated No longer a valid status */
  onHoldTrips: Array<BookingTrip>;
  owner?: Maybe<Employee>;
  ownerId?: Maybe<Scalars['ObjectId']>;
  pendingRebookingTrips: Array<BookingTrip>;
  postStayCityCodes?: Maybe<Array<Scalars['String']>>;
  postStays?: Maybe<Array<ExtendedStay>>;
  preStayCityCodes?: Maybe<Array<Scalars['String']>>;
  preStays?: Maybe<Array<ExtendedStay>>;
  /** The final selling price of the departure including add-on price. */
  price: Amount;
  priceYear: PriceYear;
  prodTourId?: Maybe<Scalars['Int']>;
  requestedRooming?: Maybe<DepartureRooming>;
  requestedTrips: Array<BookingTrip>;
  reservedCapacity: Scalars['Int'];
  /** Returns the prices for all available returning flight packages based on the base tour's end gateway code. */
  returningFlightPrices: Array<DepartureFlightPackagePrice>;
  rooming?: Maybe<DepartureRooming>;
  rooms: Array<DepartureRoom>;
  salesTourId: Scalars['String'];
  series: Scalars['Series'];
  /** Returns the prices for the available standard departing flight packages based on the base tour's start gateway code. */
  standardDepartingFlightPrices: Array<DepartureFlightPackagePrice>;
  /** Returns the prices for available standard returning flight packages based on the base tour's end gateway code. */
  standardReturningFlightPrices: Array<DepartureFlightPackagePrice>;
  startDate: Scalars['Date'];
  startGateway?: Maybe<Gateway>;
  startGatewayCode: Scalars['String'];
  status: DepartureStatus;
  tagIds: Array<Scalars['ObjectId']>;
  tags: Array<Tag>;
  timingStatus: DepartureTimingStatus;
  /** Parent tour associated with the departure */
  tour?: Maybe<Tour>;
  tourCode: Scalars['String'];
  tourContent?: Maybe<TourContent>;
  /** The DPD at which a tour director will start seeing future departures and will be visible to the travelers */
  tourDirectorFutureToursGateDpd?: Maybe<Scalars['Int']>;
  tourDirectors: Array<TourDirector>;
  tourEndReportRelease?: Maybe<ReleaseDetails>;
  travelers: Array<Customer>;
  /** All trips, including booked and quoted trips associated with the departure */
  trips: Array<Trip>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The identity of the user who last updated the record */
  updatedBy?: Maybe<AuditIdentity>;
};


/** Departure of a tour */
export type DepartureActiveExtensionContentArgs = {
  language: Scalars['String'];
};


/** Departure of a tour */
export type DepartureLeadInPriceArgs = {
  campaignCode?: InputMaybe<Scalars['String']>;
  promoCodes?: InputMaybe<Array<Scalars['String']>>;
};


/** Departure of a tour */
export type DepartureTourContentArgs = {
  language: Scalars['String'];
};

/** Departure evaluation statistics */
export type DepartureEvaluationSummary = {
  __typename?: 'DepartureEvaluationSummary';
  /** The average percentage based on the average score and the maximum score */
  averagePercentage: Scalars['Float'];
  /** The average score of all answered tour director questions on a departure */
  averageScore: Scalars['Float'];
  /** The average score level based on the average score */
  averageScoreLevel: EvaluationScoreLevel;
  /** Customer responses to the tour director question, only questions with additional comments are processed */
  customerResponses: Array<EvaluationSummaryCustomerResponse>;
  departure: Departure;
  /** Departure ID */
  departureId: Scalars['ObjectId'];
  /** Percentage of evaluations completed */
  evaluationCompletionPercentage: Scalars['Float'];
  /** Evaluation completion percentage level */
  evaluationCompletionPercentageLevel: EvaluationScoreLevel;
  /** Number of completed evaluations */
  nbOfCompletedEvaluations: Scalars['Int'];
  /** Number of evaluations */
  nbOfEvaluations: Scalars['Int'];
  /** NPS score of the tour. */
  npsScore: Scalars['Int'];
  /** NPS score level */
  npsScoreLevel: EvaluationScoreLevel;
  /** List of score ranges, based on the average score of each answered evaluation */
  ranges: Array<EvaluationScoreRange>;
  /** Release information for the evaluation statistics */
  releaseInformation: ReleaseDetails;
};

export enum DepartureExclusivityType {
  Exclusive = 'EXCLUSIVE',
  Standard = 'STANDARD'
}

/** Excursion configuration for a departure */
export type DepartureExcursion = {
  __typename?: 'DepartureExcursion';
  _id: Scalars['ObjectId'];
  /**
   * The deadline past which the status of this Excursion will be REQUESTED when added to a Trip. Default to departure end date if none provided
   * @deprecated Do not use this field. This field is no longer in use and will be removed in a future release. We're keeping it for backward compatibility. Use autoApproveDeadlineDate instead.
   */
  autoApproveDeadline: Scalars['Date'];
  /** The deadline past which the status of this Excursion will be REQUESTED when added to a Trip. Null when fully sellable before and during a tour. */
  autoApproveDeadlineDate?: Maybe<Scalars['Date']>;
  autoApproveDeadlineDpd?: Maybe<Scalars['Int']>;
  cancellationMeta?: Maybe<DepartureItemCancellationMeta>;
  capacity: Scalars['Int'];
  content?: Maybe<TourExcursionContent>;
  hasSpotsLeft: Scalars['Boolean'];
  /** Whether or not status is considered an active status. */
  isActive: Scalars['Boolean'];
  /** Whether or not status is considered a purchasable status. */
  isPurchasable: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  matchCode: Scalars['String'];
  /** Indicates the minimum number of travelers required to run the excursion. */
  minNbTravelersRequired: Scalars['Int'];
  nbSpotsBooked: Scalars['Int'];
  nbSpotsLeft: Scalars['Int'];
  price: Amount;
  series: Scalars['Series'];
  status: DepartureStatus;
  tourExcursion?: Maybe<TourExcursion>;
};


/** Excursion configuration for a departure */
export type DepartureExcursionContentArgs = {
  language: Scalars['String'];
};

export type DepartureExcursionOffer = {
  __typename?: 'DepartureExcursionOffer';
  appliedToTrip: Scalars['Boolean'];
  discountAmount?: Maybe<Money>;
  excursion: DepartureExcursion;
  projectedLineItemStatus?: Maybe<LineItemStatus>;
  salePrice?: Maybe<Money>;
};

/** Extension config for a Departure */
export type DepartureExtension = {
  __typename?: 'DepartureExtension';
  _id: Scalars['ObjectId'];
  autoApproveDeadline: Scalars['Date'];
  cancellationMeta?: Maybe<DepartureItemCancellationMeta>;
  capacity: Scalars['Int'];
  confirmedRooming?: Maybe<DepartureRooming>;
  /** Returns the prices for available custom departing flight packages based on the extension or departure's start gateway code. */
  customDepartingFlightPrices: Array<DepartureFlightPackagePrice>;
  /** Returns the prices for available custom returning flight packages based on the extension or departure's end gateway code. */
  customReturningFlightPrices: Array<DepartureFlightPackagePrice>;
  /** Returns the prices for all available departing flight packages based on the extension or departure's start gateway code. */
  departingFlightPrices: Array<DepartureFlightPackagePrice>;
  departure?: Maybe<Departure>;
  departureDate: Scalars['Date'];
  departureId: Scalars['ObjectId'];
  dpd: Scalars['Int'];
  endDate: Scalars['Date'];
  endGatewayCode: Scalars['String'];
  excursions: Array<DepartureExcursion>;
  extendedFamilyCode: Scalars['String'];
  familyCode: Scalars['String'];
  hasSpotsLeft: Scalars['Boolean'];
  isFlightShoppingAllowed: Scalars['Boolean'];
  isPreExtension: Scalars['Boolean'];
  /** Whether or not status is purchasable status. */
  isPurchasable: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  nbSpotsBooked: Scalars['Int'];
  nbSpotsLeft: Scalars['Int'];
  postStayCityCodes?: Maybe<Array<Scalars['String']>>;
  postStays?: Maybe<Array<ExtendedStay>>;
  preStayCityCodes?: Maybe<Array<Scalars['String']>>;
  preStays?: Maybe<Array<ExtendedStay>>;
  price: Amount;
  prodTourId?: Maybe<Scalars['Int']>;
  requestedRooming?: Maybe<DepartureRooming>;
  /** Returns the prices for all available returning flight packages based on the extension or departure's end gateway code. */
  returningFlightPrices: Array<DepartureFlightPackagePrice>;
  rooming?: Maybe<DepartureRooming>;
  rooms: Array<DepartureRoom>;
  salesTourId: Scalars['String'];
  series: Scalars['Series'];
  /** Returns the prices for available standard departing flight packages based on the extension or departure's start gateway code. */
  standardDepartingFlightPrices: Array<DepartureFlightPackagePrice>;
  /** Returns the prices for available standard returning flight packages based on the extension or departure's end gateway code. */
  standardReturningFlightPrices: Array<DepartureFlightPackagePrice>;
  startDate: Scalars['Date'];
  startGatewayCode: Scalars['String'];
  status: DepartureStatus;
  timingStatus: DepartureTimingStatus;
  tourCode: Scalars['String'];
  tourExtension?: Maybe<TourExtension>;
  tourExtensionContent?: Maybe<TourExtensionContent>;
};


/** Extension config for a Departure */
export type DepartureExtensionTourExtensionContentArgs = {
  language: Scalars['String'];
};

export type DepartureExtensionOffer = {
  __typename?: 'DepartureExtensionOffer';
  appliedToTrip: Scalars['Boolean'];
  discountAmount?: Maybe<Money>;
  extension: DepartureExtension;
  projectedLineItemStatus?: Maybe<LineItemStatus>;
  salePrice?: Maybe<Money>;
};

/** Flight manifest for tour directors showing all traveler flights organized by category */
export type DepartureFlightManifest = {
  __typename?: 'DepartureFlightManifest';
  /** All unique flights across all categories for easy lookup by ID */
  flights: Array<ManifestFlight>;
  /** Departures for travelers without post-tour extensions (standard tour end) */
  flightsHome: ManifestFlightCategory;
  /** Arrivals for travelers without pre-tour extensions (standard tour start) */
  flightsToTour: ManifestFlightCategory;
  /** Departures for travelers with post-tour extensions (null if none) */
  postExtensionDepartures?: Maybe<ManifestFlightCategory>;
  /** Arrivals for travelers with pre-tour extensions (null if none) */
  preExtensionArrivals?: Maybe<ManifestFlightCategory>;
};

export type DepartureFlightPackagePrice = {
  __typename?: 'DepartureFlightPackagePrice';
  homeGateway?: Maybe<Gateway>;
  homeGatewayCode: Scalars['String'];
  isCustomGateway: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  prices: Array<Money>;
};

/** Information about why a departure or extension was cancelled */
export type DepartureItemCancellationMeta = {
  __typename?: 'DepartureItemCancellationMeta';
  cancellationDate: Scalars['Date'];
  cancellationReason?: Maybe<DepartureItemCancellationReason>;
  cancelledById?: Maybe<Scalars['ObjectId']>;
};

export enum DepartureItemCancellationReason {
  AdhocChange = 'ADHOC_CHANGE',
  DateChange = 'DATE_CHANGE',
  FlightsIssue = 'FLIGHTS_ISSUE',
  InternalError = 'INTERNAL_ERROR',
  InventoryRelease = 'INVENTORY_RELEASE',
  LowEnrollment = 'LOW_ENROLLMENT',
  OperationalIssue = 'OPERATIONAL_ISSUE',
  RevenueManagement = 'REVENUE_MANAGEMENT',
  SeasonalityChange = 'SEASONALITY_CHANGE',
  TourCancellation = 'TOUR_CANCELLATION',
  TourChange = 'TOUR_CHANGE',
  WorldEvent = 'WORLD_EVENT'
}

/** The itinerary of a departure */
export type DepartureItinerary = {
  __typename?: 'DepartureItinerary';
  _id: Scalars['ObjectId'];
  components: Array<DepartureItineraryComponent>;
  prodTourId: Scalars['Int'];
  tourDirectors: Array<DepartureItineraryComponent>;
};

/** The component on a departure itinerary */
export type DepartureItineraryComponent = {
  __typename?: 'DepartureItineraryComponent';
  agent?: Maybe<Supplier>;
  breakdown?: Maybe<Scalars['String']>;
  /** Whether this component type supports AI-generated supplier confirmation emails */
  canGenerateSupplierConfirmation: Scalars['Boolean'];
  endDate: Scalars['Date'];
  externalReferenceNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes: Array<Scalars['String']>;
  productionComponentId: Scalars['Int'];
  reconfirmationDpd?: Maybe<Scalars['Int']>;
  reservation?: Maybe<Reservation>;
  startDate: Scalars['Date'];
  startTime?: Maybe<Scalars['Time']>;
  supplier?: Maybe<Supplier>;
  type: Scalars['String'];
};

/** Departure not bookable error */
export type DepartureNotBookableError = DomainError & {
  __typename?: 'DepartureNotBookableError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** A paginated result of Departures */
export type DeparturePaginatedResult = {
  __typename?: 'DeparturePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Departure>;
};

/** Room on a Departure */
export type DepartureRoom = {
  __typename?: 'DepartureRoom';
  _id: Scalars['ObjectId'];
  bed: TourBed;
  cabinCode?: Maybe<Scalars['TourCabinCode']>;
  /** Whether or not a room generally allows roommates. */
  canHaveRoommates: Scalars['Boolean'];
  cancellationMeta?: Maybe<DepartureItemCancellationMeta>;
  capacity: Scalars['Int'];
  content?: Maybe<RoomContent>;
  hasSpotsLeft: Scalars['Boolean'];
  /** Whether or not status is purchasable status. */
  isPurchasable: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  nbSpotsBooked: Scalars['Int'];
  nbSpotsLeft: Scalars['Int'];
  price: Amount;
  /** Whether or not the room must have roommates assigned to full capacity, as configured on the tour room. */
  requiresCompleteRoommates: Scalars['Boolean'];
  /**
   * Whether or not the room requires a roommate configuration.
   * @deprecated Use canHaveRoommates instead.
   */
  requiresRooming: Scalars['Boolean'];
  series: Scalars['Series'];
  status: DepartureStatus;
};


/** Room on a Departure */
export type DepartureRoomContentArgs = {
  language: Scalars['String'];
};

export type DepartureRoomOffer = {
  __typename?: 'DepartureRoomOffer';
  appliedToTrip: Scalars['Boolean'];
  discountAmount?: Maybe<Money>;
  projectedLineItemStatus?: Maybe<LineItemStatus>;
  room: DepartureRoom;
  salePrice?: Maybe<Money>;
};

/** Departure Rooming */
export type DepartureRooming = {
  __typename?: 'DepartureRooming';
  /** Travelers with assigned roommates */
  assignedRooms: Array<AssignedRoom>;
  /** Total room and traveler counts for each bed count */
  breakdown: Array<DepartureRoomingBreakdown>;
  /** Travelers who are yet to be assigned a roommate */
  unassignedTravelers: Array<UnassignedTravelers>;
};

/** The breakdown by bed code */
export type DepartureRoomingBreakdown = {
  __typename?: 'DepartureRoomingBreakdown';
  bedCode: Scalars['String'];
  nbRooms: Scalars['Int'];
  nbTravelers: Scalars['Int'];
};

/** Settings for departure management, timing, and information release */
export type DepartureSettings = {
  __typename?: 'DepartureSettings';
  /** Settings for document metadata and availability */
  documentMetadata: Array<DocumentMetadataSettings>;
  /** The DPD at which this business expects flight segments to have e-ticket numbers populated */
  eTicketsAvailabilityDpd?: Maybe<Scalars['Int']>;
  /** The DPD at which this business expects flights information populated */
  flightsReleaseDpd: Scalars['Int'];
  /** Days prior to departure when flight requests should be made */
  flightsRequestDpd: Scalars['Int'];
  /** Days prior to departure when flight request messaging should be sent */
  flightsRequestMessagingDpd: Scalars['Int'];
  /** Days prior to departure when hotel information is released */
  hotelsReleaseDpd: Scalars['Int'];
  /** Days prior to departure when hotel requests should be made */
  hotelsRequestDpd: Scalars['Int'];
  /** The estimated days after the flights release date which this business expects flights information to be populated */
  nbEstimatedDaysForFlightRelease?: Maybe<Scalars['Int']>;
  /** Minimum days prior to departure for public departure visibility */
  publicDepartureMinDpd: Scalars['Int'];
  /** The maximum number of spots left we will show to the public */
  publicSpotsLeftThreshold: Scalars['Int'];
  /** The DPD at which a tour director will start seeing future departures and will be visible to the travelers */
  tourDirectorFutureToursGateDpd?: Maybe<Scalars['Int']>;
};

export enum DepartureSortField {
  AddOnPriceCad = 'addOnPriceCAD',
  AddOnPriceUsd = 'addOnPriceUSD',
  AutoApproveDeadline = 'autoApproveDeadline',
  Capacity = 'capacity',
  CreatedAt = 'createdAt',
  DepartureDate = 'departureDate',
  EndDate = 'endDate',
  ExclusivityType = 'exclusivityType',
  FinalPaymentDeadline = 'finalPaymentDeadline',
  NbSpotsBooked = 'nbSpotsBooked',
  PriceCad = 'priceCAD',
  PriceUsd = 'priceUSD',
  PriceYear = 'priceYear',
  ProdTourId = 'prodTourId',
  SalesTourId = 'salesTourId',
  StartDate = 'startDate',
  Status = 'status',
  TourCode = 'tourCode',
  UpdatedAt = 'updatedAt'
}

export enum DepartureStatus {
  /** The departure has been cancelled, all trips are cancelled, and the departure is cancelled in Atlas. */
  Cancelled = 'CANCELLED',
  /** The trip is no longer available because it's passed it's run date. */
  Closed = 'CLOSED',
  /** Like PENDING except the prod has been created in Atlas. */
  Hold = 'HOLD',
  /** The trip is past the tour finalization and allocation has begun therefore all bookings will be ON_REQUEST until approved by Ops and/or Travel teams */
  OnRequest = 'ON_REQUEST',
  /** The departure is not available for sale yet and the prod has not been created in Atlas. */
  Pending = 'PENDING',
  /** The Prod tour is cancelled in atlas but not all customer trips on it have been cancelled. */
  PendingCancellation = 'PENDING_CANCELLATION',
  /** The departure is available for sale. */
  Sell = 'SELL'
}

export enum DepartureTimingStatus {
  OnTour = 'OnTour',
  PostTour = 'PostTour',
  PreTour = 'PreTour'
}

export enum Direction {
  Departing = 'DEPARTING',
  Returning = 'RETURNING'
}

/** Document metadata for a specific departure. */
export type DocumentMetadata = {
  __typename?: 'DocumentMetadata';
  /** The full path where the document can be downloaded from. */
  downloadPath: Scalars['String'];
  /** The title of the document to be displayed by clients. */
  title: Scalars['String'];
};

/** Document metadata settings */
export type DocumentMetadataSettings = {
  __typename?: 'DocumentMetadataSettings';
  /** Type of document */
  documentType: DocumentType;
  /** The url path where the document can be found */
  downloadPath: Scalars['String'];
  /** Title of the document */
  title: Scalars['String'];
};

export enum DocumentType {
  Cruise = 'CRUISE',
  Extension = 'EXTENSION',
  General = 'GENERAL'
}

/** Domain Error interface for all to implement */
export type DomainError = {
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** A draft of an order for editing */
export type DraftOrder = {
  __typename?: 'DraftOrder';
  _id: Scalars['ObjectId'];
  order: Order;
};

export type DraftOrderWithRedemptionEvaluation = {
  __typename?: 'DraftOrderWithRedemptionEvaluation';
  draftOrder: DraftOrder;
  evaluation: PointRedemptionEvaluation;
};

/** An entity with the same unique key already exists */
export type DuplicateUniqueKeyError = DomainError & {
  __typename?: 'DuplicateUniqueKeyError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** A duration of time backed by milliseconds. */
export type Duration = {
  __typename?: 'Duration';
  /** The duration formatted using DayJS format string */
  formatted: Scalars['String'];
  /** The duration formatted to a given unit of time precision */
  formattedToPrecision: Scalars['String'];
  /** The duration in hours with fractional precision */
  hours: Scalars['Float'];
  /** The duration in milliseconds */
  milliseconds: Scalars['Float'];
  /** The duration in minutes with fractional precision */
  minutes: Scalars['Float'];
  /** The duration in seconds with fractional precision */
  seconds: Scalars['Float'];
};


/** A duration of time backed by milliseconds. */
export type DurationFormattedArgs = {
  format: Scalars['String'];
};


/** A duration of time backed by milliseconds. */
export type DurationFormattedToPrecisionArgs = {
  maximumPrecision: DurationFormatPrecision;
};

export enum DurationFormatPrecision {
  Hours = 'HOURS',
  Minutes = 'MINUTES'
}

export type EfTransferPaymentMethod = {
  __typename?: 'EFTransferPaymentMethod';
  efProduct: Scalars['String'];
  efStaffName: Scalars['String'];
  efTransferNumber: Scalars['String'];
  externCustomerName: Scalars['String'];
  externalCustomerId: Scalars['String'];
  externalTripId: Scalars['String'];
};

/** An email audience member */
export type EmailAudienceMember = AudienceMember & {
  __typename?: 'EmailAudienceMember';
  _id: Scalars['ObjectId'];
  audienceId: Scalars['ObjectId'];
  email: Scalars['Email'];
};

export enum EmailInternalCode {
  BalanceUpdate = 'BalanceUpdate',
  Complete = 'Complete',
  CreditConfirmation = 'CreditConfirmation',
  DirectDebitConfirmation = 'DirectDebitConfirmation',
  EnrollmentConfirmation = 'EnrollmentConfirmation',
  FutureScheduled = 'FutureScheduled',
  GcDepartureMeetingRsvpConfirmation = 'GCDepartureMeetingRSVPConfirmation',
  PlanChange = 'PlanChange',
  WithdrawalConfirmation = 'WithdrawalConfirmation'
}

/** Failed to send an email */
export type EmailSendFailedError = DomainError & {
  __typename?: 'EmailSendFailedError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** emergency contact information */
export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  _id: Scalars['ObjectId'];
  confirmationDate?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['Email']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['PhoneNumber']>;
  relationship: EmergencyContactRelationship;
};

export type EmergencyContactChecklistItem = SystemChecklistItem & {
  __typename?: 'EmergencyContactChecklistItem';
  dueDate?: Maybe<Scalars['Date']>;
  isCompleted: Scalars['Boolean'];
  status?: Maybe<TripChecklistItemStatus>;
};

export type EmergencyContactInput = {
  confirmationDate?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  relationship: EmergencyContactRelationship;
};

export enum EmergencyContactRelationship {
  Child = 'CHILD',
  Friend = 'FRIEND',
  NotSpecified = 'NOT_SPECIFIED',
  Other = 'OTHER',
  Parent = 'PARENT',
  Sibling = 'SIBLING',
  Spouse = 'SPOUSE'
}

/** An EF employee and its associated data */
export type Employee = User & {
  __typename?: 'Employee';
  _id: Scalars['ObjectId'];
  email?: Maybe<Scalars['Email']>;
  entraId: Scalars['String'];
  firstName: Scalars['String'];
  fullname: Scalars['String'];
  lastName: Scalars['String'];
  roleIds: Array<Scalars['ObjectId']>;
  roles: Array<Role>;
};

/** A paginated result of Tours */
export type EmployeePaginatedResult = {
  __typename?: 'EmployeePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Employee>;
};

export enum EmployeeSortField {
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName'
}

/** Details required to estimate a booking trips cancellation summary. */
export type EstimateBookingTripsCancellationSummaryInput = {
  /** The booking ID */
  _id: Scalars['ObjectId'];
  /** List of cancellation adjustments associated with the specified tripIds. */
  cancellationAdjustments: Array<TripCancellationChargeInput>;
  /** The trip IDs to cancel */
  tripIds: Array<Scalars['ObjectId']>;
  /** Whether or not to waive the cancellation fee */
  waiveFee: Scalars['Boolean'];
};

/** Provide exactly one of orderId or draftOrderId to identify the order to evaluate. */
export type EvaluateReferralTravelBankRedemptionInput = {
  amountToRedeem: MoneyInput;
  customerId: Scalars['ObjectId'];
  /** The ID of a draft order. Mutually exclusive with orderId. */
  draftOrderId?: InputMaybe<Scalars['ObjectId']>;
  /** The ID of a published order. Mutually exclusive with draftOrderId. */
  orderId?: InputMaybe<Scalars['ObjectId']>;
};

export type EvaluateReferralTravelBankRedemptionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | IncentivesError | IncentivesIntegrationDisabledError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | PointRedemptionEvaluation | ValidationError;

/** Base type for all evaluations */
export type Evaluation = {
  _id: Scalars['ObjectId'];
  /** The date that the evaluation is available */
  availabilityDate: Scalars['DateTime'];
  businessCode?: Maybe<BusinessCode>;
  /** The date that the evaluation is due */
  deadlineDate: Scalars['DateTime'];
  /** The departure ID of the departure that this evaluation belong to */
  departureId: Scalars['ObjectId'];
  evaluationType: EvaluationType;
  /** The date that the evaluation was finalized */
  finalizationDate?: Maybe<Scalars['DateTime']>;
  hasAnsweredQuestions: Scalars['Boolean'];
  questions: Array<EvaluationQuestion>;
  /** The date that the evaluation was submitted */
  submissionDate?: Maybe<Scalars['DateTime']>;
  templateId: Scalars['ObjectId'];
  userId: Scalars['ObjectId'];
};

/** Base type for all evaluation answers */
export type EvaluationAnswer = {
  additionalComments?: Maybe<Scalars['String']>;
};

/** An evaluation scale choice */
export type EvaluationChoice = {
  __typename?: 'EvaluationChoice';
  _id: Scalars['ObjectId'];
  label: Scalars['String'];
  /** The value of the choice, can be either a string or a number but always represented as a string in the graph */
  value: Scalars['String'];
};

/** Evaluation free text answer */
export type EvaluationFreeTextAnswer = EvaluationAnswer & {
  __typename?: 'EvaluationFreeTextAnswer';
  additionalComments?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** An evaluation free text question */
export type EvaluationFreeTextQuestion = EvaluationQuestion & {
  __typename?: 'EvaluationFreeTextQuestion';
  _id: Scalars['ObjectId'];
  answer?: Maybe<EvaluationFreeTextAnswer>;
  canonicalId: Scalars['String'];
  /** Whether the question has been answered */
  hasBeenAnswered: Scalars['Boolean'];
  isRequired?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<EvaluationQuestionMeta>;
  text: Scalars['String'];
};

/** An evaluation matrix answer */
export type EvaluationMatrixAnswer = EvaluationAnswer & {
  __typename?: 'EvaluationMatrixAnswer';
  additionalComments?: Maybe<Scalars['String']>;
  choiceId: Scalars['ObjectId'];
  /** The value of the choice, can be either a string or a number but always represented as a string in the graph */
  value: Scalars['String'];
};

/** An evaluation matrix question */
export type EvaluationMatrixQuestion = EvaluationQuestion & {
  __typename?: 'EvaluationMatrixQuestion';
  _id: Scalars['ObjectId'];
  canonicalId: Scalars['String'];
  choices: Array<EvaluationChoice>;
  /** Whether the question has been answered */
  hasBeenAnswered: Scalars['Boolean'];
  isRequired?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<EvaluationQuestionMeta>;
  rows: Array<EvaluationMatrixRow>;
  text: Scalars['String'];
};

/** An evaluation matrix row */
export type EvaluationMatrixRow = {
  __typename?: 'EvaluationMatrixRow';
  _id: Scalars['ObjectId'];
  answer?: Maybe<EvaluationMatrixAnswer>;
  text: Scalars['String'];
};

/** Evaluation multiple choice answer */
export type EvaluationMultipleChoiceAnswer = EvaluationAnswer & {
  __typename?: 'EvaluationMultipleChoiceAnswer';
  additionalComments?: Maybe<Scalars['String']>;
  choiceId: Scalars['ObjectId'];
  /** The value of the choice, can be either a string or a number but always represented as a string in the graph */
  value: Scalars['String'];
};

/** An evaluation multiple choice question */
export type EvaluationMultipleChoiceQuestion = EvaluationQuestion & {
  __typename?: 'EvaluationMultipleChoiceQuestion';
  _id: Scalars['ObjectId'];
  answer?: Maybe<EvaluationMultipleChoiceAnswer>;
  canonicalId: Scalars['String'];
  choices: Array<EvaluationChoice>;
  /** Whether the question has been answered */
  hasBeenAnswered: Scalars['Boolean'];
  isRequired?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<EvaluationQuestionMeta>;
  text: Scalars['String'];
};

/** Base type for all evaluations */
export type EvaluationQuestion = {
  _id: Scalars['ObjectId'];
  canonicalId: Scalars['String'];
  /** Whether the question has been answered */
  hasBeenAnswered: Scalars['Boolean'];
  isRequired?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<EvaluationQuestionMeta>;
  text: Scalars['String'];
};

/** Meta information about an evaluation question */
export type EvaluationQuestionMeta = {
  __typename?: 'EvaluationQuestionMeta';
  /** The end date of the component, can be used in the UI to group questions by day */
  componentEndDate?: Maybe<Scalars['Date']>;
  /** The start time of the component, can be used in the UI to help order questions */
  componentStartTime?: Maybe<Scalars['Time']>;
  /** The type code of the component (e.g. OP for excursion, HO for hotel) */
  componentType?: Maybe<Scalars['String']>;
  /** The match code of the component, used to identify which component the question is about */
  matchCode?: Maybe<Scalars['String']>;
  /** The placement type of the question, can be used in the UI to determine where the question should be displayed */
  placementType?: Maybe<EvaluationQuestionPlacementType>;
};

export enum EvaluationQuestionPlacementType {
  PreDeparture = 'PRE_DEPARTURE',
  PreDepartureEnd = 'PRE_DEPARTURE_END'
}

export type EvaluationResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | EvaluationSuccess | InvalidDateError | InvalidDateRangeError | InvalidEvaluationError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export enum EvaluationScoreLevel {
  Average = 'AVERAGE',
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Na = 'NA',
  Poor = 'POOR'
}

/** Evaluation score range */
export type EvaluationScoreRange = {
  __typename?: 'EvaluationScoreRange';
  /** Label for the score range */
  label: Scalars['String'];
  /** Score level */
  level: EvaluationScoreLevel;
  /** Maximum score */
  max: Scalars['Float'];
  /** Minimum score */
  min: Scalars['Float'];
  /** the percentage of items within this range */
  percentage: Scalars['Float'];
  /** the number of items within this range */
  value: Scalars['Int'];
};

/** Evaluation settings */
export type EvaluationSettings = {
  __typename?: 'EvaluationSettings';
  /** the default template string for component questions, example: 'How was your experience with <COMPONENT_NAME>'  */
  componentQuestionText: Scalars['String'];
  /** Customer evaluation settings */
  customerEvaluationSettings: CustomerEvaluationSettings;
  /** Tour director tour end report settings */
  tourDirectorTourEndReportSettings: TourDirectorTourEndReportSettings;
};

export type EvaluationSuccess = {
  __typename?: 'EvaluationSuccess';
  data: Evaluation;
};

/** Evaluation statistics customer response */
export type EvaluationSummaryCustomerResponse = {
  __typename?: 'EvaluationSummaryCustomerResponse';
  /** The level of the response, can be used to highlight good or bad responses */
  level: EvaluationScoreLevel;
  /** The response populated by the additional comments field in the user's answer */
  response: Scalars['String'];
  /** The selected value of the tour director question by the user. This should be a whole number */
  score: Scalars['Int'];
};

export enum EvaluationType {
  CustomerEvaluation = 'CUSTOMER_EVALUATION',
  TourDirectorTourEndReport = 'TOUR_DIRECTOR_TOUR_END_REPORT'
}

export enum ExcursionTourType {
  Extension = 'EXTENSION',
  MainTour = 'MAIN_TOUR'
}

/** An experimental lead tied to a customer and experiment */
export type ExperimentalLead = {
  __typename?: 'ExperimentalLead';
  _id: Scalars['ObjectId'];
  businessCode?: Maybe<BusinessCode>;
  claimedAt?: Maybe<Scalars['DateTime']>;
  claimedBy?: Maybe<Scalars['ObjectId']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId: Scalars['ObjectId'];
  description?: Maybe<Scalars['String']>;
  experimentName?: Maybe<Scalars['String']>;
  interactionDate?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
  market?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  talkingPoints?: Maybe<Array<TalkingPoint>>;
  tourCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ExperimentalLeadPaginatedResult = {
  __typename?: 'ExperimentalLeadPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<ExperimentalLead>;
};

/** Product that represents an extended stay pre or post tour */
export type ExtendedStay = PricedTripComponent & TripComponent & {
  __typename?: 'ExtendedStay';
  _id: Scalars['ObjectId'];
  basePrice: Amount;
  bedCode: TourBedCode;
  businessCode?: Maybe<BusinessCode>;
  cityCode: Scalars['String'];
  /** Additional information about the gateway */
  cityGateway?: Maybe<Gateway>;
  hasPriceRules: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  priceRules: Array<PriceRule>;
  status: TripComponentStatus;
  type: TripComponentType;
};

export type ExtendedStayLineItem = LineItem & {
  __typename?: 'ExtendedStayLineItem';
  _id: Scalars['ObjectId'];
  /** Days between the departure date and the end date, inclusive of those days */
  additionalDays: Scalars['Int'];
  /** Nights between the departure date and the end date */
  additionalNights: Scalars['Int'];
  /** The bed code for the extended stay */
  bedCode?: Maybe<TourBedCode>;
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  cityCode: Scalars['String'];
  /** Additional information about the city gateway */
  cityGateway?: Maybe<Gateway>;
  departureDate: Scalars['Date'];
  endDate: Scalars['Date'];
  isOpen: Scalars['Boolean'];
  isPreStay: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

/** A paginated result of Extended Stays */
export type ExtendedStayPaginatedResult = {
  __typename?: 'ExtendedStayPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<ExtendedStay>;
};

export type ExternalToken = {
  __typename?: 'ExternalToken';
  token: Scalars['String'];
};

export type FaqContent = {
  __typename?: 'FaqContent';
  items: Array<FaqContentItem>;
};

export type FaqContentItem = {
  __typename?: 'FaqContentItem';
  answer?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type Fee = PricedTripComponent & TripComponent & {
  __typename?: 'Fee';
  _id: Scalars['ObjectId'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  categoryCode: Scalars['FeeCategoryCode'];
  hasPriceRules: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  isRefundable: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  persistsOnRebooking: Scalars['Boolean'];
  priceRules: Array<PriceRule>;
  rollsUpToTarget: Scalars['Boolean'];
  status: TripComponentStatus;
  type: TripComponentType;
  typeCode: FeeTypeCode;
};

export type FeeApplicationInfo = {
  __typename?: 'FeeApplicationInfo';
  applyTo: FeeApplicationInstructions;
  fee: FeeLineItem;
};

/** Instructs how to apply the fee to the trips on a Quote */
export enum FeeApplicationInstructions {
  AllTrips = 'ALL_TRIPS',
  PrimaryTripOnly = 'PRIMARY_TRIP_ONLY',
  RelevantTrips = 'RELEVANT_TRIPS'
}

/** Rule for calculating cancellation fees based on DPD and strategy */
export type FeeCalculationRule = {
  __typename?: 'FeeCalculationRule';
  /** Defines the maximum DPD value for this rule to match */
  maxDpd: Scalars['Int'];
  /** The strategy to use when calculating the fee */
  strategy: FeeCalculationStrategy;
  /** The percentage of the trip cost to use for the fee */
  tripPercent: Scalars['Percentage'];
};

export enum FeeCalculationStrategy {
  GreaterFeePriceOrTripCostPercent = 'GreaterFeePriceOrTripCostPercent',
  TripCostPercent = 'TripCostPercent'
}

/** Category Calculation Rule Settings */
export type FeeCancellationSettings = {
  __typename?: 'FeeCancellationSettings';
  /** Fee calculation rules specific to certain categories */
  categorySpecificRules: Array<FeeCategorySpecificCalculationRule>;
  /** Default fee calculation rules applied to all categories */
  defaultRules: Array<FeeCalculationRule>;
};

/** Category Calculation Rule Settings */
export type FeeCategorySpecificCalculationRule = {
  __typename?: 'FeeCategorySpecificCalculationRule';
  /** List of category codes this rule applies to */
  categoryCodes: Array<Scalars['FeeCategoryCode']>;
  /** Fee calculation rules for these categories */
  rules: Array<FeeCalculationRule>;
};

/** A product line item */
export type FeeLineItem = LineItem & {
  __typename?: 'FeeLineItem';
  _id: Scalars['ObjectId'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  fee?: Maybe<Fee>;
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

/** A paginated result of Fees */
export type FeePaginatedResult = {
  __typename?: 'FeePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Fee>;
};

/** Fee settings */
export type FeeSettings = {
  __typename?: 'FeeSettings';
  /** Settings for calculating cancellation fees */
  cancellationSettings: FeeCancellationSettings;
  /** Whether to use the lowest DPD in a rebooking chain for fee calculations */
  useLowestDpdInRebookingChain: Scalars['Boolean'];
};

export enum FeeSortField {
  CategoryCode = 'categoryCode',
  LineItemCode = 'lineItemCode'
}

export enum FeeTypeCode {
  Cax = 'CAX',
  Flightaddcollect = 'FLIGHTADDCOLLECT',
  Flightcax = 'FLIGHTCAX',
  Flightchange = 'FLIGHTCHANGE',
  Flightshopusage = 'FLIGHTSHOPUSAGE',
  Latebooking = 'LATEBOOKING',
  Latepay = 'LATEPAY',
  Mpp = 'MPP',
  Payfail = 'PAYFAIL',
  Rebook = 'REBOOK',
  Refundprocessing = 'REFUNDPROCESSING',
  Retcheck = 'RETCHECK',
  Sptravel = 'SPTRAVEL',
  Tsa = 'TSA'
}

export type FilterAdjustmentInput = {
  adjustmentCode?: InputMaybe<Scalars['String']>;
  businessCode?: InputMaybe<BusinessCode>;
  displayName?: InputMaybe<Scalars['String']>;
  isCompanionDiscount?: InputMaybe<Scalars['Boolean']>;
  isEligibleForRolloverOnRebooking?: InputMaybe<Scalars['Boolean']>;
  isFreePlace?: InputMaybe<Scalars['Boolean']>;
  isRefundable?: InputMaybe<Scalars['Boolean']>;
  isStaffOnTour?: InputMaybe<Scalars['Boolean']>;
  lineItemCode?: InputMaybe<Scalars['LineItemCode']>;
  persistsOnCancelAndRebook?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  rollsUpToTarget?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type FilterAudienceInput = {
  businessCode?: InputMaybe<BusinessCode>;
  name?: InputMaybe<Scalars['String']>;
  offerCode?: InputMaybe<Scalars['String']>;
};

/** Filter input for audience members. */
export type FilterAudienceMemberInput = {
  audienceId?: InputMaybe<Scalars['ObjectId']>;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  email?: InputMaybe<Scalars['String']>;
};

export type FilterBookingInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  dateBooked?: InputMaybe<Scalars['DateTime']>;
  dateBookedFrom?: InputMaybe<Scalars['DateTime']>;
  dateBookedTo?: InputMaybe<Scalars['DateTime']>;
  departureDateFrom?: InputMaybe<Scalars['Date']>;
  departureDateTo?: InputMaybe<Scalars['Date']>;
  departureId?: InputMaybe<Scalars['ObjectId']>;
  finalPaymentDateFrom?: InputMaybe<Scalars['Date']>;
  finalPaymentDateTo?: InputMaybe<Scalars['Date']>;
  isEnrolledInAutopay?: InputMaybe<Scalars['Boolean']>;
  lastAutopayTransactionDate?: InputMaybe<Scalars['DateTime']>;
};

export type FilterBookingTripInput = {
  ageFrom?: InputMaybe<Scalars['Int']>;
  ageTo?: InputMaybe<Scalars['Int']>;
  amountPaidFrom?: InputMaybe<Scalars['Float']>;
  amountPaidTo?: InputMaybe<Scalars['Float']>;
  balanceFrom?: InputMaybe<Scalars['Float']>;
  balanceTo?: InputMaybe<Scalars['Float']>;
  customerName?: InputMaybe<Scalars['String']>;
  customerType?: InputMaybe<Array<TripCustomerType>>;
  dateBookedFrom?: InputMaybe<Scalars['DateTime']>;
  dateBookedTo?: InputMaybe<Scalars['DateTime']>;
  departingGatewayCode?: InputMaybe<Scalars['String']>;
  departureDateFrom?: InputMaybe<Scalars['Date']>;
  departureDateTo?: InputMaybe<Scalars['Date']>;
  departureId?: InputMaybe<Scalars['ObjectId']>;
  /** Requires lineItemCode to be provided. Filters for trips on departures with a departure item for the specified lineItemCode and the specified departure item status. */
  departureItemStatus?: InputMaybe<Array<DepartureStatus>>;
  email?: InputMaybe<Scalars['String']>;
  emergencyContactStatus?: InputMaybe<Array<TripReadinessStatusFilter>>;
  extensionRoomStatus?: InputMaybe<Array<LineItemStatus>>;
  extensionStatus?: InputMaybe<Array<LineItemStatus>>;
  gcDepartureId?: InputMaybe<Scalars['ObjectId']>;
  grandTotalFrom?: InputMaybe<Scalars['Float']>;
  grandTotalTo?: InputMaybe<Scalars['Float']>;
  hasSignedTerms?: InputMaybe<Scalars['Boolean']>;
  idStatus?: InputMaybe<Array<TripReadinessStatusFilter>>;
  insuranceInternalName?: InputMaybe<Scalars['String']>;
  isAutopay?: InputMaybe<Scalars['Boolean']>;
  /** Filter for trips with a line item for this code */
  lineItemCode?: InputMaybe<Scalars['LineItemCode']>;
  /** Requires lineItemCode to be provided. Filters for trips with a line item for the specified lineItemCode and the specified line item status. */
  lineItemStatus?: InputMaybe<Array<LineItemStatus>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postStayStatus?: InputMaybe<Array<LineItemStatus>>;
  preStayStatus?: InputMaybe<Array<LineItemStatus>>;
  returningGatewayCode?: InputMaybe<Scalars['String']>;
  rfpDateFrom?: InputMaybe<Scalars['Date']>;
  rfpDateTo?: InputMaybe<Scalars['Date']>;
  roomStatus?: InputMaybe<Array<LineItemStatus>>;
  series?: InputMaybe<Scalars['Series']>;
  tourCodes?: InputMaybe<Array<Scalars['String']>>;
  travelerNotesStatus?: InputMaybe<Array<TripReadinessStatusFilter>>;
  tripStatus?: InputMaybe<Array<TripStatus>>;
  tsaStatus?: InputMaybe<Array<TripReadinessStatusFilter>>;
};

/** Filter input for campaigns. */
export type FilterCampaignInput = {
  businessCode?: InputMaybe<BusinessCode>;
  campaignCodes?: InputMaybe<Array<Scalars['String']>>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']>;
  promoIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  status?: InputMaybe<CampaignStatus>;
  /** Include only valid active campaigns. */
  valid?: InputMaybe<Scalars['Boolean']>;
};

/** Filters for category query */
export type FilterCategoryInput = {
  businessCode?: InputMaybe<BusinessCode>;
  query?: InputMaybe<Scalars['String']>;
};

export type FilterCustomerEvaluationInput = {
  availabilityDate?: InputMaybe<CustomerEvaluationDateTimeRangeInput>;
  businessCode?: InputMaybe<BusinessCode>;
  deadlineDate?: InputMaybe<CustomerEvaluationDateTimeRangeInput>;
  departureId?: InputMaybe<Scalars['ObjectId']>;
  finalizationDate?: InputMaybe<CustomerEvaluationFinalizationDateFilterInput>;
  submissionDate?: InputMaybe<CustomerEvaluationSubmissionDateFilterInput>;
};

export type FilterCustomerInput = {
  /** Search by id */
  _id?: InputMaybe<Scalars['ObjectId']>;
  /** Search by email */
  email?: InputMaybe<Scalars['String']>;
  /** Search by first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** Search by last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Search by phone number */
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  /** Search first name, last name, email and phone number */
  query?: InputMaybe<Scalars['String']>;
};

export type FilterCustomerTripsInput = {
  businessCode: BusinessCode;
};

export type FilterDepartureInput = {
  addOnPriceCADFrom?: InputMaybe<Scalars['Float']>;
  addOnPriceCADTo?: InputMaybe<Scalars['Float']>;
  addOnPriceUSDFrom?: InputMaybe<Scalars['Float']>;
  addOnPriceUSDTo?: InputMaybe<Scalars['Float']>;
  businessCode?: InputMaybe<BusinessCode>;
  capacityFrom?: InputMaybe<Scalars['Int']>;
  capacityTo?: InputMaybe<Scalars['Int']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']>;
  departureRange?: InputMaybe<DateOnlyRangeInput>;
  dpdFrom?: InputMaybe<Scalars['Int']>;
  dpdTo?: InputMaybe<Scalars['Int']>;
  endDateRange?: InputMaybe<DateOnlyRangeInput>;
  endGatewayCode?: InputMaybe<Scalars['String']>;
  exclusivityType?: InputMaybe<DepartureExclusivityType>;
  extensionRooms?: InputMaybe<Array<TourBedCode>>;
  hasActiveExtension?: InputMaybe<Scalars['Boolean']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']>;
  isPostStayAllowed?: InputMaybe<Scalars['Boolean']>;
  isPreStayAllowed?: InputMaybe<Scalars['Boolean']>;
  isWaitlistAllowed?: InputMaybe<Scalars['Boolean']>;
  lineItemCodes?: InputMaybe<Array<Scalars['LineItemCode']>>;
  nbSpotsBookedFrom?: InputMaybe<Scalars['Int']>;
  nbSpotsBookedTo?: InputMaybe<Scalars['Int']>;
  nbSpotsLeftFrom?: InputMaybe<Scalars['Int']>;
  nbSpotsLeftTo?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['ObjectId']>;
  priceCADFrom?: InputMaybe<Scalars['Float']>;
  priceCADTo?: InputMaybe<Scalars['Float']>;
  priceUSDFrom?: InputMaybe<Scalars['Float']>;
  priceUSDTo?: InputMaybe<Scalars['Float']>;
  priceYear?: InputMaybe<Scalars['Int']>;
  priceYears?: InputMaybe<Array<Scalars['Int']>>;
  prodTourId?: InputMaybe<Scalars['Int']>;
  prodTourIds?: InputMaybe<Array<Scalars['Int']>>;
  query?: InputMaybe<Scalars['String']>;
  rooms?: InputMaybe<Array<TourBedCode>>;
  startDateRange?: InputMaybe<DateOnlyRangeInput>;
  startGatewayCode?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<DepartureStatus>>;
  tourCodes?: InputMaybe<Array<Scalars['String']>>;
  updatedAtFrom?: InputMaybe<Scalars['DateTime']>;
  updatedAtTo?: InputMaybe<Scalars['DateTime']>;
};

export type FilterEmployeeInput = {
  email?: InputMaybe<Scalars['Email']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type FilterExperimentalLeadInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  experimentName?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<Scalars['String']>;
  tourCode?: InputMaybe<Scalars['String']>;
};

export type FilterExtendedStayInput = {
  bedCode?: InputMaybe<TourBedCode>;
  businessCode?: InputMaybe<BusinessCode>;
  cityCode?: InputMaybe<Scalars['String']>;
  hasPriceRules?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type FilterFeeInput = {
  businessCode?: InputMaybe<BusinessCode>;
  categoryCode?: InputMaybe<Scalars['String']>;
  hasPriceRules?: InputMaybe<Scalars['Boolean']>;
  isRefundable?: InputMaybe<Scalars['Boolean']>;
  lineItemCode?: InputMaybe<Scalars['LineItemCode']>;
  persistsOnRebooking?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  rollsUpToTarget?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TripComponentStatus>;
  typeCode?: InputMaybe<FeeTypeCode>;
};

export type FilterFlightPackageInput = {
  arrivalGatewayCode?: InputMaybe<Scalars['String']>;
  arrivalGatewayCodes?: InputMaybe<Array<Scalars['String']>>;
  businessCode?: InputMaybe<BusinessCode>;
  departureGatewayCode?: InputMaybe<Scalars['String']>;
  departureGatewayCodes?: InputMaybe<Array<Scalars['String']>>;
  hasPriceRules?: InputMaybe<Scalars['Boolean']>;
  isCustomGateway?: InputMaybe<Scalars['Boolean']>;
  isPriced?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TripComponentStatus>;
};

/** Filters for flight shopping eligibility result query */
export type FilterFlightShopEligibilityResultInput = {
  orderId?: InputMaybe<Scalars['ObjectId']>;
  windowStatus?: InputMaybe<FlightShoppingWindowStatus>;
};

export type FilterFlightShopInput = {
  businessCode?: InputMaybe<BusinessCode>;
  status?: InputMaybe<TripComponentStatus>;
};

export type FilterGcDepartureAggregateQueryInput = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  businessCode?: InputMaybe<BusinessCode>;
  departureDateRange?: InputMaybe<DateOnlyRangeInput>;
  departureIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  exclusivityType?: InputMaybe<DepartureExclusivityType>;
  extensionRooms?: InputMaybe<Array<TourBedCode>>;
  groupCoordinatorCustomerIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  groupCoordinatorName?: InputMaybe<Scalars['String']>;
  hasActiveExtension?: InputMaybe<Scalars['Boolean']>;
  opportunityIds?: InputMaybe<Array<Scalars['String']>>;
  reconciliationDateRange?: InputMaybe<DateOnlyRangeInput>;
  rooms?: InputMaybe<Array<TourBedCode>>;
  statuses?: InputMaybe<Array<GcDepartureStatus>>;
  tourCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type FilterGcDepartureInput = {
  _id?: InputMaybe<Scalars['ObjectId']>;
  businessCode?: InputMaybe<BusinessCode>;
  departureDateRange?: InputMaybe<DateOnlyRangeInput>;
  departureIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  groupCoordinatorCustomerIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  opportunityIds?: InputMaybe<Array<Scalars['String']>>;
  reconciliationDateRange?: InputMaybe<DateOnlyRangeInput>;
  statuses?: InputMaybe<Array<GcDepartureStatus>>;
  tourCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type FilterGcDepartureMeetingInput = {
  businessCode?: InputMaybe<BusinessCode>;
  displayName?: InputMaybe<Scalars['String']>;
  gcCustomerId?: InputMaybe<Scalars['ObjectId']>;
  gcDepartureId?: InputMaybe<Scalars['ObjectId']>;
  meetingStartDateRange?: InputMaybe<DateRangeInput>;
  rsvpDueDateRange?: InputMaybe<DateOnlyRangeInput>;
  status?: InputMaybe<GcDepartureMeetingStatus>;
  style?: InputMaybe<MeetingStyle>;
};

export type FilterGcDepartureMeetingRsvpInput = {
  attended?: InputMaybe<Scalars['Boolean']>;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  meetingId?: InputMaybe<Scalars['ObjectId']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<GcDepartureMeetingRsvpResponse>;
};

export type FilterGcDepartureProspectInput = {
  email?: InputMaybe<Scalars['String']>;
  gcDepartureId?: InputMaybe<Scalars['ObjectId']>;
  groupCoordinatorCustomerId?: InputMaybe<Scalars['ObjectId']>;
  levelOfInterest?: InputMaybe<Array<GcDepartureProspectLevelOfInterest>>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type FilterGatewayInput = {
  cityCode?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  isCityCodeOnly?: InputMaybe<Scalars['Boolean']>;
};

export type FilterInsurancePlanInput = {
  businessCode?: InputMaybe<BusinessCode>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']>;
  internalName?: InputMaybe<Scalars['String']>;
  planCode?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TripComponentStatus>;
  /** Include only valid active insurance plans. */
  valid?: InputMaybe<Scalars['Boolean']>;
};

export type FilterInsurancePolicyInput = {
  businessCode?: InputMaybe<BusinessCode>;
  providerName?: InputMaybe<Scalars['String']>;
};

export type FilterNoteInput = {
  employeeId?: InputMaybe<Scalars['ObjectId']>;
  targetId?: InputMaybe<Scalars['ObjectId']>;
};

export type FilterOpportunityQuotesInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId: Scalars['ObjectId'];
  expirationDateRange?: InputMaybe<DateRangeInput>;
  /** Will return quotes that have a valid opportunity ID */
  hasOpportunity?: InputMaybe<Scalars['Boolean']>;
  /** Will return quotes that have a GC departure ID */
  isGCDeparture: Scalars['Boolean'];
  /** Will return quotes that are currently saved */
  isSaved?: InputMaybe<Scalars['Boolean']>;
  opportunityId: Scalars['String'];
  /** Will return quotes specific to the rebooking opportunity */
  rebookedFromOrderId?: InputMaybe<Scalars['ObjectId']>;
};

export type FilterOrderInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  departureDate?: InputMaybe<Scalars['Date']>;
  departureId?: InputMaybe<Scalars['ObjectId']>;
  stage?: InputMaybe<OrderStage>;
};

export type FilterPaymentReconciliationTransactionInput = {
  businessCode?: InputMaybe<BusinessCode>;
  reconciliationStatus?: InputMaybe<ReconciliationStatus>;
  uploadDateFrom?: InputMaybe<Scalars['DateTime']>;
  uploadDateTo?: InputMaybe<Scalars['DateTime']>;
  uploadId?: InputMaybe<Scalars['ObjectId']>;
};

export type FilterPaymentReconciliationUploadInput = {
  businessCode?: InputMaybe<BusinessCode>;
  sourceProcessorOrAcquirer?: InputMaybe<SourceProcessorOrAcquirer>;
  uploadDateFrom?: InputMaybe<Scalars['DateTime']>;
  uploadDateTo?: InputMaybe<Scalars['DateTime']>;
};

export type FilterPaymentTransactionInput = {
  amountFrom?: InputMaybe<Scalars['Float']>;
  amountTo?: InputMaybe<Scalars['Float']>;
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  dateBooked?: InputMaybe<Scalars['DateTime']>;
  dateBookedFrom?: InputMaybe<Scalars['DateTime']>;
  dateBookedTo?: InputMaybe<Scalars['DateTime']>;
  departureId?: InputMaybe<Scalars['ObjectId']>;
  initiatedByName?: InputMaybe<Scalars['String']>;
  isAutopay?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['ObjectId']>;
  paymentMethodNumber?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']>>;
  statuses?: InputMaybe<Array<PaymentTransactionStatus>>;
  transactionDateFrom?: InputMaybe<Scalars['DateTime']>;
  transactionDateTo?: InputMaybe<Scalars['DateTime']>;
};

export type FilterPromoInput = {
  /** When provided, promos will be returned in the order they appear in this array */
  _ids?: InputMaybe<Array<Scalars['ObjectId']>>;
  businessCode?: InputMaybe<BusinessCode>;
  customerIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  displayName?: InputMaybe<Scalars['String']>;
  /** The effective start date of a promo. */
  effectiveFrom?: InputMaybe<Scalars['DateTime']>;
  /** The effective end date of a promo. */
  effectiveTo?: InputMaybe<Scalars['DateTime']>;
  exclusivities?: InputMaybe<Array<PromoExclusivity>>;
  exclusivity?: InputMaybe<PromoExclusivity>;
  gcDepartureIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  isGroupsOnly?: InputMaybe<Scalars['Boolean']>;
  isHiddenFromSales?: InputMaybe<Scalars['Boolean']>;
  isIndiesOnly?: InputMaybe<Scalars['Boolean']>;
  lineItemCode?: InputMaybe<Scalars['String']>;
  /** Max number of redemptions */
  maxRedeemed?: InputMaybe<Scalars['Int']>;
  /** Maximum value for the maxRedemptions */
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  /** Min number of redemptions */
  minRedeemed?: InputMaybe<Scalars['Int']>;
  /** Minimum value for the maxRedemptions */
  minRedemptions?: InputMaybe<Scalars['Int']>;
  offerCode?: InputMaybe<Scalars['String']>;
  promoCategories?: InputMaybe<Array<PromoCategory>>;
  promoCodes?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TripComponentStatus>;
  /** Include only valid active promos. */
  valid?: InputMaybe<Scalars['Boolean']>;
  /** Filters for promos that apply to this customerId or have an audience member with this customer id */
  validForCustomerIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Filters for promos that have an audience member with this email */
  validForEmails?: InputMaybe<Array<Scalars['String']>>;
  validForGCDepartureIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Filters for sharable promos that apply to these customerIds or have an audience member with one of these customer ids */
  validShareableCustomerIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Filters for sharable promos that have an audience member with one of these emails */
  validShareableEmails?: InputMaybe<Array<Scalars['String']>>;
};

export type FilterQuoteInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  expirationDateRange?: InputMaybe<DateRangeInput>;
  gcDepartureId?: InputMaybe<Scalars['ObjectId']>;
  /** Will return quotes that have a valid opportunity ID */
  hasOpportunity?: InputMaybe<Scalars['Boolean']>;
  /** Will return quotes that have a GC departure ID */
  isGCDeparture?: InputMaybe<Scalars['Boolean']>;
  /** Will return quotes that are currently saved */
  isSaved?: InputMaybe<Scalars['Boolean']>;
  opportunityId?: InputMaybe<Scalars['String']>;
  /** Will return quotes that have been saved at any point in the past, regardless of their current state */
  previouslySaved?: InputMaybe<Scalars['Boolean']>;
};

export type FilterRoleInput = {
  businessCode?: InputMaybe<BusinessCode>;
  permissionKeys?: InputMaybe<Array<PermissionKey>>;
  query?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type FilterServiceRecoveryInput = {
  businessCode?: InputMaybe<BusinessCode>;
  orderId?: InputMaybe<Scalars['ObjectId']>;
  promoId?: InputMaybe<Scalars['ObjectId']>;
  query?: InputMaybe<Scalars['String']>;
  recoveryReason?: InputMaybe<Scalars['String']>;
  tripId?: InputMaybe<Scalars['ObjectId']>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type FilterStayCityInput = {
  code?: InputMaybe<Scalars['String']>;
  countryName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Filters for tag query */
export type FilterTagInput = {
  businessCode?: InputMaybe<BusinessCode>;
  query?: InputMaybe<Scalars['String']>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type FilterTourContentInput = {
  businessCode?: InputMaybe<BusinessCode>;
  language?: InputMaybe<Scalars['String']>;
  /** Search in tour name and description */
  query?: InputMaybe<Scalars['String']>;
};

/** Filter Tour Directors by specific criteria */
export type FilterTourDirectorInput = {
  _id?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  supplierId?: InputMaybe<Scalars['Int']>;
};

export type FilterTourEndReportInput = {
  departureId?: InputMaybe<Scalars['ObjectId']>;
  tourDirectorId?: InputMaybe<Scalars['ObjectId']>;
};

export type FilterTourExcursionInput = {
  autoApprovedDeadlineDpdFrom?: InputMaybe<Scalars['Int']>;
  autoApprovedDeadlineDpdTo?: InputMaybe<Scalars['Int']>;
  basePriceCADFrom?: InputMaybe<Scalars['Float']>;
  basePriceCADTo?: InputMaybe<Scalars['Float']>;
  basePriceUSDFrom?: InputMaybe<Scalars['Float']>;
  basePriceUSDTo?: InputMaybe<Scalars['Float']>;
  businessCode?: InputMaybe<BusinessCode>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']>;
  hasPriceRules?: InputMaybe<Scalars['Boolean']>;
  internalName?: InputMaybe<Scalars['String']>;
  lineItemCode?: InputMaybe<Scalars['LineItemCode']>;
  matchCode?: InputMaybe<Scalars['String']>;
  minNbTravelersRequiredFrom?: InputMaybe<Scalars['Int']>;
  minNbTravelersRequiredTo?: InputMaybe<Scalars['Int']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  priceYear?: InputMaybe<Scalars['Int']>;
  priceYears?: InputMaybe<Array<Scalars['Int']>>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type FilterTourExcursionSpecInput = {
  businessCode?: InputMaybe<BusinessCode>;
  matchCode?: InputMaybe<Scalars['String']>;
  matchCodes?: InputMaybe<Array<Scalars['String']>>;
  year?: InputMaybe<Scalars['Int']>;
};

export type FilterTourExtensionInput = {
  autoApproveDeadlineDpdFrom?: InputMaybe<Scalars['Int']>;
  autoApproveDeadlineDpdTo?: InputMaybe<Scalars['Int']>;
  basePriceCADFrom?: InputMaybe<Scalars['Float']>;
  basePriceCADTo?: InputMaybe<Scalars['Float']>;
  basePriceUSDFrom?: InputMaybe<Scalars['Float']>;
  basePriceUSDTo?: InputMaybe<Scalars['Float']>;
  bedCodes?: InputMaybe<Array<Scalars['String']>>;
  businessCode?: InputMaybe<BusinessCode>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']>;
  defaultCapacityFrom?: InputMaybe<Scalars['Int']>;
  defaultCapacityTo?: InputMaybe<Scalars['Int']>;
  endGatewayCode?: InputMaybe<Scalars['String']>;
  hasPriceRules?: InputMaybe<Scalars['Boolean']>;
  internalName?: InputMaybe<Scalars['String']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']>;
  isPreExtension?: InputMaybe<Scalars['Boolean']>;
  nbTourDaysFrom?: InputMaybe<Scalars['Int']>;
  nbTourDaysTo?: InputMaybe<Scalars['Int']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  priceYear?: InputMaybe<Scalars['Int']>;
  priceYears?: InputMaybe<Array<Scalars['Int']>>;
  startGatewayCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  tourCode?: InputMaybe<Scalars['String']>;
  tourCodes?: InputMaybe<Array<Scalars['String']>>;
  tourType?: InputMaybe<TourType>;
  tourTypeCode?: InputMaybe<TourTypeCode>;
};

export type FilterTourInput = {
  bedCodes?: InputMaybe<Array<TourBedCode>>;
  businessCode?: InputMaybe<BusinessCode>;
  createdAtRange?: InputMaybe<DateOnlyRangeInput>;
  defaultCapacityFrom?: InputMaybe<Scalars['Int']>;
  defaultCapacityTo?: InputMaybe<Scalars['Int']>;
  hasPriceRules?: InputMaybe<Scalars['Boolean']>;
  hasPrivateGroup?: InputMaybe<Scalars['Boolean']>;
  internalName?: InputMaybe<Scalars['String']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']>;
  isNonRevenueTour?: InputMaybe<Scalars['Boolean']>;
  isPostStayAllowed?: InputMaybe<Scalars['Boolean']>;
  isPreStayAllowed?: InputMaybe<Scalars['Boolean']>;
  isWaitlistAllowed?: InputMaybe<Scalars['Boolean']>;
  maxTravelerAgeFrom?: InputMaybe<Scalars['Int']>;
  maxTravelerAgeTo?: InputMaybe<Scalars['Int']>;
  minTravelerAgeFrom?: InputMaybe<Scalars['Int']>;
  minTravelerAgeTo?: InputMaybe<Scalars['Int']>;
  nbTourDaysFrom?: InputMaybe<Scalars['Int']>;
  nbTourDaysTo?: InputMaybe<Scalars['Int']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  priceYear?: InputMaybe<Scalars['Int']>;
  priceYears?: InputMaybe<Array<Scalars['Int']>>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  tourCode?: InputMaybe<Scalars['String']>;
  tourCodes?: InputMaybe<Array<Scalars['String']>>;
  tourType?: InputMaybe<TourType>;
  tourTypeCode?: InputMaybe<TourTypeCode>;
};

export type FilterTourPageContentInput = {
  businessCode: BusinessCode;
  language: Scalars['String'];
  market: Scalars['String'];
};

export type FilterTourSpecInput = {
  businessCode?: InputMaybe<BusinessCode>;
  tourCode?: InputMaybe<Scalars['String']>;
  tourCodes?: InputMaybe<Array<Scalars['String']>>;
  year?: InputMaybe<Scalars['Int']>;
};

export type FilterTripChecklistItemTemplateInput = {
  businessCode?: InputMaybe<BusinessCode>;
};

export type FilterVoucherInput = {
  bookingId?: InputMaybe<Scalars['ObjectId']>;
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  expirationDateRange?: InputMaybe<DateOnlyRangeInput>;
  isRefundable?: InputMaybe<Scalars['Boolean']>;
  issueDateRange?: InputMaybe<DateOnlyRangeInput>;
  statuses?: InputMaybe<Array<VoucherStatus>>;
};

/** Result of a flight booking request including status, pricing, and confirmation details */
export type FlightBookingResult = {
  __typename?: 'FlightBookingResult';
  /** Unique identifier for this flight booking result */
  _id: Scalars['ObjectId'];
  /** When this booking result was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The line item code for the flight booking result */
  flightShopLineItemCode?: Maybe<Scalars['LineItemCode']>;
  /** Whether the flight is included in the trip price (customer price is $0) */
  isIncluded: Scalars['Boolean'];
  /** The order this flight booking result is for */
  order?: Maybe<Booking>;
  /** The ID of the booking/order this flight booking is for */
  orderId: Scalars['ObjectId'];
  /** The PNR (Passenger Name Record) locator code when status is BOOKED */
  pnrLocator?: Maybe<Scalars['String']>;
  /** Details of price change if status is PRICE_CHANGE */
  priceChange?: Maybe<FlightShopPriceChange>;
  /** The current status of the flight booking. PENDING → VALIDATED/PRICE_CHANGE/SOLUTION_INVALID → BOOKING → BOOKED/USER_UNABLE_TO_BOOK/SOLUTION_INVALID */
  status: FlightBookingResultStatus;
  /** The estimated date at which flight tickets are expected to be released */
  ticketsReleaseDate?: Maybe<Scalars['DateTime']>;
  /** The IDs of the trips associated with the flight booking */
  tripIds: Array<Scalars['ObjectId']>;
  /** When this booking result was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Selected flight solution is no longer valid */
export type FlightBookingResultInvalidSolutionError = DomainError & {
  __typename?: 'FlightBookingResultInvalidSolutionError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  /** The ID of the invalid solution */
  externalSolutionId: Scalars['String'];
  message: Scalars['String'];
  /** Why the solution is invalid */
  reason: Scalars['String'];
};

/** Booking operation attempted on entity in wrong state */
export type FlightBookingResultInvalidStateError = DomainError & {
  __typename?: 'FlightBookingResultInvalidStateError';
  code: Scalars['String'];
  /** The current status of the booking result */
  currentStatus: FlightBookingResultStatus;
  /** The status the operation was trying to reach */
  destinationStatus: FlightBookingResultStatus;
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  /** The expected status for this operation */
  expectedStatus: FlightBookingResultStatus;
  message: Scalars['String'];
};

/** Invalid status transition attempted */
export type FlightBookingResultInvalidStatusTransitionError = DomainError & {
  __typename?: 'FlightBookingResultInvalidStatusTransitionError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  /** The current status */
  fromStatus: FlightBookingResultStatus;
  message: Scalars['String'];
  /** The attempted target status */
  toStatus: FlightBookingResultStatus;
};

/** Status of a flight booking request */
export enum FlightBookingResultStatus {
  Booked = 'BOOKED',
  Booking = 'BOOKING',
  InternalError = 'INTERNAL_ERROR',
  Pending = 'PENDING',
  PriceChange = 'PRICE_CHANGE',
  SolutionInvalid = 'SOLUTION_INVALID',
  UserUnableToBook = 'USER_UNABLE_TO_BOOK',
  Validated = 'VALIDATED'
}

/** A flight shopping leg */
export type FlightLeg = {
  __typename?: 'FlightLeg';
  arrivalGatewayCode: Scalars['String'];
  departureDate: Scalars['Date'];
  departureGatewayCode: Scalars['String'];
  flightType: FlightType;
};

export type FlightOffer = {
  __typename?: 'FlightOffer';
  appliedToTrip: Scalars['Boolean'];
  discountAmount?: Maybe<Money>;
  flight: FlightPackage;
  salePrice?: Maybe<Money>;
};

/** Common interface for flight options (outbound and return) */
export type FlightOption = {
  /** Unique identifier for this flight option */
  _id: Scalars['ObjectId'];
  /**
   * Arrival date of the last segment (for sorting)
   * @deprecated Use localArrivalDateTime instead
   */
  arrivalDateTime?: Maybe<Scalars['Date']>;
  /** Number of allowed checked bags */
  baggageCount?: Maybe<Scalars['Int']>;
  /** Unique marketing carrier codes from all segments (for sorting/filtering) */
  carrierCodes: Array<Scalars['String']>;
  /**
   * Departure date of the first segment (for sorting)
   * @deprecated Use localDepartureDateTime instead
   */
  departureDateTime?: Maybe<Scalars['Date']>;
  /** The direction of travel */
  direction: Direction;
  /** Whether this option is included in the flight package price */
  isIncluded: Scalars['Boolean'];
  /** Local arrival date/time of the last segment (for sorting) */
  localArrivalDateTime?: Maybe<Scalars['LocalDateTime']>;
  /** Local departure date/time of the first segment (for sorting) */
  localDepartureDateTime?: Maybe<Scalars['LocalDateTime']>;
  /** Unique operating carrier codes from all segments (for sorting/filtering) */
  operatingCarrierCodes: Array<Scalars['String']>;
  /** The flight segments that make up this option */
  segments: Array<FlightShoppingSegment>;
  /** Total number of stops (connections between segments) (for sorting) */
  stopCount: Scalars['Int'];
  /** Total duration from first departure to final arrival, including layovers */
  totalDuration: Duration;
  /** Total price for all travelers */
  totalPrice: Money;
};

/** Product that represents a flight from one Gateway to another */
export type FlightPackage = PricedTripComponent & TripComponent & {
  __typename?: 'FlightPackage';
  _id: Scalars['ObjectId'];
  /** Additional information about the arrival gateway */
  arrivalGateway?: Maybe<Gateway>;
  arrivalGatewayCode: Scalars['String'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  /** Additional information about the departure gateway */
  departureGateway?: Maybe<Gateway>;
  departureGatewayCode: Scalars['String'];
  hasPriceRules: Scalars['Boolean'];
  isCustomGateway: Scalars['Boolean'];
  isLandOnly: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  /** Price for a given departure date */
  price: Amount;
  priceRules: Array<PriceRule>;
  status: TripComponentStatus;
  type: TripComponentType;
};


/** Product that represents a flight from one Gateway to another */
export type FlightPackagePriceArgs = {
  departureDate: Scalars['Date'];
};

export enum FlightPackageCancellationReason {
  FlightAdditionalCostOrFees = 'FLIGHT_ADDITIONAL_COST_OR_FEES',
  FlightPackageDatesOrGatewaysChanged = 'FLIGHT_PACKAGE_DATES_OR_GATEWAYS_CHANGED',
  ItineraryOutsideWojoContracts = 'ITINERARY_OUTSIDE_WOJO_CONTRACTS',
  ItineraryPnrOrSeatingPreference = 'ITINERARY_PNR_OR_SEATING_PREFERENCE',
  MilesOrCreditCardPoints = 'MILES_OR_CREDIT_CARD_POINTS',
  PoorExperienceWithStaff = 'POOR_EXPERIENCE_WITH_STAFF',
  TripCancelledOrRebooked = 'TRIP_CANCELLED_OR_REBOOKED'
}

/** Departing or Returning flight line item and configuration */
export type FlightPackageLineItem = LineItem & {
  __typename?: 'FlightPackageLineItem';
  _id: Scalars['ObjectId'];
  airportTransfer?: Maybe<AirportTransfer>;
  /** Additional information about the arrival gateway */
  arrivalGateway?: Maybe<Gateway>;
  arrivalGatewayCode: Scalars['String'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  departureDate: Scalars['Date'];
  /** Additional information about the departure gateway */
  departureGateway?: Maybe<Gateway>;
  departureGatewayCode: Scalars['String'];
  flightPackageCancellationReason?: Maybe<FlightPackageCancellationReason>;
  flightType: FlightType;
  isEligibleForAirportTransfer?: Maybe<Scalars['Boolean']>;
  isLandOnly: Scalars['Boolean'];
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  stopOver?: Maybe<StopOver>;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

/** A paginated result of Flight Packages */
export type FlightPackagePaginatedResult = {
  __typename?: 'FlightPackagePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<FlightPackage>;
  totalCount: Scalars['Int'];
};

/** Travelers grouped by shared flight routing (one-way, roundtrip, or open-jaw) from open flight line items */
export type FlightRoutingGroup = {
  __typename?: 'FlightRoutingGroup';
  /** Outbound leg; null for one-way-returning groups */
  departingLeg?: Maybe<FlightRoutingGroupLeg>;
  /** Return leg; null for one-way-departing groups */
  returningLeg?: Maybe<FlightRoutingGroupLeg>;
  travelers: Array<FlightRoutingGroupTraveler>;
  type: FlightRoutingGroupType;
};

/** A flight leg with departure and arrival gateways */
export type FlightRoutingGroupLeg = {
  __typename?: 'FlightRoutingGroupLeg';
  arrivalGateway: Gateway;
  departureDate: Scalars['Date'];
  departureGateway: Gateway;
};

/** A traveler within a flight routing group */
export type FlightRoutingGroupTraveler = {
  __typename?: 'FlightRoutingGroupTraveler';
  customer: Customer;
  tripId: Scalars['ObjectId'];
  tsaInfo?: Maybe<TsaInformation>;
};

/** Route shape: one-way (departing or returning), roundtrip, or open-jaw */
export enum FlightRoutingGroupType {
  OneWayDeparting = 'ONE_WAY_DEPARTING',
  OneWayReturning = 'ONE_WAY_RETURNING',
  OpenJaw = 'OPEN_JAW',
  Roundtrip = 'ROUNDTRIP'
}

/** Flight settings */
export type FlightSettings = {
  __typename?: 'FlightSettings';
  /** List of allowed remote gateway, those on tour, for flight shopping as IATA airport codes or IATA MAC (city) codes */
  allowedFlightShoppingRemoteGateways: Array<Scalars['String']>;
  /** List of gateway codes where stopovers are allowed */
  allowedStopoverGatewayCodes: Array<Scalars['String']>;
  /** Business level setting if the flight shopping feature is enabled for Canadian origin gateways */
  enableFlightShoppingFromCanadianOriginGateways: Scalars['Boolean'];
  /** Business level setting if the flight shopping feature is enabled for US origin gateways. */
  enableFlightShoppingFromUSOriginGateways: Scalars['Boolean'];
  /** Commission percentage applied to the difference in cost between lowest price and user's selection (only if not in included range) */
  flightShoppingAddCollectCommissionPercentage: Scalars['Percentage'];
  /** DPD from which we will allow users to select their flights */
  flightShoppingAllowedFromDpd: Scalars['Int'];
  /** DPD until which we allow users to select their flights if they have immediately purchased their trip */
  flightShoppingAllowedUntilDpd: Scalars['Int'];
  /** Percentage above the lowest price that will be marked as included */
  flightShoppingIncludedPercentage: Scalars['Percentage'];
  /** Optional dollar maximum for the included range */
  flightShoppingMaxIncludedAmount: Amount;
  /** DPD by which flight tickets are expected to be released for flight shopping */
  flightShoppingTicketsReleaseDpd: Scalars['Int'];
  /** The max percentage of the flight package price that the lowest priced flight option is allowed to be */
  flightsPackageCeilingPercentage: Scalars['Percentage'];
  /** Dollar value to round the total up to */
  flightsShoppingRoundingDollar: Scalars['Int'];
  /** Settings for lost baggage service availability */
  lostBaggageServiceSettings: LostBaggageServiceSettings;
  /** Number of days after either the shopping window has opened or a user has purchased a flight that we will allow them to enter the Flight Shopping Flow */
  numberOfDaysToAllowFlightShopping: Scalars['Int'];
};

/** A Flight Shop trip component that defines pricing rules for flight shopping */
export type FlightShop = TripComponent & {
  __typename?: 'FlightShop';
  _id: Scalars['ObjectId'];
  addCollectCommissionPercentage: Scalars['Percentage'];
  businessCode?: Maybe<BusinessCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  includedPercentage: Scalars['Percentage'];
  isPublished: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  maxIncludedAmount?: Maybe<Amount>;
  packageCeilingPercentage: Scalars['Percentage'];
  roundingAmount: Amount;
  serviceLevel: ServiceLevel;
  status: TripComponentStatus;
  type: TripComponentType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Flight shopping eligibility status for a booking trip. */
export type FlightShopEligibilityResult = {
  __typename?: 'FlightShopEligibilityResult';
  businessCode: BusinessCode;
  customerId: Scalars['ObjectId'];
  deadlineDate?: Maybe<Scalars['Date']>;
  departureDate: Scalars['Date'];
  isAllowed: Scalars['Boolean'];
  orderId: Scalars['ObjectId'];
  reason?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  tripId: Scalars['ObjectId'];
  windowStatus: FlightShoppingWindowStatus;
};

export type FlightShopEligibilityResultPaginatedResult = {
  __typename?: 'FlightShopEligibilityResultPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<FlightShopEligibilityResult>;
};

/** Flight shop line item */
export type FlightShopLineItem = LineItem & {
  __typename?: 'FlightShopLineItem';
  _id: Scalars['ObjectId'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  departingFlight?: Maybe<FlightLeg>;
  flights: Array<FlightLeg>;
  gdsSource: Scalars['String'];
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  price: Money;
  recordLocator: Scalars['String'];
  returningFlight?: Maybe<FlightLeg>;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

/** A paginated result of Flight Shop components */
export type FlightShopPaginatedResult = {
  __typename?: 'FlightShopPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<FlightShop>;
};

/** Details of a price change detected during flight booking revalidation */
export type FlightShopPriceChange = {
  __typename?: 'FlightShopPriceChange';
  /** The new price per customer after price change */
  newPricePerCustomer: Money;
  /** The new total price after price change */
  newTotalPrice: Money;
  /** When the price change was detected */
  occurredAt: Scalars['DateTime'];
  /** The original price per customer before price change */
  originalPricePerCustomer: Money;
  /** The original total price before price change */
  originalTotalPrice: Money;
  /** The difference in price per customer */
  priceDifferencePerCustomer: Money;
  /** The difference in total price */
  priceDifferenceTotal: Money;
};

/** Represents the overall result of a flight shopping request, including status and available flight options */
export type FlightShoppingResult = {
  __typename?: 'FlightShoppingResult';
  /** Internal unique identifier for this flight shop result */
  _id: Scalars['ObjectId'];
  /** Whether the shop request can be retried if it failed */
  canRetry?: Maybe<Scalars['Boolean']>;
  /** Available outbound flight options with their return options. Empty when status is PENDING */
  outboundFlightOptions: Array<OutboundFlightOption>;
  /** The ID of the FlightShopSession that triggered this result */
  sessionId: Scalars['ObjectId'];
  /** The current status of the flight shopping request */
  status: FlightShoppingResultStatus;
  /** The trips associated with this flight shopping request */
  trips: Array<Trip>;
};

export enum FlightShoppingResultStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Timeout = 'TIMEOUT'
}

/** Represents a flight segment in a shopping result */
export type FlightShoppingSegment = {
  __typename?: 'FlightShoppingSegment';
  /** The arrival date (YYYY-MM-DD) for this segment in Airport Local Time */
  arrivalDate: Scalars['Date'];
  /** Additional information about the arrival gateway for this flight segment */
  arrivalGateway?: Maybe<Gateway>;
  /** Arrival gateway/airport code */
  arrivalGatewayCode: Scalars['String'];
  /** A string representing the time (in local airport time) that the flight arrives at the arrival gateway. This string should be displayed by converting it to a date with no time zone adjustment, before formatting */
  arrivalTime: Scalars['Time'];
  /**
   * The arrival time (HH:MM) for this segment in Airport Local Time
   * @deprecated Use arrivalTime instead
   */
  arrivesAtLocalTime: Scalars['String'];
  /** The booking/fare class code */
  bookingClass?: Maybe<Scalars['String']>;
  /** The cabin class (ECONOMY, PREMIUM_ECONOMY, BUSINESS, FIRST) */
  cabinClass?: Maybe<CabinClass>;
  /** Marketing carrier */
  carrier?: Maybe<Airline>;
  /** Marketing carrier airline code */
  carrierCode: Scalars['String'];
  /**
   * The departure time (HH:MM) for this segment in Airport Local Time
   * @deprecated Use departureTime instead
   */
  departsAtLocalTime: Scalars['String'];
  /** The departure date (YYYY-MM-DD) for this segment in Airport Local Time */
  departureDate: Scalars['Date'];
  /** Additional information about the departure gateway for this flight segment */
  departureGateway?: Maybe<Gateway>;
  /** Departure gateway/airport code */
  departureGatewayCode: Scalars['String'];
  /** A string representing the time (in local airport time) that the flight departs from the departure gateway. This string should be displayed by converting it to a date with no time zone adjustment, before formatting */
  departureTime: Scalars['Time'];
  /** Duration of the flight segment */
  duration: Duration;
  equipment?: Maybe<Scalars['String']>;
  /** Resolved aircraft equipment type with human-readable name and specifications */
  equipmentType?: Maybe<AircraftEquipmentType>;
  /** The flight number for the marketing carrier */
  flightNumber: Scalars['String'];
  /** The duration of the layover after this segment, if applicable */
  layoverDuration?: Maybe<Duration>;
  /** Operating carrier */
  operatedByCarrier?: Maybe<Airline>;
  /** Operating carrier airline code */
  operatingCarrierCode?: Maybe<Scalars['String']>;
  /** The flight number for the operating carrier */
  operatingCarrierFlightNumber?: Maybe<Scalars['String']>;
};

/** Flight shopping availability and window information for a booking. */
export type FlightShoppingStatus = {
  __typename?: 'FlightShoppingStatus';
  /** The deadline date for flight shopping. Null only if structurally ineligible. */
  deadlineDate?: Maybe<Scalars['Date']>;
  /** Whether flight shopping is currently allowed (status === OPEN). */
  isAllowed: Scalars['Boolean'];
  /** The reason flight shopping is not eligible, if applicable. */
  reason?: Maybe<Scalars['String']>;
  /** The date when flight shopping becomes/became available. Null only if structurally ineligible. */
  startDate?: Maybe<Scalars['Date']>;
  /** The current status of the flight shopping window. */
  status: FlightShoppingWindowStatus;
};

/** Validation error for flight shopping trips */
export type FlightShoppingTripsValidationError = DomainError & {
  __typename?: 'FlightShoppingTripsValidationError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The current status of the flight shopping window for a booking. */
export enum FlightShoppingWindowStatus {
  BeforeWindow = 'BEFORE_WINDOW',
  Expired = 'EXPIRED',
  NotEligible = 'NOT_ELIGIBLE',
  Open = 'OPEN'
}

export enum FlightType {
  Departing = 'DEPARTING',
  Returning = 'RETURNING'
}

export type ForkBookingInput = {
  fromBookingId: Scalars['ObjectId'];
  newPrimaryTripId: Scalars['ObjectId'];
  transferInputs: Array<ForkTransferInput>;
  tripIds: Array<Scalars['ObjectId']>;
};

export type ForkBookingResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type ForkTransferInput = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  paymentMethodHash?: InputMaybe<Scalars['String']>;
  /** @deprecated Please begin using paymentMethodHash */
  savedPaymentMethodId?: InputMaybe<Scalars['ObjectId']>;
};

/** A collection of travelers (GMs) booking under a Group Coordinator (GC) on a given Departure */
export type GcDeparture = {
  __typename?: 'GCDeparture';
  _id: Scalars['ObjectId'];
  /** The actual price of the private group fee, if it were assessed based on the number of confirmed trips at the time of the API call. */
  actualPrivateGroupFeePrice?: Maybe<Money>;
  /** Adjustments that will be automatically applied to new GM quotes for this GC Departure */
  autoAppliedAdjustments: Array<GcDepartureAdjustment>;
  averageProgramPrice?: Maybe<Money>;
  businessCode: BusinessCode;
  cancelledTrips?: Maybe<Array<BookingTrip>>;
  /** The percentage of the average program fee that counts towards a companion discount for each traveler not already counting towards a free place */
  companionDiscountRate: GcDepartureBenefitRate;
  /** A summary of the companion discount benefit for the GC */
  companionDiscountSummary?: Maybe<GcDepartureCompanionDiscountSummary>;
  confirmedTrips?: Maybe<Array<BookingTrip>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  departure?: Maybe<Departure>;
  /** The date of the departure */
  departureDate: Scalars['Date'];
  /** The Departure this group is traveling on */
  departureId: Scalars['ObjectId'];
  /** Includes the date at which eTicket information is released, and whether or not it is already released */
  eTicketsRelease?: Maybe<ReleaseDetails>;
  /** The price of the private group fee, if it were assessed based on the estimated group size. Used as an estimation tool. Requires the groupSizeEstimate to be set. */
  estimatedPrivateGroupFeePrice?: Maybe<Money>;
  /** The expected number of travelers in the group, used as the stretch goal for the GC */
  expectedVolume?: Maybe<Scalars['Int']>;
  /** Includes the date at which flights are released, and whether or not they are already released */
  flightsRelease?: Maybe<ReleaseDetails>;
  /** The date at which flights are released */
  flightsReleasedDate?: Maybe<Scalars['Date']>;
  /** The rate at which the GC earns free places based on the number of travelers paying for an insurance plan */
  freeInsuranceRatio: Scalars['FreePlaceRatio'];
  /** The rate at which the GC earns free places based on the number of travelers paying for a certain trip component */
  freePlaceRatio: Scalars['FreePlaceRatio'];
  /** A breakdown of free places earned and applied for the various components of bookings on this GCDeparture */
  freePlaceSummary: GcDepartureFreePlaceSummary;
  gcDepartureMeetings?: Maybe<Array<GcDepartureMeeting>>;
  gcProfileContent?: Maybe<GcProfileContent>;
  groupCoordinator?: Maybe<Customer>;
  /** The customer ID of the GC for this group */
  groupCoordinatorCustomerId: Scalars['ObjectId'];
  /** A configurable estimate of the number of travelers, used to estimate the private group fee */
  groupSizeEstimate?: Maybe<Scalars['Int']>;
  /** Whether or not the private group fee should be assessed at the time of reconciliation */
  includePrivateGroupFee?: Maybe<Scalars['Boolean']>;
  isCancelled: Scalars['Boolean'];
  isConfirmed: Scalars['Boolean'];
  /** Whether or not GCs can participate in the Free Place program */
  isFreePlaceEnabled: Scalars['Boolean'];
  isGroupCoordinator: Scalars['Boolean'];
  isNonBookedGroupCoordinator: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  /** Rules that govern whether certain line items must, should, or cannot be added to group member trips */
  lineItemRules?: Maybe<Array<GcDepartureRule>>;
  micrositeContent?: Maybe<MicrositeContent>;
  /**
   * The URL of the microsite where GMs can quote and book
   * @deprecated Use micrositeUrls instead
   */
  micrositeUrl?: Maybe<Scalars['String']>;
  micrositeUrls: GcDepartureMicrositeUrls;
  nbTravelersCancelled: Scalars['Int'];
  nbTravelersConfirmed: Scalars['Int'];
  nbTravelersConfirmedLandOnly: Scalars['Int'];
  nbTravelersConfirmedWithFlights: Scalars['Int'];
  nbTravelersRebooked: Scalars['Int'];
  nbTravelersRequested: Scalars['Int'];
  nbTravelersWaitlisted: Scalars['Int'];
  nbTravelersWithExtension: Scalars['Int'];
  nbTravelersWithInsurance: Scalars['Int'];
  nextConfirmedMeeting?: Maybe<GcDepartureMeeting>;
  /** @deprecated No longer a valid status */
  onHoldTrips?: Maybe<Array<BookingTrip>>;
  /** The Salesforce Opportunity ID associated with this GCDeparture, if any */
  opportunityId?: Maybe<Scalars['String']>;
  pendingRebookingTrips?: Maybe<Array<BookingTrip>>;
  /** The primary currency code that will be used to generate price previews and record benefits */
  primaryCurrencyCode: CurrencyCode;
  /** A summary of the pricing for a potential group member quote for this GCDeparture */
  quoteSummary?: Maybe<GcDepartureQuoteSummary>;
  rebookedTrips?: Maybe<Array<BookingTrip>>;
  /** Rules that govern whether certain line items should be added to group member trips */
  recommendedLineItemRules?: Maybe<Array<GcDepartureRule>>;
  /** The date at which EF will review the GCDeparture to assess fees and redeem benefits for the GC */
  reconciliationDate: Scalars['Date'];
  /** The date of the recruitment meeting for the GC to promote the GCDeparture */
  recruitmentMeetingDate?: Maybe<Scalars['Date']>;
  /** The remaining amount of money available to be awarded to the GC a stipend, based on the average program price and any stipend already redeemed */
  remainingStipendAmountAvailable?: Maybe<Money>;
  requestedTrips?: Maybe<Array<BookingTrip>>;
  /** Rules that govern whether certain line items must be added to group member trips */
  requiredLineItemRules?: Maybe<Array<GcDepartureRule>>;
  /** Rules that govern whether certain line items cannot be added to group member trips */
  restrictedLineItemRules?: Maybe<Array<GcDepartureRule>>;
  status: GcDepartureStatus;
  /** A breakdown of the stipend benefit for the GC */
  stipendDetail?: Maybe<GcDepartureStipendDetail>;
  /** The percentage of the average program fee that counts towards the stipend for each traveler not already counting towards a free place */
  stipendRate: GcDepartureBenefitRate;
  /** The terms signed by the group coordinator */
  termsSignature?: Maybe<TermsSignature>;
  /** The tour code associated with the departure */
  tourCode: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  waitlistedTrips?: Maybe<Array<BookingTrip>>;
};


/** A collection of travelers (GMs) booking under a Group Coordinator (GC) on a given Departure */
export type GcDepartureGcProfileContentArgs = {
  language: Scalars['String'];
};


/** A collection of travelers (GMs) booking under a Group Coordinator (GC) on a given Departure */
export type GcDepartureMicrositeContentArgs = {
  language: Scalars['String'];
};

/** Configuration allowing the user to specify which adjustments should auto-apply to GM quotes on a GC Departure. Prices are determined by the settings in this object and visibility is set on the Adjustment itself */
export type GcDepartureAdjustment = {
  __typename?: 'GCDepartureAdjustment';
  adjustment?: Maybe<Adjustment>;
  amount: Amount;
  lineItemCode: Scalars['LineItemCode'];
  /** @deprecated Do not use this field. This field is no longer in use and will be removed in a future release. We're keeping it for backward compatibility. Use amount instead. */
  price: Money;
};

/** An integer representing the percentage a GC earns when redeeming certain types of benefits */
export type GcDepartureBenefitRate = {
  __typename?: 'GCDepartureBenefitRate';
  asDecimal: Scalars['Float'];
  value: Scalars['Float'];
};

export enum GcDepartureCancellationCategory {
  Financial = 'FINANCIAL',
  LifeEvent = 'LIFE_EVENT',
  ProductTransition = 'PRODUCT_TRANSITION',
  TravelerDiscontent = 'TRAVELER_DISCONTENT',
  TravelRequirementNotMet = 'TRAVEL_REQUIREMENT_NOT_MET',
  Unknown = 'UNKNOWN',
  WojoCancellation = 'WOJO_CANCELLATION',
  WorldEvent = 'WORLD_EVENT'
}

export type GcDepartureCompanionDiscountSummary = {
  __typename?: 'GCDepartureCompanionDiscountSummary';
  /** The total amount of money that has been applied to trips as a companion discount */
  amountApplied: Money;
  /** The remaining amount of money available to be applied to trips as a companion discount */
  amountAvailable: Money;
  /** The IDs of the trips that have had the companion discount applied to them */
  appliedToTripIds: Array<Scalars['ObjectId']>;
  /** The trips that have had the companion discount applied to them */
  appliedToTrips: Array<BookingTrip>;
};

/** A preview of a flight package that a group member could add to their quote */
export type GcDepartureFlightPackageSummary = {
  __typename?: 'GCDepartureFlightPackageSummary';
  /** The date that this flight will depart based on whether the extension is recommended or required */
  departureDate: Scalars['Date'];
  flightPackage: FlightPackage;
  /** The price in the gcDeparture's primaryCurrencyCode */
  price: Money;
};

export type GcDepartureFreePlaceDetail = {
  __typename?: 'GCDepartureFreePlaceDetail';
  /** The IDs of the trips that have had the free places applied to them for this trip component */
  appliedToTripIds: Array<Scalars['ObjectId']>;
  /** The trips that have had the free places applied to them for this trip component */
  appliedToTrips: Array<BookingTrip>;
  /** The number of free places earned for this trip component */
  placesEarned: Scalars['Int'];
};

export type GcDepartureFreePlaceExcursionDetail = {
  __typename?: 'GCDepartureFreePlaceExcursionDetail';
  /** The IDs of the trips that have had the free places applied to them */
  appliedToTripIds: Array<Scalars['ObjectId']>;
  /** The trips that have had the free places applied to them */
  appliedToTrips: Array<BookingTrip>;
  /** The line item code of the excursion */
  lineItemCode: Scalars['LineItemCode'];
  /** The number of free places earned for the excursion */
  placesEarned: Scalars['Int'];
};

export type GcDepartureFreePlaceSummary = {
  __typename?: 'GCDepartureFreePlaceSummary';
  excursions: Array<GcDepartureFreePlaceExcursionDetail>;
  extension?: Maybe<GcDepartureFreePlaceDetail>;
  insurance: GcDepartureFreePlaceDetail;
  tour: GcDepartureFreePlaceDetail;
};

/** A meeting for a group departure */
export type GcDepartureMeeting = {
  __typename?: 'GCDepartureMeeting';
  _id: Scalars['ObjectId'];
  allowsLateRSVP: Scalars['Boolean'];
  businessCode: BusinessCode;
  canRSVP: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The identity of the user who created the record */
  createdBy?: Maybe<AuditIdentity>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  gcDeparture?: Maybe<GcDeparture>;
  gcDepartureId: Scalars['ObjectId'];
  /** A URL that potential attendees can use to RSVP for this meeting */
  link?: Maybe<GcDepartureMeetingUrls>;
  /** Where this meeting will take place */
  location?: Maybe<Scalars['String']>;
  meetingDateRange: DateTimeRange;
  /** The count of RSVPs for the meeting that have been marked as having attended the meeting */
  nbAttended: Scalars['Int'];
  /** The count of RSVPs for the meeting that have indicated that they will be attending the meeting */
  nbAttending: Scalars['Int'];
  /** The count of RSVPs for the meeting that have indicated they are interested in attending the meeting */
  nbInterested: Scalars['Int'];
  /** The count of RSVPs for the meeting that have indicated they will not be attending the meeting */
  nbNotAttending: Scalars['Int'];
  /** The total count of RSVPs for the meeting */
  nbRsvps: Scalars['Int'];
  rsvpDueDate: Scalars['Date'];
  rsvpDueDateIsPast: Scalars['Boolean'];
  rsvps: Array<GcDepartureMeetingRsvp>;
  status: GcDepartureMeetingStatus;
  style: MeetingStyle;
  /** IANA timezone identifier for client-side display of meeting times */
  timezone: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The identity of the user who last updated the record */
  updatedBy?: Maybe<AuditIdentity>;
  /** A link to join this meeting virtually */
  virtualMeetingLink?: Maybe<Scalars['String']>;
};

/** A paginated result of Departure Meetings */
export type GcDepartureMeetingPaginatedResult = {
  __typename?: 'GCDepartureMeetingPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<GcDepartureMeeting>;
};

/** A response to a departure meeting */
export type GcDepartureMeetingRsvp = {
  __typename?: 'GCDepartureMeetingRSVP';
  _id: Scalars['ObjectId'];
  attended?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The identity of the user who created the record */
  createdBy?: Maybe<AuditIdentity>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ObjectId']>;
  email?: Maybe<Scalars['Email']>;
  firstName?: Maybe<Scalars['String']>;
  /** Whether the RSVP was submitted after the meeting's due date */
  isLateRSVP: Scalars['Boolean'];
  /** Whether the RSVP is the primary RSVP */
  isPrimary: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  meetingId: Scalars['ObjectId'];
  notes?: Maybe<Scalars['String']>;
  /** The ID of the primary RSVP */
  parentRsvpId?: Maybe<Scalars['ObjectId']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  response: GcDepartureMeetingRsvpResponse;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The identity of the user who last updated the record */
  updatedBy?: Maybe<AuditIdentity>;
};

/** A paginated result of Departure Meeting RSVPS */
export type GcDepartureMeetingRsvpPaginatedResult = {
  __typename?: 'GCDepartureMeetingRSVPPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<GcDepartureMeetingRsvp>;
  totalCount: Scalars['Int'];
};

export enum GcDepartureMeetingRsvpResponse {
  Attending = 'ATTENDING',
  Interested = 'INTERESTED',
  NotAttending = 'NOT_ATTENDING'
}

export enum GcDepartureMeetingRsvpSortField {
  UpdatedAt = 'updatedAt'
}

export enum GcDepartureMeetingStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED'
}

export type GcDepartureMeetingUrls = {
  __typename?: 'GCDepartureMeetingUrls';
  ca?: Maybe<Scalars['String']>;
  us?: Maybe<Scalars['String']>;
};

export type GcDepartureMicrositeUrls = {
  __typename?: 'GCDepartureMicrositeUrls';
  ca?: Maybe<Scalars['String']>;
  us?: Maybe<Scalars['String']>;
};

/** A paginated result of Departures */
export type GcDeparturePaginatedResult = {
  __typename?: 'GCDeparturePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<GcDeparture>;
};

/** A prospective traveler aspiring to book under a Group Coordinator (GC) on a given Departure */
export type GcDepartureProspect = {
  __typename?: 'GCDepartureProspect';
  _id: Scalars['ObjectId'];
  address?: Maybe<Address>;
  bookedTrip?: Maybe<BookingTrip>;
  businessCode?: Maybe<BusinessCode>;
  cancelledTrip?: Maybe<BookingTrip>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The identity of the user or service who created the prospect */
  createdBy?: Maybe<AuditIdentity>;
  customer?: Maybe<Customer>;
  email?: Maybe<Scalars['Email']>;
  firstName: Scalars['String'];
  gcDeparture?: Maybe<GcDeparture>;
  gcDepartureId: Scalars['ObjectId'];
  groupCoordinatorCustomerId: Scalars['ObjectId'];
  isBooked: Scalars['Boolean'];
  /** Check if GC Departure of the Prospect is in the past */
  isPast?: Maybe<Scalars['Boolean']>;
  /** Whether this prospect is visible to the Sales team */
  isVisibleToSales: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  levelOfInterest?: Maybe<GcDepartureProspectLevelOfInterest>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Date and time from which this prospect is visible to the Sales team */
  visibleToSalesFrom?: Maybe<Scalars['DateTime']>;
};

export enum GcDepartureProspectLevelOfInterest {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** A paginated result of GC Departure Prospects. */
export type GcDepartureProspectPaginatedResult = {
  __typename?: 'GCDepartureProspectPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<GcDepartureProspect>;
};

export type GcDepartureProspectRemovedResult = {
  __typename?: 'GCDepartureProspectRemovedResult';
  removedId: Scalars['ObjectId'];
};

export enum GcDepartureProspectSortField {
  BusinessCode = 'businessCode',
  CustomerId = 'customerId',
  Email = 'email',
  FirstName = 'firstName',
  GcDepartureId = 'gcDepartureId',
  GroupCoordinatorCustomerId = 'groupCoordinatorCustomerId',
  LastName = 'lastName',
  LevelOfInterest = 'levelOfInterest',
  Notes = 'notes',
  PhoneNumber = 'phoneNumber'
}

/** A slice of the pricing summary of a potential group member quote for a GC departure */
export type GcDepartureQuoteSummary = {
  __typename?: 'GCDepartureQuoteSummary';
  departingFlightSummary?: Maybe<GcDepartureFlightPackageSummary>;
  insurancePlanOffers: Array<InsurancePlanOffer>;
  privateGroupFeePrice?: Maybe<Money>;
  returningFlightSummary?: Maybe<GcDepartureFlightPackageSummary>;
  totalFlightPackagePrice?: Maybe<Money>;
  /** The base price of the quote with all items recommended by the GC. Includes the tour, extension, optionals, and flight packages */
  totalWithRecommendItems: Money;
  /** The base price of the quote with all items required by the GC. Includes the tour, extension, optionals, and flight packages */
  totalWithRequiredItems: Money;
};

export type GcDepartureQuoteSummaryAdjustmentInput = {
  amount: Array<MoneyInput>;
  lineItemCode: Scalars['LineItemCode'];
  /** @deprecated Do not use this field. This field is no longer in use and will be removed in a future release. We're keeping it for backward compatibility. Use amount instead. */
  price?: MoneyInput;
};

export type GcDepartureQuoteSummaryInput = {
  /** The ID of the GC Departure to calculate a quote summary for */
  _id: Scalars['ObjectId'];
  autoAppliedAdjustments?: InputMaybe<Array<GcDepartureQuoteSummaryAdjustmentInput>>;
  effectivePrivateGroupFeeGroupSize?: InputMaybe<Scalars['Int']>;
  includePrivateGroupFee?: InputMaybe<Scalars['Boolean']>;
  lineItemRules: Array<GcDepartureQuoteSummaryLineItemRuleInput>;
};

export type GcDepartureQuoteSummaryLineItemRuleInput = {
  level: GcDepartureRuleLevel;
  lineItemCode: Scalars['LineItemCode'];
  lineItemType: GcDepartureRuleLineItemType;
};

export type GcDepartureRewardsIntegrationResult = {
  __typename?: 'GCDepartureRewardsIntegrationResult';
  integratedId: Scalars['ObjectId'];
};

/** Allows a GC to require, recommend, or restrict certains line item */
export type GcDepartureRule = {
  __typename?: 'GCDepartureRule';
  level: GcDepartureRuleLevel;
  lineItemCode: Scalars['LineItemCode'];
  lineItemType: GcDepartureRuleLineItemType;
};

export enum GcDepartureRuleLevel {
  Recommended = 'RECOMMENDED',
  Required = 'REQUIRED',
  Restricted = 'RESTRICTED'
}

export enum GcDepartureRuleLineItemType {
  DepartingFlight = 'DEPARTING_FLIGHT',
  Excursion = 'EXCURSION',
  Extension = 'EXTENSION',
  ReturningFlight = 'RETURNING_FLIGHT'
}

/** GC Departure settings */
export type GcDepartureSettings = {
  __typename?: 'GCDepartureSettings';
  /** The DPD at which this business expects flight segments to have e-ticket numbers populated */
  eTicketsAvailabilityDpd?: Maybe<Scalars['Int']>;
  /** Whether or not this business allows GCs to participate in the Free Place program */
  enableFreePlace: Scalars['Boolean'];
  /** The DPD at which this business expects flights information populated */
  flightsReleasedDpd?: Maybe<Scalars['Int']>;
  /** The estimated days after the flights release date which this business expects flights information to be populated */
  nbEstimatedDaysForFlightRelease?: Maybe<Scalars['Int']>;
  /** Days prior to departure when GC departure reconciliation should occur */
  reconciliationDpd?: Maybe<Scalars['Int']>;
  /** Number of years to look back at a customer's Group Member trips when deciding whether they are still eligible to see referrals. The cutoff is `today - referralLookbackYears`; set to 0 to require a future-booked GM trip. `null` means referral eligibility is not configured for this business. */
  referralLookbackYears?: Maybe<Scalars['Int']>;
  /** Minimum number of hours after a meeting RSVP in which the prospects can become visible to the Sales team. */
  rsvpProspectVisibilityDelay: Scalars['Int'];
};

export enum GcDepartureSortField {
  DepartureDate = 'departureDate',
  ReconciliationDate = 'reconciliationDate',
  Status = 'status'
}

export enum GcDepartureStatus {
  /** The GC Departure has been cancelled, along with the associated Trips */
  Cancelled = 'CANCELLED',
  /** The GC Departure has been prepped for booking and GMs can book */
  Confirmed = 'CONFIRMED',
  /** The GC is in the process of rebooking their group onto a new Departure */
  PendingRebooking = 'PENDING_REBOOKING',
  /** The GC Departure has been prepped for pricing but Trips cannot be booked against it yet */
  Quoted = 'QUOTED',
  /** The GC Departure has been rebooked onto a new Departure and will be tracked separately on a new GC Departure */
  Rebooked = 'REBOOKED'
}

/** The status of any stipend issued to the GC */
export type GcDepartureStipendDetail = {
  __typename?: 'GCDepartureStipendDetail';
  amount?: Maybe<Money>;
  cancelledDate?: Maybe<Scalars['Date']>;
  checkNumber?: Maybe<Scalars['String']>;
  issuedDate?: Maybe<Scalars['Date']>;
  status: GcDepartureStipendDetailStatus;
};

export enum GcDepartureStipendDetailStatus {
  Cancelled = 'CANCELLED',
  PaidOut = 'PAID_OUT',
  Pending = 'PENDING'
}

/** A past group member of a GC with all their past trips with the GC. */
export type GcPastGroupMember = {
  __typename?: 'GCPastGroupMember';
  customer?: Maybe<Customer>;
  /** The customer ID of the past group member. */
  customerId: Scalars['ObjectId'];
  /** The group members past trips in CANCELLED or CONFIRMED status */
  trips: Array<BookingTrip>;
};

export type GcProfileContent = {
  __typename?: 'GCProfileContent';
  backgroundImage?: Maybe<ContentAsset>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullSlug: Scalars['String'];
  gcCustomer?: Maybe<Customer>;
  gcCustomerId?: Maybe<Scalars['String']>;
  gcDepartures: Array<GcDeparture>;
  image?: Maybe<ContentAsset>;
  logo?: Maybe<ContentAsset>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};


export type GcProfileContentGcDeparturesArgs = {
  businessCode: BusinessCode;
};

/** A gateway that represents either an Airport or a City */
export type Gateway = {
  __typename?: 'Gateway';
  _id: Scalars['ObjectId'];
  airRegionCode: Scalars['String'];
  cityCode: Scalars['String'];
  code: Scalars['String'];
  /** Two-letter country code */
  countryCode?: Maybe<Scalars['String']>;
  /** Country name */
  countryName?: Maybe<Scalars['String']>;
  internalCityLongName: Scalars['String'];
  internalCityName: Scalars['String'];
  isCityCodeOnly: Scalars['Boolean'];
  name: Scalars['String'];
  stateCode?: Maybe<Scalars['String']>;
  utcOffset?: Maybe<Scalars['Float']>;
  utcOffsetSummer?: Maybe<Scalars['Float']>;
  utcOffsetWinter?: Maybe<Scalars['Float']>;
};

/** A paginated result of Gateways */
export type GatewayPaginatedResult = {
  __typename?: 'GatewayPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Gateway>;
};

/** A group coordinator's staff contacts for a specific business code */
export type GcStaffContact = {
  __typename?: 'GcStaffContact';
  accountManager?: Maybe<StaffContact>;
  businessCode: BusinessCode;
  tourConsultant?: Maybe<StaffContact>;
};

export type GeographicRegion = Place & {
  __typename?: 'GeographicRegion';
  _id: Scalars['ObjectId'];
  /** Ancestry of the place, resolved ancestors (e.g. parent places, grandparent places, etc.). Avoid using with nested place queries as it can lead to performance issues. */
  ancestry: Array<PlaceWithAncestry>;
  name: Scalars['String'];
  parentIds: Array<Scalars['ObjectId']>;
  /** Parent places of the place, e.g. country for a city, continent for a country, etc. */
  parents: Array<Place>;
  /** The place code is a unique identifier for the place, used for global identification. */
  placeCode: Scalars['String'];
  type: PlaceType;
};

/** A summary of the global rewards status and point for Group Coordinators */
export type GlobalRewardsSummary = {
  __typename?: 'GlobalRewardsSummary';
  firstName: Scalars['String'];
  globalRewardsId: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  membershipLevelId: Scalars['Int'];
  membershipLevelName: Scalars['String'];
  pointsAccrued: Scalars['Int'];
  pointsActive: Scalars['Int'];
  pointsPending: Scalars['Int'];
  pointsRedeemed: Scalars['Int'];
  pointsSuspended: Scalars['Int'];
  pointsTotal: Scalars['Int'];
};

/** Group trip checklist settings */
export type GroupTripChecklistSettings = {
  __typename?: 'GroupTripChecklistSettings';
  /** Days prior to departure when emergency contact information is due for group trips */
  emergencyContactDueAtDpd?: Maybe<Scalars['Int']>;
  /** Days prior to departure when health notes are due for group trips */
  healthNotesDueAtDpd?: Maybe<Scalars['Int']>;
  /** Days prior to departure when passport information is due for group trips */
  passportInformationDueAtDpd?: Maybe<Scalars['Int']>;
  /** Number of days after booking when roommate selection is due for group trips. If not set, roommate request is not required. */
  roommateDaysDueAfterBooking?: Maybe<Scalars['Int']>;
  /** Number of days after booking when terms signature is due for group trips */
  termsSignatureDaysDueAfterBooking?: Maybe<Scalars['Int']>;
  /**
   * Days prior to departure when traveler information is due for group trips (deprecated)
   * @deprecated Use the tsa identifier and passport info settings
   */
  travelerInfoDueAtDpd?: Maybe<Scalars['Int']>;
  /** Days prior to departure when TSA identifiers are due for group trips */
  tsaIdentifiersDueAtDpd?: Maybe<Scalars['Int']>;
};

export type HealthNotesChecklistItem = SystemChecklistItem & {
  __typename?: 'HealthNotesChecklistItem';
  dueDate?: Maybe<Scalars['Date']>;
  isCompleted: Scalars['Boolean'];
  status?: Maybe<TripChecklistItemStatus>;
};

/** Response from the Zendesk help center API */
export type HelpCenterArticle = {
  __typename?: 'HelpCenterArticle';
  id?: Maybe<Scalars['String']>;
  sectionName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Response from the Zendesk help center API */
export type HelpCenterArticleResponse = {
  __typename?: 'HelpCenterArticleResponse';
  count?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  pageCount?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  previousPage?: Maybe<Scalars['String']>;
  results?: Maybe<Array<HelpCenterArticle>>;
};

/** Icon asset with name and two ContentAsset properties */
export type IconContent = {
  __typename?: 'IconContent';
  businessCode: BusinessCode;
  darkModeIcon?: Maybe<ContentAsset>;
  fullSlug: Scalars['String'];
  id: Scalars['String'];
  language: Scalars['String'];
  lightModeIcon?: Maybe<ContentAsset>;
  name: Scalars['String'];
};

export enum IdentityDocumentType {
  DriversLicense = 'DRIVERS_LICENSE',
  Passport = 'PASSPORT'
}

/** Immutable term error */
export type ImmutableTermError = DomainError & {
  __typename?: 'ImmutableTermError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Incentives metadata associated with an adjustment line item from Talon One */
export type IncentivesAdjustmentMetadata = {
  __typename?: 'IncentivesAdjustmentMetadata';
  /** The portion of the discount that was actually debited from the customer's travel bank. Not modified when the adjustment was edited on a draft. */
  amountCommitted?: Maybe<Scalars['Float']>;
  /** Campaign identifier that triggered this effect */
  campaignId: Scalars['Int'];
  /** Display name of the effect */
  effectName: Scalars['String'];
  /** Type of the effect applied */
  effectType: Scalars['String'];
  /** Customer session identifier */
  sessionId: Scalars['String'];
  /** Source system that generated this adjustment */
  source: Scalars['String'];
};

/** Incentives or point redemption validation error */
export type IncentivesError = DomainError & {
  __typename?: 'IncentivesError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  /** When present, the maximum amount that could be redeemed for this trip/order under current rules (e.g. before hitting balance or insurance limits). */
  maxRedeemable?: Maybe<Money>;
  message: Scalars['String'];
  /** The specific type of incentives error that occurred. Prefer this over code if specific error types are needed */
  subCode: IncentivesErrorSubCode;
};

/** Sub-codes for incentives/point redemption validation (use with IncentivesError.subCode) */
export enum IncentivesErrorSubCode {
  ExceedsBalanceAndTripTotal = 'EXCEEDS_BALANCE_AND_TRIP_TOTAL',
  ExceedsOrderBalance = 'EXCEEDS_ORDER_BALANCE',
  ExceedsTripTotal = 'EXCEEDS_TRIP_TOTAL',
  InsufficientBalance = 'INSUFFICIENT_BALANCE',
  IntegrationFailure = 'INTEGRATION_FAILURE',
  InvalidAmount = 'INVALID_AMOUNT',
  InvalidPoints = 'INVALID_POINTS',
  OrderInsuranceCoverage = 'ORDER_INSURANCE_COVERAGE',
  TripInsuranceCoverage = 'TRIP_INSURANCE_COVERAGE'
}

/** The incentives program integration is not enabled for this business. */
export type IncentivesIntegrationDisabledError = DomainError & {
  __typename?: 'IncentivesIntegrationDisabledError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Increases the non-expired voucher by a dollar amount */
export type IncreaseVoucherInput = {
  /** The ID of the Voucher */
  _id: Scalars['ObjectId'];
  /** The amount to increase the Voucher by */
  amount: MoneyInput;
  /** The reason that the voucher is being increased */
  reason: Scalars['String'];
};

export type IncreaseVoucherResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

export type InsuranceAddonLineItem = LineItem & {
  __typename?: 'InsuranceAddonLineItem';
  _id: Scalars['ObjectId'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

export enum InsuranceEligibilityStatus {
  /** The customer is eligible for insurance */
  Eligible = 'ELIGIBLE',
  /** The customer is ineligible due to their country of residence */
  IneligibleCountry = 'INELIGIBLE_COUNTRY',
  /** The customer is ineligible due to their destinations arrival or returning gateway */
  IneligibleGateway = 'INELIGIBLE_GATEWAY',
  /** The customer is ineligible due to their state of residence */
  IneligibleState = 'INELIGIBLE_STATE',
  /** The customer is ineligible due to being a primary trip and missing address */
  MissingAddress = 'MISSING_ADDRESS',
  /**
   * The customer is ineligible due to being a primary trip and missing address or passport information
   * @deprecated Use MISSING_ADDRESS instead. Passport information is no longer used for eligibility.
   */
  MissingAddressOrPassport = 'MISSING_ADDRESS_OR_PASSPORT'
}

/** Insurance extension plan details */
export type InsuranceExtension = PricedTripComponent & TripComponent & {
  __typename?: 'InsuranceExtension';
  _id: Scalars['ObjectId'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  hasPriceRules: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  priceRules: Array<PriceRule>;
  status: TripComponentStatus;
  type: TripComponentType;
};

export type InsuranceExtensionLineItem = LineItem & {
  __typename?: 'InsuranceExtensionLineItem';
  _id: Scalars['ObjectId'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  daysToExtend: Scalars['Int'];
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

export type InsuranceLineItem = LineItem & {
  __typename?: 'InsuranceLineItem';
  _id: Scalars['ObjectId'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  /** The date on which the insurance coverage ends */
  coverageEndDate?: Maybe<Scalars['Date']>;
  /** The date on which the insurance coverage begins. Set to the date on which the customer met the definition of insurance paid */
  coverageStartDate?: Maybe<Scalars['Date']>;
  /** The date on which the free look period ends. If this is null, it means that insurance has not yet been paid, and the free look period has not yet been determined. */
  freeLookPeriodEndDate?: Maybe<Scalars['Date']>;
  /** Whether the insurance has a free look period. If this is false, it means that the free look period end date has not yet been determined. */
  hasFreeLookPeriod: Scalars['Boolean'];
  isOpen: Scalars['Boolean'];
  /** Whether the insurance is past the free look period. If this is true, it means that the free look period is defined on this line item, and it has ended. */
  isPastFreeLookPeriod: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  /** Whether the insurance is within the free look period. If this is false, it means either that the free look period has not yet been determined or that the free look period has ended. */
  isWithinFreeLookPeriod: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  /** The length of the free look period in days. If this is null, it means that coverage has not yet started or the free look period has not yet been determined. */
  nbFreeLookPeriodDays?: Maybe<Scalars['Int']>;
  price: Money;
  /** The date on which the insurance becomes eligible for remittance to the provider */
  remittanceEligibilityDate?: Maybe<Scalars['Date']>;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  travelerInsuranceId: Scalars['ObjectId'];
  travelerInsuranceIdCreationDate: Scalars['Date'];
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

/** Primary insurance plan */
export type InsurancePlan = PricedTripComponent & TripComponent & {
  __typename?: 'InsurancePlan';
  _id: Scalars['ObjectId'];
  addons: Array<InsurancePlanAddon>;
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  /** The date when the insurance plan is applicable and can be used */
  effectiveFrom: Scalars['DateTime'];
  /** The date when the insurance plan expires and is no longer valid. */
  effectiveTo: Scalars['DateTime'];
  friendlyName?: Maybe<Scalars['String']>;
  hasPriceRules: Scalars['Boolean'];
  insuranceExtension?: Maybe<InsuranceExtension>;
  internalName: Scalars['String'];
  isEligibleForRolloverOnRebooking: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  isValid: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  planCode: Scalars['String'];
  policyId: Scalars['ObjectId'];
  priceRules: Array<PriceRule>;
  providerName: Scalars['String'];
  purchasableAfterDays?: Maybe<Scalars['Int']>;
  purchasableWithinDays?: Maybe<Scalars['Int']>;
  status: TripComponentStatus;
  type: TripComponentType;
};

/** Secondary insurance to be combined with primary insurance */
export type InsurancePlanAddon = PricedTripComponent & TripComponent & {
  __typename?: 'InsurancePlanAddon';
  _id: Scalars['ObjectId'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  hasPriceRules: Scalars['Boolean'];
  includedWithinDays?: Maybe<Scalars['Int']>;
  insurancePlanAddonCode: Scalars['String'];
  internalName: Scalars['String'];
  isPublished: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  preventPurchaseAfterDays?: Maybe<Scalars['Int']>;
  priceRules: Array<PriceRule>;
  status: TripComponentStatus;
  type: TripComponentType;
};

export type InsurancePlanAddonOffer = {
  __typename?: 'InsurancePlanAddonOffer';
  insurancePlanAddon: InsurancePlanAddon;
  price: Money;
};

/** Content describing an insurance plan */
export type InsurancePlanContent = {
  __typename?: 'InsurancePlanContent';
  addons: Array<InsurancePlanContentAddon>;
  benefits: Array<InsurancePlanContentBenefit>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  includedAddonsDescription?: Maybe<Scalars['String']>;
  includedAddonsSubtitle?: Maybe<Scalars['String']>;
  includedAddonsTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  planCode?: Maybe<Scalars['String']>;
  planSummaryDocument?: Maybe<ContentAsset>;
  planSummaryLink?: Maybe<ContentLink>;
  underwriterDescription?: Maybe<Scalars['String']>;
  underwriterDisclaimer?: Maybe<Scalars['String']>;
};

/** Content describing an insurance plan addon */
export type InsurancePlanContentAddon = {
  __typename?: 'InsurancePlanContentAddon';
  addonCode?: Maybe<Scalars['String']>;
  benefits: Array<InsurancePlanContentBenefit>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Content describing an insurance plan benefit */
export type InsurancePlanContentBenefit = {
  __typename?: 'InsurancePlanContentBenefit';
  description?: Maybe<Scalars['String']>;
  /** Describes the limit for a benefit e.g. 'Up to $50,000' */
  limitMessage?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type InsurancePlanOffer = {
  __typename?: 'InsurancePlanOffer';
  addons: Array<InsurancePlanAddonOffer>;
  content?: Maybe<InsurancePlanContent>;
  insurancePlan: InsurancePlan;
  price: Money;
};


export type InsurancePlanOfferContentArgs = {
  language: Scalars['String'];
};

/** Paginated result of Insurance Plans, filtered and sorted */
export type InsurancePlanPaginatedResult = {
  __typename?: 'InsurancePlanPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<InsurancePlan>;
};

export enum InsurancePlanSortField {
  PlanCode = 'planCode'
}

export type InsurancePolicy = {
  __typename?: 'InsurancePolicy';
  _id: Scalars['ObjectId'];
  businessCode: BusinessCode;
  coversPreExistingConditions: Scalars['Boolean'];
  friendlyName?: Maybe<Scalars['String']>;
  internalName?: Maybe<Scalars['String']>;
  providerName: Scalars['String'];
  revisions: Array<InsuranceRevision>;
};

/** Paginated result of Insurance Policies, filtered and sorted */
export type InsurancePolicyPaginatedResult = {
  __typename?: 'InsurancePolicyPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<InsurancePolicy>;
};

export enum InsurancePolicySortField {
  ProviderName = 'providerName'
}

export type InsuranceRevision = {
  __typename?: 'InsuranceRevision';
  _id: Scalars['ObjectId'];
  carrier?: Maybe<Scalars['String']>;
  /** Co-pay amount for the insurance plan */
  copay?: Maybe<Money>;
  /** Deductible amount for the insurance plan */
  deductible?: Maybe<Money>;
  /** The date when the insurance revision is applicable and can be used */
  effectiveFrom: Scalars['DateTime'];
  /** The date when the insurance revision expires and is no longer valid. */
  effectiveTo: Scalars['DateTime'];
  /** Maximum coverage for emergency medical evacuation and return of mortal remains */
  emergencyMedicalMaximum?: Maybe<Money>;
  freeLookPeriodDays: Scalars['Int'];
  grossWrittenPremium?: Maybe<Money>;
  /** Maximum coverage amount for medical expenses */
  medicalMaximum?: Maybe<Money>;
  policyNumber: Scalars['String'];
  programCode?: Maybe<Scalars['String']>;
  /** Maximum coverage amount for travel delay expenses */
  travelDelayMaximum?: Maybe<Money>;
};

/** Insurance settings */
export type InsuranceSettings = {
  __typename?: 'InsuranceSettings';
  /** Default line item code used for insurance adjustments */
  defaultAdjustmentLineItemCode: Scalars['LineItemCode'];
  /** List of Canadian province abbreviations where insurance purchase is not allowed */
  ineligibleStatesCA: Array<Scalars['String']>;
  /** List of US state abbreviations where insurance purchase is not allowed */
  ineligibleStatesUS: Array<Scalars['String']>;
  /** Whether insurance is available for purchase to customers in Canada */
  isAvailableInCanada: Scalars['Boolean'];
  /** Maximum number of days insurance can be extended */
  nbMaximumDaysToExtend: Scalars['Int'];
  /**
   * Number of days in the removal window (deprecated)
   * @deprecated The free look period now controls this
   */
  removalWindowDays: Scalars['Int'];
  /** List of gateway codes where insurance purchase is not allowed for Canadian customers */
  restrictedDestinationGatewaysCA: Array<Scalars['String']>;
};

export type IntegrateDepartureToProductionResult = BusinessNotSpecifiedError | Departure | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type IntegrateGcDepartureGlobalRewardsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDepartureRewardsIntegrationResult | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | MissingGlobalRewardsIdError | NotAuthorizedError | NotFoundError | ValidationError;

export type IntegrateOrderToProductionResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Settings related to 3rd party APIs or integrations */
export type IntegrationSettings = {
  __typename?: 'IntegrationSettings';
  /** Canadian merchant ID for cybersource */
  cybersourceMerchantIdCA?: Maybe<Scalars['String']>;
  /** US merchant ID for cybersource */
  cybersourceMerchantIdUS?: Maybe<Scalars['String']>;
  /**
   * Talon.One campaign ID for the indies referral program
   * @deprecated This has been deprecated in favor of config values.
   */
  indiesReferralCampaignId?: Maybe<Scalars['String']>;
  /** Whether Talon.One incentives integration is enabled */
  isTalonOneEnabled: Scalars['Boolean'];
  /** Mailroom settings */
  mailroom?: Maybe<MailroomSettings>;
  /** Canadian microsite URL */
  micrositeUrlCA?: Maybe<Scalars['String']>;
  /** US microsite URL */
  micrositeUrlUS?: Maybe<Scalars['String']>;
  /** Atlas Product Market billing code for the CA market */
  productMarketBillingCodeCA?: Maybe<Scalars['String']>;
  /** Atlas Product Market billing code for the US market */
  productMarketBillingCodeUS?: Maybe<Scalars['String']>;
  /** Atlas Product Market code for the CA market */
  productMarketCodeCA?: Maybe<Scalars['String']>;
  /** Atlas Product Market code for the US market */
  productMarketCodeUS?: Maybe<Scalars['String']>;
  /** Line item code used for referral program incentive discount adjustments on trips */
  referralIncentiveDiscountLineItemCode?: Maybe<Scalars['String']>;
  /** Canadian office ID for RightFlight, required for all API calls */
  rightFlightBrandIdCA?: Maybe<Scalars['String']>;
  /** US office ID for RightFlight, required for all API calls */
  rightFlightBrandIdUS?: Maybe<Scalars['String']>;
  /** Channel remark for RightFlight flight bookings */
  rightFlightChannelRemark: Scalars['String'];
  /**
   * Talon.One loyalty program name used to access ledger balances
   * @deprecated This has been deprecated in favor of config values.
   */
  talonOneLoyaltyProgramName?: Maybe<Scalars['String']>;
  /**
   * Talon.One subledger name used to access the specific subledger balance for the indies referral program
   * @deprecated This has been deprecated in favor of config values.
   */
  talonOneReferralSubledgerName?: Maybe<Scalars['String']>;
  /** Settings for transactional emails */
  transactionalEmails?: Maybe<Array<TransactionalEmailSettings>>;
  /** Canadian website URL */
  websiteUrlCA?: Maybe<Scalars['String']>;
  /** US website URL */
  websiteUrlUS?: Maybe<Scalars['String']>;
};

/** Invalid adjustment error */
export type InvalidAdjustmentError = DomainError & {
  __typename?: 'InvalidAdjustmentError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Error thrown when airport transfer validation fails */
export type InvalidAirportTransferError = DomainError & {
  __typename?: 'InvalidAirportTransferError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The amount object is invalid */
export type InvalidAmountError = DomainError & {
  __typename?: 'InvalidAmountError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The audience is invalid. */
export type InvalidAudienceError = DomainError & {
  __typename?: 'InvalidAudienceError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The audience member is invalid. */
export type InvalidAudienceMemberError = DomainError & {
  __typename?: 'InvalidAudienceMemberError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The campaign is invalid. */
export type InvalidCampaignError = DomainError & {
  __typename?: 'InvalidCampaignError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The DateOnly object is not a valid date type */
export type InvalidDateError = DomainError & {
  __typename?: 'InvalidDateError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The date range is invalid */
export type InvalidDateRangeError = DomainError & {
  __typename?: 'InvalidDateRangeError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type InvalidDepartureError = DomainError & {
  __typename?: 'InvalidDepartureError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The deposit amount item is invalid */
export type InvalidDepositItemError = DomainError & {
  __typename?: 'InvalidDepositItemError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid evaluation */
export type InvalidEvaluationError = DomainError & {
  __typename?: 'InvalidEvaluationError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type InvalidExtendedStayError = DomainError & {
  __typename?: 'InvalidExtendedStayError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid fee error */
export type InvalidFeeError = DomainError & {
  __typename?: 'InvalidFeeError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type InvalidFlightPackageError = DomainError & {
  __typename?: 'InvalidFlightPackageError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid flight shop error */
export type InvalidFlightShopError = DomainError & {
  __typename?: 'InvalidFlightShopError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type InvalidGcDepartureError = DomainError & {
  __typename?: 'InvalidGCDepartureError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid GC Departure Meeting Error */
export type InvalidGcDepartureMeetingError = DomainError & {
  __typename?: 'InvalidGCDepartureMeetingError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type InvalidGcDepartureProspectError = DomainError & {
  __typename?: 'InvalidGCDepartureProspectError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid insurance extension */
export type InvalidInsuranceExtensionError = DomainError & {
  __typename?: 'InvalidInsuranceExtensionError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid insurance plan */
export type InvalidInsurancePlanError = DomainError & {
  __typename?: 'InvalidInsurancePlanError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid insurance policy */
export type InvalidInsurancePolicyError = DomainError & {
  __typename?: 'InvalidInsurancePolicyError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Magic link is not valid */
export type InvalidMagicLinkError = DomainError & {
  __typename?: 'InvalidMagicLinkError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The money object is invalid */
export type InvalidMoneyError = DomainError & {
  __typename?: 'InvalidMoneyError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid trip error */
export type InvalidOrderError = DomainError & {
  __typename?: 'InvalidOrderError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid payment error */
export type InvalidPaymentError = DomainError & {
  __typename?: 'InvalidPaymentError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  /** List of payment errors */
  paymentErrors: Array<Scalars['String']>;
};

/** Invalid payment schedule error */
export type InvalidPaymentScheduleError = DomainError & {
  __typename?: 'InvalidPaymentScheduleError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid Place Error */
export type InvalidPlaceError = DomainError & {
  __typename?: 'InvalidPlaceError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** A PriceYear failed to be created due to validation issues */
export type InvalidPriceYearError = DomainError & {
  __typename?: 'InvalidPriceYearError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The PriceRule is not valid at time of creation */
export type InvalidPricingError = DomainError & {
  __typename?: 'InvalidPricingError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid private group error */
export type InvalidPrivateGroupError = DomainError & {
  __typename?: 'InvalidPrivateGroupError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The promotion is invalid. */
export type InvalidPromoError = DomainError & {
  __typename?: 'InvalidPromoError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid rating error */
export type InvalidRatingError = DomainError & {
  __typename?: 'InvalidRatingError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The referral connection is invalid (e.g. already exists, missing referral code, same customer). */
export type InvalidReferralError = DomainError & {
  __typename?: 'InvalidReferralError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid review error */
export type InvalidReviewError = DomainError & {
  __typename?: 'InvalidReviewError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid review response error */
export type InvalidReviewResponseError = DomainError & {
  __typename?: 'InvalidReviewResponseError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** User credentials are invalid during login */
export type InvalidSigninError = DomainError & {
  __typename?: 'InvalidSigninError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid term error */
export type InvalidTermError = DomainError & {
  __typename?: 'InvalidTermError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The time range is invalid */
export type InvalidTimeRangeError = DomainError & {
  __typename?: 'InvalidTimeRangeError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** The timezone is invalid */
export type InvalidTimezoneError = DomainError & {
  __typename?: 'InvalidTimezoneError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type InvalidTourCabinCodeError = DomainError & {
  __typename?: 'InvalidTourCabinCodeError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid tour error */
export type InvalidTourError = DomainError & {
  __typename?: 'InvalidTourError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid travel companion request error */
export type InvalidTravelCompanionRequestError = DomainError & {
  __typename?: 'InvalidTravelCompanionRequestError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** An invalid trip checklist item template was specified */
export type InvalidTripChecklistItemTemplateError = DomainError & {
  __typename?: 'InvalidTripChecklistItemTemplateError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Invalid voucher */
export type InvalidVoucherError = DomainError & {
  __typename?: 'InvalidVoucherError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type IssueARefundResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidPaymentError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError;

export type LeadInPrice = {
  __typename?: 'LeadInPrice';
  /** Amount of discount if applicable. Null if no discount. */
  discountAmount?: Maybe<Money>;
  /** Minimum remaining redemptions for discount offer codes. */
  discountLowestSpotsRemaining?: Maybe<Scalars['Int']>;
  /** Offer codes to calculate sale price. */
  discountOfferCodes: Array<Scalars['String']>;
  /** Original price. */
  price: Money;
  /** Previous discounts applied */
  redeemedPromos: Array<RedeemedPromoType>;
  /** Price after discount if applicable. Null if no discount. */
  salePrice?: Maybe<Money>;
};

export type LegacyCustomerIds = {
  __typename?: 'LegacyCustomerIds';
  gatSalesforceAccountId?: Maybe<Scalars['String']>;
  jasmineCustomerId?: Maybe<Scalars['String']>;
  phxIndividualIds?: Maybe<Array<Scalars['String']>>;
  ubSalesforceAccountId?: Maybe<Scalars['String']>;
};

/** Base line item */
export type LineItem = {
  _id: Scalars['ObjectId'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

/** Line item cancellation meta data. */
export type LineItemCancellationMeta = {
  __typename?: 'LineItemCancellationMeta';
  cancellationDate?: Maybe<Scalars['Date']>;
  /** @deprecated This field will be updated in the future to use the new cancellation reason enum. */
  cancellationReason: LineItemCancellationReason;
  cancelledBy?: Maybe<Scalars['ObjectId']>;
  wasCanceledByWojo: Scalars['Boolean'];
};

export enum LineItemCancellationReason {
  Financial = 'FINANCIAL',
  HealthOrLifeEvent = 'HEALTH_OR_LIFE_EVENT',
  ParentTripCancelled = 'PARENT_TRIP_CANCELLED',
  TravelerDiscontent = 'TRAVELER_DISCONTENT',
  TravelRequirementNotMet = 'TRAVEL_REQUIREMENT_NOT_MET',
  TripDetailsChanged = 'TRIP_DETAILS_CHANGED',
  Unknown = 'UNKNOWN',
  WojoCancellation = 'WOJO_CANCELLATION',
  WorldEvent = 'WORLD_EVENT'
}

export enum LineItemStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  PendingCancellation = 'PENDING_CANCELLATION',
  PendingRebooking = 'PENDING_REBOOKING',
  Quoted = 'QUOTED',
  Rebooked = 'REBOOKED',
  Requested = 'REQUESTED',
  Waitlisted = 'WAITLISTED'
}

/** Settings for lost baggage service availability */
export type LostBaggageServiceSettings = {
  __typename?: 'LostBaggageServiceSettings';
  /** The booking must be made on or after this date for lost baggage service to be available */
  bookingDateFrom: Scalars['Date'];
  /** The departure must be on or after this date for lost baggage service to be available */
  departureDateFrom: Scalars['Date'];
};

/** A customer's repeat loyalty information with a specific business. */
export type LoyaltyLevel = {
  __typename?: 'LoyaltyLevel';
  /** The unique identifier of this item. The combination of businessCode and customerId is the more appropriate unique key */
  _id: Scalars['ObjectId'];
  /** The business code that this loyalty information is associated with */
  businessCode: BusinessCode;
  /** The content associated with this loyalty level */
  content?: Maybe<LoyaltyLevelContent>;
  /** The customer id that this loyalty information is associated with */
  customerId: Scalars['ObjectId'];
  /** The customer's loyalty level based on the repeat threshold in promotion settings that this customer has reached */
  loyaltyLevel: Scalars['Int'];
  /** The number of qualifying trips that count toward the customer's loyalty level */
  nbConfirmedLoyaltyTrips: Scalars['Int'];
  /** The number of additional qualifying trips the customer needs to reach the next loyalty level. If the busines has not configured repeat thresholds, or the customer is at the maximum loyalty level, this will be null */
  nbTripsUntilNextLevelReached?: Maybe<Scalars['Int']>;
  /** The per-tour discount that the customer is entitled based on the loyalty level they have reached */
  repeatDiscount?: Maybe<Amount>;
  /** The promo code associated with the repeat discount */
  repeatPromoCode?: Maybe<Scalars['String']>;
  /** The discount that the customer is currently entitled based on the loyalty level they have reached, as well as whether their previous qualifying trip returned within the return window defined in promo settings. */
  returnWindowDiscount?: Maybe<Amount>;
};


/** A customer's repeat loyalty information with a specific business. */
export type LoyaltyLevelContentArgs = {
  language: Scalars['String'];
};

export type LoyaltyLevelContent = {
  __typename?: 'LoyaltyLevelContent';
  icon?: Maybe<ContentAsset>;
  name?: Maybe<Scalars['String']>;
};

export type MagicLinkResult = {
  __typename?: 'MagicLinkResult';
  expiresAt: Scalars['DateTime'];
};

/** Settings for mailroom. */
export type MailroomSettings = {
  __typename?: 'MailroomSettings';
  /** Whether the mailroom feature is active */
  isActive: Scalars['Boolean'];
  /** Number of days before departure to start sending pre-departure mail */
  nbPreDepartureMailDaysFrom: Scalars['Int'];
  /** Number of days before departure to stop sending pre-departure mail */
  nbPreDepartureMailDaysTo: Scalars['Int'];
  /** Minimum balance required to trigger pre-departure mail */
  preDepartureMailMinimumBalance: Amount;
};

export type MakeAPaymentResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidAmountError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidPaymentError | InvalidPaymentScheduleError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError;

/** An individual flight with carrier, route, and traveler information */
export type ManifestFlight = {
  __typename?: 'ManifestFlight';
  /** Full gateway information for the arrival airport */
  arrivalGateway?: Maybe<Gateway>;
  /** The IATA airport code where the flight arrives */
  arrivalGatewayCode: Scalars['String'];
  /** The local arrival time in ISO 8601 format */
  arrivalLocalTime: Scalars['String'];
  /** The IATA airline carrier code (e.g., BA, AA, LH) */
  carrierCode: Scalars['String'];
  /** Full gateway information for the departure airport */
  departureGateway?: Maybe<Gateway>;
  /** The IATA airport code where the flight departs from */
  departureGatewayCode: Scalars['String'];
  /** The local departure time in ISO 8601 format */
  departureLocalTime: Scalars['String'];
  /** The flight number */
  flightNumber: Scalars['String'];
  /** Unique identifier for this flight (format: carrierCode:flightNumber:departureGatewayCode:departureLocalTime) */
  id: Scalars['String'];
  /** The number of travelers on this flight */
  travelerCount: Scalars['Int'];
  /** The IDs of all booking trips on this flight */
  tripIds: Array<Scalars['ObjectId']>;
  /** The booking trips for travelers on this flight, including customer information */
  trips: Array<BookingTrip>;
};

/** A category of flights (arrivals or departures) with metadata for UI display */
export type ManifestFlightCategory = {
  __typename?: 'ManifestFlightCategory';
  /** Unique dates across all groups in this category, sorted chronologically */
  dates: Array<Scalars['Date']>;
  /** Unique gateway codes across all groups in this category */
  gatewayCodes: Array<Scalars['String']>;
  /** Full gateway information for all unique gateways in this category */
  gateways: Array<Gateway>;
  /** Flight groups organized by date and gateway, sorted by date then gateway code */
  groups: Array<ManifestFlightGroup>;
  /** True if any group in this category has at least one flight */
  hasFlights: Scalars['Boolean'];
  /** True if there is at least one traveler traveling on their own in this category */
  hasTravelersOnTheirOwn: Scalars['Boolean'];
  /** Unique identifier for this category (format: departureId:categoryType, e.g., '80c99bb4ab60cc9ba763162f:FLIGHTS_TO_TOUR') */
  id: Scalars['String'];
  /** Land-only travelers in this category without flight transfer information */
  travelingOnTheirOwn: Array<BookingTrip>;
  /** The type of this flight category */
  type: ManifestFlightCategoryType;
};

/** The type of flight category in the manifest */
export enum ManifestFlightCategoryType {
  FlightsHome = 'FLIGHTS_HOME',
  FlightsToTour = 'FLIGHTS_TO_TOUR',
  PostExtensionDepartures = 'POST_EXTENSION_DEPARTURES',
  PreExtensionArrivals = 'PRE_EXTENSION_ARRIVALS'
}

/** A grouping of flights by date and gateway */
export type ManifestFlightGroup = {
  __typename?: 'ManifestFlightGroup';
  /** The date of the flights in this group */
  date: Scalars['Date'];
  /** The flights in this group, sorted by departure time */
  flights: Array<ManifestFlight>;
  /** Full gateway information including name and timezone */
  gateway?: Maybe<Gateway>;
  /** The IATA airport code for this group's gateway */
  gatewayCode: Scalars['String'];
  /** Unique identifier for this group (format: date:gatewayCode) */
  id: Scalars['String'];
};

export type MatchQuoteRoommatesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Quote | ValidationError;

export type MatchRoommatesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | MatchRoommatesSuccess | NotAuthorizedError | NotFoundError | ValidationError;

export type MatchRoommatesSuccess = {
  __typename?: 'MatchRoommatesSuccess';
  data: Array<Booking>;
};

export enum MeetingStyle {
  InPerson = 'IN_PERSON',
  Virtual = 'VIRTUAL'
}

export type MergeBookingInput = {
  fromBookingId: Scalars['ObjectId'];
  toBookingId: Scalars['ObjectId'];
};

export type MergeBookingResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Merge two customers */
export type MergeCustomerInput = {
  /** The id of the customer merge into and keep. */
  newCustomerId: Scalars['ObjectId'];
  /** The id of the customer to merge and deprecate. */
  oldCustomerId: Scalars['ObjectId'];
};

export type MergeCustomerResult = BusinessNotSpecifiedError | Customer | CustomerMergeError | CustomerUnavailableError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type MicrositeContent = {
  __typename?: 'MicrositeContent';
  fullSlug?: Maybe<Scalars['String']>;
  gcDeparture?: Maybe<GcDeparture>;
  gcDepartureId?: Maybe<Scalars['String']>;
  logo?: Maybe<ContentAsset>;
  title?: Maybe<Scalars['String']>;
  tripBuilderMarketingBody?: Maybe<Scalars['String']>;
  tripBuilderMarketingTitle?: Maybe<Scalars['String']>;
};

/** The customer does not have a global rewards id configured */
export type MissingGlobalRewardsIdError = DomainError & {
  __typename?: 'MissingGlobalRewardsIdError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Represents monetary value in a specific currency */
export type Money = {
  __typename?: 'Money';
  currencyCode: CurrencyCode;
  formatted: Scalars['String'];
  value: Scalars['Float'];
};

/** Input for standard money type */
export type MoneyInput = {
  currencyCode: CurrencyCode;
  value: Scalars['Float'];
};

export type MonthlyWeather = {
  __typename?: 'MonthlyWeather';
  averageHighCelsius: Scalars['Float'];
  averageHighFahrenheit: Scalars['Float'];
  averageLowCelsius: Scalars['Float'];
  averageLowFahrenheit: Scalars['Float'];
  averageRainCentimeters: Scalars['Float'];
  averageRainInches: Scalars['Float'];
  month: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept a price change detected during flight shop */
  acceptFlightShopPriceChange: AcceptFlightShopPriceChangeResult;
  /** Accepts the group terms as a group coordinator. Signs the GC departure, as well as the GC's trip if it exists */
  acceptGCDepartureTerms: AcceptGcDepartureTermsResult;
  /** Accepts the terms and conditions for a single trip on a booking */
  acceptTripTerms: AcceptTripTermsResult;
  /** Adds an offer code to an audience. */
  addAudienceOfferCode: AddAudienceOfferCodeResult;
  /** Adds offer codes to an audience. */
  addAudienceOfferCodes: AddAudienceOfferCodesResult;
  /** Add promos to a campaign */
  addCampaignPromos: AddCampaignPromosResult;
  /** Adds a payment schedule to a draft booking as long as one does not already exist */
  addDraftBookingPaymentSchedule: AddDraftBookingPaymentScheduleResult;
  /** Adds adjustment to a trip on a draft order. */
  addDraftOrderAdjustment: AddDraftOrderAdjustmentResult;
  /** Adds a campaign to a draft order for specified trips. */
  addDraftOrderCampaign: AddDraftOrderCampaignResult;
  /** Adds excursions to trips on a draft order. */
  addDraftOrderExcursions: AddDraftOrderExcursionsResult;
  /** Adds extension on draft order for specified trips. */
  addDraftOrderExtension: AddDraftOrderExtensionResult;
  /** Adds fee to a draft order for the specified trips. */
  addDraftOrderFee: AddDraftOrderFeeResult;
  /** Adds inbound airport transfer to trips on a draft order. */
  addDraftOrderInboundAirportTransfer: AddDraftOrderInboundAirportTransferResult;
  /** Adds insurance on draft order for specified trips. */
  addDraftOrderInsurance: AddDraftOrderInsuranceResult;
  /** Adds insurance plan addons to one or more trips on a draft order. */
  addDraftOrderInsuranceAddon: AddDraftOrderInsuranceAddonResult;
  /** Adds insurance extension for a draft order to one or more trips. */
  addDraftOrderInsuranceExtension: AddDraftOrderInsuranceExtensionResult;
  /** Adds outbound airport transfer to trips on a draft order. */
  addDraftOrderOutboundAirportTransfer: AddDraftOrderOutboundAirportTransferResult;
  /** Adds post-stay on draft order for specified trips. */
  addDraftOrderPostStay: AddDraftOrderPostStayResult;
  /** Adds pre-stay on draft order for specified trips. */
  addDraftOrderPreStay: AddDraftOrderPreStayResult;
  /** Adds private group fee to a draft order for the specified trips. */
  addDraftOrderPrivateGroup: AddDraftOrderPrivateGroupResult;
  /** Adds a promo to a draft order for specified trips. */
  addDraftOrderPromo: AddDraftOrderPromoResult;
  /** Adds travel companion requests to a draft order for the specified trip. */
  addDraftOrderTravelCompanionRequests: AddDraftOrderTravelCompanionRequestsResult;
  /** Adds a Trip to an existing Draft Quote. */
  addDraftQuoteTrip: AddDraftQuoteTripResult;
  /** Update an employee by id. */
  addEmployeesToRole: AddEmployeesToRoleResult;
  /** Create a new flight shop component */
  addFlightShop: AddFlightShopResult;
  /** Adds a payment method to a customer */
  addPaymentMethodToCustomer: AddPaymentMethodToCustomerResult;
  /** Adds a private group to a tour */
  addPrivateGroup: AddPrivateGroupResult;
  /** Add promo codes to a promo */
  addPromoCodes: AddPromoCodesResult;
  /** Add customers to a promo */
  addPromoCustomers: AddPromoCustomersResult;
  /** Add gc departure to a promo */
  addPromoGcDepartures: AddPromoGcDeparturesResult;
  /** Adds additional targets to a promo */
  addPromoTargets: AddPromoTargetsResult;
  /** Adds an airport transfer to a tour */
  addTourAirportTransfer: AddTourAirportTransferResult;
  /** Adds a Tour Excursion to this tour, provided it is set up in the Tour's spec and is not already on the Tour. */
  addTourExcursion: AddTourExcursionResult;
  /** Adds an airport transfer to a tour extension */
  addTourExtensionAirportTransfer: AddTourExtensionAirportTransferResult;
  /** Adds a Tour Excursion to this Tour Extension, provided it is set up in the Tour Extension's spec and is not already on the Extension. */
  addTourExtensionExcursion: AddTourExtensionExcursionResult;
  /** Generate a magic link for a customer or tour director and return it */
  adminCreateMagicLink: AdminCreateMagicLinkResult;
  /** Anonymize a customer by setting their data to the configured deletion request name and nullifying sensitive information. Used for CCPA/GDPR data deletion requests. */
  anonymizeCustomer: AnonymizeCustomerResult;
  /** Recalculates and applies or reapplies the private group fee to all confirmed Trips on Bookings associated with a GC Departure. If the fee is already found on a trip with a different price, it will be removed and reapplied with the new price. Does not use a draft publish flow and happens directly on the bookings. Will not apply the private group line item to quotes. Uses the number of confirmed trips as the group size by default. */
  applyGCDeparturePrivateGroupFee: ApplyGcDeparturePrivateGroupFeeResult;
  /** Redeem travel bank rewards or add to the existing redemption line item on a Booking Trip. The amount to redeem and the specific rewards balance the customer wishes to apply are provided as inputs. */
  applyTravelBankRewardsToBookingTrip: ApplyTravelBankRewardsToBookingTripResult;
  /** Bulk adds members to an audience. */
  bulkCreateAudienceMembers: BulkCreateAudienceMembersResult;
  bulkCreateCategories: BulkCreateCategoriesResult;
  bulkCreateDepartureExcursions: BulkCreateDepartureExcursionsResult;
  bulkCreateDepartureExtensionExcursions: BulkCreateDepartureExtensionExcursionsResult;
  bulkCreateDepartureExtensionRooms: BulkCreateDepartureExtensionRoomsResult;
  bulkCreateDepartureExtensions: BulkCreateDepartureExtensionsResult;
  bulkCreateDepartureNotes: BulkCreateDepartureNotesResult;
  bulkCreateDepartureRooms: BulkCreateDepartureRoomsResult;
  bulkCreateDepartures: BulkCreateDeparturesResult;
  bulkCreateExtendedStays: BulkCreateExtendedStaysResult;
  /** Bulk create flight packages */
  bulkCreateFlightPackages: BulkCreateFlightPackagesResult;
  bulkCreateGCDepartureMeetingRSVPs: BulkCreateGcDepartureMeetingRsvPsResult;
  /** Create GC Departure Prospects in bulk. */
  bulkCreateGCDepartureProspects: BulkCreateGcDepartureProspectsResult;
  /** Bulk create private groups */
  bulkCreatePrivateGroups: BulkCreatePrivateGroupsResult;
  bulkCreatePromoTargets: BulkCreatePromoTargetsResult;
  bulkCreatePromos: BulkCreatePromosResult;
  bulkCreateTags: BulkCreateTagsResult;
  /** Bulk create tour airport transfers */
  bulkCreateTourAirportTransfers: BulkCreateTourAirportTransfersResult;
  /** Bulk create tour extension airport transfers */
  bulkCreateTourExtensionAirportTransfers: BulkCreateTourExtensionAirportTransfersResult;
  /** Deletes multiple GC Departure Meeting RSVPs */
  bulkDeleteGCDepartureMeetingRSVPs: BulkDeleteGcDepartureMeetingRsvPsResult;
  /** Removes multiple audience members */
  bulkRemoveAudienceMembers: BulkRemoveAudienceMembersResult;
  /** Bulk updates excursions across multiple bookings. */
  bulkUpdateBookingExcursions: BulkUpdateBookingExcursionsResult;
  /** Bulk updates extensions across multiple bookings. */
  bulkUpdateBookingExtensions: BulkUpdateBookingExtensionsResult;
  bulkUpdateDepartureExcursions: BulkUpdateDepartureExcursionsResult;
  bulkUpdateDepartureExtensionExcursions: BulkUpdateDepartureExtensionExcursionsResult;
  bulkUpdateDepartureExtensionRooms: BulkUpdateDepartureExtensionRoomsResult;
  bulkUpdateDepartureExtensions: BulkUpdateDepartureExtensionsResult;
  bulkUpdateDepartureOwners: BulkUpdateDepartureOwnersResult;
  bulkUpdateDepartureRooms: BulkUpdateDepartureRoomsResult;
  /** Bulk Update departure tags. */
  bulkUpdateDepartureTags: BulkUpdateDepartureTagsResult;
  bulkUpdateDepartures: BulkUpdateDeparturesResult;
  bulkUpdateExtendedStayPriceRules: BulkUpdateExtendedStayPriceRulesResult;
  /** Bulk update the price rules for fees */
  bulkUpdateFeePriceRules: BulkUpdateFeePriceRulesResult;
  /** Bulk update flight package price rules, creates the flight package if it doesn't exist. */
  bulkUpdateFlightPackagePriceRules: BulkUpdateFlightPackagePriceRulesResult;
  /** Updates the status of multiple Flight Packages */
  bulkUpdateFlightPackageStatuses: BulkUpdateFlightPackageStatusesResult;
  /** Bulk update flight packages (base price, status, and isCustomGateway). */
  bulkUpdateFlightPackages: BulkUpdateFlightPackagesResult;
  /** Updates the attended status of multiple GC Departure Meeting RSVPs */
  bulkUpdateGCDepartureMeetingRSVPsAttended: BulkUpdateGcDepartureMeetingRsvPsAttendedResult;
  bulkUpdateInsurancePlanAddonPriceRules: BulkUpdateInsurancePlanAddonPriceRulesResult;
  bulkUpdateInsurancePlanPriceRules: BulkUpdateInsurancePlanPriceRulesResult;
  bulkUpdatePlaces: BulkUpdatePlacesResult;
  /** Bulk update the price rules for private groups */
  bulkUpdatePrivateGroupPriceRules: BulkUpdatePrivateGroupPriceRulesResult;
  /** Bulk update private groups */
  bulkUpdatePrivateGroups: BulkUpdatePrivateGroupsResult;
  /** Bulk Update promos. */
  bulkUpdatePromos: BulkUpdatePromosResult;
  /** Bulk updates details of tour airport transfers. */
  bulkUpdateTourAirportTransfers: BulkUpdateTourAirportTransfersResult;
  /** Bulk updates price rules for tour airport transfers. */
  bulkUpdateTourAirportTransfersPriceRules: BulkUpdateTourAirportTransfersPriceRulesResult;
  /**
   * Bulk Update tour excursions places.
   * @deprecated Use bulkUpdateTourExcursionPlacesByCode instead
   */
  bulkUpdateTourExcursionPlaces: BulkUpdateTourExcursionPlacesResult;
  /** Bulk Update tour excursion places by place code. */
  bulkUpdateTourExcursionPlacesByCode: BulkUpdateTourExcursionPlacesByCodeResult;
  bulkUpdateTourExcursionPriceRules: BulkUpdateTourExcursionPriceRulesResult;
  /**
   * Bulk Update tour excursion tags using tag IDs.
   * @deprecated Use bulkUpdateTourExcursionTagsByName instead
   */
  bulkUpdateTourExcursionTags: BulkUpdateTourExcursionTagsResult;
  /** Bulk Update tour excursion tags by category and tag names. */
  bulkUpdateTourExcursionTagsByName: BulkUpdateTourExcursionTagsByNameResult;
  /** Bulk Updates details of a tour room. */
  bulkUpdateTourExcursions: BulkUpdateTourExcursionsResult;
  /** Bulk updates details of tour extension airport transfers. */
  bulkUpdateTourExtensionAirportTransfers: BulkUpdateTourExtensionAirportTransfersResult;
  /** Bulk updates price rules for tour extension airport transfers. */
  bulkUpdateTourExtensionAirportTransfersPriceRules: BulkUpdateTourExtensionAirportTransfersPriceRulesResult;
  /**
   * Bulk Update tour extensions places.
   * @deprecated Use bulkUpdateTourExtensionPlacesByCode instead
   */
  bulkUpdateTourExtensionPlaces: BulkUpdateTourExtensionPlacesResult;
  /** Bulk Update tour extension places by place code. */
  bulkUpdateTourExtensionPlacesByCode: BulkUpdateTourExtensionPlacesByCodeResult;
  bulkUpdateTourExtensionPriceRules: BulkUpdateTourExtensionPriceRulesResult;
  bulkUpdateTourExtensionRoomPriceRules: BulkUpdateTourExtensionRoomPriceRulesResult;
  /** Bulk Updates details of a tour extension room. */
  bulkUpdateTourExtensionRooms: BulkUpdateTourExtensionRoomsResult;
  /**
   * Bulk Update tour extension tags using tag IDs.
   * @deprecated Use bulkUpdateTourExtensionTagsByName instead
   */
  bulkUpdateTourExtensionTags: BulkUpdateTourExtensionTagsResult;
  /** Bulk Update tour extension tags by category and tag names. */
  bulkUpdateTourExtensionTagsByName: BulkUpdateTourExtensionTagsByNameResult;
  /** Bulk Update Tour Extensions */
  bulkUpdateTourExtensions: BulkUpdateTourExtensionsResult;
  /**
   * Bulk Update tour places.
   * @deprecated Use bulkUpdateTourPlacesByCode instead
   */
  bulkUpdateTourPlaces: BulkUpdateTourPlacesResult;
  /** Bulk Update tour places by place code. */
  bulkUpdateTourPlacesByCode: BulkUpdateTourPlacesByCodeResult;
  bulkUpdateTourPriceRules: BulkUpdateTourPriceRulesResult;
  bulkUpdateTourRoomPriceRules: BulkUpdateTourRoomPriceRulesResult;
  /** Bulk Updates details of a tour room. */
  bulkUpdateTourRooms: BulkUpdateTourRoomsResult;
  /**
   * Bulk Update tour tags using tag IDs.
   * @deprecated Use bulkUpdateTourTagsByName instead
   */
  bulkUpdateTourTags: BulkUpdateTourTagsResult;
  /** Bulk Update tour tags by category and tag names. */
  bulkUpdateTourTagsByName: BulkUpdateTourTagsByNameResult;
  /** Bulk Update tours. */
  bulkUpdateTours: BulkUpdateToursResult;
  calculatePaymentSchedule: CalculatePaymentScheduleResult;
  /** Cancel a Draft Booking by cancelling all of its trips. */
  cancelDraftBooking: CancelDraftBookingResult;
  /** Cancels a payment schedule on a draft booking */
  cancelDraftBookingPaymentSchedule: CancelDraftBookingPaymentScheduleResult;
  /** Cancel one or more trips on a Draft Booking */
  cancelDraftBookingTrips: CancelDraftBookingTripsResult;
  /** Cancel a single GC Departure that is not already cancelled */
  cancelGCDeparture: CancelGcDepartureResult;
  /** Cancel a GC Departure Meeting */
  cancelGCDepartureMeeting: CancelGcDepartureMeetingResult;
  /** Changes the expiration date of a voucher */
  changeVoucherExpiration: ChangeVoucherExpirationResult;
  /** Checks a trip checklist item */
  checkTripChecklistItem: CheckTripChecklistItemResult;
  /** Claim an experimental lead for the current employee */
  claimExperimentalLead: ClaimExperimentalLeadResult;
  /** Confirm a single GC Departure */
  confirmGCDeparture: ConfirmGcDepartureResult;
  /** Staff-only: retroactively connect an advocate and friend referral in Talon One. Returns the friend's reward balance and booking info so the caller can optionally apply rewards via applyTravelBankRewardsToBookingTrip. */
  connectReferral: ConnectReferralResult;
  /** Create a new adjustment for a given price year */
  createAdjustment: CreateAdjustmentResult;
  /** Create a new API key */
  createApiKey: CreateApiKeyResult;
  /** Creates a new audience */
  createAudience: CreateAudienceResult;
  /** Create a new campaign */
  createCampaign: CreateCampaignResult;
  createCategory: CreateCategoryResult;
  /**
   * Deprecated: use createChatTokenV2. This will be removed after all clients migrate.
   * @deprecated Use createChatTokenV2
   */
  createChatToken?: Maybe<ExternalToken>;
  createChatTokenV2?: Maybe<ExternalToken>;
  /** Create a new customer from an email */
  createCustomer: CreateCustomerResult;
  createDepartureExcursion: CreateDepartureExcursionResult;
  createDepartureExtension: CreateDepartureExtensionResult;
  createDepartureExtensionExcursion: CreateDepartureExtensionExcursionResult;
  createDepartureExtensionRoom: CreateDepartureExtensionRoomResult;
  createDepartureRoom: CreateDepartureRoomResult;
  /** Create a new draft booking */
  createDraftOrder: CreateDraftOrderResult;
  /** Create a new draft term */
  createDraftTerm: CreateDraftTermResult;
  /** Create a new experimental lead */
  createExperimentalLead: CreateExperimentalLeadResult;
  /** Create a new extended stay */
  createExtendedStay: CreateExtendedStayResult;
  /** Create a new fee */
  createFee: CreateFeeResult;
  /** Create a new flight package */
  createFlightPackage: CreateFlightPackageResult;
  /** Create a single GC Departure */
  createGCDeparture: CreateGcDepartureResult;
  createGCDepartureMeeting: CreateGcDepartureMeetingResult;
  createGCDepartureMeetingRSVP: CreateGcDepartureMeetingRsvpResult;
  /** Get a JWT token for logging a customer into the help center. */
  createHelpCenterLoginToken?: Maybe<ExternalToken>;
  /** Get a JWT token for authenticating a customer with the help center messaging platform. */
  createHelpCenterMessagingToken?: Maybe<ExternalToken>;
  /** Create a new insurance extension */
  createInsuranceExtension: CreateInsuranceExtensionResult;
  /** Create a new insurance plan for a given year */
  createInsurancePlan: CreateInsurancePlanResult;
  /** Create a new insurance plan addon for the given insurance plan */
  createInsurancePlanAddon: CreateInsurancePlanAddonResult;
  /** Create a new insurance policy */
  createInsurancePolicy: CreateInsurancePolicyResult;
  /** Create a new insurance policy revision for the given insurance policy */
  createInsurancePolicyRevision: CreateInsurancePolicyRevisionResult;
  /** Create a new note targeting any other entity */
  createNote: CreateNoteResult;
  /** Register a new OAuth client. The client_secret is only visible in this response. */
  createOAuthClient: CreateOAuthClientResult;
  createPlace: CreatePlaceResult;
  /** Create a new promo offer */
  createPromo: CreatePromoResult;
  /** Create a review of a trip */
  createReview: CreateReviewResult;
  createRole: CreateRoleResult;
  /** Create a new saved place for the current user */
  createSavedPlace?: Maybe<SavedPlace>;
  /** Create a new service recovery promo */
  createServiceRecoveryPromo: CreateServiceRecoveryPromoResult;
  /** Creates a support ticket */
  createSupportTicket: CreateSupportTicketResult;
  createTag: CreateTagResult;
  /** Create a new tour for a given year */
  createTour: CreateTourResult;
  /** Create a Tour Excursion for a given base Tour */
  createTourExcursion: CreateTourExcursionResult;
  /** Create a tour excursion for a given base tour */
  createTourExtension: CreateTourExtensionResult;
  createTourExtensionRoom: CreateTourExtensionRoomResult;
  createTourRoom: CreateTourRoomResult;
  /** Creates a TripChecklistItemTemplate */
  createTripChecklistItemTemplate: CreateTripChecklistItemTemplateResult;
  /** Create a voucher that originates from a booking */
  createVoucherFromBooking: CreateVoucherFromBookingResult;
  /** Create a voucher that originates from a different system and EF product outside WOJO */
  createVoucherFromExternal: CreateVoucherFromExternalResult;
  /** Create a Wishlist Item for a Customer and Tour Code */
  createWishlistItem: CreateWishlistItemResult;
  /** Deauthorizes a payment method */
  deauthorizePaymentMethod: DeauthorizePaymentMethodResult;
  /** Decline a price change detected during flight shopping revalidation. */
  declineFlightShopPriceChange: DeclineFlightShopPriceChangeResult;
  /** Deletes an audience */
  deleteAudience: DeleteAudienceResult;
  /** Delete a category */
  deleteCategory: DeleteCategoryResult;
  /** Delete an experimental lead by ID */
  deleteExperimentalLead?: Maybe<ExperimentalLead>;
  deleteGCDepartureMeetingRSVP: DeleteGcDepartureMeetingRsvpResult;
  /** Removes a GC Departure Prospect */
  deleteGCDepartureProspect: DeleteGcDepartureProspectResult;
  /** Delete an OAuth client by its _id */
  deleteOAuthClient: DeleteOAuthClientResult;
  deleteReviewImage: DeleteReviewImageResult;
  /** Delete a saved place by id */
  deleteSavedPlace?: Maybe<SavedPlace>;
  /** Delete a tag */
  deleteTag: DeleteTagResult;
  /** Removes a Wishlist Item from a Customer's wishlist */
  deleteWishlistItem: DeleteWishlistItemResult;
  /** Preview the effect of redeeming referral travel bank points on a trip. Validates against the customer's referral balance and order/trip rules. Amount is in the order's currency (1:1 with points). */
  evaluateReferralTravelBankRedemption: EvaluateReferralTravelBankRedemptionResult;
  /** Forks one or more trips from a Booking onto a new Booking. */
  forkBooking: ForkBookingResult;
  /** Generate an AI-powered supplier confirmation email template based on departure and component data. Returns null if generation fails. */
  generateSupplierConfirmationEmail?: Maybe<SupplierConfirmationEmailResult>;
  /** Increases a non-expired, non-voided voucher by a dollar amount */
  increaseVoucher: IncreaseVoucherResult;
  /** Queues an event for a departure to be integrated to production. */
  integrateDepartureToProduction: IntegrateDepartureToProductionResult;
  /** Forces re-integration of a GC Departure to Global Rewards */
  integrateGCDepartureGlobalRewards: IntegrateGcDepartureGlobalRewardsResult;
  /** Queues an event for a booking to be integrated to production. */
  integrateOrderToProduction: IntegrateOrderToProductionResult;
  /** Makes a one time payment on an active booking. Will cause any payment plans on the booking to recalculate. */
  issueARefund: IssueARefundResult;
  /** Makes a one time payment on an active booking. Will cause any payment plans on the booking to recalculate. */
  makeAPayment: MakeAPaymentResult;
  /** Match trips on the same quote in the same room */
  matchQuoteRoommates: MatchQuoteRoommatesResult;
  /** Match trips in the same room */
  matchRoommates: MatchRoommatesResult;
  /** Merges a source booking into a target booking. */
  mergeBooking: MergeBookingResult;
  /** Merge two customers */
  mergeCustomer: MergeCustomerResult;
  /** Converts a quote into booking given payment is fulfilled in respect to the payment plan. */
  payAndBook: PayAndBookResult;
  /** Publishes draft booking */
  publishDraftBooking: PublishDraftBookingResult;
  /** Publishes draft quote */
  publishDraftQuote: PublishDraftQuoteResult;
  /** Publish a draft term */
  publishDraftTerm: PublishDraftTermResult;
  /** Create a reaction to a review */
  reactToReview: ReactToReviewResult;
  /**
   * Reconcile the status of a card or ach payment on a booking.
   * @deprecated Use reconcilePayment instead
   */
  reconcileCardOrAchPayment: ReconcileCardOrAchPaymentResult;
  /** Reconcile a pending check payment on a booking. */
  reconcileCheckPayment: ReconcileCheckPaymentResult;
  /** Reconcile the status of a card or ach payment on a booking. */
  reconcilePayment: ReconcilePaymentResult;
  /** Submit a batch of payment transactions for reconciliation; resolves transaction IDs, matches to bookings, and updates reconciliation status. */
  reconcilePayments: ReconcilePaymentsResult;
  /** Reduces a non-expired, non-voided voucher by a dollar amount */
  reduceVoucher: ReduceVoucherResult;
  /** Refunds a refundable, active voucher that has a remaining balance */
  refundVoucher: RefundVoucherResult;
  /** Reinstates a voided voucher, undoing the void. The amount reinstated will be the same as the balance when the voucher was voided. */
  reinstateVoucher: ReinstateVoucherResult;
  /** Removes a member from an audience. */
  removeAudienceMember: RemoveAudienceMemberResult;
  /** Removes an offer code from an audience. */
  removeAudienceOfferCode: RemoveAudienceOfferCodeResult;
  /** Removes offer codes from an audience. */
  removeAudienceOfferCodes: RemoveAudienceOfferCodesResult;
  /** Add promos to a campaign */
  removeCampaignPromos: RemoveCampaignPromosResult;
  /** Cancels one or more adjustments on a draft order for one or more trips. */
  removeDraftOrderAdjustments: RemoveDraftOrderAdjustmentsResult;
  /** Removes airport transfer from draft order for specified trips. */
  removeDraftOrderAirportTransfer: RemoveDraftOrderAirportTransferResult;
  /** Removes excursion on draft order for specified trips. */
  removeDraftOrderExcursion: RemoveDraftOrderExcursionResult;
  /** Removes all excursions for either the main tour or the extension on the specified trips. */
  removeDraftOrderExcursions: RemoveDraftOrderExcursionsResult;
  /** Removes extension on draft order for specified trips. */
  removeDraftOrderExtension: RemoveDraftOrderExtensionResult;
  /** Removes one or more fees from a draft order for one or more trips. */
  removeDraftOrderFees: RemoveDraftOrderFeesResult;
  /** Removes flight shopping from a draft order for specified trips. */
  removeDraftOrderFlightShop: RemoveDraftOrderFlightShopResult;
  /** Removes insurance from one or more trips on a draft order. */
  removeDraftOrderInsurance: RemoveDraftOrderInsuranceResult;
  /** Removes insurance addon for one or more trips on a draft order. */
  removeDraftOrderInsuranceAddon: RemoveDraftOrderInsuranceAddonResult;
  /** Removes the insurance extension for one or more trips on a draft order. */
  removeDraftOrderInsuranceExtension: RemoveDraftOrderInsuranceExtensionResult;
  /** Removes post-stay on draft order for specified trips. */
  removeDraftOrderPostStay: RemoveDraftOrderPostStayResult;
  /** Removes pre-stay on draft order for specified trips. */
  removeDraftOrderPreStay: RemoveDraftOrderPreStayResult;
  /** Removes the private group fee from a draft order for one or more trips. */
  removeDraftOrderPrivateGroup: RemoveDraftOrderPrivateGroupResult;
  /** Removes a promo from one or more trips on a draft order. */
  removeDraftOrderPromo: RemoveDraftOrderPromoResult;
  /** Removes travel companion requests from a draft order for the specified trip. */
  removeDraftOrderTravelCompanionRequests: RemoveDraftOrderTravelCompanionRequestsResult;
  /** Remove one or more trips from a Draft Quote */
  removeDraftQuoteTrips: RemoveDraftQuoteTripsResult;
  /** Removes the role for employees */
  removeEmployeesFromRole: RemoveEmployeesFromRoleResult;
  removePlace: RemovePlaceResult;
  /** Remove the private group from a tour */
  removePrivateGroup: RemovePrivateGroupResult;
  /** Remove promo codes */
  removePromoCodes: RemovePromoCodesResult;
  /** Remove customers from a promo */
  removePromoCustomers: RemovePromoCustomersResult;
  /** Remove gc departure from a promo */
  removePromoGcDepartures: RemovePromoGcDeparturesResult;
  /** Remove targets from a promo */
  removePromoTargets: RemovePromoTargetsResult;
  /** Removes a Tour Excursion from this tour. */
  removeTourExcursions: RemoveTourExcursionsResult;
  /** Removes a Tour Excursion from this extension. */
  removeTourExtensionExcursions: RemoveTourExtensionExcursionsResult;
  /** Rotate the client_secret for an OAuth client. The new secret is only visible in this response. */
  rotateOAuthClientSecret: RotateOAuthClientSecretResult;
  /** Save an evaluation */
  saveEvaluation: SaveEvaluationResult;
  /** Generate a magic link, and send to a customer or tour director */
  sendMagicLink: SendMagicLinkResult;
  /** Sets a payment method as the default for the customer */
  setDefaultPaymentMethod: SetDefaultPaymentMethodResult;
  /** Sets customer on draft quote */
  setDraftQuoteCustomer: SetDraftQuoteCustomerResult;
  /** Set review as featured */
  setReviewFeatured: Review;
  /** Shop for flights for the given trip IDs */
  shopFlights: ShopFlightsResult;
  /** Signin a customer from a magic link */
  signinCustomerWithMagicLink: SigninCustomerWithMagicLinkResult;
  /** Signin a customer from an email and password */
  signinCustomerWithPassword: SigninCustomerWithPasswordResult;
  /** Signin a tour director from a magic link */
  signinTourDirectorWithMagicLink: SigninTourDirectorWithMagicLinkResult;
  /** Signout the current user */
  signout: SignoutResult;
  /** Create a new customer from an email */
  signupCustomer: SignupCustomerResult;
  /** Start the flight booking process by initiating revalidation of selected flights and creating a booking result */
  startFlightBooking: StartFlightBookingResult;
  /** Start a Quote by creating a DraftOrder for a Quote that does not yet exist. Used to start the Quoting process. While this mutation creates a DraftOrder, the Quote is not saved and cannot be queried until the Draft has been published. By default, creates only a single Trip (The primary Trip). */
  startQuote: StartQuoteResult;
  /** Sets the booking to PENDING_REBOOKING status. */
  startRebooking: StartRebookingResult;
  /** Start a Quote by creating a DraftOrder for a Quote that does not yet exist. Used to start the Quoting process. While this mutation creates a DraftOrder, the Quote is not saved and cannot be queried until the Draft has been published. By default, creates only a single Trip (The primary Trip). */
  startRebookingQuote: StartRebookingQuoteResult;
  /** Submit an evaluation */
  submitEvaluation: SubmitEvaluationResult;
  /** Transfer the balance from one voucher to another */
  transferVoucherExternal: TransferVoucherExternalResult;
  /** Transfer the balance from one voucher to another */
  transferVoucherInternal: TransferVoucherInternalResult;
  /** Unchecks a trip checklist item */
  uncheckTripChecklistItem: UncheckTripChecklistItemResult;
  /** Unclaim an experimental lead (only the claimer can unclaim) */
  unclaimExperimentalLead: UnclaimExperimentalLeadResult;
  /** Unmatch trips on the same quote from a room */
  unmatchQuoteRoommates: UnmatchQuoteRoommatesResult;
  /** Unmatch trips from a room */
  unmatchRoommates: UnmatchRoommatesResult;
  /** Unsets the default status of a payment method */
  unsetDefaultPaymentMethod: UnsetDefaultPaymentMethodResult;
  /** Updates an adjustment. */
  updateAdjustment: UpdateAdjustmentResult;
  /** Updates the status of an adjustment. */
  updateAdjustmentStatus: UpdateAdjustmentStatusResult;
  /** Update the details of an audience */
  updateAudience: UpdateAudienceResult;
  /** Forces the coverage start date for the given insurance line item(s) to the specified date. Sets the free look period and policy number on the line item. Requires the trip to have an open insurance line item. */
  updateBookingTripInsuranceCoverageStartDate: UpdateBookingTripInsuranceCoverageStartDateResult;
  /** Updates the current business's chat settings */
  updateBusinessChatSettings: UpdateBusinessChatSettingsResult;
  /** Updates the current business's customer settings */
  updateBusinessCustomerSettings: UpdateBusinessCustomerSettingsResult;
  /** Updates the current business's departure settings */
  updateBusinessDepartureSettings: UpdateBusinessDepartureSettingsResult;
  /** Updates the current business's evaluation settings */
  updateBusinessEvaluationSettings: UpdateBusinessEvaluationSettingsResult;
  /** Updates the current business's fee settings */
  updateBusinessFeeSettings: UpdateBusinessFeeSettingsResult;
  /** Updates the current business's flight settings */
  updateBusinessFlightSettings: UpdateBusinessFlightSettingsResult;
  /** Updates the current business's GC departure settings */
  updateBusinessGCDepartureSettings: UpdateBusinessGcDepartureSettingsResult;
  /** Updates the current business's group trip checklist settings */
  updateBusinessGroupTripChecklistSettings: UpdateBusinessGroupTripChecklistSettingsResult;
  /** Updates the current business's insurance settings */
  updateBusinessInsuranceSettings: UpdateBusinessInsuranceSettingsResult;
  /** Updates the current business's integration settings */
  updateBusinessIntegrationSettings: UpdateBusinessIntegrationSettingsResult;
  /** Updates the current business's order payment related settings */
  updateBusinessOrderPaymentSettings: UpdateBusinessOrderPaymentSettingsResult;
  /** Updates the current business's order quotes section settings */
  updateBusinessOrderQuoteSettings: UpdateBusinessOrderQuoteSettingsResult;
  /** Updates the current business's order rooming settings */
  updateBusinessOrderRoomingSettings: UpdateBusinessOrderRoomingSettingsResult;
  /** Updates the current business's order settings */
  updateBusinessOrderSettings: UpdateBusinessOrderSettingsResult;
  /** Updates the current business's promo settings */
  updateBusinessPromoSettings: UpdateBusinessPromoSettingsResult;
  /** Updates the current business's review settings */
  updateBusinessReviewSettings: UpdateBusinessReviewSettingsResult;
  /** Updates the current business's support ticket settings */
  updateBusinessSupportTicketSettings: UpdateBusinessSupportTicketSettingsResult;
  /** Updates the current business's tour search settings */
  updateBusinessTourSearchSettings: UpdateBusinessTourSearchSettingsResult;
  /** Updates the current business's trip checklist settings */
  updateBusinessTripChecklistSettings: UpdateBusinessTripChecklistSettingsResult;
  /** Updates the current business's TSA settings */
  updateBusinessTsaSettings: UpdateBusinessTsaSettingsResult;
  /** Update the details of a campaign */
  updateCampaign: UpdateCampaignResult;
  /** Publish or Unpublish a campaign. */
  updateCampaignStatus: UpdateCampaignStatusResult;
  /** Update the basic details of a category */
  updateCategory: UpdateCategoryResult;
  /** Updates a customer address */
  updateCustomerAddress: UpdateCustomerAddressResult;
  /** Update a customer's email used for logging in */
  updateCustomerEmail: UpdateCustomerEmailResult;
  /** Update a customer's Global Rewards ID (currently Phoenix CustomerNumber) */
  updateCustomerGlobalRewardsId: Customer;
  /** Update a customer's preferred name */
  updateCustomerName: UpdateCustomerNameResult;
  /** Change a customer's password */
  updateCustomerPassword: UpdateCustomerPasswordResult;
  /** Updates a customer phone number. */
  updateCustomerPhoneNumber: UpdateCustomerPhoneNumberResult;
  /** Update customer bio */
  updateCustomerProfileBio: Customer;
  /** Update customer's profile image */
  updateCustomerProfileImage: Customer;
  /** Update customer privacy */
  updateCustomerProfilePrivacy: Customer;
  /** Update customer's social media */
  updateCustomerProfileSocialMedia: Customer;
  updateDeparture: UpdateDepartureResult;
  updateDepartureExcursion: UpdateDepartureExcursionResult;
  updateDepartureExtension: UpdateDepartureExtensionResult;
  updateDepartureExtensionExcursion: UpdateDepartureExtensionExcursionResult;
  updateDepartureExtensionRoom: UpdateDepartureExtensionRoomResult;
  updateDepartureItemStatus: UpdateDepartureItemStatusResult;
  updateDepartureRoom: UpdateDepartureRoomResult;
  /** Updated the payment schedule of a draft booking */
  updateDraftBookingPaymentSchedule: UpdateDraftBookingPaymentScheduleResult;
  /** Updates the payment method for the active payment schedule of a draft booking. */
  updateDraftBookingPaymentSchedulePaymentMethod: UpdateDraftBookingPaymentSchedulePaymentMethodResult;
  /** Updates line item statuses on a draft booking. Can be one of CONFIRMED, REQUESTED, or WAITLISTED. Otherwise, please use the respective mutations for the rest of the statuses. */
  updateDraftBookingTripLineItemStatuses: UpdateDraftBookingTripLineItemStatusesResult;
  /** Updates trip statuses on a draft booking. Can be one of CONFIRMED, REQUESTED, or WAITLISTED. Otherwise, please use the respective mutations for the rest of the statuses. */
  updateDraftBookingTripStatuses: UpdateDraftBookingTripStatusesResult;
  /** Sets Address information on draft order. */
  updateDraftOrderAddress: UpdateDraftOrderAddressResult;
  /** Overrides the price of one or more adjustments from a draft order for one or more trips. */
  updateDraftOrderAdjustmentPrices: UpdateDraftOrderAdjustmentPricesResult;
  /** Update an orders airport transfer details for when a flight is LO1 and customer has purchased a transfer */
  updateDraftOrderAirportTransfer: UpdateDraftOrderAirportTransferResult;
  /** Update the emergency contacts for a traveler on a trip. */
  updateDraftOrderEmergencyContacts: UpdateDraftOrderEmergencyContactsResult;
  /** Updates extension rooms on a draft order. */
  updateDraftOrderExtensionRooms: UpdateDraftOrderExtensionRoomsResult;
  /** Overrides the price of one or more fees from a draft order for one or more trips. */
  updateDraftOrderFeePrices: UpdateDraftOrderFeePricesResult;
  /** Sets the final installment deadline on a draft order. */
  updateDraftOrderFinalInstallmentDeadline: UpdateDraftOrderFinalInstallmentDeadlineResult;
  /** Sets the final payment deadline on a draft order. */
  updateDraftOrderFinalPaymentDeadline: UpdateDraftOrderFinalPaymentDeadlineResult;
  /** Updates flight packages on a draft order. */
  updateDraftOrderFlightPackages: UpdateDraftOrderFlightPackagesResult;
  /** Sets the incentive redemption adjustment line item on a trip within an existing draft order to the specified total amount. */
  updateDraftOrderIncentivesRedemptionAdjustment: UpdateDraftOrderIncentivesRedemptionAdjustmentResult;
  /** Updates insurance on draft order for specified trips. */
  updateDraftOrderInsurance: UpdateDraftOrderInsuranceResult;
  /** Sets TSA information for multiple trips on a draft order. */
  updateDraftOrderMultiTripTsaInformation: UpdateDraftOrderMultiTripTsaInformationResult;
  /** Updates the primary trip on a draft booking */
  updateDraftOrderPrimaryTrip: UpdateDraftOrderPrimaryTripResult;
  /** Overrides the price of one or more promos from a draft order for one or more trips. */
  updateDraftOrderPromoPrices: UpdateDraftOrderPromoPricesResult;
  /** Sets the requested roommates for a trip on a draft order. */
  updateDraftOrderRequestedRoommates: UpdateDraftOrderRequestedRoommatesResult;
  /**
   * Sets the requested travel companions for a trip on a draft order.
   * @deprecated Use addDraftOrderTravelCompanionRequests instead
   */
  updateDraftOrderRequestedTravelCompanions: UpdateDraftOrderRequestedTravelCompanionsResult;
  /** Updates rooms on a draft order */
  updateDraftOrderRooms: UpdateDraftOrderRoomsResult;
  /** Update the health notes for a traveler on a trip */
  updateDraftOrderTravelerNotes: UpdateDraftOrderTravelerNotesResult;
  /** Sets TSA information for a trip on a draft order. */
  updateDraftOrderTsaInformation: UpdateDraftOrderTsaInformationResult;
  /** Save or un-save a draft quote */
  updateDraftQuoteSaved: UpdateDraftQuoteSavedResult;
  /** Update a draft term */
  updateDraftTerm: UpdateDraftTermResult;
  /** Update an existing experimental lead */
  updateExperimentalLead: UpdateExperimentalLeadResult;
  /** Update an extended stay's base price */
  updateExtendedStay: UpdateExtendedStayResult;
  /** Updates an Extended Stay status */
  updateExtendedStayStatus: UpdateExtendedStayStatusResult;
  /** Update the base price of a fee. */
  updateFee: UpdateFeeResult;
  /** Updates a Fee status */
  updateFeeStatus: UpdateFeeStatusResult;
  /** Update a flight package details and base price */
  updateFlightPackage: UpdateFlightPackageResult;
  /** Updates a Flight Package status */
  updateFlightPackageStatus: UpdateFlightPackageStatusResult;
  /** Update an existing flight shop component */
  updateFlightShop: UpdateFlightShopResult;
  /** Updates a Flight Shop status */
  updateFlightShopStatus: UpdateFlightShopStatusResult;
  updateGCDeparture: UpdateGcDepartureResult;
  updateGCDepartureMeeting: UpdateGcDepartureMeetingResult;
  updateGCDepartureMeetingRSVP: UpdateGcDepartureMeetingRsvpResult;
  /** Update a GC Departure Prospect  */
  updateGCDepartureProspect: UpdateGcDepartureProspectResult;
  updateGCDepartureStipendDetail: UpdateGcDepartureStipendDetailResult;
  /** Update insurance extension */
  updateInsuranceExtension: UpdateInsuranceExtensionResult;
  /** Publish or unpublish an insurance extension. */
  updateInsuranceExtensionStatus: UpdateInsuranceExtensionStatusResult;
  /** Update an existing insurance plan */
  updateInsurancePlan: UpdateInsurancePlanResult;
  /** Update an insurance plan addon */
  updateInsurancePlanAddon: UpdateInsurancePlanAddonResult;
  /** Publish or Unpublish a insurance plan. */
  updateInsurancePlanAddonStatus: UpdateInsurancePlanAddonStatusResult;
  /** Publish or Unpublish a insurance plan. */
  updateInsurancePlanStatus: UpdateInsurancePlanStatusResult;
  /** Update an existing insurance policy */
  updateInsurancePolicy: UpdateInsurancePolicyResult;
  /** Update an insurance policy revision */
  updateInsurancePolicyRevision: UpdateInsurancePolicyRevisionResult;
  /** Update an existing note */
  updateNote: UpdateNoteResult;
  /** Update an existing OAuth client's metadata */
  updateOAuthClient: UpdateOAuthClientResult;
  updatePlace: UpdatePlaceResult;
  /** Update the base price of a private group. */
  updatePrivateGroup: UpdatePrivateGroupResult;
  /** Updates a tour's private group status */
  updatePrivateGroupStatus: UpdatePrivateGroupStatusResult;
  /** Update the details of a promo */
  updatePromo: UpdatePromoResult;
  /** Publish or Unpublish a promo. */
  updatePromoStatus: UpdatePromoStatusResult;
  /** Update the targets of a promo. Passing empty array will clear the targets. */
  updatePromoTargets: UpdatePromoTargetsResult;
  /** Updates a quote expiration date */
  updateQuoteExpiry: UpdateQuoteExpiryResult;
  /** Save or un-save a quote */
  updateQuoteSaved: UpdateQuoteSavedResult;
  /** Updates basic fields of an existing review */
  updateReview: UpdateReviewResult;
  /** Updates a review reply or creates one if it doesn't exist. If input is null, it clears the response. */
  updateReviewDetailResponse: UpdateReviewDetailResponseResult;
  /** Updates the review detail status */
  updateReviewDetailStatus: UpdateReviewDetailStatusResult;
  /** Updates the review images status */
  updateReviewImagesStatus: UpdateReviewImagesStatusResult;
  updateRole: UpdateRoleResult;
  /** Update user-specific attributes of a saved place */
  updateSavedPlace?: Maybe<SavedPlace>;
  /** Update the details of a service recovery promo. */
  updateServiceRecoveryPromo: UpdateServiceRecoveryPromoResult;
  /** Publish or Unpublish a service recovery promo. */
  updateServiceRecoveryPromoStatus: UpdateServiceRecoveryPromoStatusResult;
  /** Update the basic details of a tag */
  updateTag: UpdateTagResult;
  /** Update a tour by id. */
  updateTour: UpdateTourResult;
  /** Updates details of a tour airport transfer. */
  updateTourAirportTransfer: UpdateTourAirportTransferResult;
  /** Update profile info of a tour director such as bio and communication preferences */
  updateTourDirectorProfile: TourDirector;
  /** Updates a Tour Excursion basic details */
  updateTourExcursion: UpdateTourExcursionResult;
  /** Publish or Unpublish a tour excursion. */
  updateTourExcursionStatus: UpdateTourExcursionStatusResult;
  /** Updates details of an extension */
  updateTourExtension: UpdateTourExtensionResult;
  /** Updates details of a tour extension airport transfer. */
  updateTourExtensionAirportTransfer: UpdateTourExtensionAirportTransferResult;
  /** Updates details of a tour extension room. */
  updateTourExtensionRoom: UpdateTourExtensionRoomResult;
  /** Publish or Unpublish a tour extension room. */
  updateTourExtensionRoomStatus: UpdateTourExtensionRoomStatusResult;
  /** Publish or Unpublish a tour extension. */
  updateTourExtensionStatus: UpdateTourExtensionStatusResult;
  /** Update prices for any part of a tour including the tour itself */
  updateTourPricing: UpdateTourPricingResult;
  /** Updates details of a tour room. */
  updateTourRoom: UpdateTourRoomResult;
  /** Publish or Unpublish a tour. */
  updateTourRoomStatus: UpdateTourRoomStatusResult;
  /** Publish or Unpublish a tour. */
  updateTourStatus: UpdateTourStatusResult;
  /** Updates a TripChecklistItemTemplate */
  updateTripChecklistItemTemplate: UpdateTripChecklistItemTemplateResult;
  /** Updates the detail of a refund transaction on the specified Voucher, e.g. to add missing check detail */
  updateVoucherRefundDetail: UpdateVoucherRefundDetailResult;
  /** Void a transfer payment on a booking. */
  voidBookingTransferPayment: VoidBookingTransferPaymentResult;
  /** Voids a non-expired, non-voided voucher that has a balance remaining */
  voidVoucher: VoidVoucherResult;
};


export type MutationAcceptFlightShopPriceChangeArgs = {
  flightBookingResultId: Scalars['ObjectId'];
};


export type MutationAcceptGcDepartureTermsArgs = {
  _id: Scalars['ObjectId'];
  acceptanceMethod?: InputMaybe<TermSignatureMethod>;
  signingCustomerId?: InputMaybe<Scalars['ObjectId']>;
  termId: Scalars['ObjectId'];
};


export type MutationAcceptTripTermsArgs = {
  acceptanceMethod?: InputMaybe<TermSignatureMethod>;
  bookingId: Scalars['ObjectId'];
  signingCustomerId?: InputMaybe<Scalars['ObjectId']>;
  termId: Scalars['ObjectId'];
  tripId: Scalars['ObjectId'];
};


export type MutationAddAudienceOfferCodeArgs = {
  _id: Scalars['ObjectId'];
  offerCode: Scalars['String'];
};


export type MutationAddAudienceOfferCodesArgs = {
  _id: Scalars['ObjectId'];
  offerCodes: Array<Scalars['String']>;
};


export type MutationAddCampaignPromosArgs = {
  _id: Scalars['ObjectId'];
  input: AddCampaignPromosInput;
};


export type MutationAddDraftBookingPaymentScheduleArgs = {
  _id: Scalars['ObjectId'];
  paymentSchedule: PaymentScheduleInput;
};


export type MutationAddDraftOrderAdjustmentArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<AddDraftOrderAdjustmentInput>;
  lineItemCode: Scalars['LineItemCode'];
};


export type MutationAddDraftOrderCampaignArgs = {
  _id: Scalars['ObjectId'];
  autoApplied?: Scalars['Boolean'];
  campaignCode: Scalars['String'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationAddDraftOrderExcursionsArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<AddDraftOrderExcursionInput>;
};


export type MutationAddDraftOrderExtensionArgs = {
  _id: Scalars['ObjectId'];
  lineItemCode: Scalars['LineItemCode'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationAddDraftOrderFeeArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<AddDraftOrderFeeInput>;
  lineItemCode: Scalars['LineItemCode'];
};


export type MutationAddDraftOrderInboundAirportTransferArgs = {
  _id: Scalars['ObjectId'];
  input: AddInboundAirportTransferInput;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationAddDraftOrderInsuranceArgs = {
  _id: Scalars['ObjectId'];
  addOnLineItemCodes?: InputMaybe<Array<Scalars['LineItemCode']>>;
  lineItemCode: Scalars['LineItemCode'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationAddDraftOrderInsuranceAddonArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<AddDraftOrderInsuranceAddonInput>;
};


export type MutationAddDraftOrderInsuranceExtensionArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<AddDraftOrderInsuranceExtensionInput>;
};


export type MutationAddDraftOrderOutboundAirportTransferArgs = {
  _id: Scalars['ObjectId'];
  input: AddOutboundAirportTransferInput;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationAddDraftOrderPostStayArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<AddDraftOrderExtendedStayInput>;
  lineItemCode: Scalars['LineItemCode'];
};


export type MutationAddDraftOrderPreStayArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<AddDraftOrderExtendedStayInput>;
  lineItemCode: Scalars['LineItemCode'];
};


export type MutationAddDraftOrderPrivateGroupArgs = {
  _id: Scalars['ObjectId'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationAddDraftOrderPromoArgs = {
  _id: Scalars['ObjectId'];
  autoApplied?: Scalars['Boolean'];
  promoCode: Scalars['String'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationAddDraftOrderTravelCompanionRequestsArgs = {
  _id: Scalars['ObjectId'];
  requestedTripIds: Array<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
};


export type MutationAddDraftQuoteTripArgs = {
  input: AddDraftQuoteTripInput;
};


export type MutationAddEmployeesToRoleArgs = {
  _id: Scalars['ObjectId'];
  input: AddEmployeesToRoleInput;
};


export type MutationAddFlightShopArgs = {
  input: AddFlightShopInput;
};


export type MutationAddPaymentMethodToCustomerArgs = {
  input: AddPaymentMethodToCustomerInput;
};


export type MutationAddPrivateGroupArgs = {
  _id: Scalars['ObjectId'];
  input: AddPrivateGroupInput;
};


export type MutationAddPromoCodesArgs = {
  _id: Scalars['ObjectId'];
  input: AddPromoCodesInput;
};


export type MutationAddPromoCustomersArgs = {
  _id: Scalars['ObjectId'];
  input: AddPromoCustomersInput;
};


export type MutationAddPromoGcDeparturesArgs = {
  _id: Scalars['ObjectId'];
  input: AddPromoGcDepartureInput;
};


export type MutationAddPromoTargetsArgs = {
  _id: Scalars['ObjectId'];
  input: AddPromoTargetsInput;
};


export type MutationAddTourAirportTransferArgs = {
  _id: Scalars['ObjectId'];
  input: AddTourAirportTransferInput;
};


export type MutationAddTourExcursionArgs = {
  _id: Scalars['ObjectId'];
  tourExcursionId: Scalars['ObjectId'];
};


export type MutationAddTourExtensionAirportTransferArgs = {
  _id: Scalars['ObjectId'];
  input: AddTourExtensionAirportTransferInput;
};


export type MutationAddTourExtensionExcursionArgs = {
  _id: Scalars['ObjectId'];
  tourExcursionId: Scalars['ObjectId'];
};


export type MutationAdminCreateMagicLinkArgs = {
  input: AdminCreateMagicLinkInput;
};


export type MutationAnonymizeCustomerArgs = {
  _id: Scalars['ObjectId'];
  businessCode: BusinessCode;
};


export type MutationApplyGcDeparturePrivateGroupFeeArgs = {
  _id: Scalars['ObjectId'];
  useEstimatedGroupSize?: InputMaybe<Scalars['Boolean']>;
};


export type MutationApplyTravelBankRewardsToBookingTripArgs = {
  input: ApplyTravelBankRewardsToBookingTripInput;
};


export type MutationBulkCreateAudienceMembersArgs = {
  _id: Scalars['ObjectId'];
  input: Array<BulkCreateAudienceMembersInput>;
};


export type MutationBulkCreateCategoriesArgs = {
  input: Array<BulkCreateCategoryInput>;
};


export type MutationBulkCreateDepartureExcursionsArgs = {
  input: Array<BulkCreateDepartureExcursionInput>;
};


export type MutationBulkCreateDepartureExtensionExcursionsArgs = {
  input: Array<BulkCreateDepartureExtensionExcursionInput>;
};


export type MutationBulkCreateDepartureExtensionRoomsArgs = {
  input: Array<BulkCreateDepartureExtensionRoomInput>;
};


export type MutationBulkCreateDepartureExtensionsArgs = {
  input: Array<BulkCreateDepartureExtensionInput>;
};


export type MutationBulkCreateDepartureNotesArgs = {
  input: Array<BulkCreateDepartureNotesInput>;
};


export type MutationBulkCreateDepartureRoomsArgs = {
  input: Array<BulkCreateDepartureRoomInput>;
};


export type MutationBulkCreateDeparturesArgs = {
  input: Array<BulkCreateDepartureInput>;
};


export type MutationBulkCreateExtendedStaysArgs = {
  input: Array<CreateExtendedStayInput>;
};


export type MutationBulkCreateFlightPackagesArgs = {
  input: BulkCreateFlightPackagesInput;
};


export type MutationBulkCreateGcDepartureMeetingRsvPsArgs = {
  input: BulkCreateGcDepartureMeetingRsvPsInput;
};


export type MutationBulkCreateGcDepartureProspectsArgs = {
  groupCoordinatorCustomerId: Scalars['ObjectId'];
  input: Array<BulkCreateGcDepartureProspectsInput>;
};


export type MutationBulkCreatePrivateGroupsArgs = {
  input: Array<BulkCreatePrivateGroupsInput>;
};


export type MutationBulkCreatePromoTargetsArgs = {
  input: Array<BulkCreatePromoTargetInput>;
};


export type MutationBulkCreatePromosArgs = {
  input: Array<CreatePromoInput>;
};


export type MutationBulkCreateTagsArgs = {
  input: Array<BulkCreateTagsInput>;
};


export type MutationBulkCreateTourAirportTransfersArgs = {
  input: Array<BulkCreateTourAirportTransfersInput>;
};


export type MutationBulkCreateTourExtensionAirportTransfersArgs = {
  input: Array<BulkCreateTourExtensionAirportTransfersInput>;
};


export type MutationBulkDeleteGcDepartureMeetingRsvPsArgs = {
  input: BulkDeleteGcDepartureMeetingRsvPsInput;
};


export type MutationBulkRemoveAudienceMembersArgs = {
  input: BulkRemoveAudienceMembersInput;
};


export type MutationBulkUpdateBookingExcursionsArgs = {
  input: BulkUpdateBookingExcursionsInput;
};


export type MutationBulkUpdateBookingExtensionsArgs = {
  input: BulkUpdateBookingExtensionsInput;
};


export type MutationBulkUpdateDepartureExcursionsArgs = {
  input: Array<BulkUpdateDepartureExcursionInput>;
};


export type MutationBulkUpdateDepartureExtensionExcursionsArgs = {
  input: Array<BulkUpdateDepartureExtensionExcursionInput>;
};


export type MutationBulkUpdateDepartureExtensionRoomsArgs = {
  input: Array<BulkUpdateDepartureExtensionRoomInput>;
};


export type MutationBulkUpdateDepartureExtensionsArgs = {
  input: Array<BulkUpdateDepartureExtensionInput>;
};


export type MutationBulkUpdateDepartureOwnersArgs = {
  input: Array<BulkUpdateDepartureOwnerInput>;
};


export type MutationBulkUpdateDepartureRoomsArgs = {
  input: Array<BulkUpdateDepartureRoomInput>;
};


export type MutationBulkUpdateDepartureTagsArgs = {
  input: Array<BulkUpdateDepartureTagsInput>;
};


export type MutationBulkUpdateDeparturesArgs = {
  input: Array<BulkUpdateDepartureInput>;
};


export type MutationBulkUpdateExtendedStayPriceRulesArgs = {
  input: Array<BulkUpdateExtendedStayPriceRulesInput>;
};


export type MutationBulkUpdateFeePriceRulesArgs = {
  input: Array<BulkUpdateFeePriceRulesInput>;
};


export type MutationBulkUpdateFlightPackagePriceRulesArgs = {
  input: Array<BulkUpdateFlightPackagePriceRulesInput>;
};


export type MutationBulkUpdateFlightPackageStatusesArgs = {
  input: BulkUpdateFlightPackageStatusesInput;
};


export type MutationBulkUpdateFlightPackagesArgs = {
  input: Array<BulkUpdateFlightPackagesInput>;
};


export type MutationBulkUpdateGcDepartureMeetingRsvPsAttendedArgs = {
  input: BulkUpdateGcDepartureMeetingRsvPsAttendedInput;
};


export type MutationBulkUpdateInsurancePlanAddonPriceRulesArgs = {
  input: Array<BulkUpdateInsurancePlanAddonPriceRulesInput>;
};


export type MutationBulkUpdateInsurancePlanPriceRulesArgs = {
  input: Array<BulkUpdateInsurancePlanPriceRulesInput>;
};


export type MutationBulkUpdatePlacesArgs = {
  input: Array<BulkUpdatePlaceInput>;
};


export type MutationBulkUpdatePrivateGroupPriceRulesArgs = {
  input: Array<BulkUpdatePrivateGroupPriceRulesInput>;
};


export type MutationBulkUpdatePrivateGroupsArgs = {
  input: Array<BulkUpdatePrivateGroupsInput>;
};


export type MutationBulkUpdatePromosArgs = {
  input: Array<BulkUpdatePromoInput>;
};


export type MutationBulkUpdateTourAirportTransfersArgs = {
  input: Array<BulkUpdateTourAirportTransferInput>;
};


export type MutationBulkUpdateTourAirportTransfersPriceRulesArgs = {
  input: Array<BulkUpdateTourAirportTransfersPriceRulesInput>;
};


export type MutationBulkUpdateTourExcursionPlacesArgs = {
  input: BulkUpdateTourExcursionPlacesInput;
};


export type MutationBulkUpdateTourExcursionPlacesByCodeArgs = {
  input: Array<BulkUpdateTourExcursionPlacesByCodeInput>;
};


export type MutationBulkUpdateTourExcursionPriceRulesArgs = {
  input: Array<BulkUpdateTourExcursionPriceRulesInput>;
};


export type MutationBulkUpdateTourExcursionTagsArgs = {
  input: BulkUpdateTourExcursionTagsInput;
};


export type MutationBulkUpdateTourExcursionTagsByNameArgs = {
  input: Array<BulkUpdateTourExcursionTagsByNameInput>;
};


export type MutationBulkUpdateTourExcursionsArgs = {
  input: Array<BulkUpdateTourExcursionInput>;
};


export type MutationBulkUpdateTourExtensionAirportTransfersArgs = {
  input: Array<BulkUpdateTourExtensionAirportTransferInput>;
};


export type MutationBulkUpdateTourExtensionAirportTransfersPriceRulesArgs = {
  input: Array<BulkUpdateTourExtensionAirportTransfersPriceRulesInput>;
};


export type MutationBulkUpdateTourExtensionPlacesArgs = {
  input: BulkUpdateTourExtensionPlacesInput;
};


export type MutationBulkUpdateTourExtensionPlacesByCodeArgs = {
  input: Array<BulkUpdateTourExtensionPlacesByCodeInput>;
};


export type MutationBulkUpdateTourExtensionPriceRulesArgs = {
  input: Array<BulkUpdateTourExtensionPriceRulesInput>;
};


export type MutationBulkUpdateTourExtensionRoomPriceRulesArgs = {
  input: Array<BulkUpdateTourExtensionRoomPriceRulesInput>;
};


export type MutationBulkUpdateTourExtensionRoomsArgs = {
  input: Array<BulkUpdateTourExtensionRoomInput>;
};


export type MutationBulkUpdateTourExtensionTagsArgs = {
  input: BulkUpdateTourExtensionTagsInput;
};


export type MutationBulkUpdateTourExtensionTagsByNameArgs = {
  input: Array<BulkUpdateTourExtensionTagsByNameInput>;
};


export type MutationBulkUpdateTourExtensionsArgs = {
  input: Array<BulkUpdateTourExtensionInput>;
};


export type MutationBulkUpdateTourPlacesArgs = {
  input: BulkUpdateTourPlacesInput;
};


export type MutationBulkUpdateTourPlacesByCodeArgs = {
  input: Array<BulkUpdateTourPlacesByCodeInput>;
};


export type MutationBulkUpdateTourPriceRulesArgs = {
  input: Array<BulkUpdateTourPriceRulesInput>;
};


export type MutationBulkUpdateTourRoomPriceRulesArgs = {
  input: Array<BulkUpdateTourRoomPriceRulesInput>;
};


export type MutationBulkUpdateTourRoomsArgs = {
  input: Array<BulkUpdateTourRoomInput>;
};


export type MutationBulkUpdateTourTagsArgs = {
  input: BulkUpdateTourTagsInput;
};


export type MutationBulkUpdateTourTagsByNameArgs = {
  input: Array<BulkUpdateTourTagsByNameInput>;
};


export type MutationBulkUpdateToursArgs = {
  input: Array<BulkUpdateTourInput>;
};


export type MutationCalculatePaymentScheduleArgs = {
  draftOrderId: Scalars['ObjectId'];
  input: CalculatePaymentScheduleInput;
};


export type MutationCancelDraftBookingArgs = {
  input: CancelDraftBookingInput;
};


export type MutationCancelDraftBookingPaymentScheduleArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationCancelDraftBookingTripsArgs = {
  input: CancelDraftBookingTripsInput;
};


export type MutationCancelGcDepartureArgs = {
  input: CancelGcDepartureInput;
};


export type MutationCancelGcDepartureMeetingArgs = {
  input: CancelGcDepartureMeetingInput;
};


export type MutationChangeVoucherExpirationArgs = {
  input: ChangeVoucherExpirationInput;
};


export type MutationCheckTripChecklistItemArgs = {
  checklistItemTemplateId: Scalars['ObjectId'];
  tripId: Scalars['ObjectId'];
};


export type MutationClaimExperimentalLeadArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationConfirmGcDepartureArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationConnectReferralArgs = {
  input: ConnectReferralInput;
};


export type MutationCreateAdjustmentArgs = {
  input: CreateAdjustmentInput;
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationCreateAudienceArgs = {
  input: CreateAudienceInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type MutationCreateChatTokenArgs = {
  businessCode: BusinessCode;
};


export type MutationCreateChatTokenV2Args = {
  businessCode: BusinessCode;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateDepartureExcursionArgs = {
  _id: Scalars['ObjectId'];
  input: CreateDepartureExcursionInput;
};


export type MutationCreateDepartureExtensionArgs = {
  _id: Scalars['ObjectId'];
  input: CreateDepartureExtensionInput;
};


export type MutationCreateDepartureExtensionExcursionArgs = {
  _id: Scalars['ObjectId'];
  extensionId: Scalars['ObjectId'];
  input: CreateDepartureExtensionExcursionInput;
};


export type MutationCreateDepartureExtensionRoomArgs = {
  _id: Scalars['ObjectId'];
  extensionId: Scalars['ObjectId'];
  input: CreateDepartureExtensionRoomInput;
};


export type MutationCreateDepartureRoomArgs = {
  _id: Scalars['ObjectId'];
  input: CreateDepartureRoomInput;
};


export type MutationCreateDraftOrderArgs = {
  orderId: Scalars['ObjectId'];
};


export type MutationCreateDraftTermArgs = {
  input: CreateDraftTermInput;
};


export type MutationCreateExperimentalLeadArgs = {
  input: CreateExperimentalLeadInput;
};


export type MutationCreateExtendedStayArgs = {
  input: CreateExtendedStayInput;
};


export type MutationCreateFeeArgs = {
  input: CreateFeeInput;
};


export type MutationCreateFlightPackageArgs = {
  input: CreateFlightPackageInput;
};


export type MutationCreateGcDepartureArgs = {
  input: CreateGcDepartureInput;
};


export type MutationCreateGcDepartureMeetingArgs = {
  input: CreateGcDepartureMeetingInput;
};


export type MutationCreateGcDepartureMeetingRsvpArgs = {
  input: CreateGcDepartureMeetingRsvpInput;
};


export type MutationCreateInsuranceExtensionArgs = {
  _id: Scalars['ObjectId'];
  basePrice: Array<MoneyInput>;
};


export type MutationCreateInsurancePlanArgs = {
  input: CreateInsurancePlanInput;
};


export type MutationCreateInsurancePlanAddonArgs = {
  _id: Scalars['ObjectId'];
  input: CreateInsurancePlanAddonInput;
};


export type MutationCreateInsurancePolicyArgs = {
  input: CreateInsurancePolicyInput;
};


export type MutationCreateInsurancePolicyRevisionArgs = {
  _id: Scalars['ObjectId'];
  input: CreateInsurancePolicyRevisionInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateOAuthClientArgs = {
  input: CreateOAuthClientInput;
};


export type MutationCreatePlaceArgs = {
  input: CreatePlaceInput;
};


export type MutationCreatePromoArgs = {
  input: CreatePromoInput;
};


export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateSavedPlaceArgs = {
  input: CreateSavedPlaceInput;
};


export type MutationCreateServiceRecoveryPromoArgs = {
  input: CreateServiceRecoveryPromoInput;
};


export type MutationCreateSupportTicketArgs = {
  businessCode: BusinessCode;
  input: SupportTicketInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateTourArgs = {
  input: CreateTourInput;
};


export type MutationCreateTourExcursionArgs = {
  input: CreateTourExcursionInput;
};


export type MutationCreateTourExtensionArgs = {
  input: CreateTourExtensionInput;
};


export type MutationCreateTourExtensionRoomArgs = {
  input: CreateTourExtensionRoomInput;
  tourExtensionId: Scalars['ObjectId'];
};


export type MutationCreateTourRoomArgs = {
  input: CreateTourRoomInput;
  tourId: Scalars['ObjectId'];
};


export type MutationCreateTripChecklistItemTemplateArgs = {
  input: CreateTripChecklistItemTemplateInput;
};


export type MutationCreateVoucherFromBookingArgs = {
  input: CreateVoucherFromBookingInput;
};


export type MutationCreateVoucherFromExternalArgs = {
  input: CreateVoucherFromExternalInput;
};


export type MutationCreateWishlistItemArgs = {
  input: CreateWishlistItemInput;
};


export type MutationDeauthorizePaymentMethodArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationDeclineFlightShopPriceChangeArgs = {
  flightBookingResultId: Scalars['ObjectId'];
};


export type MutationDeleteAudienceArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationDeleteCategoryArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationDeleteExperimentalLeadArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationDeleteGcDepartureMeetingRsvpArgs = {
  input: DeleteGcDepartureMeetingRsvpInput;
};


export type MutationDeleteGcDepartureProspectArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationDeleteOAuthClientArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationDeleteReviewImageArgs = {
  reviewId: Scalars['ObjectId'];
  reviewImageIds: Array<Scalars['ObjectId']>;
};


export type MutationDeleteSavedPlaceArgs = {
  id: Scalars['ObjectId'];
};


export type MutationDeleteTagArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationDeleteWishlistItemArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationEvaluateReferralTravelBankRedemptionArgs = {
  input: EvaluateReferralTravelBankRedemptionInput;
};


export type MutationForkBookingArgs = {
  input: ForkBookingInput;
};


export type MutationGenerateSupplierConfirmationEmailArgs = {
  input: SupplierConfirmationEmailInput;
};


export type MutationIncreaseVoucherArgs = {
  input: IncreaseVoucherInput;
};


export type MutationIntegrateDepartureToProductionArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationIntegrateGcDepartureGlobalRewardsArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationIntegrateOrderToProductionArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationIssueARefundArgs = {
  bookingId: Scalars['ObjectId'];
  overrideOrderBalanceRestrictions?: InputMaybe<Scalars['Boolean']>;
  refundInput: RefundInput;
};


export type MutationMakeAPaymentArgs = {
  bookingId: Scalars['ObjectId'];
  payments: Array<PaymentInput>;
};


export type MutationMatchQuoteRoommatesArgs = {
  quoteId: Scalars['ObjectId'];
  roomTourType: RoomTourType;
  tripIds: Array<Scalars['ObjectId']>;
};


export type MutationMatchRoommatesArgs = {
  departureId: Scalars['ObjectId'];
  roomTourType: RoomTourType;
  tripIds: Array<Scalars['ObjectId']>;
};


export type MutationMergeBookingArgs = {
  input: MergeBookingInput;
};


export type MutationMergeCustomerArgs = {
  input: MergeCustomerInput;
};


export type MutationPayAndBookArgs = {
  input: PayAndBookInput;
  quoteId: Scalars['ObjectId'];
};


export type MutationPublishDraftBookingArgs = {
  _id: Scalars['ObjectId'];
  input?: InputMaybe<PublishDraftBookingInput>;
};


export type MutationPublishDraftQuoteArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationPublishDraftTermArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationReactToReviewArgs = {
  input: ReactToReviewInput;
};


export type MutationReconcileCardOrAchPaymentArgs = {
  bookingId: Scalars['ObjectId'];
  settlementDate?: InputMaybe<Scalars['Date']>;
  status: PaymentTransactionStatus;
  transactionId: Scalars['ObjectId'];
};


export type MutationReconcileCheckPaymentArgs = {
  bookingId: Scalars['ObjectId'];
  checkPaymentMethodInput?: InputMaybe<CheckPaymentMethodInput>;
  checkTransactionId: Scalars['ObjectId'];
  status: PaymentTransactionStatus;
};


export type MutationReconcilePaymentArgs = {
  bookingId: Scalars['ObjectId'];
  settlementDate?: InputMaybe<Scalars['Date']>;
  status: PaymentTransactionStatus;
  transactionId: Scalars['ObjectId'];
};


export type MutationReconcilePaymentsArgs = {
  businessCode: BusinessCode;
  correlationId: Scalars['String'];
  currencyCode: CurrencyCode;
  sourceProcessorOrAcquirer: SourceProcessorOrAcquirer;
  transactions: Array<ReconcileTransactionInput>;
};


export type MutationReduceVoucherArgs = {
  input: ReduceVoucherInput;
};


export type MutationRefundVoucherArgs = {
  input: RefundVoucherInput;
};


export type MutationReinstateVoucherArgs = {
  input: ReinstateVoucherInput;
};


export type MutationRemoveAudienceMemberArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationRemoveAudienceOfferCodeArgs = {
  _id: Scalars['ObjectId'];
  offerCode: Scalars['String'];
};


export type MutationRemoveAudienceOfferCodesArgs = {
  _id: Scalars['ObjectId'];
  offerCodes: Array<Scalars['String']>;
};


export type MutationRemoveCampaignPromosArgs = {
  _id: Scalars['ObjectId'];
  input: RemoveCampaignPromosInput;
};


export type MutationRemoveDraftOrderAdjustmentsArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<RemoveDraftOrderAdjustmentInput>;
};


export type MutationRemoveDraftOrderAirportTransferArgs = {
  _id: Scalars['ObjectId'];
  input: Array<RemoveDraftOrderAirportTransferInput>;
};


export type MutationRemoveDraftOrderExcursionArgs = {
  _id: Scalars['ObjectId'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  excursionTourType?: InputMaybe<ExcursionTourType>;
  lineItemCode: Scalars['LineItemCode'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationRemoveDraftOrderExcursionsArgs = {
  _id: Scalars['ObjectId'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tourTypes: Array<ExcursionTourType>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationRemoveDraftOrderExtensionArgs = {
  _id: Scalars['ObjectId'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationRemoveDraftOrderFeesArgs = {
  _id: Scalars['ObjectId'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  inputs: Array<RemoveDraftOrderFeesInput>;
};


export type MutationRemoveDraftOrderFlightShopArgs = {
  _id: Scalars['ObjectId'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationRemoveDraftOrderInsuranceArgs = {
  _id: Scalars['ObjectId'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationRemoveDraftOrderInsuranceAddonArgs = {
  _id: Scalars['ObjectId'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  lineItemCode: Scalars['LineItemCode'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationRemoveDraftOrderInsuranceExtensionArgs = {
  _id: Scalars['ObjectId'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationRemoveDraftOrderPostStayArgs = {
  _id: Scalars['ObjectId'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationRemoveDraftOrderPreStayArgs = {
  _id: Scalars['ObjectId'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationRemoveDraftOrderPrivateGroupArgs = {
  _id: Scalars['ObjectId'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationRemoveDraftOrderPromoArgs = {
  _id: Scalars['ObjectId'];
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  lineItemCode: Scalars['LineItemCode'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationRemoveDraftOrderTravelCompanionRequestsArgs = {
  _id: Scalars['ObjectId'];
  requestedTripIds: Array<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
};


export type MutationRemoveDraftQuoteTripsArgs = {
  _id: Scalars['ObjectId'];
  tripIds: Array<Scalars['ObjectId']>;
};


export type MutationRemoveEmployeesFromRoleArgs = {
  _id: Scalars['ObjectId'];
  input: RemoveEmployeesFromRoleInput;
};


export type MutationRemovePlaceArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationRemovePrivateGroupArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationRemovePromoCodesArgs = {
  _id: Scalars['ObjectId'];
  input: RemovePromoCodesInput;
};


export type MutationRemovePromoCustomersArgs = {
  _id: Scalars['ObjectId'];
  input: RemovePromoCustomersInput;
};


export type MutationRemovePromoGcDeparturesArgs = {
  _id: Scalars['ObjectId'];
  input: RemovePromoGcDeparturesInput;
};


export type MutationRemovePromoTargetsArgs = {
  _id: Scalars['ObjectId'];
  input: RemovePromoTargetsInput;
};


export type MutationRemoveTourExcursionsArgs = {
  _id: Scalars['ObjectId'];
  tourExcursionIds: Array<Scalars['ObjectId']>;
};


export type MutationRemoveTourExtensionExcursionsArgs = {
  _id: Scalars['ObjectId'];
  tourExcursionIds: Array<Scalars['ObjectId']>;
};


export type MutationRotateOAuthClientSecretArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationSaveEvaluationArgs = {
  _id: Scalars['ObjectId'];
  freeTextQuestions?: InputMaybe<Array<AnswerFreeTextQuestionInput>>;
  matrixQuestions?: InputMaybe<Array<AnswerMatrixQuestionInput>>;
  multipleChoiceQuestions?: InputMaybe<Array<AnswerMultipleChoiceQuestionInput>>;
};


export type MutationSendMagicLinkArgs = {
  input: SendMagicLinkInput;
};


export type MutationSetDefaultPaymentMethodArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationSetDraftQuoteCustomerArgs = {
  _id: Scalars['ObjectId'];
  existingCustomerInput?: InputMaybe<TripExistingCustomerInput>;
  identityDocumentTypes?: Array<IdentityDocumentType>;
  newCustomerInput?: InputMaybe<TripNewCustomerInput>;
  tripId: Scalars['ObjectId'];
};


export type MutationSetReviewFeaturedArgs = {
  _id: Scalars['ObjectId'];
  isFeatured: Scalars['Boolean'];
};


export type MutationShopFlightsArgs = {
  tripIds: Array<Scalars['ObjectId']>;
};


export type MutationSigninCustomerWithMagicLinkArgs = {
  token: Scalars['String'];
};


export type MutationSigninCustomerWithPasswordArgs = {
  input: SigninWithPasswordInput;
};


export type MutationSigninTourDirectorWithMagicLinkArgs = {
  token: Scalars['String'];
};


export type MutationSignupCustomerArgs = {
  input: SignupCustomerInput;
  skipSessionCookie?: Scalars['Boolean'];
};


export type MutationStartFlightBookingArgs = {
  flightShopResultId: Scalars['ObjectId'];
  outboundFlightOptionId: Scalars['ObjectId'];
  returnFlightOptionId: Scalars['ObjectId'];
};


export type MutationStartQuoteArgs = {
  input: StartQuoteInput;
};


export type MutationStartRebookingArgs = {
  input: StartRebookingInput;
};


export type MutationStartRebookingQuoteArgs = {
  input: StartRebookingQuoteInput;
};


export type MutationSubmitEvaluationArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationTransferVoucherExternalArgs = {
  input: TransferVoucherExternalInput;
};


export type MutationTransferVoucherInternalArgs = {
  input: TransferVoucherInternalInput;
};


export type MutationUncheckTripChecklistItemArgs = {
  checklistItemTemplateId: Scalars['ObjectId'];
  tripId: Scalars['ObjectId'];
};


export type MutationUnclaimExperimentalLeadArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationUnmatchQuoteRoommatesArgs = {
  quoteId: Scalars['ObjectId'];
  roomTourType: RoomTourType;
  tripIds: Array<Scalars['ObjectId']>;
};


export type MutationUnmatchRoommatesArgs = {
  departureId: Scalars['ObjectId'];
  roomTourType: RoomTourType;
  tripIds: Array<Scalars['ObjectId']>;
};


export type MutationUnsetDefaultPaymentMethodArgs = {
  _id: Scalars['ObjectId'];
};


export type MutationUpdateAdjustmentArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateAdjustmentInput;
};


export type MutationUpdateAdjustmentStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateAdjustmentStatusInput;
};


export type MutationUpdateAudienceArgs = {
  _id: Scalars['ObjectId'];
  name: Scalars['String'];
};


export type MutationUpdateBookingTripInsuranceCoverageStartDateArgs = {
  _id: Scalars['ObjectId'];
  date: Scalars['Date'];
  tripIds: Array<Scalars['ObjectId']>;
};


export type MutationUpdateBusinessChatSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateChatSettingsInput;
};


export type MutationUpdateBusinessCustomerSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateCustomerSettingsInput;
};


export type MutationUpdateBusinessDepartureSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateDepartureSettingsInput;
};


export type MutationUpdateBusinessEvaluationSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateEvaluationSettingsInput;
};


export type MutationUpdateBusinessFeeSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateFeeSettingsInput;
};


export type MutationUpdateBusinessFlightSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateFlightSettingsInput;
};


export type MutationUpdateBusinessGcDepartureSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateGcDepartureSettingsInput;
};


export type MutationUpdateBusinessGroupTripChecklistSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateGroupTripChecklistSettingsInput;
};


export type MutationUpdateBusinessInsuranceSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateInsuranceSettingsInput;
};


export type MutationUpdateBusinessIntegrationSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateIntegrationSettingsInput;
};


export type MutationUpdateBusinessOrderPaymentSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateOrderPaymentSettingsInput;
};


export type MutationUpdateBusinessOrderQuoteSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateOrderQuoteSettingsInput;
};


export type MutationUpdateBusinessOrderRoomingSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateOrderRoomingSettingsInput;
};


export type MutationUpdateBusinessOrderSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateOrderSettingsInput;
};


export type MutationUpdateBusinessPromoSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdatePromoSettingsInput;
};


export type MutationUpdateBusinessReviewSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateReviewSettingsInput;
};


export type MutationUpdateBusinessSupportTicketSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateSupportSettingsInput;
};


export type MutationUpdateBusinessTourSearchSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateTourSearchSettingsInput;
};


export type MutationUpdateBusinessTripChecklistSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateTripChecklistSettingsInput;
};


export type MutationUpdateBusinessTsaSettingsArgs = {
  businessCode: BusinessCode;
  input: UpdateTsaSettingsInput;
};


export type MutationUpdateCampaignArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateCampaignInput;
};


export type MutationUpdateCampaignStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateCampaignStatusInput;
};


export type MutationUpdateCategoryArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateCategoryInput;
};


export type MutationUpdateCustomerAddressArgs = {
  customerId: Scalars['ObjectId'];
  input: UpdateCustomerAddressInput;
};


export type MutationUpdateCustomerEmailArgs = {
  customerId: Scalars['ObjectId'];
  input: UpdateCustomerEmailInput;
};


export type MutationUpdateCustomerGlobalRewardsIdArgs = {
  _id: Scalars['ObjectId'];
  globalRewardsId: Scalars['String'];
};


export type MutationUpdateCustomerNameArgs = {
  customerId: Scalars['ObjectId'];
  input: UpdateCustomerNameInput;
};


export type MutationUpdateCustomerPasswordArgs = {
  input: UpdateCustomerPasswordInput;
};


export type MutationUpdateCustomerPhoneNumberArgs = {
  customerId: Scalars['ObjectId'];
  input: UpdateCustomerPhoneNumberInput;
};


export type MutationUpdateCustomerProfileBioArgs = {
  _id: Scalars['ObjectId'];
  bio: Scalars['String'];
};


export type MutationUpdateCustomerProfileImageArgs = {
  _id: Scalars['ObjectId'];
  profileImageAssetId: Scalars['ObjectId'];
};


export type MutationUpdateCustomerProfilePrivacyArgs = {
  _id: Scalars['ObjectId'];
  isPrivate: Scalars['Boolean'];
};


export type MutationUpdateCustomerProfileSocialMediaArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateCustomerProfileSocialMediaInput;
};


export type MutationUpdateDepartureArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateDepartureInput;
};


export type MutationUpdateDepartureExcursionArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateDepartureExcursionInput;
};


export type MutationUpdateDepartureExtensionArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateDepartureExtensionInput;
};


export type MutationUpdateDepartureExtensionExcursionArgs = {
  _id: Scalars['ObjectId'];
  extensionId: Scalars['ObjectId'];
  input: UpdateDepartureExtensionExcursionInput;
};


export type MutationUpdateDepartureExtensionRoomArgs = {
  _id: Scalars['ObjectId'];
  extensionId: Scalars['ObjectId'];
  input: UpdateDepartureExtensionRoomInput;
};


export type MutationUpdateDepartureItemStatusArgs = {
  departureId: Scalars['ObjectId'];
  input: Array<UpdateDepartureItemStatusInput>;
};


export type MutationUpdateDepartureRoomArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateDepartureRoomInput;
};


export type MutationUpdateDraftBookingPaymentScheduleArgs = {
  _id: Scalars['ObjectId'];
  frequency: PaymentScheduleFrequency;
  startDate: Scalars['Date'];
};


export type MutationUpdateDraftBookingPaymentSchedulePaymentMethodArgs = {
  _id: Scalars['ObjectId'];
  paymentSchedulePaymentMethod: PaymentSchedulePaymentMethodInput;
};


export type MutationUpdateDraftBookingTripLineItemStatusesArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<UpdateDraftBookingTripLineItemStatusesInput>;
};


export type MutationUpdateDraftBookingTripStatusesArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<UpdateDraftBookingTripStatusesInput>;
};


export type MutationUpdateDraftOrderAddressArgs = {
  _id: Scalars['ObjectId'];
  address: AddressInput;
  tripId: Scalars['ObjectId'];
};


export type MutationUpdateDraftOrderAdjustmentPricesArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<UpdateDraftOrderAdjustmentPricesInput>;
};


export type MutationUpdateDraftOrderAirportTransferArgs = {
  _id: Scalars['ObjectId'];
  input: Array<UpdateDraftOrderAirportTransferInput>;
};


export type MutationUpdateDraftOrderEmergencyContactsArgs = {
  _id: Scalars['ObjectId'];
  emergencyContacts: Array<EmergencyContactInput>;
  tripId: Scalars['ObjectId'];
};


export type MutationUpdateDraftOrderExtensionRoomsArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<UpdateDraftOrderRoomInput>;
};


export type MutationUpdateDraftOrderFeePricesArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<UpdateDraftOrderFeePricesInput>;
};


export type MutationUpdateDraftOrderFinalInstallmentDeadlineArgs = {
  _id: Scalars['ObjectId'];
  finalInstallmentDeadline: Scalars['Date'];
};


export type MutationUpdateDraftOrderFinalPaymentDeadlineArgs = {
  _id: Scalars['ObjectId'];
  finalPaymentDeadline: Scalars['Date'];
};


export type MutationUpdateDraftOrderFlightPackagesArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<UpdateDraftOrderFlightPackageInput>;
};


export type MutationUpdateDraftOrderIncentivesRedemptionAdjustmentArgs = {
  input: UpdateDraftOrderIncentivesRedemptionAdjustmentInput;
};


export type MutationUpdateDraftOrderInsuranceArgs = {
  _id: Scalars['ObjectId'];
  addOnLineItemCodes?: InputMaybe<Array<Scalars['LineItemCode']>>;
  lineItemCode: Scalars['LineItemCode'];
  tripIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};


export type MutationUpdateDraftOrderMultiTripTsaInformationArgs = {
  _id: Scalars['ObjectId'];
  overrideExpirationDateCheck?: Scalars['Boolean'];
  trips: Array<TripTsaInformationInput>;
};


export type MutationUpdateDraftOrderPrimaryTripArgs = {
  _id: Scalars['ObjectId'];
  tripId: Scalars['ObjectId'];
};


export type MutationUpdateDraftOrderPromoPricesArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<UpdateDraftOrderPromoPricesInput>;
};


export type MutationUpdateDraftOrderRequestedRoommatesArgs = {
  _id: Scalars['ObjectId'];
  requestedRoommates: Array<Scalars['String']>;
  tripId: Scalars['ObjectId'];
};


export type MutationUpdateDraftOrderRequestedTravelCompanionsArgs = {
  _id: Scalars['ObjectId'];
  requestedTravelCompanions: Array<Scalars['String']>;
  tripId: Scalars['ObjectId'];
};


export type MutationUpdateDraftOrderRoomsArgs = {
  _id: Scalars['ObjectId'];
  inputs: Array<UpdateDraftOrderRoomInput>;
};


export type MutationUpdateDraftOrderTravelerNotesArgs = {
  _id: Scalars['ObjectId'];
  input: TravelerNotesInput;
  tripId: Scalars['ObjectId'];
};


export type MutationUpdateDraftOrderTsaInformationArgs = {
  _id: Scalars['ObjectId'];
  confirmDocumentInformation?: Scalars['Boolean'];
  confirmTravelerInformation?: Scalars['Boolean'];
  overrideExpirationDateCheck?: Scalars['Boolean'];
  tripId: Scalars['ObjectId'];
  tsaInformation: TsaInformationInput;
};


export type MutationUpdateDraftQuoteSavedArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateDraftQuoteSavedInput;
};


export type MutationUpdateDraftTermArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateDraftTermInput;
};


export type MutationUpdateExperimentalLeadArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateExperimentalLeadInput;
};


export type MutationUpdateExtendedStayArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateExtendedStayInput;
};


export type MutationUpdateExtendedStayStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateExtendedStayStatusInput;
};


export type MutationUpdateFeeArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateFeeInput;
};


export type MutationUpdateFeeStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateFeeStatusInput;
};


export type MutationUpdateFlightPackageArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateFlightPackageInput;
};


export type MutationUpdateFlightPackageStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateFlightPackageStatusInput;
};


export type MutationUpdateFlightShopArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateFlightShopInput;
};


export type MutationUpdateFlightShopStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateFlightShopStatusInput;
};


export type MutationUpdateGcDepartureArgs = {
  input: UpdateGcDepartureInput;
};


export type MutationUpdateGcDepartureMeetingArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateGcDepartureMeetingInput;
};


export type MutationUpdateGcDepartureMeetingRsvpArgs = {
  input: UpdateGcDepartureMeetingRsvpInput;
};


export type MutationUpdateGcDepartureProspectArgs = {
  input: UpdateGcDepartureProspectInput;
};


export type MutationUpdateGcDepartureStipendDetailArgs = {
  input: UpdateGcDepartureStipendDetailInput;
};


export type MutationUpdateInsuranceExtensionArgs = {
  input: UpdateInsuranceExtensionInput;
  insurancePlanId: Scalars['ObjectId'];
};


export type MutationUpdateInsuranceExtensionStatusArgs = {
  input: UpdateInsuranceExtensionStatusInput;
  insurancePlanId: Scalars['ObjectId'];
};


export type MutationUpdateInsurancePlanArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateInsurancePlanInput;
};


export type MutationUpdateInsurancePlanAddonArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateInsurancePlanAddonInput;
  insurancePlanId: Scalars['ObjectId'];
};


export type MutationUpdateInsurancePlanAddonStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateInsurancePlanAddonStatusInput;
};


export type MutationUpdateInsurancePlanStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateInsurancePlanStatusInput;
};


export type MutationUpdateInsurancePolicyArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateInsurancePolicyInput;
};


export type MutationUpdateInsurancePolicyRevisionArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateInsurancePolicyRevisionInput;
  insurancePolicyId: Scalars['ObjectId'];
};


export type MutationUpdateNoteArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateNoteInput;
};


export type MutationUpdateOAuthClientArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateOAuthClientInput;
};


export type MutationUpdatePlaceArgs = {
  _id: Scalars['ObjectId'];
  input: UpdatePlaceInput;
};


export type MutationUpdatePrivateGroupArgs = {
  _id: Scalars['ObjectId'];
  input: UpdatePrivateGroupInput;
};


export type MutationUpdatePrivateGroupStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdatePrivateGroupStatusInput;
};


export type MutationUpdatePromoArgs = {
  _id: Scalars['ObjectId'];
  input: UpdatePromoInput;
};


export type MutationUpdatePromoStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdatePromoStatusInput;
};


export type MutationUpdatePromoTargetsArgs = {
  _id: Scalars['ObjectId'];
  input: UpdatePromoTargetsInput;
};


export type MutationUpdateQuoteExpiryArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateQuoteExpiryInput;
};


export type MutationUpdateQuoteSavedArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateQuoteSavedInput;
};


export type MutationUpdateReviewArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateReviewInput;
};


export type MutationUpdateReviewDetailResponseArgs = {
  input?: InputMaybe<UpdateReviewDetailResponseInput>;
  reviewId: Scalars['ObjectId'];
};


export type MutationUpdateReviewDetailStatusArgs = {
  reviewId: Scalars['ObjectId'];
  status: ReviewStatus;
};


export type MutationUpdateReviewImagesStatusArgs = {
  input: Array<UpdateReviewImagesStatusInput>;
  reviewId: Scalars['ObjectId'];
};


export type MutationUpdateRoleArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateRoleInput;
};


export type MutationUpdateSavedPlaceArgs = {
  input: UpdateSavedPlaceInput;
};


export type MutationUpdateServiceRecoveryPromoArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateServiceRecoveryPromoInput;
};


export type MutationUpdateServiceRecoveryPromoStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateServiceRecoveryPromoStatusInput;
};


export type MutationUpdateTagArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTagInput;
};


export type MutationUpdateTourArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTourInput;
};


export type MutationUpdateTourAirportTransferArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTourAirportTransferInput;
};


export type MutationUpdateTourDirectorProfileArgs = {
  _id: Scalars['ObjectId'];
  input: SetTourDirectorProfileInput;
};


export type MutationUpdateTourExcursionArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTourExcursionInput;
};


export type MutationUpdateTourExcursionStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTourExcursionStatusInput;
};


export type MutationUpdateTourExtensionArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTourExtensionInput;
};


export type MutationUpdateTourExtensionAirportTransferArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTourExtensionAirportTransferInput;
};


export type MutationUpdateTourExtensionRoomArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTourExtensionRoomInput;
};


export type MutationUpdateTourExtensionRoomStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTourExtensionRoomStatusInput;
};


export type MutationUpdateTourExtensionStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTourExtensionStatusInput;
};


export type MutationUpdateTourPricingArgs = {
  input: UpdateTourPricingInput;
};


export type MutationUpdateTourRoomArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTourRoomInput;
};


export type MutationUpdateTourRoomStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTourRoomStatusInput;
};


export type MutationUpdateTourStatusArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTourStatusInput;
};


export type MutationUpdateTripChecklistItemTemplateArgs = {
  _id: Scalars['ObjectId'];
  input: UpdateTripChecklistItemTemplateInput;
};


export type MutationUpdateVoucherRefundDetailArgs = {
  input: UpdateVoucherRefundDetailInput;
};


export type MutationVoidBookingTransferPaymentArgs = {
  bookingId: Scalars['ObjectId'];
  transferTransactionId: Scalars['ObjectId'];
};


export type MutationVoidVoucherArgs = {
  input: VoidVoucherInput;
};

/** The next pending reward that will become available for use. Present for advocates with pending referral rewards. */
export type NextEffectiveReward = {
  __typename?: 'NextEffectiveReward';
  /** The pending reward amount. */
  amount: Scalars['Float'];
  /** Complete 24-hour periods remaining until the reward becomes available. */
  daysUntilEffective: Scalars['Int'];
  /** The date when the pending reward becomes available for use. */
  effectiveDate: Scalars['DateTime'];
};

/** The next reward that will expire or has already expired. Present for friends with active or expired rewards. */
export type NextExpiringReward = {
  __typename?: 'NextExpiringReward';
  /** The reward amount subject to expiration. */
  amount: Scalars['Float'];
  /** Complete 24-hour periods remaining until the reward expires. A value of 0 means less than 24 hours remain — use isExpired to distinguish between 'expiring soon' and 'already expired'. */
  daysUntilExpiration: Scalars['Int'];
  /** The date when the reward expires. */
  expirationDate: Scalars['DateTime'];
  /** Whether the reward has already expired. */
  isExpired: Scalars['Boolean'];
  /** Whether the expiration date falls within the configured warning window. */
  isWithinExpirationWarningWindow: Scalars['Boolean'];
};

/** The CurrentUser is not authorized to perform the requested action */
export type NotAuthorizedError = DomainError & {
  __typename?: 'NotAuthorizedError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** A required entity was not found during a mutation process */
export type NotFoundError = DomainError & {
  __typename?: 'NotFoundError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Notes attached to any other entity type */
export type Note = {
  __typename?: 'Note';
  _id: Scalars['ObjectId'];
  content: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  employee?: Maybe<Employee>;
  employeeId: Scalars['ObjectId'];
  targetId: Scalars['ObjectId'];
};

export type NotePaginatedResult = {
  __typename?: 'NotePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Note>;
};

/** A registered OAuth 2.0 / OIDC client application */
export type OAuthClient = {
  __typename?: 'OAuthClient';
  _id: Scalars['ObjectId'];
  clientId: Scalars['String'];
  clientName: Scalars['String'];
  grantTypes: Array<Scalars['String']>;
  redirectUris: Array<Scalars['String']>;
  responseTypes: Array<Scalars['String']>;
  scope: Scalars['String'];
  tokenEndpointAuthMethod: TokenEndpointAuthMethod;
};

/** OAuth client with its secret visible — only returned on creation or secret rotation */
export type OAuthClientWithSecret = {
  __typename?: 'OAuthClientWithSecret';
  _id: Scalars['ObjectId'];
  clientId: Scalars['String'];
  clientName: Scalars['String'];
  clientSecret: Scalars['String'];
  grantTypes: Array<Scalars['String']>;
  redirectUris: Array<Scalars['String']>;
  responseTypes: Array<Scalars['String']>;
  scope: Scalars['String'];
  tokenEndpointAuthMethod: TokenEndpointAuthMethod;
};

export type OffsetPaginateInput = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

/** A pre-2018 legacy trip that does not contain as much information as a BookingTrip */
export type OldTrip = {
  __typename?: 'OldTrip';
  _id: Scalars['ID'];
  businessCode: Scalars['String'];
  customerId: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  isValidForLoyalty: Scalars['Boolean'];
  legacyTripId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  tourCode: Scalars['String'];
  tourInternalName?: Maybe<Scalars['String']>;
};

export type OpportunityQuotePaginatedResult = {
  __typename?: 'OpportunityQuotePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Quote>;
};

/** An order */
export type Order = {
  _id: Scalars['ObjectId'];
  /** The authorized saved payment methods for all travelers regardless of trip status that can be used to pay for this order. Staff-only. */
  allTravelersSavedPaymentMethods: Array<SavedPaymentMethod>;
  /** Sum of total successful transactions */
  amountPaid: Money;
  /** Grand total less the amount already paid */
  balance: Money;
  businessCode: BusinessCode;
  /** Maximum age travelers can be to travel with this business */
  businessMaximumAgeForTraveler?: Maybe<Scalars['Int']>;
  /** Minimum age travelers must be to travel with this business */
  businessMinimumAgeForTraveler?: Maybe<Scalars['Int']>;
  /** Whether the order allows room combinations where there are fewer sellable spots than bed capacity. */
  canBookPartialRooms: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The currency code of the order. */
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  /** The customer who initiated the booking. */
  customerId?: Maybe<Scalars['ObjectId']>;
  departure?: Maybe<Departure>;
  /** The departure id of the order. */
  departureId: Scalars['ObjectId'];
  /** The extended date the final payment is due for the order. */
  extendedFinalPaymentDate?: Maybe<Scalars['Date']>;
  /** The possible room combinations for the order given the number of trips opted in, the extension's rooms, and the primary trip's room offers. */
  extensionRoomingCombinations: RoomingCombinations;
  /** The date the final installment for app is due for the order. */
  finalInstallmentDate: Scalars['Date'];
  /** The date the final payment is due for the order. */
  finalPaymentDate: Scalars['Date'];
  gcDeparture?: Maybe<GcDeparture>;
  /** The id of the gc departure associated with the order. */
  gcDepartureId?: Maybe<Scalars['ObjectId']>;
  /** Sum of all line item prices */
  grandTotal: Money;
  /** Sum of all line item prices without discounts applied */
  grandTotalBeforeDiscount: Money;
  /** Sum of all line items excluding flights */
  grandTotalWithoutFlights: Money;
  /** Available offers for inbound airport transfers for the order. */
  inboundAirportTransferOffers: Array<TourAirportTransferOffer>;
  /** Sum of all insuranceTotal on open trips */
  insuranceTotal: Money;
  /** Indicates if the final payment date has been extended. */
  isFinalPaymentDateExtended: Scalars['Boolean'];
  /** The latest date the final installment for app is due for the order. */
  latestFinalInstallmentDate: Scalars['Date'];
  /** The latest date the final payment is due for the order. */
  latestFinalPaymentDate: Scalars['Date'];
  /** The maximum points the current customer can redeem. */
  maxRedeemableReferralTravelBankPoints?: Maybe<Scalars['Float']>;
  /** The minimum amount due today to enroll in an automatic payment plan. */
  minimumAmountDueToEnrollInPaymentPlan: Money;
  opportunityId?: Maybe<Scalars['String']>;
  /** Available offers for outbound airport transfers for the order. */
  outboundAirportTransferOffers: Array<TourAirportTransferOffer>;
  /** How the quote was started. */
  quoteMethod?: Maybe<QuoteMethod>;
  /** The order that this order was rebooked from. */
  rebookedFromOrder?: Maybe<Order>;
  /** The order id that this order was rebooked from. */
  rebookedFromOrderId?: Maybe<Scalars['ObjectId']>;
  /** Whether the multi traveler rooms available for the order requires a roommate request. */
  requiresRoommateRequest: Scalars['Boolean'];
  /** The possible room combinations for the order given the number of trips, the departure's rooms, and the primary trip's room offers. */
  roomingCombinations: RoomingCombinations;
  /**
   * The saved payment methods for the primary trip's customer that can be used to pay for this order.
   * @deprecated Returns all saved payment methods for the primary trip's customer. If authenticated as a customer, it is favorable to use customer.savedPaymentMethods instead.
   */
  savedPaymentMethods: Array<SavedPaymentMethod>;
  /** The stage of the order. */
  stage: OrderStage;
  /** Sum of all discount line items */
  totalDiscount: Money;
  tourLineItemCode?: Maybe<Scalars['LineItemCode']>;
  /** The transactions applied to the order, sorted by ascending transaction date. */
  transactions: Array<PaymentTransaction>;
  /** The trips of the order. */
  trips: Array<Trip>;
  /** The trips of the order sorted by primary trip first. */
  tripsSortedByPrimary: Array<Trip>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The version of the order. */
  versionId: Scalars['Int'];
};


/** An order */
export type OrderAllTravelersSavedPaymentMethodsArgs = {
  includeUnauthorized?: InputMaybe<Scalars['Boolean']>;
};


/** An order */
export type OrderMaxRedeemableReferralTravelBankPointsArgs = {
  customerId?: InputMaybe<Scalars['ObjectId']>;
};


/** An order */
export type OrderSavedPaymentMethodsArgs = {
  includeUnauthorized?: InputMaybe<Scalars['Boolean']>;
};

export enum OrderLineItemHistoryAction {
  Added = 'ADDED',
  AddedFlights = 'ADDED_FLIGHTS',
  AddedLo1Flights = 'ADDED_LO1_FLIGHTS',
  AddedLo1Transfer = 'ADDED_LO1_TRANSFER',
  AmountChanged = 'AMOUNT_CHANGED',
  DateGatewayChange = 'DATE_GATEWAY_CHANGE',
  Lo1TransferChange = 'LO1_TRANSFER_CHANGE',
  Removed = 'REMOVED',
  RoommateChanged = 'ROOMMATE_CHANGED',
  RoomTypeChanged = 'ROOM_TYPE_CHANGED',
  StatusChanged = 'STATUS_CHANGED',
  SwitchedFlightsToLo1 = 'SWITCHED_FLIGHTS_TO_LO1',
  SwitchedLo1ToFlights = 'SWITCHED_LO1_TO_FLIGHTS'
}

export type OrderLineItemHistoryChange = {
  __typename?: 'OrderLineItemHistoryChange';
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ObjectId']>;
  displayName?: Maybe<Scalars['String']>;
  fieldName: Scalars['String'];
  lineItem: LineItem;
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
};

export type OrderLineItemHistoryEntry = {
  __typename?: 'OrderLineItemHistoryEntry';
  /** The action that was taken on the line item */
  action: OrderLineItemHistoryAction;
  /** The changes that were made to the line item */
  changeSet: Array<OrderLineItemHistoryChange>;
  /** The customer id of the trip that the line item belongs to */
  customerIds: Array<Scalars['ObjectId']>;
  customers: Array<Customer>;
  /** The date the change was made */
  date: Scalars['DateTime'];
  /** The line item type that the history entry is for */
  lineItemType: TripComponentType;
  /** The user that made the change */
  modifiedBy?: Maybe<AuditIdentity>;
  orderId: Scalars['ObjectId'];
};

export type OrderPaginatedResult = {
  __typename?: 'OrderPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Order>;
};

/** Settings related to the order management. */
export type OrderSettings = {
  __typename?: 'OrderSettings';
  /** Settings for ACH/check payment method */
  achCheck: PaymentMethodSettings;
  /** Whether to bypass errors when payment processor is down */
  bypassErrorOnProcessorDown: Scalars['Boolean'];
  /** Settings for credit card payment method */
  creditCard: PaymentMethodSettings;
  /** Number of days required to meet minimum installment requirements */
  daysToMeetMinimumInstallments: Scalars['Int'];
  /** Settings for debit card payment method */
  debitCard: PaymentMethodSettings;
  /** Days prior to departure for priority window processing */
  departurePriorityWindowDpd: Scalars['Int'];
  /** The earliest number of days before departure that a payment schedule can start */
  earliestPaymentScheduleStartDays: Scalars['Int'];
  /** Number of days prior to departure that the emergency contact information is no longer allowed to be submitted by the user */
  emergencyContactSelfServiceDeadlineDpd: Scalars['Int'];
  /** Number of minutes before an order expires */
  expiresInMinutes: Scalars['Int'];
  /** Number of days prior to departure that health notes are no longer allowed to be submitted by the user */
  healthNotesSelfServiceDeadlineDpd: Scalars['Int'];
  /** The latest number of days before departure that a payment schedule can start */
  latestPaymentScheduleStartDays: Scalars['Int'];
  /** Whether rooms with fewer spots left than bed capacity can be included in rooming combinations. */
  matchPartialRooms: Scalars['Boolean'];
  /** Maximum age allowed for travelers */
  maximumAgeForTraveler?: Maybe<Scalars['Int']>;
  /** The maximum promotion amount that can be applied per trip */
  maximumPerTripPromotionAmount: Amount;
  /** Minimum age required for travelers */
  minimumAgeForTraveler?: Maybe<Scalars['Int']>;
  /** Maximum number of autopay attempts allowed */
  nbMaximumAutopayAttempts: Scalars['Int'];
  /** Number of days prior to departure that passport information is no longer allowed to be submitted by the user */
  passportInformationSelfServiceDeadlineDpd: Scalars['Int'];
  /** Settings for physical check payment method */
  physicalCheck: PaymentMethodSettings;
  /** Settings for the risk-free period refund policy */
  riskFreePeriodSettings: RiskFreePeriodSettings;
  /** List of bed codes that can be self-serviced by customers */
  selfServiceableBedCodes: Array<TourBedCode>;
  /** Settings for travel companion requests */
  travelCompanionsSettings: TravelCompanionsSettings;
  /** Number of days prior to departure that tsa identifiers is no longer allowed to be submitted by the user */
  tsaIdentifiersSelfServiceDeadlineDpd: Scalars['Int'];
};

export enum OrderStage {
  Booking = 'BOOKING',
  Quote = 'QUOTE'
}

export enum OrderTsaHistoryAction {
  Added = 'ADDED',
  Updated = 'UPDATED'
}

export type OrderTsaHistoryChange = {
  __typename?: 'OrderTSAHistoryChange';
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ObjectId']>;
  fieldName: Scalars['String'];
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  tsaInformation: TsaInformation;
};

export type OrderTsaHistoryEntry = {
  __typename?: 'OrderTSAHistoryEntry';
  /** The action that was taken on the tsa information */
  action: OrderTsaHistoryAction;
  /** The changes that were made to the tsa information */
  changeSet: Array<OrderTsaHistoryChange>;
  /** The customer id of the trip that the tsa information belongs to */
  customerIds: Array<Scalars['ObjectId']>;
  customers: Array<Customer>;
  /** The date the change was made */
  date: Scalars['DateTime'];
  /** The type of information that was changed, ID or TSA */
  infoType: OrderTsaInfoType;
  /** The user that made the change */
  modifiedBy?: Maybe<AuditIdentity>;
  orderId: Scalars['ObjectId'];
};

export enum OrderTsaInfoType {
  Id = 'ID',
  Tsa = 'TSA'
}

export enum OrderTripHistoryAction {
  TermsAccepted = 'TERMS_ACCEPTED',
  TermsInvalidated = 'TERMS_INVALIDATED'
}

export type OrderTripHistoryChange = {
  __typename?: 'OrderTripHistoryChange';
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ObjectId']>;
  fieldName: Scalars['String'];
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  trip: Trip;
};

export type OrderTripHistoryEntry = {
  __typename?: 'OrderTripHistoryEntry';
  /** The action that was taken on the trip */
  action: OrderTripHistoryAction;
  /** The changes that were made to the trip */
  changeSet: Array<OrderTripHistoryChange>;
  /** The customer id of the trip that the trip information belongs to */
  customerIds: Array<Scalars['ObjectId']>;
  customers: Array<Customer>;
  /** The date the change was made */
  date: Scalars['DateTime'];
  /** The user that made the change */
  modifiedBy?: Maybe<AuditIdentity>;
  orderId: Scalars['ObjectId'];
};

/** An outbound flight option with associated return flight options */
export type OutboundFlightOption = FlightOption & {
  __typename?: 'OutboundFlightOption';
  /** Unique identifier for this flight option */
  _id: Scalars['ObjectId'];
  /**
   * Arrival date of the last segment (for sorting)
   * @deprecated Use localArrivalDateTime instead
   */
  arrivalDateTime?: Maybe<Scalars['Date']>;
  /** Number of allowed checked bags */
  baggageCount?: Maybe<Scalars['Int']>;
  /** Unique marketing carrier codes from all segments (for sorting/filtering) */
  carrierCodes: Array<Scalars['String']>;
  /**
   * Departure date of the first segment (for sorting)
   * @deprecated Use localDepartureDateTime instead
   */
  departureDateTime?: Maybe<Scalars['Date']>;
  /** The direction of travel */
  direction: Direction;
  /** Whether this option is included in the flight package price */
  isIncluded: Scalars['Boolean'];
  /** Local arrival date/time of the last segment (for sorting) */
  localArrivalDateTime?: Maybe<Scalars['LocalDateTime']>;
  /** Local departure date/time of the first segment (for sorting) */
  localDepartureDateTime?: Maybe<Scalars['LocalDateTime']>;
  /** The lowest price per traveler available when pairing this outbound with any return flight */
  lowestPricePerTraveler: Money;
  /** The lowest total price available when pairing this outbound with any return flight */
  lowestTotalPrice: Money;
  /** Unique operating carrier codes from all segments (for sorting/filtering) */
  operatingCarrierCodes: Array<Scalars['String']>;
  /** Available return flight options that can be paired with this outbound flight option */
  returnFlightOptions: Array<ReturnFlightOption>;
  /** The flight segments that make up this option */
  segments: Array<FlightShoppingSegment>;
  /** Total number of stops (connections between segments) (for sorting) */
  stopCount: Scalars['Int'];
  /** Total duration from first departure to final arrival, including layovers */
  totalDuration: Duration;
  /** Total price for all travelers */
  totalPrice: Money;
};

export type PaginateInput = {
  limit?: InputMaybe<Scalars['Int']>;
  next?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['String']>;
};

export type PassportInformationChecklistItem = SystemChecklistItem & {
  __typename?: 'PassportInformationChecklistItem';
  dueDate?: Maybe<Scalars['Date']>;
  isCompleted: Scalars['Boolean'];
  status?: Maybe<TripChecklistItemStatus>;
};

export type PayAndBookInput = {
  acceptWaitlist?: Scalars['Boolean'];
  /** Where this booking was made. */
  bookingMethod: BookingMethod;
  paymentSchedule?: InputMaybe<PaymentScheduleInput>;
  payments?: InputMaybe<Array<PaymentInput>>;
  staffMinimumBalanceOverrideRequested?: InputMaybe<Scalars['Boolean']>;
  staffSkipAgeValidationRequested?: InputMaybe<Scalars['Boolean']>;
  staffSkipInsuranceValidationRequested?: InputMaybe<Scalars['Boolean']>;
};

export type PayAndBookResult = Booking | BusinessNotSpecifiedError | CustomerUnavailableError | DepartureNotBookableError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidInsurancePlanError | InvalidOrderError | InvalidPaymentError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type PaymentBalanceByPaymentMethod = {
  __typename?: 'PaymentBalanceByPaymentMethod';
  amount: Money;
  customerId: Scalars['ObjectId'];
  paymentMethod: TransactionPaymentMethod;
  paymentMethodHash: Scalars['String'];
  savedPaymentMethodId?: Maybe<Scalars['ObjectId']>;
};

export type PaymentInput = {
  amount: Scalars['Float'];
  method: PaymentMethodInput;
};

export type PaymentInstallment = {
  __typename?: 'PaymentInstallment';
  _id: Scalars['ObjectId'];
  amount: Money;
  /** The date the payment is scheduled to be processed on. */
  scheduledDate: Scalars['Date'];
  status: PaymentInstallmentStatus;
};

export enum PaymentInstallmentStatus {
  /** The payment installment has been attempted. */
  Attempted = 'ATTEMPTED',
  /** The payment installment has been cancelled. */
  Cancelled = 'CANCELLED',
  /** The payment installment has been processed. */
  Processed = 'PROCESSED',
  /** The payment installment has been skipped. */
  Skipped = 'SKIPPED',
  /** The payment installment has not been processed. */
  Unprocessed = 'UNPROCESSED'
}

/** Payment method input. Only specify one of the payment methods. */
export type PaymentMethodInput = {
  /** Affirm payment method */
  affirm?: InputMaybe<AffirmPaymentMethodInput>;
  /** Physical check payment method */
  check?: InputMaybe<CheckPaymentMethodInput>;
  /** Saved payment method */
  savedPayment?: InputMaybe<SavedPaymentMethodInput>;
  /** Tokenized payment method. Provided by the tokenizer iframe */
  tokenized?: InputMaybe<TokenizedPaymentMethodInput>;
  /** Transfer funds from another booking */
  transfer?: InputMaybe<TransferPaymentMethodInput>;
  /** Voucher payment method */
  voucher?: InputMaybe<VoucherPaymentMethodInput>;
};

/** Payment method settings for the order. */
export type PaymentMethodSettings = {
  __typename?: 'PaymentMethodSettings';
  /** Whether autopay is allowed for this payment method */
  isAutopayAllowed: Scalars['Boolean'];
  /** Whether manual payments are allowed for this payment method */
  isManualAllowed: Scalars['Boolean'];
};

/** A summary info for a single reconciled payment */
export type PaymentReconciliationTransaction = {
  __typename?: 'PaymentReconciliationTransaction';
  acquirerId?: Maybe<Scalars['String']>;
  amount: Money;
  bookingId?: Maybe<Scalars['ObjectId']>;
  businessCode: BusinessCode;
  processDate: Scalars['Date'];
  processorMerchantReferenceNumber?: Maybe<Scalars['String']>;
  reconciliationStatus: ReconciliationStatus;
  reconciliationStatusMessage?: Maybe<Scalars['String']>;
  returnReasonCode?: Maybe<Scalars['String']>;
  returnReasonString?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['Int']>;
  transactionType: ReconciliationTransactionType;
  uploadId: Scalars['ObjectId'];
};

export type PaymentReconciliationTransactionPaginatedResult = {
  __typename?: 'PaymentReconciliationTransactionPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<PaymentReconciliationTransaction>;
};

export enum PaymentReconciliationTransactionSortField {
  BookingId = 'bookingId',
  ReconciliationStatus = 'reconciliationStatus',
  TransactionId = 'transactionId'
}

/** A summary info for a single reconciled payment */
export type PaymentReconciliationUpload = {
  __typename?: 'PaymentReconciliationUpload';
  _id: Scalars['ObjectId'];
  businessCode: BusinessCode;
  correlationId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  nbFailedTransactions: Scalars['Int'];
  nbSkippedTransactions: Scalars['Int'];
  nbSuccessfulTransactions: Scalars['Int'];
  nbUnprocessedTransactions: Scalars['Int'];
  sourceProcessorOrAcquirer: SourceProcessorOrAcquirer;
};

export type PaymentReconciliationUploadPaginatedResult = {
  __typename?: 'PaymentReconciliationUploadPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<PaymentReconciliationUpload>;
};

export type PaymentSchedule = {
  __typename?: 'PaymentSchedule';
  _id: Scalars['ObjectId'];
  /** The plan's installments which are either in status UNPROCESSED or PROCESSED. Most customer or sales/service facing applications will want to use this. */
  activeInstallments: Array<PaymentInstallment>;
  /** The current payment plan balance for unprocessed installments. */
  balance?: Maybe<Money>;
  /** The frequency of the payment plan. */
  frequency: PaymentScheduleFrequency;
  /** The payment plan installments, regardless of status. If you are displaying installments to a customer or sales/service staff, consider using activeInstallments instead. */
  installments: Array<PaymentInstallment>;
  /** The maximum number of attempts to process the payment installment. */
  maxAttempts: Scalars['Int'];
  /** The plan's installments in status PROCESSED. */
  processedInstallments: Array<PaymentInstallment>;
  /** The saved payment method. */
  savedPaymentMethod?: Maybe<SavedPaymentMethod>;
  savedPaymentMethodId?: Maybe<Scalars['ObjectId']>;
  /** The date the payment plan starts. */
  startDate: Scalars['Date'];
  /** The status of the payment plan. */
  status: PaymentScheduleStatus;
  /** The payment plan total, from the first installment to the last. */
  total?: Maybe<Money>;
  /** The plan's installments in status UNPROCESSED. */
  unprocessedInstallments: Array<PaymentInstallment>;
};

export enum PaymentScheduleFrequency {
  /** The payment installment is processed biweekly. */
  Biweekly = 'BIWEEKLY',
  /** The payment installment is processed monthly. */
  Monthly = 'MONTHLY'
}

export type PaymentScheduleInput = {
  frequency: PaymentScheduleFrequency;
  method: PaymentSchedulePaymentMethodInput;
  startDate: Scalars['Date'];
};

export type PaymentSchedulePaymentMethodInput = {
  /** Saved payment method */
  savedPayment?: InputMaybe<SavedPaymentMethodInput>;
  /** Tokenized payment method. Provided by the tokenizer iframe */
  tokenized?: InputMaybe<TokenizedPaymentMethodInput>;
};

export enum PaymentScheduleStatus {
  /** The payment plan is active */
  Active = 'ACTIVE',
  /** The payment plan is cancelled and payment may have been refunded. */
  Cancelled = 'CANCELLED',
  /** The payment plan is completed and all payments have been made. */
  Completed = 'COMPLETED',
  /** The payment plan is pending */
  Pending = 'PENDING',
  PendingWithdrawal = 'PENDING_WITHDRAWAL',
  /** The payment plan is withdrawn */
  Withdrawn = 'WITHDRAWN'
}

export type PaymentTransaction = {
  _id: Scalars['ObjectId'];
  amount: Money;
  /** The customer of this transaction. */
  customerId: Scalars['ObjectId'];
  displayStatus: PaymentTransactionDisplayStatus;
  /** Audit history of status and reconciliation changes for this transaction. */
  history: Array<PaymentTransactionHistoryEntry>;
  /** The user who initiated the transaction */
  initiatedBy?: Maybe<User>;
  /** The order ID on which this transaction was made */
  orderId?: Maybe<Scalars['ObjectId']>;
  paymentMethod: TransactionPaymentMethod;
  paymentSysResponseCode?: Maybe<Scalars['String']>;
  paymentSysResponseMessage?: Maybe<Scalars['String']>;
  processorTransactionId?: Maybe<Scalars['Int']>;
  reconciledBy?: Maybe<Employee>;
  referenceNumber?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['Date']>;
  /** The status of this transaction. */
  status: PaymentTransactionStatus;
  transactionDate: Scalars['DateTime'];
};

/** The display status of a transaction */
export enum PaymentTransactionDisplayStatus {
  /** The transaction was succesfully processed. */
  Accepted = 'ACCEPTED',
  /** The transaction has not been processed yet. */
  Pending = 'PENDING',
  /** The transaction was rejected. */
  Rejected = 'REJECTED'
}

export type PaymentTransactionHistoryEntry = {
  __typename?: 'PaymentTransactionHistoryEntry';
  changedBy?: Maybe<User>;
  changedDate?: Maybe<Scalars['Date']>;
  status: PaymentTransactionStatus;
};

export type PaymentTransactionPaginatedResult = {
  __typename?: 'PaymentTransactionPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<PaymentTransaction>;
};

/** The status of a transaction */
export enum PaymentTransactionStatus {
  /** The transaction was attempted, but something went wrong during processing. */
  Attempted = 'ATTEMPTED',
  /**  The transactions was settled by the processor, the amount was successfully processed. */
  Confirmed = 'CONFIRMED',
  /** The transaction failed at the processor. See the fields: `paymentSysResponseCode` and `paymentSysReponseMessage` for details. */
  Failed = 'FAILED',
  /** The transaction is pending, yet to be processed. */
  Pending = 'PENDING',
  /** (ACH transactions only) The check was returned by the bank (due to insufficient funds). */
  Returned = 'RETURNED',
  /** The pending transaction was voided thus never processed by payment processor. */
  Voided = 'VOIDED'
}

export type Permission = {
  __typename?: 'Permission';
  description: Scalars['String'];
  id: Scalars['String'];
  key: PermissionKey;
  name: Scalars['String'];
};

export enum PermissionKey {
  /** Allows you to create a adjustment */
  AdjustmentCreate = 'ADJUSTMENT_CREATE',
  /** Allows you to manage adjustments */
  AdjustmentManageAll = 'ADJUSTMENT_MANAGE_ALL',
  /** Allows you to manage adjustment prices */
  AdjustmentManagePricing = 'ADJUSTMENT_MANAGE_PRICING',
  /** Allows you to read adjustments */
  AdjustmentReadAll = 'ADJUSTMENT_READ_ALL',
  /** Admins have full access to the business and pass all permissions checks for that business */
  Admin = 'ADMIN',
  /** Allows you to create audiences */
  AudienceCreate = 'AUDIENCE_CREATE',
  /** Allows you to delete audiences */
  AudienceDelete = 'AUDIENCE_DELETE',
  /** Allows you to manage audiences */
  AudienceManageAll = 'AUDIENCE_MANAGE_ALL',
  /** Allows you to create audience members */
  AudienceMemberCreate = 'AUDIENCE_MEMBER_CREATE',
  /** Allows you to delete audience members */
  AudienceMemberDelete = 'AUDIENCE_MEMBER_DELETE',
  /** Allows you to create a booking */
  BookingCreate = 'BOOKING_CREATE',
  /** Allows you to read bookings */
  BookingReadAll = 'BOOKING_READ_ALL',
  /** Allows you to update business chat settings */
  BusinessUpdateSettingsChat = 'BUSINESS_UPDATE_SETTINGS_CHAT',
  /** Allows you to update business customer settings */
  BusinessUpdateSettingsCustomer = 'BUSINESS_UPDATE_SETTINGS_CUSTOMER',
  /** Allows you to update business departure settings */
  BusinessUpdateSettingsDeparture = 'BUSINESS_UPDATE_SETTINGS_DEPARTURE',
  /** Allows you to update business evaluation settings */
  BusinessUpdateSettingsEvaluation = 'BUSINESS_UPDATE_SETTINGS_EVALUATION',
  /** Allows you to update business fee settings */
  BusinessUpdateSettingsFee = 'BUSINESS_UPDATE_SETTINGS_FEE',
  /** Allows you to update business flight settings */
  BusinessUpdateSettingsFlight = 'BUSINESS_UPDATE_SETTINGS_FLIGHT',
  /** Allows you to update business GC departure settings */
  BusinessUpdateSettingsGcDeparture = 'BUSINESS_UPDATE_SETTINGS_GC_DEPARTURE',
  /** Allows you to update business group trip checklist settings */
  BusinessUpdateSettingsGroupTripChecklist = 'BUSINESS_UPDATE_SETTINGS_GROUP_TRIP_CHECKLIST',
  /** Allows you to update business insurance settings */
  BusinessUpdateSettingsInsurance = 'BUSINESS_UPDATE_SETTINGS_INSURANCE',
  /** Allows you to update business integration settings */
  BusinessUpdateSettingsIntegration = 'BUSINESS_UPDATE_SETTINGS_INTEGRATION',
  /** Allows you to update business order settings */
  BusinessUpdateSettingsOrder = 'BUSINESS_UPDATE_SETTINGS_ORDER',
  /** Allows you to update business order payment related settings */
  BusinessUpdateSettingsOrderPayments = 'BUSINESS_UPDATE_SETTINGS_ORDER_PAYMENTS',
  /** Allows you to update business order quotes section settings */
  BusinessUpdateSettingsOrderQuotes = 'BUSINESS_UPDATE_SETTINGS_ORDER_QUOTES',
  /** Allows you to update business order rooming settings */
  BusinessUpdateSettingsOrderRooming = 'BUSINESS_UPDATE_SETTINGS_ORDER_ROOMING',
  /** Allows you to update business promo settings */
  BusinessUpdateSettingsPromo = 'BUSINESS_UPDATE_SETTINGS_PROMO',
  /** Allows you to update business review settings */
  BusinessUpdateSettingsReview = 'BUSINESS_UPDATE_SETTINGS_REVIEW',
  /** Allows you to update business support ticket settings */
  BusinessUpdateSettingsSupportTicket = 'BUSINESS_UPDATE_SETTINGS_SUPPORT_TICKET',
  /** Allows you to update business tour search settings */
  BusinessUpdateSettingsTourSearch = 'BUSINESS_UPDATE_SETTINGS_TOUR_SEARCH',
  /** Allows you to update business trip checklist settings */
  BusinessUpdateSettingsTripChecklist = 'BUSINESS_UPDATE_SETTINGS_TRIP_CHECKLIST',
  /** Allows you to update business TSA settings */
  BusinessUpdateSettingsTsa = 'BUSINESS_UPDATE_SETTINGS_TSA',
  /** Allows you to create a campaign */
  CampaignCreate = 'CAMPAIGN_CREATE',
  /** Allows you to manage campaigns */
  CampaignManageAll = 'CAMPAIGN_MANAGE_ALL',
  /** Allows you to read campaigns */
  CampaignReadAll = 'CAMPAIGN_READ_ALL',
  /** Allows you to read evaluations */
  CustomerEvaluationReadAll = 'CUSTOMER_EVALUATION_READ_ALL',
  /** Allows you to process customer data deletion requests per CCPA/GDPR guidelines */
  CustomerManageDataDeletion = 'CUSTOMER_MANAGE_DATA_DELETION',
  /** Allows you to merge customers */
  CustomerManageMerge = 'CUSTOMER_MANAGE_MERGE',
  /** Allows you to read a customer */
  CustomerRead = 'CUSTOMER_READ',
  /** Allows you to read from a paginated list of customers */
  CustomerReadAll = 'CUSTOMER_READ_ALL',
  /** Allows you to read a customer's incentives profile */
  CustomerReadIncentives = 'CUSTOMER_READ_INCENTIVES',
  /** Allows you to create a departure */
  DepartureCreate = 'DEPARTURE_CREATE',
  /** Allows you to create a departure excursion */
  DepartureExcursionCreate = 'DEPARTURE_EXCURSION_CREATE',
  /** Allows you to manage departure excursions */
  DepartureExcursionManageAll = 'DEPARTURE_EXCURSION_MANAGE_ALL',
  /** Allows you to manage departure excursion prices */
  DepartureExcursionManagePricing = 'DEPARTURE_EXCURSION_MANAGE_PRICING',
  /** Allows you to create a departure extension */
  DepartureExtensionCreate = 'DEPARTURE_EXTENSION_CREATE',
  /** Allows you to manage departure extensions */
  DepartureExtensionManageAll = 'DEPARTURE_EXTENSION_MANAGE_ALL',
  /** Allows you to manage departure extension prices */
  DepartureExtensionManagePricing = 'DEPARTURE_EXTENSION_MANAGE_PRICING',
  /** Allows you to integrate a departure to production */
  DepartureIntegrateProduction = 'DEPARTURE_INTEGRATE_PRODUCTION',
  /** Allows you to read departure itineraries */
  DepartureItineraryReadAll = 'DEPARTURE_ITINERARY_READ_ALL',
  /** Allows you to manage departures */
  DepartureManageAll = 'DEPARTURE_MANAGE_ALL',
  /** Allows you to manage the status of a CANCELLED departure */
  DepartureManageCancelled = 'DEPARTURE_MANAGE_CANCELLED',
  /** Allows you to change the status of a CLOSED departure */
  DepartureManageClosed = 'DEPARTURE_MANAGE_CLOSED',
  /** Allows you to change the departure owner */
  DepartureManageOwner = 'DEPARTURE_MANAGE_OWNER',
  /** Allows you to manage departure prices */
  DepartureManagePricing = 'DEPARTURE_MANAGE_PRICING',
  /** Allows you to view the departure TDI report */
  DepartureManageViewTdi = 'DEPARTURE_MANAGE_VIEW_TDI',
  /** Allows you to read departures */
  DepartureReadAll = 'DEPARTURE_READ_ALL',
  /** Allows you to create a departure room */
  DepartureRoomCreate = 'DEPARTURE_ROOM_CREATE',
  /** Allows you to manage departure rooms */
  DepartureRoomManageAll = 'DEPARTURE_ROOM_MANAGE_ALL',
  /** Allows you to manage departure room prices */
  DepartureRoomManagePricing = 'DEPARTURE_ROOM_MANAGE_PRICING',
  /** Allows you to read from a paginated list of employees */
  EmployeeReadAll = 'EMPLOYEE_READ_ALL',
  /** Allows you to create a new extended stay */
  ExtendedStayCreate = 'EXTENDED_STAY_CREATE',
  /** Allows you to create a fee */
  FeeCreate = 'FEE_CREATE',
  /** Allows you to manage fees */
  FeeManageAll = 'FEE_MANAGE_ALL',
  /** Allows you to manage fee prices */
  FeeManagePricing = 'FEE_MANAGE_PRICING',
  /** Allows you to read fees */
  FeeReadAll = 'FEE_READ_ALL',
  /** Allows you to create a flight package */
  FlightPackageCreate = 'FLIGHT_PACKAGE_CREATE',
  /** Allows you to manage flight packages */
  FlightPackageManageAll = 'FLIGHT_PACKAGE_MANAGE_ALL',
  /** Allows you to manage flight package prices */
  FlightPackageManagePricing = 'FLIGHT_PACKAGE_MANAGE_PRICING',
  /** Allows you to read flight packages */
  FlightPackageReadAll = 'FLIGHT_PACKAGE_READ_ALL',
  /** Allows you to book flights */
  FlightShoppingBook = 'FLIGHT_SHOPPING_BOOK',
  /** Allows you to search for flights */
  FlightShoppingSearch = 'FLIGHT_SHOPPING_SEARCH',
  /** Allows a webhook to update a flight shop session */
  FlightShoppingUpdate = 'FLIGHT_SHOPPING_UPDATE',
  /** Allows you to create a flight shop */
  FlightShopCreate = 'FLIGHT_SHOP_CREATE',
  /** Allows you to update a flight shop */
  FlightShopUpdate = 'FLIGHT_SHOP_UPDATE',
  /** Allows you to cancel a GC Departure */
  GcDepartureCancel = 'GC_DEPARTURE_CANCEL',
  /** Allows you to create a new GC Departure */
  GcDepartureCreate = 'GC_DEPARTURE_CREATE',
  /** Allows you to update a GC Departure */
  GcDepartureManage = 'GC_DEPARTURE_MANAGE',
  /** Allows you to cancel a GC Departure Meeting */
  GcDepartureMeetingCancel = 'GC_DEPARTURE_MEETING_CANCEL',
  /** Allows you to create a new GC Departure Meeting */
  GcDepartureMeetingCreate = 'GC_DEPARTURE_MEETING_CREATE',
  /** Allows you to manage a GC Departure Meeting */
  GcDepartureMeetingManage = 'GC_DEPARTURE_MEETING_MANAGE',
  /** Allows you to read global rewards summaries and data */
  GlobalRewardsReadAll = 'GLOBAL_REWARDS_READ_ALL',
  /** Allows you to create a insurance */
  InsuranceCreate = 'INSURANCE_CREATE',
  /** Allows you to manage insurances */
  InsuranceManageAll = 'INSURANCE_MANAGE_ALL',
  /** Allows you to manage insurance prices */
  InsuranceManagePricing = 'INSURANCE_MANAGE_PRICING',
  /** Allows you to read insurances */
  InsuranceReadAll = 'INSURANCE_READ_ALL',
  /** Allows you to manually connect a referral between an advocate and friend */
  ManageConnections = 'MANAGE_CONNECTIONS',
  /** Allows you to manage incentive redemptions (e.g. evaluate and apply referral travel bank points) */
  ManageRedemptions = 'MANAGE_REDEMPTIONS',
  /** Allows you to create, update, and delete OAuth clients */
  OauthClientManageAll = 'OAUTH_CLIENT_MANAGE_ALL',
  /** Allows you to view all registered OAuth clients */
  OauthClientReadAll = 'OAUTH_CLIENT_READ_ALL',
  /** Allows you to create a draft order */
  OrderDraft = 'ORDER_DRAFT',
  /** Allows you to read draft orders */
  OrderDraftReadAll = 'ORDER_DRAFT_READ_ALL',
  /** Allows you to integrate a booking to production */
  OrderIntegrateProduction = 'ORDER_INTEGRATE_PRODUCTION',
  /** Allows you to manage adjustments on orders */
  OrderManageAdjustments = 'ORDER_MANAGE_ADJUSTMENTS',
  /** Allows you to manage airport transfers on orders */
  OrderManageAirportTransfers = 'ORDER_MANAGE_AIRPORT_TRANSFERS',
  /** Allows you to manage cancelling orders */
  OrderManageCancel = 'ORDER_MANAGE_CANCEL',
  /** Allows you to manage cancelling orders that have departed */
  OrderManageCancelPastDeparture = 'ORDER_MANAGE_CANCEL_PAST_DEPARTURE',
  /** Allows you to manage closed excursions on orders */
  OrderManageClosedExcursions = 'ORDER_MANAGE_CLOSED_EXCURSIONS',
  /** Allows you to manage closed extensions on orders */
  OrderManageClosedExtensions = 'ORDER_MANAGE_CLOSED_EXTENSIONS',
  /** Allows you to manage closed rooms on orders */
  OrderManageClosedRooms = 'ORDER_MANAGE_CLOSED_ROOMS',
  /** Allows you to manage excursions on orders */
  OrderManageExcursions = 'ORDER_MANAGE_EXCURSIONS',
  /** Allows you to bulk update excursions on multiple orders */
  OrderManageExcursionsBulkUpdate = 'ORDER_MANAGE_EXCURSIONS_BULK_UPDATE',
  /** Allows you to manage extended stays on orders */
  OrderManageExtendedStays = 'ORDER_MANAGE_EXTENDED_STAYS',
  /** Allows you to manage extensions on orders */
  OrderManageExtensions = 'ORDER_MANAGE_EXTENSIONS',
  /** Allows you to manage fees on orders */
  OrderManageFees = 'ORDER_MANAGE_FEES',
  /** Allows you to manage flights on orders */
  OrderManageFlights = 'ORDER_MANAGE_FLIGHTS',
  /** Allows you to manage forking orders */
  OrderManageFork = 'ORDER_MANAGE_FORK',
  /** Allows you to manage insurance on orders */
  OrderManageInsurance = 'ORDER_MANAGE_INSURANCE',
  /** Allows you to back or future date the coverage start date for insurance */
  OrderManageInsuranceBackOrFutureDateCoverageStart = 'ORDER_MANAGE_INSURANCE_BACK_OR_FUTURE_DATE_COVERAGE_START',
  /** Allows you to cancel insurance plans past their free look period */
  OrderManageInsuranceCancelPastFreeLookPeriod = 'ORDER_MANAGE_INSURANCE_CANCEL_PAST_FREE_LOOK_PERIOD',
  /** Allows you to force the coverage start date for insurance to a specific date */
  OrderManageInsuranceOverrideCoverageStart = 'ORDER_MANAGE_INSURANCE_OVERRIDE_COVERAGE_START',
  /** Allows you to skip the insurance eligibility validation for an order */
  OrderManageInsuranceSkipEligibilityValidation = 'ORDER_MANAGE_INSURANCE_SKIP_ELIGIBILITY_VALIDATION',
  /** Allows you to manage merging orders */
  OrderManageMerge = 'ORDER_MANAGE_MERGE',
  /** Allows you to change the primary trip on orders */
  OrderManagePrimaryTrip = 'ORDER_MANAGE_PRIMARY_TRIP',
  /** Allows you to manage private group fees on orders */
  OrderManagePrivateGroup = 'ORDER_MANAGE_PRIVATE_GROUP',
  /** Allows you to manage promos on orders */
  OrderManagePromos = 'ORDER_MANAGE_PROMOS',
  /** Allows you to manage rebooking orders */
  OrderManageRebook = 'ORDER_MANAGE_REBOOK',
  /** Allows you to manage rebooking orders that have departed */
  OrderManageRebookPastDeparture = 'ORDER_MANAGE_REBOOK_PAST_DEPARTURE',
  /** Allows you to manage roommates on orders */
  OrderManageRoommates = 'ORDER_MANAGE_ROOMMATES',
  /** Allows you to manage rooms on orders */
  OrderManageRooms = 'ORDER_MANAGE_ROOMS',
  /** Allows you to manually change the status of a trip on an order */
  OrderManageStatus = 'ORDER_MANAGE_STATUS',
  /** Allows you to manage traveler information on orders */
  OrderManageTravelerInformation = 'ORDER_MANAGE_TRAVELER_INFORMATION',
  /** Allows you to manage travel companions on orders */
  OrderManageTravelCompanions = 'ORDER_MANAGE_TRAVEL_COMPANIONS',
  /** Allows you to override TSA expiration date check */
  OrderOverrideTsaExpiration = 'ORDER_OVERRIDE_TSA_EXPIRATION',
  /** Allows you to adjust an orders' autopay */
  OrderPaymentsAutopay = 'ORDER_PAYMENTS_AUTOPAY',
  /** Allows you to book an order with no payments */
  OrderPaymentsBookNoPayments = 'ORDER_PAYMENTS_BOOK_NO_PAYMENTS',
  /** Allows you to make payments for an order */
  OrderPaymentsMakePayment = 'ORDER_PAYMENTS_MAKE_PAYMENT',
  /** Allows you to set a later final installment date for a booking */
  OrderPaymentsOverrideFinalInstallmentDate = 'ORDER_PAYMENTS_OVERRIDE_FINAL_INSTALLMENT_DATE',
  /** Allows you to set a later final payment date for a booking */
  OrderPaymentsOverrideFinalPaymentDate = 'ORDER_PAYMENTS_OVERRIDE_FINAL_PAYMENT_DATE',
  /** Allows you to take a payment for less than the minimum due on booking */
  OrderPaymentsOverrideMinimum = 'ORDER_PAYMENTS_OVERRIDE_MINIMUM',
  /** Allows you to read the transactions on an order */
  OrderPaymentsReadAll = 'ORDER_PAYMENTS_READ_ALL',
  /** Allows you to manually change the status of a payment on an order */
  OrderPaymentsReconcile = 'ORDER_PAYMENTS_RECONCILE',
  /** Allows you to make a refund from an order */
  OrderPaymentsRefund = 'ORDER_PAYMENTS_REFUND',
  /** Allows you to make a refund from an order that would take the order below the minimum balance owed */
  OrderPaymentsRefundOverrideMinimumBalance = 'ORDER_PAYMENTS_REFUND_OVERRIDE_MINIMUM_BALANCE',
  /** Allows you to make payment transfers between orders */
  OrderPaymentsTransfer = 'ORDER_PAYMENTS_TRANSFER',
  /** Allows you to read orders */
  OrderReadAll = 'ORDER_READ_ALL',
  /** Allows you to read order related documents */
  OrderReadDocument = 'ORDER_READ_DOCUMENT',
  /** Allows you to book an order when a traveler's age is outside the allowed range */
  OrderTsaBookAgeOutOfRange = 'ORDER_TSA_BOOK_AGE_OUT_OF_RANGE',
  /** Allows you to manage payment methods */
  PaymentMethodManageAll = 'PAYMENT_METHOD_MANAGE_ALL',
  /** Allows you to read payment methods */
  PaymentMethodReadAll = 'PAYMENT_METHOD_READ_ALL',
  /** Allows you to manage places */
  PlacesManageAll = 'PLACES_MANAGE_ALL',
  /** Allows you to create a tour private group fee */
  PrivateGroupFeeCreate = 'PRIVATE_GROUP_FEE_CREATE',
  /** Allows you to manage tour private group fees */
  PrivateGroupFeeManageAll = 'PRIVATE_GROUP_FEE_MANAGE_ALL',
  /** Allows you to manage tour private group fee prices */
  PrivateGroupFeeManagePricing = 'PRIVATE_GROUP_FEE_MANAGE_PRICING',
  /** Allows you to create a promo */
  PromoCreate = 'PROMO_CREATE',
  /** Allows you to manage promos */
  PromoManageAll = 'PROMO_MANAGE_ALL',
  /** Allows you to manage promo prices */
  PromoManagePricing = 'PROMO_MANAGE_PRICING',
  /** Allows you to read promos */
  PromoReadAll = 'PROMO_READ_ALL',
  /** Allows you to create a quote */
  QuoteCreate = 'QUOTE_CREATE',
  /** Allows you to read quotes */
  QuoteReadAll = 'QUOTE_READ_ALL',
  /** Allows you to manage reviews */
  ReviewManageAll = 'REVIEW_MANAGE_ALL',
  /** Allows you to create a service recovery promo */
  ServiceRecoveryCreate = 'SERVICE_RECOVERY_CREATE',
  /** Allows you to update support ticket */
  SupportTicketUpdate = 'SUPPORT_TICKET_UPDATE',
  /** Allows you to manage tags */
  TagsManageAll = 'TAGS_MANAGE_ALL',
  /** Allows you to create a new term */
  TermCreate = 'TERM_CREATE',
  /** Allows you to invoke Query Snowflake. Note: This is an elevated permission. */
  ToolInvokeQuerySnowflake = 'TOOL_INVOKE_QUERY_SNOWFLAKE',
  /** Allows you to use the add draft order extension AI tool when creating agents */
  ToolUseAddDraftOrderExtension = 'TOOL_USE_ADD_DRAFT_ORDER_EXTENSION',
  /** Allows you to use the add draft order insurance AI tool when creating agents */
  ToolUseAddDraftOrderInsurance = 'TOOL_USE_ADD_DRAFT_ORDER_INSURANCE',
  /** Allows you to use the add draft order promo AI tool when creating agents */
  ToolUseAddDraftOrderPromo = 'TOOL_USE_ADD_DRAFT_ORDER_PROMO',
  /** Allows you to use the data visualization metadata tool when creating agents */
  ToolUseDataVizMetadata = 'TOOL_USE_DATA_VIZ_METADATA',
  /** Allows you to use the find single booking AI tool when creating agents */
  ToolUseFindBooking = 'TOOL_USE_FIND_BOOKING',
  /** Allows you to use the find bookings AI tool when creating agents */
  ToolUseFindBookings = 'TOOL_USE_FIND_BOOKINGS',
  /** Allows you to use the booking trips AI tool when creating agents */
  ToolUseFindBookingTrips = 'TOOL_USE_FIND_BOOKING_TRIPS',
  /** Allows you to use the find single customer AI tool when creating agents */
  ToolUseFindCustomer = 'TOOL_USE_FIND_CUSTOMER',
  /** Allows you to use the find customers AI tool when creating agents */
  ToolUseFindCustomers = 'TOOL_USE_FIND_CUSTOMERS',
  /** Allows you to use the find single customer evaluation AI tool when creating agents */
  ToolUseFindCustomerEvaluation = 'TOOL_USE_FIND_CUSTOMER_EVALUATION',
  /** Allows you to use the find customer evaluations AI tool when creating agents */
  ToolUseFindCustomerEvaluations = 'TOOL_USE_FIND_CUSTOMER_EVALUATIONS',
  /** Allows you to use the find single departure AI tool when creating agents */
  ToolUseFindDeparture = 'TOOL_USE_FIND_DEPARTURE',
  /** Allows you to use the find departures AI tool when creating agents */
  ToolUseFindDepartures = 'TOOL_USE_FIND_DEPARTURES',
  /** Allows you to use the find departure itinerary AI tool when creating agents */
  ToolUseFindDepartureItinerary = 'TOOL_USE_FIND_DEPARTURE_ITINERARY',
  /** Allows you to use the find single employee AI tool when creating agents */
  ToolUseFindEmployee = 'TOOL_USE_FIND_EMPLOYEE',
  /** Allows you to use the find employees AI tool when creating agents */
  ToolUseFindEmployees = 'TOOL_USE_FIND_EMPLOYEES',
  /** Allows you to use the find extensions AI tool when creating agents */
  ToolUseFindExtensions = 'TOOL_USE_FIND_EXTENSIONS',
  /** Allows you to use the find flight packages AI tool when creating agents */
  ToolUseFindFlightPackages = 'TOOL_USE_FIND_FLIGHT_PACKAGES',
  /** Allows you to use the find single GC departure AI tool when creating agents */
  ToolUseFindGcDeparture = 'TOOL_USE_FIND_GC_DEPARTURE',
  /** Allows you to use the find GC departures AI tool when creating agents */
  ToolUseFindGcDepartures = 'TOOL_USE_FIND_GC_DEPARTURES',
  /** Allows you to use the GC departure quote summary AI tool when creating agents */
  ToolUseFindGcDepartureQuoteSummary = 'TOOL_USE_FIND_GC_DEPARTURE_QUOTE_SUMMARY',
  /** Allows you to use the find global rewards summary AI tool when creating agents */
  ToolUseFindGlobalRewardsSummary = 'TOOL_USE_FIND_GLOBAL_REWARDS_SUMMARY',
  /** Allows you to use the find insurance plans AI tool when creating agents */
  ToolUseFindInsurancePlans = 'TOOL_USE_FIND_INSURANCE_PLANS',
  /** Allows you to use the find insurance policies AI tool when creating agents */
  ToolUseFindInsurancePolicies = 'TOOL_USE_FIND_INSURANCE_POLICIES',
  /** Allows you to use the find places AI tool when creating agents */
  ToolUseFindPlaces = 'TOOL_USE_FIND_PLACES',
  /** Allows you to use the find single quote AI tool when creating agents */
  ToolUseFindQuote = 'TOOL_USE_FIND_QUOTE',
  /** Allows you to use the find quotes AI tool when creating agents */
  ToolUseFindQuotes = 'TOOL_USE_FIND_QUOTES',
  /** Allows you to use the find single review AI tool when creating agents */
  ToolUseFindReview = 'TOOL_USE_FIND_REVIEW',
  /** Allows you to use the find reviews AI tool when creating agents */
  ToolUseFindReviews = 'TOOL_USE_FIND_REVIEWS',
  /** Allows you to use the find review aggregate AI tool when creating agents */
  ToolUseFindReviewAggregate = 'TOOL_USE_FIND_REVIEW_AGGREGATE',
  /** Allows you to use the find single tour AI tool when creating agents */
  ToolUseFindTour = 'TOOL_USE_FIND_TOUR',
  /** Allows you to use the find tours AI tool when creating agents */
  ToolUseFindTours = 'TOOL_USE_FIND_TOURS',
  /** Allows you to use the find tour content AI tool when creating agents */
  ToolUseFindTourContents = 'TOOL_USE_FIND_TOUR_CONTENTS',
  /** Allows you to use the find single tour director AI tool when creating agents */
  ToolUseFindTourDirector = 'TOOL_USE_FIND_TOUR_DIRECTOR',
  /** Allows you to use the find tour directors AI tool when creating agents */
  ToolUseFindTourDirectors = 'TOOL_USE_FIND_TOUR_DIRECTORS',
  /** Allows you to use the find single tour end report AI tool when creating agents */
  ToolUseFindTourEndReport = 'TOOL_USE_FIND_TOUR_END_REPORT',
  /** Allows you to use the find tour end reports AI tool when creating agents */
  ToolUseFindTourEndReports = 'TOOL_USE_FIND_TOUR_END_REPORTS',
  /** Allows you to use the find single tour excursion AI tool when creating agents */
  ToolUseFindTourExcursion = 'TOOL_USE_FIND_TOUR_EXCURSION',
  /** Allows you to use the find tour excursions AI tool when creating agents */
  ToolUseFindTourExcursions = 'TOOL_USE_FIND_TOUR_EXCURSIONS',
  /** Allows you to use the find single tour extension AI tool when creating agents */
  ToolUseFindTourExtension = 'TOOL_USE_FIND_TOUR_EXTENSION',
  /** Allows you to use the pay and book AI tool when creating agents */
  ToolUsePayAndBook = 'TOOL_USE_PAY_AND_BOOK',
  /** Allows you to use the publish draft booking AI tool when creating agents */
  ToolUsePublishDraftBooking = 'TOOL_USE_PUBLISH_DRAFT_BOOKING',
  /** Allows you to use the publish draft quote AI tool when creating agents */
  ToolUsePublishDraftQuote = 'TOOL_USE_PUBLISH_DRAFT_QUOTE',
  /** Allows you to query Snowflake with the AI tool when creating agents */
  ToolUseQuerySnowflake = 'TOOL_USE_QUERY_SNOWFLAKE',
  /** Allows you to use the help center search AI tool when creating agents */
  ToolUseSearchHelpCenter = 'TOOL_USE_SEARCH_HELP_CENTER',
  /** Allows you to use the signup customer AI tool when creating agents */
  ToolUseSignupCustomer = 'TOOL_USE_SIGNUP_CUSTOMER',
  /** Allows you to use the start quote AI tool when creating agents */
  ToolUseStartQuote = 'TOOL_USE_START_QUOTE',
  /** Allows you to use the update draft order flight packages AI tool when creating agents */
  ToolUseUpdateDraftOrderFlightPackages = 'TOOL_USE_UPDATE_DRAFT_ORDER_FLIGHT_PACKAGES',
  /** Allows you to use the update draft order rooms AI tool when creating agents */
  ToolUseUpdateDraftOrderRooms = 'TOOL_USE_UPDATE_DRAFT_ORDER_ROOMS',
  /** Allows you to use the update quote saved AI tool when creating agents */
  ToolUseUpdateQuoteSaved = 'TOOL_USE_UPDATE_QUOTE_SAVED',
  /** Allows you to use the vector search reviews AI tool when creating agents */
  ToolUseVectorSearchReviews = 'TOOL_USE_VECTOR_SEARCH_REVIEWS',
  /** Allows you to use the vector search tour content AI tool when creating agents */
  ToolUseVectorSearchTourContent = 'TOOL_USE_VECTOR_SEARCH_TOUR_CONTENT',
  /** Allows you to use the vector search tour page search hits AI tool when creating agents */
  ToolUseVectorSearchTourPageSearchHits = 'TOOL_USE_VECTOR_SEARCH_TOUR_PAGE_SEARCH_HITS',
  /** Allows you to use the web search AI tool when creating agents */
  ToolUseWebSearch = 'TOOL_USE_WEB_SEARCH',
  /** Allows you to create a tour airport transfer */
  TourAirportTransferCreate = 'TOUR_AIRPORT_TRANSFER_CREATE',
  /** Allows you to manage tour airport transfers */
  TourAirportTransferManageAll = 'TOUR_AIRPORT_TRANSFER_MANAGE_ALL',
  /** Allows you to create a tour */
  TourCreate = 'TOUR_CREATE',
  /** Allows you to read tour end reports */
  TourDirectorTourEndReportReadAll = 'TOUR_DIRECTOR_TOUR_END_REPORT_READ_ALL',
  /** Allows you to create a tour excursion */
  TourExcursionCreate = 'TOUR_EXCURSION_CREATE',
  /** Allows you to manage tour excursions */
  TourExcursionManageAll = 'TOUR_EXCURSION_MANAGE_ALL',
  /** Allows you to manage tour excursion prices */
  TourExcursionManagePricing = 'TOUR_EXCURSION_MANAGE_PRICING',
  /** Allows you to create a tour extension */
  TourExtensionCreate = 'TOUR_EXTENSION_CREATE',
  /** Allows you to manage tour extensions */
  TourExtensionManageAll = 'TOUR_EXTENSION_MANAGE_ALL',
  /** Allows you to manage tour extension prices */
  TourExtensionManagePricing = 'TOUR_EXTENSION_MANAGE_PRICING',
  /** Allows you to manage tours */
  TourManageAll = 'TOUR_MANAGE_ALL',
  /** Allows you to manage tour prices */
  TourManagePricing = 'TOUR_MANAGE_PRICING',
  /** Allows you to read tours */
  TourReadAll = 'TOUR_READ_ALL',
  /** Allows you to create a tour room */
  TourRoomCreate = 'TOUR_ROOM_CREATE',
  /** Allows you to manage tour rooms */
  TourRoomManageAll = 'TOUR_ROOM_MANAGE_ALL',
  /** Allows you to manage tour room prices */
  TourRoomManagePricing = 'TOUR_ROOM_MANAGE_PRICING',
  /** Allows you to read the TSA information for a trip */
  TripReadTsaInformation = 'TRIP_READ_TSA_INFORMATION',
  /** Allows you to create a new voucher */
  VoucherCreate = 'VOUCHER_CREATE',
  /** Allows you to update the expiration date of a voucher */
  VoucherManageExpiration = 'VOUCHER_MANAGE_EXPIRATION',
  /** Allows you to increase the balance of a voucher outside the context of a booking */
  VoucherManageIncrease = 'VOUCHER_MANAGE_INCREASE',
  /** Allows you to lower the balance of a voucher outside the context of a booking */
  VoucherManageReduce = 'VOUCHER_MANAGE_REDUCE',
  /** Allows you to mark part of all of the balance of a refundable voucher as refunded to a customer, and edit refund details */
  VoucherManageRefund = 'VOUCHER_MANAGE_REFUND',
  /** Allows you to reinstate a voided voucher */
  VoucherManageReinstate = 'VOUCHER_MANAGE_REINSTATE',
  /** Allows you to transfer the balance of a voucher to another voucher or outside of WOJO */
  VoucherManageTransfer = 'VOUCHER_MANAGE_TRANSFER',
  /** Allows you to void a voucher */
  VoucherManageVoid = 'VOUCHER_MANAGE_VOID'
}

export type Place = {
  _id: Scalars['ObjectId'];
  name: Scalars['String'];
  /** The place code is a unique identifier for the place, used for global identification. */
  placeCode: Scalars['String'];
  type: PlaceType;
};

/** Filters for places query */
export type PlaceFilterInput = {
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ObjectId']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  query?: InputMaybe<Scalars['String']>;
  /** Use 'types' instead, as the place repository doesn't support a 'type' filter. As a result, this filter has no effect. */
  type?: InputMaybe<PlaceType>;
  types?: InputMaybe<Array<PlaceType>>;
};

/** A paginated result of Places */
export type PlacePaginatedResult = {
  __typename?: 'PlacePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Place>;
};

export enum PlaceSortField {
  Name = 'name',
  Type = 'type'
}

export type PlaceSortInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: PlaceSortField;
};

/** The type of place. E.g. country, city, continent, etc. */
export enum PlaceType {
  City = 'CITY',
  Continent = 'CONTINENT',
  Country = 'COUNTRY',
  CountryRegion = 'COUNTRY_REGION',
  GeographicRegion = 'GEOGRAPHIC_REGION'
}

/** Place with ancestry */
export type PlaceWithAncestry = {
  __typename?: 'PlaceWithAncestry';
  /** The level of the place in the hierarchy */
  level: Scalars['Int'];
  /** The place */
  place: Place;
};

export type PointRedemptionEvaluation = {
  __typename?: 'PointRedemptionEvaluation';
  /** The redemption amount that has been applied to the trip in addition to any existing amount */
  amountToRedeem: Money;
  /** The travel bank redemption amount already applied to this trip before this change */
  existingDiscount: Money;
  /** The maximum total redemption amount allowed, based on the customer's travel bank balance, the current order balance, and trip and order totals exclusive of insurance */
  maxRedeemable: Money;
  /** The new order balance after the redemption is applied */
  newOrderBalance: Money;
  /** The new order grand total after the redemption is applied */
  newOrderGrandTotal: Money;
  /** The new trip total after the redemption is applied */
  newTripTotal: Money;
  /** The remaining travel bank balance after the redemption is applied */
  remainingIncentiveBalance: Money;
  /** The total travel bank redemption amount applied to this trip after this change */
  totalDiscount: Money;
};

export type PriceRule = {
  __typename?: 'PriceRule';
  dayOfWeek?: Maybe<Scalars['Int']>;
  departureDateFrom?: Maybe<Scalars['Date']>;
  departureDateTo?: Maybe<Scalars['Date']>;
  dpdFrom?: Maybe<Scalars['Int']>;
  dpdTo?: Maybe<Scalars['Int']>;
  effectiveFrom?: Maybe<Scalars['Date']>;
  effectiveTo?: Maybe<Scalars['Date']>;
  nbSpotsBookedFrom?: Maybe<Scalars['Int']>;
  nbSpotsBookedTo?: Maybe<Scalars['Int']>;
  nbSpotsLeftFrom?: Maybe<Scalars['Int']>;
  nbSpotsLeftTo?: Maybe<Scalars['Int']>;
  price: Amount;
  tripLengthFrom?: Maybe<Scalars['Int']>;
  tripLengthTo?: Maybe<Scalars['Int']>;
  tripPriceFrom?: Maybe<Amount>;
  tripPriceTo?: Maybe<Amount>;
};

export type PriceRuleInput = {
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  departureDateFrom?: InputMaybe<Scalars['Date']>;
  departureDateTo?: InputMaybe<Scalars['Date']>;
  dpdFrom?: InputMaybe<Scalars['Int']>;
  dpdTo?: InputMaybe<Scalars['Int']>;
  effectiveFrom?: InputMaybe<Scalars['Date']>;
  effectiveTo?: InputMaybe<Scalars['Date']>;
  nbSpotsBookedFrom?: InputMaybe<Scalars['Int']>;
  nbSpotsBookedTo?: InputMaybe<Scalars['Int']>;
  nbSpotsLeftFrom?: InputMaybe<Scalars['Int']>;
  nbSpotsLeftTo?: InputMaybe<Scalars['Int']>;
  prices: Array<MoneyInput>;
  tripLengthFrom?: InputMaybe<Scalars['Int']>;
  tripLengthTo?: InputMaybe<Scalars['Int']>;
  tripPriceFrom?: InputMaybe<Array<MoneyInput>>;
  tripPriceTo?: InputMaybe<Array<MoneyInput>>;
};

export type PriceYear = {
  __typename?: 'PriceYear';
  year: Scalars['Int'];
  yearCode: Scalars['String'];
  yearEnd: Scalars['Date'];
  yearStart: Scalars['Date'];
};

/** Root fields for all priced trip components */
export type PricedTripComponent = {
  _id: Scalars['ObjectId'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  hasPriceRules: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  priceRules: Array<PriceRule>;
  status: TripComponentStatus;
  type: TripComponentType;
};

export type PrivateGroup = PricedTripComponent & TripComponent & {
  __typename?: 'PrivateGroup';
  _id: Scalars['ObjectId'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  hasPriceRules: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  priceRules: Array<PriceRule>;
  rollsUpToTarget: Scalars['Boolean'];
  status: TripComponentStatus;
  tourCode: Scalars['String'];
  type: TripComponentType;
};

export type PrivateGroupLineItem = LineItem & {
  __typename?: 'PrivateGroupLineItem';
  _id: Scalars['ObjectId'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

export type ProcessorPaymentMethodRefundInput = {
  amount: Scalars['Float'];
  paymentMethodHash: Scalars['String'];
  /** @deprecated Use paymentMethodHash instead */
  processorPaymentMethodId?: InputMaybe<Scalars['Int']>;
};

export type ProductBadgeContent = {
  __typename?: 'ProductBadgeContent';
  icon?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

/** A promotion. */
export type Promo = TripComponent & {
  __typename?: 'Promo';
  _id: Scalars['ObjectId'];
  businessCode?: Maybe<BusinessCode>;
  /** When present this promo can only be redeemed by this specific customer. */
  customerIds?: Maybe<Array<Scalars['ObjectId']>>;
  customers: Array<Customer>;
  /** The name of the promo. */
  displayName: Scalars['String'];
  /** The date when the promo is applicable and can be used */
  effectiveFrom: Scalars['DateTime'];
  /** The date when the promo expires and is no longer valid. */
  effectiveTo: Scalars['DateTime'];
  /** Determines the combinability of promotion */
  exclusivity: PromoExclusivity;
  gcDepartureIds?: Maybe<Array<Scalars['ObjectId']>>;
  gcDepartures: Array<GcDeparture>;
  isGroupsOnly: Scalars['Boolean'];
  isHiddenFromSales: Scalars['Boolean'];
  isIndiesOnly: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  /** If true and the promotion targets specific customers, the promotion can be shared with all trips on the customers order. */
  isShareable: Scalars['Boolean'];
  /** Is the promo valid for use. */
  isValid: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  /** The maximum number of times the promo can be used. */
  maxRedemptions?: Maybe<Scalars['Int']>;
  /** The number of audiences that use this promo */
  nbAudiences?: Maybe<Scalars['Int']>;
  /** The promo offer's unique code. */
  offerCode: Scalars['String'];
  /** Denotes the promotion as either marketing, service recovery, loyalty, or none. */
  promoCategory: PromoCategory;
  /** The promo codes used to apply the promotion. */
  promoCodes: Array<Scalars['String']>;
  /** The number of times the promo has been used. */
  redemptions: Scalars['Int'];
  status: TripComponentStatus;
  /** The targets of the promo. */
  targets: Array<PromoTarget>;
  type: TripComponentType;
};

export enum PromoCategory {
  Loyalty = 'LOYALTY',
  Marketing = 'MARKETING',
  None = 'NONE',
  ServiceRecovery = 'SERVICE_RECOVERY'
}

export type PromoConfigContent = {
  __typename?: 'PromoConfigContent';
  campaignCode?: Maybe<Scalars['String']>;
  groupsCampaignCode?: Maybe<Scalars['String']>;
  groupsPromoCode?: Maybe<Scalars['String']>;
  maxSpotsRemainingThreshold?: Maybe<Scalars['Int']>;
  promoCode?: Maybe<Scalars['String']>;
};

export enum PromoExclusivity {
  Exclusive = 'EXCLUSIVE',
  None = 'NONE',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  SecondaryExclusive = 'SECONDARY_EXCLUSIVE'
}

export type PromoLineItem = LineItem & {
  __typename?: 'PromoLineItem';
  _id: Scalars['ObjectId'];
  campaignCode?: Maybe<Scalars['String']>;
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  offerCode: Scalars['String'];
  price: Money;
  promoCode: Scalars['String'];
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemCode?: Maybe<Scalars['LineItemCode']>;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  targetType?: Maybe<TripComponentType>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

export type PromoPaginatedResult = {
  __typename?: 'PromoPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Promo>;
};

/** Settings related to promotions and service recovery. */
export type PromoSettings = {
  __typename?: 'PromoSettings';
  /** Promo code for advanced repeat customer promotions */
  advancedRepeatPromoCode: Scalars['String'];
  /** Display name for advanced repeat customer promotions */
  advancedRepeatPromoName: Scalars['String'];
  /** Settings for repeat customer promotion thresholds */
  repeatThresholds: Array<RepeatThresholdSettings>;
  /** List of reasons for service recovery promotions. */
  serviceRecoveryReasons: Array<Scalars['String']>;
  /** Whether to use advanced repeat customer promotion logic */
  useAdvancedRepeatPromo: Scalars['Boolean'];
};

/** A product promo target. */
export type PromoTarget = {
  __typename?: 'PromoTarget';
  _id: Scalars['ObjectId'];
  /** The amount of the discount. */
  amount?: Maybe<Amount>;
  /** The offer code of the associated promo offer. */
  componentType: Scalars['String'];
  departureDateFrom?: Maybe<Scalars['Date']>;
  departureDateTo?: Maybe<Scalars['Date']>;
  /** The line item code being targeted. */
  lineItemCode?: Maybe<Scalars['LineItemCode']>;
  requiredComponent?: Maybe<PromoTargetRequiredComponent>;
  series?: Maybe<Scalars['Series']>;
};

/** The application status of the promo target. */
export enum PromoTargetApplicationStatus {
  Applied = 'APPLIED',
  Eligible = 'ELIGIBLE',
  NotEligible = 'NOT_ELIGIBLE'
}

/** A required component for a promo target. */
export type PromoTargetRequiredComponent = {
  __typename?: 'PromoTargetRequiredComponent';
  /** The type of trip component to target. */
  componentType: Scalars['String'];
  /** The specific line item code being targeted. */
  lineItemCode?: Maybe<Scalars['LineItemCode']>;
};

/** Required component for promo target */
export type PromoTargetRequiredComponentInput = {
  componentType: TripComponentType;
  lineItemCode?: InputMaybe<Scalars['LineItemCode']>;
};

export type PublishDraftBookingInput = {
  payments?: InputMaybe<Array<PaymentInput>>;
  staffSkipInsuranceValidationRequested?: InputMaybe<Scalars['Boolean']>;
};

export type PublishDraftBookingResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | IncentivesError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidInsurancePlanError | InvalidOrderError | InvalidPaymentError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type PublishDraftQuoteResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Quote | ValidationError;

export type PublishDraftTermResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ImmutableTermError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Term | ValidationError;

export type Query = {
  __typename?: 'Query';
  adjustment?: Maybe<Adjustment>;
  adjustmentByLineItemCode?: Maybe<Adjustment>;
  adjustments: AdjustmentPaginatedResult;
  /** A paginated list of GC departures. This query supports filtering cross collections. Note: Filtering across collections may impact performance. */
  aggregatedGcDepartures: GcDeparturePaginatedResult;
  airline?: Maybe<Airline>;
  /** Get an API key metadata by _id */
  apiKey?: Maybe<ApiKey>;
  asset?: Maybe<Asset>;
  /** Filter and paginate Assets */
  assets: AssetPaginatedResult;
  audience?: Maybe<Audience>;
  /** Returns a paginated list of audience members. */
  audienceMembers: AudienceMemberPaginatedResult;
  /** Returns a paginated list of audiences. */
  audiences: AudiencePaginatedResult;
  /** Returns a single booking by id */
  booking?: Maybe<Booking>;
  /** Returns a single trip by id */
  bookingTrip?: Maybe<BookingTrip>;
  /**
   * Returns a single trip by legacy id
   * @deprecated Use bookingTripById instead
   */
  bookingTripByLegacyId?: Maybe<BookingTrip>;
  /** Returns a paginated list of booking trips with optional filters */
  bookingTrips?: Maybe<BookingTripPaginatedResult>;
  /** Returns a paginated list of bookings */
  bookings: BookingPaginatedResult;
  /** Get a business by its code */
  business?: Maybe<Business>;
  /** Return all businesses */
  businesses: Array<Business>;
  campaign?: Maybe<Campaign>;
  /** Returns a paginated list of campaigns. */
  campaigns: CampaignPaginatedResult;
  /** Get a paginated list of categories */
  categories: CategoryPaginatedResult;
  category?: Maybe<Category>;
  checkCustomerEmail?: Maybe<CustomerCredentialOptions>;
  /** Contact information for the business and customer-facing departments */
  contactInfoContent?: Maybe<ContactInfoContent>;
  contentAncestors: Array<ContentAncestor>;
  /** Get a customer by id */
  customer?: Maybe<Customer>;
  /** Get a customer by id or legacy id */
  customerByLegacyId?: Maybe<Customer>;
  customerEvaluation?: Maybe<CustomerEvaluation>;
  /** Get a list of customer evaluations based on the provided filters */
  customerEvaluations?: Maybe<CustomerEvaluationPaginatedResult>;
  /** Retrieve customer incentives including referral code and program details. Tries the live API first; falls back to cached data when the API is unavailable. */
  customerIncentives?: Maybe<CustomerIncentives>;
  /** Returns a paginated list of customers */
  customers: CustomerPaginatedResult;
  departure?: Maybe<Departure>;
  departureByProdTour?: Maybe<Departure>;
  departureBySalesTour?: Maybe<Departure>;
  departures: DeparturePaginatedResult;
  /** Returns a single draft order by id */
  draftOrder?: Maybe<DraftOrder>;
  employee?: Maybe<Employee>;
  employees: EmployeePaginatedResult;
  /** Returns an estimated cancellation summary for the given booking trips. Does not perform any actual cancellation. */
  estimateBookingTripsCancellationSummary?: Maybe<BookingTripsCancellationEstimatedSummary>;
  evaluation?: Maybe<EvaluationResult>;
  experimentalLead?: Maybe<ExperimentalLead>;
  experimentalLeads: ExperimentalLeadPaginatedResult;
  extendedStay?: Maybe<ExtendedStay>;
  extendedStays: ExtendedStayPaginatedResult;
  faqContent?: Maybe<FaqContent>;
  fee?: Maybe<Fee>;
  feeByType?: Maybe<Fee>;
  fees: FeePaginatedResult;
  /** Get flight booking result by ID for checking booking status. */
  flightBookingResult?: Maybe<FlightBookingResult>;
  flightPackage?: Maybe<FlightPackage>;
  flightPackageByLineItemCode?: Maybe<FlightPackage>;
  flightPackages: FlightPackagePaginatedResult;
  /** Returns a single flight shop component by ID */
  flightShop?: Maybe<FlightShop>;
  /** Returns a paginated list of flight shopping eligibility result records, filtered by orderId and/or status. */
  flightShopEligibilityResult: FlightShopEligibilityResultPaginatedResult;
  /** Look up flight shopping information for a user selecting their flights */
  flightShopResult?: Maybe<FlightShoppingResult>;
  /** Returns a paginated list of flight shop components */
  flightShops: FlightShopPaginatedResult;
  futureGCDepartureProspects: Array<GcDepartureProspect>;
  futureGCDepartureProspectsByGCAndProspect: Array<GcDepartureProspect>;
  gateway?: Maybe<Gateway>;
  gateways: GatewayPaginatedResult;
  gcDeparture?: Maybe<GcDeparture>;
  gcDepartureMeeting?: Maybe<GcDepartureMeeting>;
  gcDepartureMeetingRSVP?: Maybe<GcDepartureMeetingRsvp>;
  gcDepartureMeetingRSVPs: GcDepartureMeetingRsvpPaginatedResult;
  gcDepartureMeetings: GcDepartureMeetingPaginatedResult;
  gcDepartureProspect?: Maybe<GcDepartureProspect>;
  gcDepartureProspects: GcDepartureProspectPaginatedResult;
  gcDepartureQuoteSummary?: Maybe<GcDepartureQuoteSummary>;
  gcDepartures: GcDeparturePaginatedResult;
  gcProfileContent?: Maybe<GcProfileContent>;
  /** Get a summary of a customer's global rewards status and points. Returns null if the provided ID is invalid or not enrolled in Global Rewards */
  globalRewardsSummary?: Maybe<GlobalRewardsSummary>;
  insurancePlan?: Maybe<InsurancePlan>;
  insurancePlans: InsurancePlanPaginatedResult;
  insurancePolicies: InsurancePolicyPaginatedResult;
  insurancePolicy?: Maybe<InsurancePolicy>;
  /** Find the latest published term by market and type. */
  latestTerm?: Maybe<Term>;
  /** Returns the current user associated with the given session */
  me?: Maybe<User>;
  micrositeContent?: Maybe<MicrositeContent>;
  /** Get a summary of the current customer. Returns null if the current user is not a customer or the customer is not enrolled in Global Rewards */
  myGlobalRewardsSummary?: Maybe<GlobalRewardsSummary>;
  notes: NotePaginatedResult;
  /** Find an OAuth client by its _id */
  oauthClient?: Maybe<OAuthClient>;
  /** List all registered OAuth clients */
  oauthClients: Array<OAuthClient>;
  /** Returns a single pre-2018 trip by id */
  oldTrip?: Maybe<OldTrip>;
  /** Returns a paginated list of quotes suitable for display on an opportunity, whether the quote belongs to the opportunity or the customer to whom the opportunity is assigned */
  opportunityQuotes: OpportunityQuotePaginatedResult;
  /** Returns a single order by id */
  order?: Maybe<Order>;
  /**
   * Returns line item history for a single order by order id
   * @deprecated Use orderLineItemHistory instead
   */
  orderHistory?: Maybe<Array<OrderLineItemHistoryEntry>>;
  /** Returns line item history for a single order by order id */
  orderLineItemHistory?: Maybe<Array<OrderLineItemHistoryEntry>>;
  /** Returns tsa history for a single order by order id */
  orderTSAHistory?: Maybe<Array<OrderTsaHistoryEntry>>;
  /** Returns trip history for a single order by order id */
  orderTripHistory: Array<OrderTripHistoryEntry>;
  /** Returns a paginated list of orders */
  orders: OrderPaginatedResult;
  pastGCDepartureProspects: Array<GcDepartureProspect>;
  paymentReconciliationTransactions: PaymentReconciliationTransactionPaginatedResult;
  paymentReconciliationUpload?: Maybe<PaymentReconciliationUpload>;
  paymentReconciliationUploads: PaymentReconciliationUploadPaginatedResult;
  /** Returns paginated payment transactions based on filter criteria */
  paymentTransactions: PaymentTransactionPaginatedResult;
  permissions: Array<Permission>;
  /** Get a place by _id */
  place?: Maybe<Place>;
  /** Get a list of places */
  places: PlacePaginatedResult;
  promo?: Maybe<Promo>;
  promoConfigContent?: Maybe<PromoConfigContent>;
  /** Returns a paginated list of promos, with optional filtering by audiences */
  promos: PromoPaginatedResult;
  /** Returns a single quote by id */
  quote?: Maybe<Quote>;
  /** Returns a paginated list of quotes */
  quotes: QuotePaginatedResult;
  /** Returns potential roommates for a trip based on search criteria */
  requestableRoommates: Array<RequestableRoommate>;
  /** Returns potential travel companions for a trip based on search criteria */
  requestableTravelCompanions: Array<RequestableTravelCompanion>;
  /** Returns a set of reservation document file metadata. */
  reservationDocuments: Array<ReservationDocument>;
  /** Returns a single review */
  review?: Maybe<Review>;
  /** Get the summary of reviews for a set of tours codes */
  reviewAggregate?: Maybe<ReviewAggregate>;
  reviews: ReviewPaginatedResult;
  role?: Maybe<Role>;
  roles: RolePaginatedResult;
  savedPaymentMethod?: Maybe<SavedPaymentMethod>;
  /** Get a user's saved places with optional filtering and pagination */
  savedPlaces: SavedPlacePaginatedResult;
  searchFeeCategoryCodes: Array<Scalars['String']>;
  /** Get public help center articles that match the query string. */
  searchHelpCenter?: Maybe<HelpCenterArticleResponse>;
  /** Returns a paginated list of service recoveries. */
  serviceRecoveries: ServiceRecoveryPaginatedResult;
  serviceRecovery?: Maybe<ServiceRecovery>;
  stayCities: StayCityPaginatedResult;
  tag?: Maybe<Tag>;
  /** Get a paginated list of tags */
  tags: TagPaginatedResult;
  term?: Maybe<Term>;
  /** Get terms paginated with filters */
  terms: TermPaginatedResult;
  tour?: Maybe<Tour>;
  tourContent?: Maybe<TourContent>;
  tourContentByFullSlug?: Maybe<TourContent>;
  tourContentByTourCode?: Maybe<TourContent>;
  tourContents: TourContentPaginatedResult;
  /** Get a tour director by id */
  tourDirector?: Maybe<TourDirector>;
  tourDirectorDepartureEvaluationSummary?: Maybe<DepartureEvaluationSummary>;
  tourDirectorEvaluationSummary?: Maybe<TourDirectorEvaluationSummary>;
  tourDirectorTourEndReport?: Maybe<TourDirectorTourEndReport>;
  /** Get a list of tour end reports based on the provided filters */
  tourDirectorTourEndReports?: Maybe<TourEndReportPaginatedResult>;
  /** Get a list of tour directors based on the provided filters */
  tourDirectors: TourDirectorPaginatedResult;
  tourExcursion?: Maybe<TourExcursion>;
  tourExcursionSpec?: Maybe<TourExcursionSpec>;
  tourExcursionSpecs: TourExcursionSpecPaginatedResult;
  tourExcursions: TourExcursionPaginatedResult;
  tourExtension?: Maybe<TourExtension>;
  /** Get a paginated list of Tour Extensions */
  tourExtensions: TourExtensionPaginatedResult;
  tourPageContent?: Maybe<TourPageContent>;
  tourPagesContent: TourPagePaginatedResult;
  /** Search for tours using semantic vector search with optional reranking */
  tourSearch?: Maybe<TourSearchResult>;
  tourSpec?: Maybe<TourSpec>;
  tourSpecs: TourSpecPaginatedResult;
  tours: TourPaginatedResult;
  /** Returns a paginated list of TripChecklistItemTemplates */
  tripChecklistItemTemplates: TripChecklistItemTemplatePaginatedResult;
  /** Search for reviews using semantic vector search with optional reranking */
  vectorSearchReviews: Array<ReviewVectorSearchResult>;
  /** Search for tour content using semantic vector search with optional reranking */
  vectorSearchTourContent: Array<TourContentVectorSearchResult>;
  /** Search for tour page search hits using semantic vector search with optional reranking */
  vectorSearchTourPageSearchHits: Array<TourPageSearchHitVectorSearchResult>;
  voucher?: Maybe<Voucher>;
  vouchers: VoucherPaginatedResult;
};


export type QueryAdjustmentArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryAdjustmentByLineItemCodeArgs = {
  lineItemCode: Scalars['LineItemCode'];
};


export type QueryAdjustmentsArgs = {
  filter?: InputMaybe<FilterAdjustmentInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortAdjustmentInput>;
};


export type QueryAggregatedGcDeparturesArgs = {
  filter?: InputMaybe<FilterGcDepartureAggregateQueryInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortGcDepartureInput>;
};


export type QueryAirlineArgs = {
  code: Scalars['String'];
};


export type QueryApiKeyArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryAssetArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryAssetsArgs = {
  filter?: InputMaybe<AssetFilterInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryAudienceArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryAudienceMembersArgs = {
  filter?: InputMaybe<FilterAudienceMemberInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryAudiencesArgs = {
  filter?: InputMaybe<FilterAudienceInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryBookingArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryBookingTripArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryBookingTripByLegacyIdArgs = {
  id: Scalars['String'];
};


export type QueryBookingTripsArgs = {
  filter?: InputMaybe<FilterBookingTripInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryBookingsArgs = {
  filter?: InputMaybe<FilterBookingInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortBookingInput>;
};


export type QueryBusinessArgs = {
  code: BusinessCode;
};


export type QueryCampaignArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryCampaignsArgs = {
  filter?: InputMaybe<FilterCampaignInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryCategoriesArgs = {
  filter?: InputMaybe<FilterCategoryInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryCategoryArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryCheckCustomerEmailArgs = {
  email: Scalars['String'];
};


export type QueryContactInfoContentArgs = {
  businessCode: BusinessCode;
  language: Scalars['String'];
};


export type QueryContentAncestorsArgs = {
  businessCode: BusinessCode;
  fullSlug: Scalars['String'];
  language: Scalars['String'];
};


export type QueryCustomerArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryCustomerByLegacyIdArgs = {
  id: Scalars['String'];
};


export type QueryCustomerEvaluationArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryCustomerEvaluationsArgs = {
  filter?: InputMaybe<FilterCustomerEvaluationInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortCustomerEvaluationInput>;
};


export type QueryCustomerIncentivesArgs = {
  businessCode: BusinessCode;
  customerId: Scalars['ObjectId'];
};


export type QueryCustomersArgs = {
  filter?: InputMaybe<FilterCustomerInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryDepartureArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryDepartureByProdTourArgs = {
  prodTourId: Scalars['Int'];
};


export type QueryDepartureBySalesTourArgs = {
  salesTourId: Scalars['String'];
};


export type QueryDeparturesArgs = {
  filter?: InputMaybe<FilterDepartureInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortDepartureInput>;
};


export type QueryDraftOrderArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryEmployeeArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryEmployeesArgs = {
  filter?: InputMaybe<FilterEmployeeInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortEmployeeInput>;
};


export type QueryEstimateBookingTripsCancellationSummaryArgs = {
  input: EstimateBookingTripsCancellationSummaryInput;
};


export type QueryEvaluationArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryExperimentalLeadArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryExperimentalLeadsArgs = {
  filter?: InputMaybe<FilterExperimentalLeadInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryExtendedStayArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryExtendedStaysArgs = {
  filter?: InputMaybe<FilterExtendedStayInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryFaqContentArgs = {
  businessCode: BusinessCode;
  language: Scalars['String'];
  uuid: Scalars['String'];
};


export type QueryFeeArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryFeeByTypeArgs = {
  businessCode: BusinessCode;
  categoryCode: Scalars['String'];
  typeCode: FeeTypeCode;
};


export type QueryFeesArgs = {
  filter?: InputMaybe<FilterFeeInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortFeeInput>;
};


export type QueryFlightBookingResultArgs = {
  id: Scalars['ObjectId'];
};


export type QueryFlightPackageArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryFlightPackageByLineItemCodeArgs = {
  lineItemCode: Scalars['LineItemCode'];
};


export type QueryFlightPackagesArgs = {
  filter?: InputMaybe<FilterFlightPackageInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryFlightShopArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryFlightShopEligibilityResultArgs = {
  filter?: InputMaybe<FilterFlightShopEligibilityResultInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryFlightShopResultArgs = {
  id: Scalars['ObjectId'];
};


export type QueryFlightShopsArgs = {
  filter?: InputMaybe<FilterFlightShopInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryFutureGcDepartureProspectsArgs = {
  businessCode: BusinessCode;
  groupCoordinatorCustomerId: Scalars['ObjectId'];
};


export type QueryFutureGcDepartureProspectsByGcAndProspectArgs = {
  groupCoordinatorCustomerId: Scalars['ObjectId'];
  prospectCustomerId: Scalars['ObjectId'];
};


export type QueryGatewayArgs = {
  code: Scalars['String'];
};


export type QueryGatewaysArgs = {
  filter?: InputMaybe<FilterGatewayInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryGcDepartureArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryGcDepartureMeetingArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryGcDepartureMeetingRsvpArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryGcDepartureMeetingRsvPsArgs = {
  filter?: InputMaybe<FilterGcDepartureMeetingRsvpInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortGcDepartureMeetingRsvpInput>;
};


export type QueryGcDepartureMeetingsArgs = {
  filter?: InputMaybe<FilterGcDepartureMeetingInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryGcDepartureProspectArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryGcDepartureProspectsArgs = {
  filter?: InputMaybe<FilterGcDepartureProspectInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortGcDepartureProspectInput>;
};


export type QueryGcDepartureQuoteSummaryArgs = {
  input: GcDepartureQuoteSummaryInput;
};


export type QueryGcDeparturesArgs = {
  filter?: InputMaybe<FilterGcDepartureInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortGcDepartureInput>;
};


export type QueryGcProfileContentArgs = {
  businessCode: BusinessCode;
  fullSlug: Scalars['String'];
  language: Scalars['String'];
};


export type QueryGlobalRewardsSummaryArgs = {
  globalRewardsId: Scalars['String'];
};


export type QueryInsurancePlanArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryInsurancePlansArgs = {
  filter?: InputMaybe<FilterInsurancePlanInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortInsurancePlanInput>;
};


export type QueryInsurancePoliciesArgs = {
  filter?: InputMaybe<FilterInsurancePolicyInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortInsurancePolicyInput>;
};


export type QueryInsurancePolicyArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryLatestTermArgs = {
  businessCode: BusinessCode;
  market: TermMarket;
  termType: TermType;
};


export type QueryMicrositeContentArgs = {
  businessCode: BusinessCode;
  fullSlug: Scalars['String'];
  language: Scalars['String'];
};


export type QueryNotesArgs = {
  filter?: InputMaybe<FilterNoteInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryOauthClientArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryOldTripArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryOpportunityQuotesArgs = {
  filter: FilterOpportunityQuotesInput;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortOpportunityQuoteInput>;
};


export type QueryOrderArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryOrderHistoryArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryOrderLineItemHistoryArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryOrderTsaHistoryArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryOrderTripHistoryArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<FilterOrderInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryPastGcDepartureProspectsArgs = {
  businessCodes?: InputMaybe<Array<BusinessCode>>;
  groupCoordinatorCustomerId: Scalars['ObjectId'];
};


export type QueryPaymentReconciliationTransactionsArgs = {
  filter?: InputMaybe<FilterPaymentReconciliationTransactionInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortPaymentReconciliationTransactionInput>;
};


export type QueryPaymentReconciliationUploadArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryPaymentReconciliationUploadsArgs = {
  filter?: InputMaybe<FilterPaymentReconciliationUploadInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryPaymentTransactionsArgs = {
  filter?: InputMaybe<FilterPaymentTransactionInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryPlaceArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryPlacesArgs = {
  filter?: InputMaybe<PlaceFilterInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<PlaceSortInput>;
};


export type QueryPromoArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryPromoConfigContentArgs = {
  businessCode: BusinessCode;
  language: Scalars['String'];
};


export type QueryPromosArgs = {
  filter?: InputMaybe<FilterPromoInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryQuoteArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryQuotesArgs = {
  filter?: InputMaybe<FilterQuoteInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortQuoteInput>;
};


export type QueryRequestableRoommatesArgs = {
  query: Scalars['String'];
  roomType: RoomTourType;
  tripId: Scalars['ObjectId'];
};


export type QueryRequestableTravelCompanionsArgs = {
  query: Scalars['String'];
  tripId: Scalars['ObjectId'];
};


export type QueryReservationDocumentsArgs = {
  reservationIds: Array<Scalars['Int']>;
};


export type QueryReviewArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryReviewAggregateArgs = {
  businessCode: BusinessCode;
  tourCodes: Array<Scalars['String']>;
};


export type QueryReviewsArgs = {
  filter?: InputMaybe<ReviewFilterInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<ReviewSortInput>;
};


export type QueryRoleArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryRolesArgs = {
  filter?: InputMaybe<FilterRoleInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QuerySavedPaymentMethodArgs = {
  _id: Scalars['ObjectId'];
};


export type QuerySavedPlacesArgs = {
  filter?: InputMaybe<SavedPlaceFilterInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QuerySearchFeeCategoryCodesArgs = {
  businessCode?: InputMaybe<BusinessCode>;
  query: Scalars['String'];
};


export type QuerySearchHelpCenterArgs = {
  businessCode: BusinessCode;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QueryServiceRecoveriesArgs = {
  filter?: InputMaybe<FilterServiceRecoveryInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryServiceRecoveryArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryStayCitiesArgs = {
  filter?: InputMaybe<FilterStayCityInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryTagArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryTagsArgs = {
  filter?: InputMaybe<FilterTagInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryTermArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryTermsArgs = {
  filter?: InputMaybe<TermFilterInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<TermSortInput>;
};


export type QueryTourArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryTourContentArgs = {
  businessCode: BusinessCode;
  id: Scalars['String'];
  language: Scalars['String'];
};


export type QueryTourContentByFullSlugArgs = {
  businessCode: BusinessCode;
  fullSlug: Scalars['String'];
  language: Scalars['String'];
};


export type QueryTourContentByTourCodeArgs = {
  businessCode: BusinessCode;
  language: Scalars['String'];
  tourCode: Scalars['String'];
  tourYear: Scalars['Int'];
};


export type QueryTourContentsArgs = {
  filter: FilterTourContentInput;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryTourDirectorArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryTourDirectorDepartureEvaluationSummaryArgs = {
  departureId: Scalars['ObjectId'];
  tourDirectorId: Scalars['ObjectId'];
};


export type QueryTourDirectorEvaluationSummaryArgs = {
  businessCode?: InputMaybe<BusinessCode>;
  tourDirectorId: Scalars['ObjectId'];
};


export type QueryTourDirectorTourEndReportArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryTourDirectorTourEndReportsArgs = {
  filter?: InputMaybe<FilterTourEndReportInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortTourEndReportInput>;
};


export type QueryTourDirectorsArgs = {
  filter?: InputMaybe<FilterTourDirectorInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortTourDirectorInput>;
};


export type QueryTourExcursionArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryTourExcursionSpecArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryTourExcursionSpecsArgs = {
  filter?: InputMaybe<FilterTourExcursionSpecInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryTourExcursionsArgs = {
  filter?: InputMaybe<FilterTourExcursionInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortTourExcursionInput>;
};


export type QueryTourExtensionArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryTourExtensionsArgs = {
  filter?: InputMaybe<FilterTourExtensionInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortTourExtensionInput>;
};


export type QueryTourPageContentArgs = {
  alternateYearTourId?: InputMaybe<Scalars['String']>;
  businessCode: BusinessCode;
  fullSlug: Scalars['String'];
  language: Scalars['String'];
};


export type QueryTourPagesContentArgs = {
  filter: FilterTourPageContentInput;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryTourSearchArgs = {
  input: TourSearchInput;
};


export type QueryTourSpecArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryTourSpecsArgs = {
  filter?: InputMaybe<FilterTourSpecInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryToursArgs = {
  filter?: InputMaybe<FilterTourInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortTourInput>;
};


export type QueryTripChecklistItemTemplatesArgs = {
  filter?: InputMaybe<FilterTripChecklistItemTemplateInput>;
  pagination?: InputMaybe<PaginateInput>;
};


export type QueryVectorSearchReviewsArgs = {
  input: ReviewSearchInput;
};


export type QueryVectorSearchTourContentArgs = {
  input: TourContentSearchInput;
};


export type QueryVectorSearchTourPageSearchHitsArgs = {
  input: TourPageSearchHitSearchInput;
};


export type QueryVoucherArgs = {
  _id: Scalars['ObjectId'];
};


export type QueryVouchersArgs = {
  filter?: InputMaybe<FilterVoucherInput>;
  pagination?: InputMaybe<PaginateInput>;
  sort?: InputMaybe<SortVoucherInput>;
};

/** An order in the Quote stage */
export type Quote = Order & {
  __typename?: 'Quote';
  _id: Scalars['ObjectId'];
  /** The authorized saved payment methods for all travelers regardless of trip status that can be used to pay for this order. Staff-only. */
  allTravelersSavedPaymentMethods: Array<SavedPaymentMethod>;
  /** Sum of total successful transactions */
  amountPaid: Money;
  averageTotalPerTrip: Money;
  /** Grand total less the amount already paid */
  balance: Money;
  businessCode: BusinessCode;
  /** Maximum age travelers can be to travel with this business */
  businessMaximumAgeForTraveler?: Maybe<Scalars['Int']>;
  /** Minimum age travelers must be to travel with this business */
  businessMinimumAgeForTraveler?: Maybe<Scalars['Int']>;
  /** Whether the order allows room combinations where there are fewer sellable spots than bed capacity. */
  canBookPartialRooms: Scalars['Boolean'];
  checkoutOptions: Array<QuoteCheckoutOption>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The currency code of the order. */
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  /** The customer who initiated the booking. */
  customerId?: Maybe<Scalars['ObjectId']>;
  departure?: Maybe<Departure>;
  /** The departure id of the order. */
  departureId: Scalars['ObjectId'];
  expirationDate: Scalars['DateTime'];
  /** The extended date the final payment is due for the order. */
  extendedFinalPaymentDate?: Maybe<Scalars['Date']>;
  /** The possible room combinations for the order given the number of trips opted in, the extension's rooms, and the primary trip's room offers. */
  extensionRoomingCombinations: RoomingCombinations;
  /** The date the final installment for app is due for the order. */
  finalInstallmentDate: Scalars['Date'];
  /** The date the final payment is due for the order. */
  finalPaymentDate: Scalars['Date'];
  gcDeparture?: Maybe<GcDeparture>;
  /** The id of the gc departure associated with the order. */
  gcDepartureId?: Maybe<Scalars['ObjectId']>;
  /** Sum of all line item prices */
  grandTotal: Money;
  /** Sum of all line item prices without discounts applied */
  grandTotalBeforeDiscount: Money;
  /** Sum of all line items excluding flights */
  grandTotalWithoutFlights: Money;
  /** Available offers for inbound airport transfers for the order. */
  inboundAirportTransferOffers: Array<TourAirportTransferOffer>;
  /** Sum of all insuranceTotal on open trips */
  insuranceTotal: Money;
  isExpired: Scalars['Boolean'];
  /** Indicates if the final payment date has been extended. */
  isFinalPaymentDateExtended: Scalars['Boolean'];
  /** Whether the quote has been flagged to be revisited by or shared with the customer */
  isSaved?: Maybe<Scalars['Boolean']>;
  /** The latest date the final installment for app is due for the order. */
  latestFinalInstallmentDate: Scalars['Date'];
  /** The latest date the final payment is due for the order. */
  latestFinalPaymentDate: Scalars['Date'];
  /** The maximum points the current customer can redeem. */
  maxRedeemableReferralTravelBankPoints?: Maybe<Scalars['Float']>;
  /** The minimum amount due today to enroll in an automatic payment plan. */
  minimumAmountDueToEnrollInPaymentPlan: Money;
  opportunityId?: Maybe<Scalars['String']>;
  /** Available offers for outbound airport transfers for the order. */
  outboundAirportTransferOffers: Array<TourAirportTransferOffer>;
  /** How the quote was started. */
  quoteMethod?: Maybe<QuoteMethod>;
  /** The order that this order was rebooked from. */
  rebookedFromOrder?: Maybe<Order>;
  /** The order id that this order was rebooked from. */
  rebookedFromOrderId?: Maybe<Scalars['ObjectId']>;
  /** Whether the multi traveler rooms available for the order requires a roommate request. */
  requiresRoommateRequest: Scalars['Boolean'];
  /** The possible room combinations for the order given the number of trips, the departure's rooms, and the primary trip's room offers. */
  roomingCombinations: RoomingCombinations;
  /**
   * The saved payment methods for the primary trip's customer that can be used to pay for this order.
   * @deprecated Returns all saved payment methods for the primary trip's customer. If authenticated as a customer, it is favorable to use customer.savedPaymentMethods instead.
   */
  savedPaymentMethods: Array<SavedPaymentMethod>;
  /** The stage of the order. */
  stage: OrderStage;
  /** Sum of all discount line items */
  totalDiscount: Money;
  tourLineItemCode?: Maybe<Scalars['LineItemCode']>;
  /** The transactions applied to the order, sorted by ascending transaction date. */
  transactions: Array<PaymentTransaction>;
  trips: Array<QuoteTrip>;
  /** The trips of the quoted order sorted by primary trip first. */
  tripsSortedByPrimary: Array<QuoteTrip>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Validation errors that will prevent the quote from being booked */
  validationErrors: Array<QuoteBookingDepartureValidationError>;
  /** The version of the order. */
  versionId: Scalars['Int'];
  /** Whether the quote will be waitlisted based on whether waitlist is allowed and the remaining capacity. If waitlist is accepted when booking and capacities have not changed, the booking will be waitlisted */
  willWaitlist: Scalars['Boolean'];
};


/** An order in the Quote stage */
export type QuoteAllTravelersSavedPaymentMethodsArgs = {
  includeUnauthorized?: InputMaybe<Scalars['Boolean']>;
};


/** An order in the Quote stage */
export type QuoteMaxRedeemableReferralTravelBankPointsArgs = {
  customerId?: InputMaybe<Scalars['ObjectId']>;
};


/** An order in the Quote stage */
export type QuoteSavedPaymentMethodsArgs = {
  includeUnauthorized?: InputMaybe<Scalars['Boolean']>;
};

export type QuoteAutopayCheckoutOption = {
  __typename?: 'QuoteAutopayCheckoutOption';
  allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>;
  amount: Money;
  earliestPaymentScheduleStartDate: Scalars['Date'];
  latestPaymentScheduleStartDate: Scalars['Date'];
  riskFreePeriodEndDate: Scalars['Date'];
  type: QuoteCheckoutType;
};

/** A validation error that will prevent a quote from being booked */
export type QuoteBookingDepartureValidationError = {
  __typename?: 'QuoteBookingDepartureValidationError';
  code: QuoteBookingDepartureValidationErrorCode;
  message: Scalars['String'];
};

export enum QuoteBookingDepartureValidationErrorCode {
  DuplicateCustomerOnTrip = 'DUPLICATE_CUSTOMER_ON_TRIP',
  UnbookableDepartureCapacity = 'UNBOOKABLE_DEPARTURE_CAPACITY',
  UnbookableDepartureStatus = 'UNBOOKABLE_DEPARTURE_STATUS',
  UnpurchasableDepartureItem = 'UNPURCHASABLE_DEPARTURE_ITEM',
  WaitlistNotAccepted = 'WAITLIST_NOT_ACCEPTED'
}

/** The type of payment methods allows for a checkout option for a Quote */
export enum QuoteCheckoutAllowedPaymentMethodType {
  Ach = 'ACH',
  CreditCard = 'CREDIT_CARD',
  DebitCard = 'DEBIT_CARD'
}

export type QuoteCheckoutOption = QuoteAutopayCheckoutOption | QuoteManualCheckoutOption;

/** The type of checkout option for a Quote */
export enum QuoteCheckoutType {
  AutoPay = 'AUTO_PAY',
  Manual = 'MANUAL',
  PayInFull = 'PAY_IN_FULL'
}

export type QuoteManualCheckoutOption = {
  __typename?: 'QuoteManualCheckoutOption';
  allowedPaymentMethods: Array<QuoteCheckoutAllowedPaymentMethodType>;
  /** The amount required to book based on checkout option. For AUTO_PAY, this is the APP deposit. For PAY_IN_FULL, this is the grand total. */
  amount: Money;
  commonFees: Array<FeeApplicationInfo>;
  riskFreePeriodEndDate: Scalars['Date'];
  type: QuoteCheckoutType;
};

export enum QuoteMethod {
  Mobile = 'MOBILE',
  Offline = 'OFFLINE',
  Web = 'WEB'
}

export type QuotePaginatedResult = {
  __typename?: 'QuotePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Quote>;
};

export enum QuoteSortField {
  CreatedAt = 'createdAt',
  DepartureDate = 'departureDate',
  ExpirationDate = 'expirationDate',
  UpdatedAt = 'updatedAt'
}

/** A trip on a quote */
export type QuoteTrip = Trip & {
  __typename?: 'QuoteTrip';
  _id: Scalars['ObjectId'];
  /** The address for the trip. */
  address?: Maybe<Address>;
  /** The age of the traveler at departure date, inclusive of any pre-extension */
  ageAtDeparture?: Maybe<Scalars['Int']>;
  /** The applied promos with the number of times they have been applied to the trip. */
  appliedPromosWithCount: Array<AppliedPromoWithCount>;
  /** The exclusivities of promos that can be added to the trip. */
  availablePromoExclusivities: Array<PromoExclusivity>;
  businessCode?: Maybe<BusinessCode>;
  /** The estimated cancellation fee and effective DPD for the trip. */
  cancellationFeeEstimation?: Maybe<CancellationFeeEstimation>;
  /** Offers that can be applied to the trip but are not specific to a single component. Flight package offers are not included. */
  conditionalOffers: Array<ConditionalOffer>;
  /** The currency code of the trip. */
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  /** The customer id of the trip. */
  customerId?: Maybe<Scalars['ObjectId']>;
  /** The customer's loyalty level for the business matching this trip's order */
  customerLoyaltyLevel?: Maybe<LoyaltyLevel>;
  customerType: TripCustomerType;
  /** Offers for departing flights that can be added to the trip. */
  departingFlightOffers: Array<FlightOffer>;
  departure?: Maybe<Departure>;
  /** The trip's actual departure date, inclusive of any departing flight */
  departureDate: Scalars['Date'];
  /** The net deposit amount for the trip. */
  depositAmount: Money;
  /** The emergency contacts for the trip. */
  emergencyContacts?: Maybe<Array<EmergencyContact>>;
  /** The trip's actual end date, inclusive of any returning flight */
  endDate: Scalars['Date'];
  /** Offers for excursions that can be added to the trip. Includes extension excursions if the trip is booked on the extension. */
  excursionOffers: Array<DepartureExcursionOffer>;
  /** The departure excursions and extension excursions for the open excursion line items on this trip */
  excursions: Array<DepartureExcursion>;
  /** Sum of all open excursion line items */
  excursionsTotal: Money;
  /** The departure extension for the open extension line item on this trip */
  extension?: Maybe<DepartureExtension>;
  /** Offer for an extension that can be added to the trip. */
  extensionOffer?: Maybe<DepartureExtensionOffer>;
  /** The departure room for the open extension room line item on this trip */
  extensionRoom?: Maybe<DepartureRoom>;
  extensionRoommateTrips?: Maybe<Array<Trip>>;
  extensionRoommates?: Maybe<Array<Customer>>;
  /** The total fees amount for the trip. */
  feesTotal: Money;
  /** @deprecated Use grossFlightPackagePrice instead */
  flightPackagePrice?: Maybe<Money>;
  grandTotal: Money;
  /** The total flight package price for the trip. */
  grossFlightPackagePrice?: Maybe<Money>;
  /** The total tour price with flights and private group if applicable. */
  grossTourTotalWithFlights: Money;
  hasAddress: Scalars['Boolean'];
  hasConfirmedDocumentInformation: Scalars['Boolean'];
  hasConfirmedTravelerInformation: Scalars['Boolean'];
  hasDepartingFlightDeviation: Scalars['Boolean'];
  hasEmergencyContacts: Scalars['Boolean'];
  /** Whether the trip has an open line item for an extension */
  hasExtension: Scalars['Boolean'];
  hasInsurance: Scalars['Boolean'];
  hasReturningFlightDeviation: Scalars['Boolean'];
  hasTsaInformation: Scalars['Boolean'];
  /** Available inbound airport transfer offers for the trip, based on the active departure extension when applicable, otherwise on the main tour. */
  inboundAirportTransferOffers: Array<TourAirportTransferOffer>;
  /** The travel companion requests from other trips on the same departure that request this trip. */
  incomingTravelCompanionRequests: Array<TravelCompanionRequest>;
  /** The insurance eligibility status for this trip */
  insuranceEligibilityStatus: InsuranceEligibilityStatus;
  insurancePlanOffers: Array<InsurancePlanOffer>;
  /** The total insurance amount for the trip after adjustments. */
  insuranceTotal?: Maybe<Money>;
  /** Whether the trip is cancelled. */
  isCancelled: Scalars['Boolean'];
  /** Whether the trip is confirmed. */
  isConfirmed: Scalars['Boolean'];
  isEligibleToSubmitTravelCompanionRequests?: Maybe<Scalars['Boolean']>;
  /** Whether the trip is eligible for an inbound airport transfer */
  isInboundAirportTransferEligible: Scalars['Boolean'];
  isLandOnly: Scalars['Boolean'];
  /** Whether the trip is open. */
  isOpen: Scalars['Boolean'];
  /** Whether the trip is eligible for an outbound airport transfer */
  isOutboundAirportTransferEligible: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  /** Whether the proof of insurance document is available for this traveler */
  isProofOfInsuranceDocumentAvailable: Scalars['Boolean'];
  /** Whether the trip is quoted. */
  isQuoted: Scalars['Boolean'];
  /** Whether the trip is rebooked. */
  isRebooked: Scalars['Boolean'];
  /** Whether the trip is requested. */
  isRequested: Scalars['Boolean'];
  /** Whether the trip is waitlisted. */
  isWaitlisted: Scalars['Boolean'];
  /** The latest inbound airport transfer line item for the trip with status REBOOKED, PENDING_CANCELLATION, or CANCELLED. */
  latestRemovedInboundAirportTransferLineItem?: Maybe<TourAirportTransferLineItem>;
  /** The latest outbound airport transfer line item for the trip with status REBOOKED, PENDING_CANCELLATION, or CANCELLED. */
  latestRemovedOutboundAirportTransferLineItem?: Maybe<TourAirportTransferLineItem>;
  /** The line items that compose the trip. */
  lineItems: Array<LineItem>;
  /** The REBOOKED + OPEN line items if the trip is rebooked, the CANCELLED + OPEN line items with PARENT_TRIP_CANCELLED cancellation metadata if the trip is cancelled, or the open line items in all other cases.  */
  lineItemsMatchingTripStatus: Array<LineItem>;
  /** The maximum number of extension roommate requests that can be made for the trip. */
  maximumExtensionRoommateRequests: Scalars['Int'];
  /** The maximum number of main tour roommate requests that can be made for the trip. */
  maximumRoommateRequests: Scalars['Int'];
  openAdjustmentLineItems: Array<AdjustmentLineItem>;
  openAirportTransferLineItems: Array<TourAirportTransferLineItem>;
  openDepartingFlightLineItem?: Maybe<FlightPackageLineItem>;
  openExcursionLineItems: Array<TourExcursionLineItem>;
  openExtensionLineItem?: Maybe<TourExtensionLineItem>;
  openExtensionRoomLineItem?: Maybe<TourRoomLineItem>;
  openFeeLineItems: Array<FeeLineItem>;
  openFlightShopLineItem?: Maybe<FlightShopLineItem>;
  /** The open inbound airport transfer line item for the trip. */
  openInboundAirportTransferLineItem?: Maybe<TourAirportTransferLineItem>;
  openInsuranceAddonLineItems: Array<InsuranceAddonLineItem>;
  openInsuranceLineItem?: Maybe<InsuranceLineItem>;
  /** The line items that compose the trip which are not CANCELLED or REBOOKED */
  openLineItems: Array<LineItem>;
  /** The open outbound airport transfer line item for the trip. */
  openOutboundAirportTransferLineItem?: Maybe<TourAirportTransferLineItem>;
  openPostStayLineItem?: Maybe<ExtendedStayLineItem>;
  openPreStayLineItem?: Maybe<ExtendedStayLineItem>;
  openPrivateGroupLineItem?: Maybe<PrivateGroupLineItem>;
  openPromoLineItems: Array<PromoLineItem>;
  openReturningFlightLineItem?: Maybe<FlightPackageLineItem>;
  openRoomLineItem?: Maybe<TourRoomLineItem>;
  orderId: Scalars['ObjectId'];
  /** Available outbound airport transfer offers for the trip, based on the active departure extension when applicable, otherwise on the main tour. */
  outboundAirportTransferOffers: Array<TourAirportTransferOffer>;
  /** The total persisting adjustments amount for the trip. */
  persistingAdjustmentsTotal: Money;
  /** The trip ID for the trip that this trip was rebooked from. */
  rebookedFromTripId?: Maybe<Scalars['ObjectId']>;
  requestedRoommates?: Maybe<Array<Scalars['String']>>;
  /** @deprecated Use travelCompanionRequests instead */
  requestedTravelCompanions?: Maybe<Array<Scalars['String']>>;
  /** Offers for returning flights that can be added to the trip. */
  returningFlightOffers: Array<FlightOffer>;
  /** The departure room for the open room line item on this trip */
  room?: Maybe<DepartureRoom>;
  /** Offers for rooms that can be added to the trip. Includes extension rooms if the trip is booked on the extension. */
  roomOffers: Array<DepartureRoomOffer>;
  roommateTrips?: Maybe<Array<Trip>>;
  roommates?: Maybe<Array<Customer>>;
  /** The status of the trip */
  status: TripStatus;
  timingStatus: TripTimingStatus;
  /** The date the trip departs for tour, inclusive of any pre-Extension */
  tourDepartureDate: Scalars['Date'];
  /** The date the trip ends, inclusive of any post-Extension */
  tourEndDate: Scalars['Date'];
  tourLineItem?: Maybe<TourLineItem>;
  /** The travel companion requests for the trip. */
  travelCompanionRequests: Array<TravelCompanionRequest>;
  travelerNotes?: Maybe<TravelerNotes>;
  tripCustomer?: Maybe<TripCustomer>;
  /** The TSA information for the trip. */
  tsaInformation?: Maybe<TsaInformation>;
};

export type RatingCount = {
  __typename?: 'RatingCount';
  count: Scalars['Int'];
  score: Scalars['Int'];
};

/** React to a review */
export type ReactToReviewInput = {
  reactionType: ReviewReactionType;
  reviewId: Scalars['ObjectId'];
};

export type ReactToReviewResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidReviewError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Review | ValidationError;

export enum RebookingReasonCategory {
  Financial = 'FINANCIAL',
  LifeEvent = 'LIFE_EVENT',
  ProductTransition = 'PRODUCT_TRANSITION',
  TravelerDiscontent = 'TRAVELER_DISCONTENT',
  TravelRequirementNotMet = 'TRAVEL_REQUIREMENT_NOT_MET',
  Unknown = 'UNKNOWN',
  WojoCancellation = 'WOJO_CANCELLATION',
  WorldEvent = 'WORLD_EVENT'
}

export type ReconcileCardOrAchPaymentResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type ReconcileCheckPaymentResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type ReconcilePaymentResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type ReconcilePaymentsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | PaymentReconciliationUpload | ValidationError;

export type ReconcileTransactionInput = {
  amount: MoneyInput;
  processDate: Scalars['Date'];
  processorMerchantReferenceNumber: Scalars['String'];
  returnReasonCode?: InputMaybe<Scalars['String']>;
  returnReasonString?: InputMaybe<Scalars['String']>;
  transactionType: ReconciliationTransactionType;
};

export enum ReconciliationStatus {
  Failure = 'FAILURE',
  Skipped = 'SKIPPED',
  Success = 'SUCCESS',
  Unprocessed = 'UNPROCESSED'
}

export enum ReconciliationTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Return = 'RETURN'
}

export type RedeemedPromoType = {
  __typename?: 'RedeemedPromoType';
  /** Amount of discount. */
  discountAmount: Money;
  /** The promo offer's unique code. */
  discountOfferCode: Scalars['String'];
  /** The maximum number of times the promo can be used. */
  maxRedemptions: Scalars['Int'];
  /** Price after discount. */
  salePrice: Money;
};

/** Reduces the  non-expired voucher by a dollar amount */
export type ReduceVoucherInput = {
  /** The ID of the Voucher */
  _id: Scalars['ObjectId'];
  /** The amount to reduce the Voucher by */
  amount: MoneyInput;
  /** The reason that the voucher is being reduced */
  reason: Scalars['String'];
};

export type ReduceVoucherResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

export type ReferralLink = {
  __typename?: 'ReferralLink';
  /** The business code of the referral link */
  businessCode: BusinessCode;
  /** The shareable referral link for this business (full URL) */
  url: Scalars['String'];
};

export type ReferralProfile = {
  __typename?: 'ReferralProfile';
  /** The balance for this referral profile */
  balance: Scalars['Float'];
  /** The number of days until the next reward is available */
  nbDaysUntilNextReward?: Maybe<Scalars['Int']>;
  /** The number of earned referral rewards (inclusive of redeemed) earned by referring friends */
  nbEarnedReferrals: Scalars['Int'];
  /** The number of pending referral rewards (not yet earned) for referring friends */
  nbPendingReferrals: Scalars['Int'];
  /** The number of earned referrals needed to reach the next bonus reward for referring friends */
  nbReferralsUntilTargetReached: Scalars['Int'];
  /**
   * The amount of the reward that will expire soonest
   * @deprecated Use CustomerIncentives.unusedIncentiveInfo.nextExpiringReward.amount instead
   */
  nextExpiringRewardAmount?: Maybe<Scalars['Float']>;
  /**
   * The expiration date of the soonest-expiring reward
   * @deprecated Use CustomerIncentives.unusedIncentiveInfo.nextExpiringReward.expirationDate instead
   */
  nextExpiringRewardExpiryDate?: Maybe<Scalars['DateTime']>;
  /** The pending balance for this referral profile */
  pendingBalance: Scalars['Float'];
  /** The customer's referral code for sharing with friends */
  referralCode?: Maybe<Scalars['String']>;
  /** The referral links for this profile */
  referralLinks: Array<ReferralLink>;
};


export type ReferralProfileReferralLinksArgs = {
  currencyCode: CurrencyCode;
};

export type ReferralProgram = {
  __typename?: 'ReferralProgram';
  /** The balance of the customer's referral program */
  balance?: Maybe<Scalars['Float']>;
  /** The customer id that this information is associated with */
  customerId: Scalars['ObjectId'];
  /** The number of days until the next reward is available for the customer */
  nbDaysUntilNextReward?: Maybe<Scalars['Int']>;
  /** The number of earned referral rewards for the customer (inclusive of redeemed rewards) earned by referring friends */
  nbEarnedReferrals: Scalars['Int'];
  /** The number of pending referral rewards for the customer (not yet earned) for referring friends */
  nbPendingReferrals: Scalars['Int'];
  /** The number of earned referrals the customer needs to reach the next bonus reward for referring friends */
  nbReferralsUntilTargetReached: Scalars['Int'];
  /** The customer's referral code for sharing with friends */
  referralCode: Scalars['String'];
};

export type RefundInput = {
  checkRefundAmount?: InputMaybe<Scalars['Float']>;
  processorPaymentMethodRefunds?: InputMaybe<Array<ProcessorPaymentMethodRefundInput>>;
  refundReason: RefundReasonCode;
  savedPaymentMethodRefunds?: InputMaybe<Array<SavedPaymentMethodRefundInput>>;
  voucherRefunds?: InputMaybe<Array<VoucherRefundInput>>;
};

export enum RefundReasonCode {
  Cancellation = 'CANCELLATION',
  Optional = 'OPTIONAL',
  Overpayment = 'OVERPAYMENT'
}

export type RefundVoucherInput = {
  /** The ID of the Voucher */
  _id: Scalars['ObjectId'];
  /** The date the check was issued */
  checkIssuedOn?: InputMaybe<Scalars['Date']>;
  /** The check number */
  checkNumber?: InputMaybe<Scalars['String']>;
  /** Information about the employee who approved the refund check */
  issuedBy?: InputMaybe<Scalars['String']>;
  /** The reason for the refund */
  reason?: InputMaybe<Scalars['String']>;
  /** The amount to refund. If not provided, the remaining amount of the voucher will be used */
  refundAmount?: InputMaybe<Scalars['Float']>;
};

export type RefundVoucherResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** Reinstates a voided voucher */
export type ReinstateVoucherInput = {
  /** The ID of the Voucher */
  _id: Scalars['ObjectId'];
  /** The reason that the voucher is being reinstated */
  reason: Scalars['String'];
};

export type ReinstateVoucherResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

export type ReleaseDetails = {
  __typename?: 'ReleaseDetails';
  isReleased: Scalars['Boolean'];
  releaseDate?: Maybe<Scalars['DateTime']>;
  releaseEndDate?: Maybe<Scalars['DateTime']>;
};

export type RemoveAudienceMemberResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | RemoveAudienceMemberSuccess | ValidationError;

export type RemoveAudienceMemberSuccess = {
  __typename?: 'RemoveAudienceMemberSuccess';
  data: AudienceMember;
};

export type RemoveAudienceOfferCodeResult = Audience | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveAudienceOfferCodesResult = Audience | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Removes promos to a campaign */
export type RemoveCampaignPromosInput = {
  promoIds: Array<Scalars['ObjectId']>;
};

export type RemoveCampaignPromosResult = BusinessNotSpecifiedError | Campaign | DuplicateUniqueKeyError | InvalidCampaignError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderAdjustmentInput = {
  /** The adjustment lineItemIds to remove from this trip. */
  adjustmentLineItemIds: Array<Scalars['ObjectId']>;
  /** The reason for removing the adjustment. */
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  /** The trip to remove the adjustment(s) from. */
  tripId: Scalars['ObjectId'];
};

export type RemoveDraftOrderAdjustmentsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderAirportTransferInput = {
  flightType: FlightType;
  tripId: Scalars['ObjectId'];
};

export type RemoveDraftOrderAirportTransferResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderExcursionResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderExcursionsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderExtensionResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderFeesInput = {
  /** The fee lineItemIds to remove from this trip */
  feeLineItemIds: Array<Scalars['ObjectId']>;
  /** The trip to remove the fee(s) from */
  tripId: Scalars['ObjectId'];
};

export type RemoveDraftOrderFeesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderFlightShopResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidFlightShopError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderInsuranceAddonResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderInsuranceExtensionResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidInsuranceExtensionError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderInsuranceResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderPostStayResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderPreStayResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderPrivateGroupResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderPromoResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftOrderTravelCompanionRequestsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | InvalidTravelCompanionRequestError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveDraftQuoteTripsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type RemoveEmployeesFromRoleInput = {
  employeeIds: Array<Scalars['ObjectId']>;
};

export type RemoveEmployeesFromRoleResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Role | ValidationError;

export type RemovePlaceResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPlaceError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | RemovePlaceSuccess | ValidationError;

export type RemovePlaceSuccess = {
  __typename?: 'RemovePlaceSuccess';
  data: Place;
};

export type RemovePrivateGroupResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type RemovePromoCodesInput = {
  promoCodes: Array<Scalars['String']>;
};

export type RemovePromoCodesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type RemovePromoCustomersInput = {
  customerIds: Array<Scalars['ObjectId']>;
};

export type RemovePromoCustomersResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type RemovePromoGcDeparturesInput = {
  gcDepartureIds: Array<Scalars['ObjectId']>;
};

export type RemovePromoGcDeparturesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type RemovePromoTargetsInput = {
  targetIds: Array<Scalars['ObjectId']>;
};

export type RemovePromoTargetsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type RemoveTourExcursionsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type RemoveTourExtensionExcursionsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | TourExtension | ValidationError;

/** Settings related to repeat promo thresholds. */
export type RepeatThresholdSettings = {
  __typename?: 'RepeatThresholdSettings';
  /** Discount amount applied when this threshold is reached */
  discount: Amount;
  /** Number of trips required to qualify for this threshold */
  nbTrips: Scalars['Int'];
  /** Bonus amount applied when this threshold is reached */
  repeatBonus: Amount;
  /** Number of days after which the repeat bonus expires */
  repeatBonusExpiresAfterDays: Scalars['Int'];
};

/** A roommate that can be requested for a trip */
export type RequestableRoommate = {
  __typename?: 'RequestableRoommate';
  customer: Customer;
  restrictions: Array<RoommateRequestRestriction>;
  tripId: Scalars['ObjectId'];
};

/** A travel companion that can be requested for a trip */
export type RequestableTravelCompanion = {
  __typename?: 'RequestableTravelCompanion';
  customer: Customer;
  restrictions: Array<TravelCompanionRequestRestriction>;
  tripId: Scalars['ObjectId'];
};

/** The reservation of a departure itinerary component */
export type Reservation = {
  __typename?: 'Reservation';
  reservationId?: Maybe<Scalars['Int']>;
  timeFrom?: Maybe<Scalars['Time']>;
};

/** Reservation document file metadata. */
export type ReservationDocument = {
  __typename?: 'ReservationDocument';
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  externalDocumentId: Scalars['String'];
  externalReservationId: Scalars['Int'];
  filename?: Maybe<Scalars['String']>;
  removedAt?: Maybe<Scalars['DateTime']>;
  sizeInBytes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['Int']>;
};

/** A return flight option that can be paired with an outbound flight */
export type ReturnFlightOption = FlightOption & {
  __typename?: 'ReturnFlightOption';
  /** Unique identifier for this flight option */
  _id: Scalars['ObjectId'];
  /**
   * Arrival date of the last segment (for sorting)
   * @deprecated Use localArrivalDateTime instead
   */
  arrivalDateTime?: Maybe<Scalars['Date']>;
  /** Number of allowed checked bags */
  baggageCount?: Maybe<Scalars['Int']>;
  /** Unique marketing carrier codes from all segments (for sorting/filtering) */
  carrierCodes: Array<Scalars['String']>;
  /**
   * Departure date of the first segment (for sorting)
   * @deprecated Use localDepartureDateTime instead
   */
  departureDateTime?: Maybe<Scalars['Date']>;
  /** The direction of travel */
  direction: Direction;
  /** Unique identifier for this outbound/return flight combination from the external system */
  externalSolutionId: Scalars['String'];
  /** Whether this option is included in the flight package price */
  isIncluded: Scalars['Boolean'];
  /** Local arrival date/time of the last segment (for sorting) */
  localArrivalDateTime?: Maybe<Scalars['LocalDateTime']>;
  /** Local departure date/time of the first segment (for sorting) */
  localDepartureDateTime?: Maybe<Scalars['LocalDateTime']>;
  /** Unique operating carrier codes from all segments (for sorting/filtering) */
  operatingCarrierCodes: Array<Scalars['String']>;
  /** Price per traveler for this outbound/return flight combination */
  pricePerTraveler: Money;
  /** The flight segments that make up this option */
  segments: Array<FlightShoppingSegment>;
  /** Total number of stops (connections between segments) (for sorting) */
  stopCount: Scalars['Int'];
  /** Total duration from first departure to final arrival, including layovers */
  totalDuration: Duration;
  /** Total price for all travelers */
  totalPrice: Money;
};

/** A review consists of a rating and an optional review detail */
export type Review = {
  __typename?: 'Review';
  _id: Scalars['ObjectId'];
  businessCode?: Maybe<BusinessCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId: Scalars['ObjectId'];
  detail?: Maybe<ReviewDetail>;
  helpfulReactionCount: Scalars['Int'];
  images: Array<ReviewImage>;
  isEditable?: Maybe<Scalars['Boolean']>;
  isFeatured: Scalars['Boolean'];
  nbPastTrips: Scalars['Int'];
  notHelpfulReactionCount: Scalars['Int'];
  rating: Scalars['Int'];
  tour?: Maybe<Tour>;
  tourCode: Scalars['String'];
  travelDate: Scalars['Date'];
  tripId: Scalars['ObjectId'];
};


/** A review consists of a rating and an optional review detail */
export type ReviewImagesArgs = {
  status?: InputMaybe<ReviewStatus>;
};

/** Summary of reviews for a tour */
export type ReviewAggregate = {
  __typename?: 'ReviewAggregate';
  avgRating: Scalars['Float'];
  nbReviews: Scalars['Int'];
  /** Array of rating counts, one for each score 1-5. */
  ratingCounts: Array<RatingCount>;
};

/** Details of a review by a customer */
export type ReviewDetail = {
  __typename?: 'ReviewDetail';
  _id: Scalars['ObjectId'];
  author?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  moderationFeaturedResult?: Maybe<ReviewModerationFeaturedResult>;
  moderationResult?: Maybe<ReviewModerationResult>;
  response?: Maybe<ReviewResponse>;
  status: ReviewStatus;
  title?: Maybe<Scalars['String']>;
};

/** Filters for review query */
export type ReviewFilterInput = {
  businessCode?: InputMaybe<BusinessCode>;
  customerId?: InputMaybe<Scalars['ObjectId']>;
  hasDetail?: InputMaybe<Scalars['Boolean']>;
  hasHelpfulReactions?: InputMaybe<Scalars['Boolean']>;
  hasImages?: InputMaybe<Scalars['Boolean']>;
  hasNotHelpfulReactions?: InputMaybe<Scalars['Boolean']>;
  hasResponse?: InputMaybe<Scalars['Boolean']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  moderationDecision?: InputMaybe<ReviewModerationDecision>;
  ratingFrom?: InputMaybe<Scalars['Int']>;
  ratingTo?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ReviewStatus>;
  title?: InputMaybe<Scalars['String']>;
  tourCodes?: InputMaybe<Array<Scalars['String']>>;
  travelDateFrom?: InputMaybe<Scalars['Date']>;
  travelDateTo?: InputMaybe<Scalars['Date']>;
};

/** Images that have been uploaded as part of a review */
export type ReviewImage = {
  __typename?: 'ReviewImage';
  _id: Scalars['ObjectId'];
  asset?: Maybe<Asset>;
  assetId: Scalars['ObjectId'];
  moderationResult?: Maybe<ReviewModerationResult>;
  status: ReviewStatus;
};

/** The confidence level of the review moderation decision */
export enum ReviewModerationConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** The decision made by the review moderation system */
export enum ReviewModerationDecision {
  Approve = 'APPROVE',
  FlagForRejection = 'FLAG_FOR_REJECTION',
  FlagForVerification = 'FLAG_FOR_VERIFICATION'
}

/** Result of AI featured evaluation of a review */
export type ReviewModerationFeaturedResult = {
  __typename?: 'ReviewModerationFeaturedResult';
  /** Reason why the review was or was not selected as featured */
  featuredReason: Scalars['String'];
  /** AI recommendation for whether the review should be featured */
  isFeatured: Scalars['Boolean'];
};

/** Result of AI moderation of a review */
export type ReviewModerationResult = {
  __typename?: 'ReviewModerationResult';
  confidence: ReviewModerationConfidence;
  decision: ReviewModerationDecision;
  reason: Scalars['String'];
};

/** A paginated set of Reviews */
export type ReviewPaginatedResult = {
  __typename?: 'ReviewPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Review>;
};

export enum ReviewReactionType {
  Helpful = 'HELPFUL',
  NotHelpful = 'NOT_HELPFUL'
}

/** A response to the customer about their review */
export type ReviewResponse = {
  __typename?: 'ReviewResponse';
  author: Scalars['String'];
  body: Scalars['String'];
};

/** Input for searching reviews using semantic search */
export type ReviewSearchInput = {
  /** Optional filters for vector search (limited operations supported) */
  filter?: InputMaybe<ReviewVectorFilterInput>;
  /** Maximum number of results to return (default: 20) */
  limit?: Scalars['Int'];
  /** The search query text */
  query: Scalars['String'];
  /** Whether to apply reranking to improve relevance (default: true) */
  rerank?: Scalars['Boolean'];
};

/** Review settings */
export type ReviewSettings = {
  __typename?: 'ReviewSettings';
  /** Whether review auto moderation (AI) is enabled */
  reviewAutoModeratorEnabled: Scalars['Boolean'];
  /** Number of days post departure after which a review can be submitted */
  reviewCutoffDays: Scalars['Int'];
  /** Whether review image auto moderation (AI) is enabled */
  reviewImageAutoModeratorEnabled: Scalars['Boolean'];
  /** The system prompt used for AI review moderation */
  reviewModerationPrompt: Scalars['String'];
  /** The system prompt used for generating tour page review summaries */
  tourPageReviewSummaryPrompt: Scalars['String'];
};

export enum ReviewSortField {
  HelpfulReactionCount = 'helpfulReactionCount',
  IsFeatured = 'isFeatured',
  NotHelpfulReactionCount = 'notHelpfulReactionCount',
  Rating = 'rating',
  TravelDate = 'travelDate'
}

export type ReviewSortInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: ReviewSortField;
};

/** The detail and images of a review need to be moderated before being visible publicly */
export enum ReviewStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** Filters for review vector search (limited operations supported) */
export type ReviewVectorFilterInput = {
  businessCode?: InputMaybe<BusinessCode>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  nbPastTripsFrom?: InputMaybe<Scalars['Int']>;
  nbPastTripsTo?: InputMaybe<Scalars['Int']>;
  ratingFrom?: InputMaybe<Scalars['Int']>;
  ratingTo?: InputMaybe<Scalars['Int']>;
  tourCodes?: InputMaybe<Array<Scalars['String']>>;
  travelDateFrom?: InputMaybe<Scalars['Date']>;
  travelDateTo?: InputMaybe<Scalars['Date']>;
};

/** A review with its relevance score from semantic search */
export type ReviewVectorSearchResult = {
  __typename?: 'ReviewVectorSearchResult';
  result: Review;
  score: Scalars['Float'];
};

/** Risk free period settings for the order. */
export type RiskFreePeriodSettings = {
  __typename?: 'RiskFreePeriodSettings';
  /** Minimum DPD required to be eligible for the risk-free period */
  minimumEligibleDpd: Scalars['Int'];
  /** Number of days in the risk-free period for autopay orders */
  nbAutopayDays: Scalars['Int'];
  /** Number of days in the risk-free period for manual payment orders */
  nbManualDays: Scalars['Int'];
  /** Number of days in the risk-free period for pay-in-full orders */
  nbPayInFullDays: Scalars['Int'];
  /** Whether to preserve the risk-free period when an order is rebooked */
  preserveRiskFreePeriodOnRebooking: Scalars['Boolean'];
  /** Whether to use the minimum eligible DPD for risk-free period calculations */
  useMinimumEligibleDpd: Scalars['Boolean'];
};

/** A collection of permissions that can be assigned to a user */
export type Role = {
  __typename?: 'Role';
  _id: Scalars['ObjectId'];
  businessCode?: Maybe<BusinessCode>;
  name: Scalars['String'];
  permissionKeys: Array<PermissionKey>;
  permissions: Array<Permission>;
};

/** A paginated result of Roles */
export type RolePaginatedResult = {
  __typename?: 'RolePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Role>;
};

export type RoomContent = {
  __typename?: 'RoomContent';
  bedCode?: Maybe<Scalars['String']>;
  cabinCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum RoomTourType {
  Extension = 'EXTENSION',
  MainTour = 'MAIN_TOUR'
}

export type RoomingCombination = {
  __typename?: 'RoomingCombination';
  /** The rooms in the combination. */
  offers: Array<DepartureRoomOffer>;
  /** The difference between the total and sale price if any. */
  totalDiscountAmount?: Maybe<Money>;
  /** The total price for the rooming combination. */
  totalPrice: Money;
  /** The total sale price for the rooming combination if any. */
  totalSalePrice?: Maybe<Money>;
};

export type RoomingCombinations = {
  __typename?: 'RoomingCombinations';
  /** The priced room combinations. */
  combinations: Array<RoomingCombination>;
  /** Whether every combination contains only singles. */
  isOnlySingles: Scalars['Boolean'];
};

/** Status, ID and occupants of a room */
export type Roommate = {
  __typename?: 'Roommate';
  roommateId: Scalars['ObjectId'];
  status: RoommateStatus;
};

export type RoommateChecklistItem = SystemChecklistItem & {
  __typename?: 'RoommateChecklistItem';
  dueDate?: Maybe<Scalars['Date']>;
  isCompleted: Scalars['Boolean'];
  status?: Maybe<TripChecklistItemStatus>;
};

export enum RoommateRequestRestriction {
  AlreadyMatched = 'ALREADY_MATCHED',
  DifferentRoomType = 'DIFFERENT_ROOM_TYPE'
}

export enum RoommateStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

export type RotateOAuthClientSecretResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | OAuthClientWithSecret | ValidationError;

export type SaveEvaluationResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidEvaluationError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | SaveEvaluationSuccess | ValidationError;

export type SaveEvaluationSuccess = {
  __typename?: 'SaveEvaluationSuccess';
  data: Evaluation;
};

export type SaveablePaymentMethod = AchPaymentMethod | CardPaymentMethod;

/** Saved payment method for a customer */
export type SavedPaymentMethod = {
  __typename?: 'SavedPaymentMethod';
  _id: Scalars['ObjectId'];
  /** Bookings that have an active autopay plan using this payment method. */
  activeAutopayBookings: Array<Booking>;
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  customerId: Scalars['ObjectId'];
  /** Whether the payment method is active, returns false if the payment method is expired */
  isActive: Scalars['Boolean'];
  /** Whether the payment method is authorized for use */
  isAuthorizedForUse: Scalars['Boolean'];
  /** Whether the payment method is the default for the customer */
  isDefault: Scalars['Boolean'];
  /** Whether the payment method is expired */
  isExpired: Scalars['Boolean'];
  /** Whether the payment method is valid */
  isValid: Scalars['Boolean'];
  paymentMethod: SaveablePaymentMethod;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SavedPaymentMethodInput = {
  savedPaymentMethodId: Scalars['ObjectId'];
};

export type SavedPaymentMethodRefundInput = {
  amount: Scalars['Float'];
  savedPaymentMethodId: Scalars['ObjectId'];
};

/** A place saved by a user */
export type SavedPlace = {
  __typename?: 'SavedPlace';
  /** Unique identifier of the saved place */
  _id: Scalars['ObjectId'];
  /** Business code associated with the saved place */
  businessCode: BusinessCode;
  /** Google Place ID for the location */
  googlePlaceId: Scalars['String'];
  /** Geographic coordinates of the place */
  location: SavedPlaceCoordinate;
  /** Display name of the place */
  name: Scalars['String'];
  /** The place that was saved */
  place?: Maybe<Place>;
  /** The id of the place that was saved */
  placeId?: Maybe<Scalars['ObjectId']>;
  /** Whether the user has visited the place */
  userHasVisited: Scalars['Boolean'];
  /** The id of the user who saved the place */
  userId: Scalars['ObjectId'];
  /** Type of saved place user */
  userType: SavedPlaceUserKind;
  /** Whether the user wants to visit the place */
  userWantsToVisit: Scalars['Boolean'];
  /** Viewport bounds for the place */
  viewport: SavedPlaceViewport;
};

/** latitude and longitude values */
export type SavedPlaceCoordinate = {
  __typename?: 'SavedPlaceCoordinate';
  /** Latitude in decimal degrees */
  latitude: Scalars['Float'];
  /** Longitude in decimal degrees */
  longitude: Scalars['Float'];
};

/** Filters for saved place query */
export type SavedPlaceFilterInput = {
  /** Return places that match any of the provided types */
  types?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by user and user type */
  user?: InputMaybe<SavedPlaceFilterUserInput>;
  /** Return places the user has visited (true) or not (false) */
  userHasVisited?: InputMaybe<Scalars['Boolean']>;
  /** Return places the user wants to visit (true) or not (false) */
  userWantsToVisit?: InputMaybe<Scalars['Boolean']>;
};

/** User criteria for filtering saved places */
export type SavedPlaceFilterUserInput = {
  /** The user's id */
  id: Scalars['ObjectId'];
  /** Type of saved place user */
  savedPlaceUserType: SavedPlaceUserKind;
};

/** A paginated set of Saved Places */
export type SavedPlacePaginatedResult = {
  __typename?: 'SavedPlacePaginatedResult';
  /** Whether another page exists after this one */
  hasNext: Scalars['Boolean'];
  /** Whether a page exists before this one */
  hasPrevious: Scalars['Boolean'];
  /** Cursor for the next page, if any */
  next?: Maybe<Scalars['String']>;
  /** Cursor for the previous page, if any */
  previous?: Maybe<Scalars['String']>;
  /** Saved places on the current page */
  results: Array<SavedPlace>;
};

/** Represents whether the saved place belongs to a customer or a tour director */
export enum SavedPlaceUserKind {
  /** Saved by a customer */
  CustomerSavedPlace = 'CUSTOMER_SAVED_PLACE',
  /** Saved by a tour director */
  TourDirectorSavedPlace = 'TOUR_DIRECTOR_SAVED_PLACE'
}

/** Viewport bounds that frame the place */
export type SavedPlaceViewport = {
  __typename?: 'SavedPlaceViewport';
  /** North-east coordinate */
  high: SavedPlaceCoordinate;
  /** South-west coordinate */
  low: SavedPlaceCoordinate;
};

/** Activity level information for search hits */
export type SearchHitActivityLevel = {
  __typename?: 'SearchHitActivityLevel';
  activityLevel: Scalars['Int'];
  name: Scalars['String'];
};

/** Class level information for search hits */
export type SearchHitClassLevel = {
  __typename?: 'SearchHitClassLevel';
  classLevel: Scalars['Int'];
  description: Scalars['String'];
  icon?: Maybe<SearchHitContentAsset>;
  name: Scalars['String'];
};

/** Content asset information for search hits */
export type SearchHitContentAsset = {
  __typename?: 'SearchHitContentAsset';
  alt?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  focus?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum SearchHitMarket {
  Ca = 'CA',
  Us = 'US'
}

/** Price badge information for search hits */
export type SearchHitPriceBadge = {
  __typename?: 'SearchHitPriceBadge';
  text: Scalars['String'];
  variant: Scalars['String'];
};

/** Product badge information for search hits */
export type SearchHitProductBadge = {
  __typename?: 'SearchHitProductBadge';
  icon?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  variant: Scalars['String'];
};

export type SearchHitTourAssetUnion = SearchHitTourImage | SearchHitTourVideo;

/** Tour image asset for search hits */
export type SearchHitTourImage = {
  __typename?: 'SearchHitTourImage';
  image: SearchHitContentAsset;
  kind: Scalars['String'];
};

/** Tour video asset for search hits */
export type SearchHitTourVideo = {
  __typename?: 'SearchHitTourVideo';
  caption?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  wistiaVideoId: Scalars['String'];
};

/** Generate a magic link, and send to a customer or tour director */
export type SendMagicLinkInput = {
  email: Scalars['String'];
  emailTemplateId: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  isTourDirector?: InputMaybe<Scalars['Boolean']>;
  returnURL: Scalars['String'];
};

export type SendMagicLinkResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | EmailSendFailedError | InvalidDateError | InvalidDateRangeError | InvalidMagicLinkError | InvalidTimeRangeError | MagicLinkResult | NotAuthorizedError | NotFoundError | ValidationError;

export enum ServiceLevel {
  Economy = 'ECONOMY'
}

/** A service recovery promotion. */
export type ServiceRecovery = {
  __typename?: 'ServiceRecovery';
  _id: Scalars['ObjectId'];
  bookingTrip?: Maybe<BookingTrip>;
  businessCode: BusinessCode;
  orderId: Scalars['ObjectId'];
  promo?: Maybe<Promo>;
  promoId: Scalars['ObjectId'];
  recoveryReason: Scalars['String'];
  recoveryReasons?: Maybe<Array<Scalars['String']>>;
  tripId: Scalars['ObjectId'];
};

export type ServiceRecoveryPaginatedResult = {
  __typename?: 'ServiceRecoveryPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<ServiceRecovery>;
};

export type SetDefaultPaymentMethodResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | SavedPaymentMethod | ValidationError;

export type SetDraftQuoteCustomerResult = BusinessNotSpecifiedError | CustomerUnavailableError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type SetTourDirectorProfileInput = {
  bio?: InputMaybe<Scalars['String']>;
  hideEmail?: InputMaybe<Scalars['Boolean']>;
  hidePhoneNumber?: InputMaybe<Scalars['Boolean']>;
  profileImageAssetId?: InputMaybe<Scalars['ObjectId']>;
};

export type ShopFlightsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightShoppingResult | FlightShoppingTripsValidationError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type SigninCustomerWithMagicLinkResult = BusinessNotSpecifiedError | CustomerUnavailableError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidSigninError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | SigninResult | ValidationError;

export type SigninCustomerWithPasswordResult = BusinessNotSpecifiedError | CustomerUnavailableError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidSigninError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | SigninResult | ValidationError;

export type SigninResult = {
  __typename?: 'SigninResult';
  hasPassword?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
  tokenExpiresAt: Scalars['DateTime'];
  user?: Maybe<User>;
};

export type SigninTourDirectorWithMagicLinkResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidSigninError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | SigninResult | ValidationError;

/** Signin with a password */
export type SigninWithPasswordInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type SignoutResult = {
  __typename?: 'SignoutResult';
  success: Scalars['Boolean'];
};

/** Signup as a new customer */
export type SignupCustomerInput = {
  email: Scalars['Email'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  /** Referral information for this sign-up. */
  referralInformation?: InputMaybe<SignupCustomerReferralInformationInput>;
};

export type SignupCustomerReferralInformationInput = {
  /** Identifies the business context for this sign-up. Required when referralCode is provided to determine whether referrals are enabled and can be processed for that business. */
  businessCode: BusinessCode;
  /** Referral code used to register this account under a referral program. */
  referralCode: Scalars['String'];
};

export type SignupCustomerResult = BusinessNotSpecifiedError | CustomerSignupResult | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type SortAdjustmentInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: AdjustmentSortField;
};

export type SortBookingInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: BookingSortField;
};

export type SortCustomerEvaluationInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: CustomerEvaluationSortField;
};

export type SortDepartureInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: DepartureSortField;
};

export type SortEmployeeInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: EmployeeSortField;
};

export type SortFeeInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: FeeSortField;
};

export type SortGcDepartureInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: GcDepartureSortField;
};

export type SortGcDepartureMeetingRsvpInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: GcDepartureMeetingRsvpSortField;
};

export type SortGcDepartureProspectInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: GcDepartureProspectSortField;
};

export type SortInsurancePlanInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: InsurancePlanSortField;
};

export type SortInsurancePolicyInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: InsurancePolicySortField;
};

export type SortOpportunityQuoteInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: QuoteSortField;
};

export type SortPaymentReconciliationTransactionInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: PaymentReconciliationTransactionSortField;
};

export type SortQuoteInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: QuoteSortField;
};

export type SortTourDirectorInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: TourDirectorSortField;
};

export type SortTourEndReportInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: TourEndReportSortField;
};

export type SortTourExcursionInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: TourExcursionSortField;
};

export type SortTourExtensionInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: TourExtensionSortField;
};

export type SortTourInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: TourSortField;
};

export type SortVoucherInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: VoucherSortField;
};

export enum SourceProcessorOrAcquirer {
  Cybersource = 'CYBERSOURCE',
  Telecheck = 'TELECHECK',
  Worldpaycreditcard = 'WORLDPAYCREDITCARD',
  Worldpayecheck = 'WORLDPAYECHECK'
}

/** A staff contact with name, email, and optional contact details */
export type StaffContact = {
  __typename?: 'StaffContact';
  email: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type StartFlightBookingResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightBookingResult | FlightBookingResultInvalidStateError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type StartQuoteInput = {
  /** Whether to automatically apply the advanced repeat promotion. */
  applyAdvancedRepeatPromo?: InputMaybe<Scalars['Boolean']>;
  /** Campaign code to be automatically applied to the quote. */
  campaignCode?: InputMaybe<Scalars['String']>;
  currency: CurrencyCode;
  /** The Customer ID for the primary traveler, if such a Customer ID already exists.  */
  customerId?: InputMaybe<Scalars['ObjectId']>;
  departureId: Scalars['ObjectId'];
  expirationDate?: InputMaybe<Scalars['Date']>;
  gatewayCode?: InputMaybe<Scalars['String']>;
  gcDepartureId?: InputMaybe<Scalars['ObjectId']>;
  /** The supported identity document types for prefilling customer information */
  identityDocumentTypes?: Array<IdentityDocumentType>;
  /** The number of additional Trips to create beyond the primary Trip. If omitted, only the primary Trip will be created. */
  nbSecondaryTravelers?: InputMaybe<Scalars['Int']>;
  opportunityId?: InputMaybe<Scalars['String']>;
  /** Promo code to be automatically applied to the quote. */
  promoCode?: InputMaybe<Scalars['String']>;
  /** How the quote is being started. */
  quoteMethod?: InputMaybe<QuoteMethod>;
};

export type StartQuoteResult = BusinessNotSpecifiedError | CustomerUnavailableError | DraftOrder | DuplicateUniqueKeyError | InvalidAdjustmentError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidGcDepartureError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Puts a booking into `PENDING_REBOOKING` status */
export type StartRebookingInput = {
  /** The booking ID */
  _id: Scalars['ObjectId'];
  /** The amount to charge as a rebooking fee for extensions */
  extensionsRebookingFeeAmount?: InputMaybe<Scalars['Float']>;
  /** The amount to charge as a rebooking fee for flights */
  flightRebookingFeeAmount?: InputMaybe<Scalars['Float']>;
  /** The categorization of the rebooking reason */
  rebookingReasonCategory: RebookingReasonCategory;
  /** The rebooking reason */
  rebookingReasonDescription: Scalars['String'];
  /** Whether or not to waive the rebooking fee. Cannot be specified by a customer. */
  waiveFee?: InputMaybe<Scalars['Boolean']>;
};

export type StartRebookingQuoteInput = {
  campaignCode?: InputMaybe<Scalars['String']>;
  currency: CurrencyCode;
  departureId: Scalars['ObjectId'];
  expirationDate?: InputMaybe<Scalars['Date']>;
  gatewayCode?: InputMaybe<Scalars['String']>;
  gcDepartureId?: InputMaybe<Scalars['ObjectId']>;
  opportunityId?: InputMaybe<Scalars['String']>;
  promoCode?: InputMaybe<Scalars['String']>;
  /** How the quote is being started. */
  quoteMethod?: InputMaybe<QuoteMethod>;
  rebookingFromOrderId: Scalars['ObjectId'];
};

export type StartRebookingQuoteResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidGcDepartureError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type StartRebookingResult = Booking | BusinessNotSpecifiedError | CustomerUnavailableError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** A city where extended stays are available */
export type StayCity = {
  __typename?: 'StayCity';
  _id: Scalars['ObjectId'];
  code: Scalars['String'];
  countryCode?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  isoCountryCode?: Maybe<Scalars['String']>;
  landRegionCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** A paginated result of Stay Cities */
export type StayCityPaginatedResult = {
  __typename?: 'StayCityPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<StayCity>;
};

export type StopOver = {
  __typename?: 'StopOver';
  endDate: Scalars['Date'];
  gatewayCode: Scalars['String'];
  startDate: Scalars['Date'];
};

export type StopOverInput = {
  /** Stop over end date */
  endDate: Scalars['Date'];
  /** Stop over gateway code */
  gatewayCode: Scalars['String'];
  /** Stop over start date */
  startDate: Scalars['Date'];
};

export type SubmitEvaluationResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidEvaluationError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | SubmitEvaluationSuccess | ValidationError;

export type SubmitEvaluationSuccess = {
  __typename?: 'SubmitEvaluationSuccess';
  data: Evaluation;
};

export type SuccessResult = {
  __typename?: 'SuccessResult';
  success: Scalars['Boolean'];
};

/** The supplier of a departure itinerary component */
export type Supplier = {
  __typename?: 'Supplier';
  addresses: Array<Address>;
  code?: Maybe<Scalars['String']>;
  contacts: Array<SupplierContact>;
  name?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type SupplierConfirmationEmailInput = {
  /** The productionComponentId of the itinerary component */
  componentId: Scalars['Int'];
  /** Output language for the email (e.g., 'English', 'Spanish') */
  language?: InputMaybe<Scalars['String']>;
  /** The tour director ID for the email signature. Required for employees, optional for tour directors (defaults to current user). */
  tourDirectorId?: InputMaybe<Scalars['ObjectId']>;
};

export type SupplierConfirmationEmailResult = {
  __typename?: 'SupplierConfirmationEmailResult';
  componentType: Scalars['String'];
  /** The generated email content, ready to copy and paste */
  emailContent: Scalars['String'];
  supplierName: Scalars['String'];
};

/** The contact details of a supplier */
export type SupplierContact = {
  __typename?: 'SupplierContact';
  emails: Array<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumbers: Array<Scalars['String']>;
};

/** Invalid support ticket query */
export type SupportTicketError = DomainError & {
  __typename?: 'SupportTicketError';
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type SupportTicketInput = {
  body: Scalars['String'];
  customFields?: InputMaybe<Array<SupportTicketInputCustomField>>;
  public?: InputMaybe<Scalars['Boolean']>;
  requesterEmail: Scalars['String'];
  requesterName: Scalars['String'];
  subject: Scalars['String'];
  ticketFormId: Scalars['String'];
  tripId: Scalars['String'];
};

export type SupportTicketInputCustomField = {
  id: Scalars['String'];
  value: Scalars['String'];
};

/** Support Ticket Settings */
export type SupportTicketSettings = {
  __typename?: 'SupportTicketSettings';
  /** The external ID of support ticket business. */
  businessExternalId: Scalars['String'];
  /** Whether auto approved late add tickets creation is enabled. */
  isAutoApprovedLateAddEnabled: Scalars['Boolean'];
};

/** Response from the support ticket API */
export type SupportTicketSuccess = {
  __typename?: 'SupportTicketSuccess';
  ticketId: Scalars['String'];
};

export type SystemChecklistItem = {
  dueDate?: Maybe<Scalars['Date']>;
  isCompleted: Scalars['Boolean'];
  status?: Maybe<TripChecklistItemStatus>;
};

export enum TsaGender {
  F = 'F',
  M = 'M',
  X = 'X'
}

/** TSA information for a traveler */
export type TsaInformation = {
  __typename?: 'TSAInformation';
  _id: Scalars['ObjectId'];
  /** The date at which the traveler information was confirmed. */
  confirmationDate?: Maybe<Scalars['DateTime']>;
  countryOfIssue?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  /** The date at which the identity document information was confirmed. */
  documentConfirmationDate?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['Date']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<TsaGender>;
  /** Whether or not all the identity document information is completed and confirmed. */
  hasCompletedPassportInformation: Scalars['Boolean'];
  /** Whether or not the all TSA identifiers are completed and confirmed. */
  hasConfirmedTsaIdentifiers: Scalars['Boolean'];
  identityDocumentNumber?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['Date']>;
  lastName?: Maybe<Scalars['String']>;
  maskedIdentityDocumentNumber?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  stateOfIssue?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  type?: Maybe<IdentityDocumentType>;
};

/** A tag that can be associated to a variety of other entities */
export type Tag = {
  __typename?: 'Tag';
  _id: Scalars['ObjectId'];
  businessCode?: Maybe<BusinessCode>;
  category?: Maybe<Category>;
  categoryId: Scalars['ObjectId'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export enum TagAction {
  Add = 'ADD',
  Delete = 'DELETE'
}

/** A paginated set of Tags */
export type TagPaginatedResult = {
  __typename?: 'TagPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Tag>;
};

/** A talking point for staff when speaking to a customer */
export type TalkingPoint = {
  __typename?: 'TalkingPoint';
  role: TalkingPointRole;
  text: Scalars['String'];
};

export type TalkingPointInput = {
  role: TalkingPointRole;
  text: Scalars['String'];
};

export enum TalkingPointRole {
  /** Customer Service */
  CustomerService = 'CUSTOMER_SERVICE',
  /** Flights Customer Service */
  FlightsCustomerService = 'FLIGHTS_CUSTOMER_SERVICE',
  /** Sales */
  Sales = 'SALES'
}

/** Terms that can be signed */
export type Term = {
  __typename?: 'Term';
  _id: Scalars['ObjectId'];
  archivedAt?: Maybe<Scalars['DateTime']>;
  certificationText?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['JSON']>;
  market: TermMarket;
  publishedAt?: Maybe<Scalars['DateTime']>;
  stage: TermStage;
  termType: TermType;
};

/** Apply filters to a terms query */
export type TermFilterInput = {
  businessCode?: InputMaybe<BusinessCode>;
  market?: InputMaybe<TermMarket>;
  stage?: InputMaybe<TermStage>;
  termType?: InputMaybe<TermType>;
};

/** The market the term is applicable to */
export enum TermMarket {
  Ca = 'CA',
  Us = 'US'
}

/** A paginated result of Terms */
export type TermPaginatedResult = {
  __typename?: 'TermPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Term>;
};

export enum TermSignatureMethod {
  Mobile = 'MOBILE',
  Offline = 'OFFLINE',
  Web = 'WEB'
}

/** The status of the signature */
export enum TermSignatureStatus {
  Accepted = 'ACCEPTED',
  Invalidated = 'INVALIDATED'
}

export enum TermSortField {
  PublishedAt = 'publishedAt'
}

export type TermSortInput = {
  sortAscending: Scalars['Boolean'];
  sortBy: TermSortField;
};

/** Whether the term is published, draft, or archived */
export enum TermStage {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** The type of term */
export enum TermType {
  General = 'GENERAL',
  GroupCoordinator = 'GROUP_COORDINATOR'
}

/** Signature for terms and conditions */
export type TermsSignature = {
  __typename?: 'TermsSignature';
  acceptanceMethod?: Maybe<TermSignatureMethod>;
  acceptedAt: Scalars['DateTime'];
  ipAddress?: Maybe<Scalars['String']>;
  /** Employee that recorded this signature if there was an employee */
  recordedByEmployee?: Maybe<Employee>;
  /** Id of the employee that recorded this signature if there was an employee */
  recordedByEmployeeId?: Maybe<Scalars['ObjectId']>;
  /** Customer that accepted these terms */
  signingCustomer?: Maybe<Customer>;
  /** Id of the customer that accepted these terms */
  signingCustomerId?: Maybe<Scalars['ObjectId']>;
  status?: Maybe<TermSignatureStatus>;
  termId: Scalars['ObjectId'];
};

export type TermsSignatureChecklistItem = SystemChecklistItem & {
  __typename?: 'TermsSignatureChecklistItem';
  dueDate?: Maybe<Scalars['Date']>;
  isCompleted: Scalars['Boolean'];
  status?: Maybe<TripChecklistItemStatus>;
};

/** A range between two times of day. */
export type TimeRange = {
  __typename?: 'TimeRange';
  /** The duration of the time range as a Duration object */
  duration: Duration;
  /** The start time of the range */
  from: Scalars['Time'];
  /** The end time of the range */
  to: Scalars['Time'];
};

/** Input type for creating a time range */
export type TimeRangeInput = {
  /** The start time of the range */
  from: Scalars['Time'];
  /** The end time of the range */
  to: Scalars['Time'];
};

export enum TokenEndpointAuthMethod {
  ClientSecretBasic = 'ClientSecretBasic',
  ClientSecretPost = 'ClientSecretPost'
}

export type TokenizedPaymentMethodInput = {
  /** ID of the customer who should own this payment method. If not provided, defaults to the primary customer on the order */
  customerId?: InputMaybe<Scalars['ObjectId']>;
  /** Whether this payment method is authorized for use for future payments */
  isAuthorizedForUse?: Scalars['Boolean'];
  /** Whether this payment method should be set as the default for the customer */
  isDefault?: Scalars['Boolean'];
  token: Scalars['String'];
};

/** Tour product with rooms, extensions, excursions 1-1 with Atlas Tour Division Spec */
export type Tour = PricedTripComponent & TripComponent & {
  __typename?: 'Tour';
  _id: Scalars['ObjectId'];
  activityLevel: Scalars['Int'];
  activityLevelContent?: Maybe<TourActivityLevelContent>;
  /** Airport transfer services available for this tour, organized by gateway, direction, and time window */
  airportTransfers: Array<TourAirportTransfer>;
  allowedStopoverGatewayCodes?: Maybe<Array<Scalars['String']>>;
  autoApproveDeadlineDpd: Scalars['Int'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  classLevel: Scalars['Int'];
  classLevelContent?: Maybe<TourClassLevelContent>;
  content?: Maybe<TourContent>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultCapacity?: Maybe<Scalars['Int']>;
  departures: Array<Departure>;
  deposit: Amount;
  depositForAutomaticPlan: Amount;
  depositForLateAdd: Amount;
  endGateway?: Maybe<Gateway>;
  endGatewayCode: Scalars['String'];
  excursionIds: Array<Scalars['ObjectId']>;
  excursions: Array<TourExcursion>;
  extendedFamilyCode: Scalars['String'];
  extensionIds: Array<Scalars['ObjectId']>;
  extensions: Array<TourExtension>;
  familyCode: Scalars['String'];
  feeCategoryCode?: Maybe<Scalars['FeeCategoryCode']>;
  feePrice?: Maybe<Money>;
  fees: Array<Fee>;
  finalInstallmentDeadlineDpd: Scalars['Int'];
  finalPaymentDeadlineDpd: Scalars['Int'];
  hasPriceRules: Scalars['Boolean'];
  internalName: Scalars['String'];
  isFlightShoppingAllowed: Scalars['Boolean'];
  isNonRevenueTour: Scalars['Boolean'];
  isPassportRequired: Scalars['Boolean'];
  isPostStayAllowed: Scalars['Boolean'];
  isPreStayAllowed: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  isVisaRequired: Scalars['Boolean'];
  isWaitlistAllowed: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  maxNbTripsPerSelfServiceOrder: Scalars['Int'];
  maxTravelerAge?: Maybe<Scalars['Int']>;
  minTravelerAge?: Maybe<Scalars['Int']>;
  minimumCapacity?: Maybe<Scalars['Int']>;
  /** Returns the list of tour excursions that are valid for the given tour's spec but are not yet associated with it. */
  missingExcursions: Array<TourExcursion>;
  nbCruiseNights: Scalars['Int'];
  nbDepartureFlightDays: Scalars['Int'];
  nbHotelNights: Scalars['Int'];
  nbReturningFlightDays: Scalars['Int'];
  nbTourDays: Scalars['Int'];
  overnightCountries: Array<Country>;
  placeIds: Array<Scalars['ObjectId']>;
  places: Array<Place>;
  /** Places saved on the tour, including their resolved ancestors (e.g. parent places, grandparent places, etc.) */
  placesWithAncestry: Array<Place>;
  postStayCityCodes?: Maybe<Array<Scalars['String']>>;
  preStayCityCodes?: Maybe<Array<Scalars['String']>>;
  priceRules: Array<PriceRule>;
  priceYear: PriceYear;
  privateGroup?: Maybe<PrivateGroup>;
  /**
   * The url of the tour itinerary page on the website. This will be null if the tour is CTT. Use the GC Departure microsite url instead.
   * @deprecated Use publicWebsiteUrls instead
   */
  publicWebsiteUrl?: Maybe<Scalars['String']>;
  /** The url of the tour itinerary page on the website. This will be null if the tour is CTT. Use the GC Departure microsite url instead. */
  publicWebsiteUrls: TourPublicUrls;
  rooms: Array<TourRoom>;
  startGateway?: Maybe<Gateway>;
  startGatewayCode: Scalars['String'];
  status: TripComponentStatus;
  tagIds: Array<Scalars['ObjectId']>;
  tags: Array<Tag>;
  tourCode: Scalars['String'];
  tourDivisionSpecId: Scalars['Int'];
  tourPageContent?: Maybe<TourPageContent>;
  tourSpecId: Scalars['Int'];
  tourType: TourType;
  tourTypeCode: TourTypeCode;
  type: TripComponentType;
};


/** Tour product with rooms, extensions, excursions 1-1 with Atlas Tour Division Spec */
export type TourActivityLevelContentArgs = {
  language: Scalars['String'];
};


/** Tour product with rooms, extensions, excursions 1-1 with Atlas Tour Division Spec */
export type TourClassLevelContentArgs = {
  language: Scalars['String'];
};


/** Tour product with rooms, extensions, excursions 1-1 with Atlas Tour Division Spec */
export type TourContentArgs = {
  language: Scalars['String'];
};


/** Tour product with rooms, extensions, excursions 1-1 with Atlas Tour Division Spec */
export type TourFeePriceArgs = {
  currencyCode: CurrencyCode;
  departureDate: Scalars['Date'];
  typeCode: FeeTypeCode;
};


/** Tour product with rooms, extensions, excursions 1-1 with Atlas Tour Division Spec */
export type TourTourPageContentArgs = {
  language: Scalars['String'];
};

/** Accommodation content of a Tour */
export type TourAccommodationContent = {
  __typename?: 'TourAccommodationContent';
  amenities: Array<IconContent>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<ContentAsset>;
  location?: Maybe<Scalars['String']>;
  mediaAssets?: Maybe<Array<TourAssetUnion>>;
  name?: Maybe<Scalars['String']>;
};

export type TourActivityLevelContent = {
  __typename?: 'TourActivityLevelContent';
  activityLevel?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<ContentAsset>;
  name?: Maybe<Scalars['String']>;
};

/** Airport transfer service for a tour or extension, providing transportation between the airport and tour start/end points within a specific time window */
export type TourAirportTransfer = PricedTripComponent & TripComponent & {
  __typename?: 'TourAirportTransfer';
  /** Unique identifier for the airport transfer */
  _id: Scalars['ObjectId'];
  /** Days before departure when transfers can still be auto-confirmed. After this deadline, transfers require manual approval. If not set, the transfer always requires manual approval */
  autoApproveDeadlineDpd?: Maybe<Scalars['Int']>;
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  /** Transfer direction: 'INBOUND' for airport to hotel, 'OUTBOUND' for hotel to airport */
  direction: AirportTransferDirection;
  /** Airport/gateway code where the transfer service operates (e.g., 'AMS', 'CDG') */
  gatewayCode: Scalars['String'];
  hasPriceRules: Scalars['Boolean'];
  /** Internal display name for the airport transfer (e.g., 'Amsterdam Arrival Transfer') */
  internalName: Scalars['String'];
  isPublished: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  priceRules: Array<PriceRule>;
  /** Price year for the airport transfer, allowing different pricing per year */
  priceYear: PriceYear;
  status: TripComponentStatus;
  /** Time window during which flights must arrive/depart to be eligible for this transfer service */
  timeRange: TimeRange;
  /** Code of the tour this transfer belongs to */
  tourCode: Scalars['String'];
  type: TripComponentType;
  /** Classification of the time window for the airport transfer, e.g. standard or non-standard hours */
  windowType: AirportTransferWindowType;
};

/** Airport transfer service line item for main tour or extension */
export type TourAirportTransferLineItem = LineItem & {
  __typename?: 'TourAirportTransferLineItem';
  _id: Scalars['ObjectId'];
  /** Airline information for the traveler's flight */
  airline?: Maybe<Airline>;
  /** Airline code for the traveler's flight (e.g., 'KL', 'AF') */
  airlineCode?: Maybe<Scalars['String']>;
  /** Whether this transfer is for the main tour or an extension */
  airportTransferTourType: AirportTransferTourType;
  /** Arrival airport code for the traveler's flight */
  arrivalGateway: Scalars['String'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  /** Departure airport code for the traveler's flight */
  departureGateway: Scalars['String'];
  /** Transfer direction: INBOUND (airport to hotel) or OUTBOUND (hotel to airport) */
  direction: AirportTransferDirection;
  /** Flight number for the traveler's flight. Usually two characters for the airline, plus a number */
  flightNumber: Scalars['String'];
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  /** The local arrival date and time (at the arrival airport) of the traveler's flight, without timezone information */
  localArrivalDate: Scalars['LocalDateTime'];
  /** The local departure date and time (at the departure airport) of the traveler's flight, without timezone information */
  localDepartureDate: Scalars['LocalDateTime'];
  /** 6 character alphanumeric code identifying the flight booking */
  pnrLocator?: Maybe<Scalars['String']>;
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  /** The time range during which the flight must arrive or depart to be eligible for this transfer */
  timeRange: TimeRange;
  /** Reference to the TourAirportTransfer on the Tour */
  tourAirportTransferId: Scalars['ObjectId'];
  /** Airport code where the traveler will be picked up or dropped off, derived from the direction */
  transferGatewayCode: Scalars['String'];
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
  /** Classification of the time window (STANDARD or NON_STANDARD) */
  windowType: AirportTransferWindowType;
};

/** An offer for a tour airport transfer */
export type TourAirportTransferOffer = {
  __typename?: 'TourAirportTransferOffer';
  /** The _id of the TourAirportTransfer */
  _id: Scalars['ObjectId'];
  airportTransfer: TourAirportTransfer;
  /** Whether this transfer is for the main tour or an extension */
  airportTransferTourType: AirportTransferTourType;
  price: Money;
};

export type TourAssetUnion = TourImage | TourVideo;

export type TourBed = {
  __typename?: 'TourBed';
  capacity: Scalars['Int'];
  code: TourBedCode;
  count: Scalars['Int'];
  name: Scalars['String'];
};

export enum TourBedCode {
  /** Double */
  Db = 'DB',
  /** Family */
  Fa = 'FA',
  /** Quad */
  Qu = 'QU',
  /** Single */
  Si = 'SI',
  /** Student */
  St = 'ST',
  /** Twin */
  Tw = 'TW'
}

export type TourClassLevelContent = {
  __typename?: 'TourClassLevelContent';
  classLevel?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<ContentAsset>;
  name?: Maybe<Scalars['String']>;
  roomingDescription?: Maybe<Scalars['String']>;
  roomingDetailedDescription?: Maybe<Scalars['String']>;
  roomingUpgradeDescription?: Maybe<Scalars['String']>;
  tripBuilderSelectedMessage?: Maybe<Scalars['String']>;
};

/** Content describing a Tour for a specific year */
export type TourContent = {
  __typename?: 'TourContent';
  accommodationIds?: Maybe<Array<Scalars['String']>>;
  accommodations: Array<TourAccommodationContent>;
  assets: Array<TourAssetUnion>;
  badge?: Maybe<ProductBadgeContent>;
  badgeId?: Maybe<Scalars['String']>;
  businessCode?: Maybe<BusinessCode>;
  cardImage?: Maybe<ContentAsset>;
  /** Equipment offered on the tour */
  equipment?: Maybe<Array<TourEquipmentContent>>;
  equipmentDescription?: Maybe<Scalars['String']>;
  /** Summary of the types of equipment offered on the tour */
  equipmentSummary?: Maybe<TourDetailSummaryContent>;
  extension?: Maybe<TourExtensionContent>;
  extensionId?: Maybe<Scalars['String']>;
  /** Marketing FAQ content */
  faq?: Maybe<FaqContent>;
  faqId?: Maybe<Scalars['String']>;
  highlights: Array<TourHighlightContent>;
  id: Scalars['String'];
  includesBreakfast?: Maybe<Scalars['Boolean']>;
  inclusions: Array<TourHighlightContent>;
  itineraryItems: Array<TourItineraryElementUnion>;
  language?: Maybe<Scalars['String']>;
  mapImage?: Maybe<ContentAsset>;
  maximumGroupSize?: Maybe<Scalars['Int']>;
  minimumGroupSize?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nbCities?: Maybe<Scalars['Int']>;
  nbDays?: Maybe<Scalars['Int']>;
  nbDaysWithExtension?: Maybe<Scalars['Int']>;
  overviewDescription?: Maybe<Scalars['String']>;
  overviewTitle?: Maybe<Scalars['String']>;
  pace?: Maybe<Scalars['String']>;
  /** FAQ content for customers who are booked */
  postBookingFaq?: Maybe<FaqContent>;
  priceYear?: Maybe<Scalars['Int']>;
  publicDepartures: Array<Departure>;
  specialDeparturesIcon?: Maybe<ContentAsset>;
  tour?: Maybe<Tour>;
  tourCode?: Maybe<Scalars['String']>;
  tourPartnershipLogo?: Maybe<ContentAsset>;
};

/** A paginated result of TourContent */
export type TourContentPaginatedResult = {
  __typename?: 'TourContentPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<TourContent>;
};

/** Input for searching tour content using semantic search */
export type TourContentSearchInput = {
  /** Optional filters for vector search */
  filter?: InputMaybe<TourContentVectorFilterInput>;
  /** Maximum number of results to return (default: 20) */
  limit?: Scalars['Int'];
  /** The search query text */
  query: Scalars['String'];
  /** Whether to apply reranking to improve relevance (default: true) */
  rerank?: Scalars['Boolean'];
};

/** Filters for tour content vector search */
export type TourContentVectorFilterInput = {
  businessCode?: InputMaybe<BusinessCode>;
  language?: InputMaybe<Scalars['String']>;
  /** Maximum price year (inclusive) */
  maxPriceYear?: InputMaybe<Scalars['Int']>;
  /** Minimum price year (inclusive) */
  minPriceYear?: InputMaybe<Scalars['Int']>;
  tourCodes?: InputMaybe<Array<Scalars['String']>>;
};

/** A tour content item with its relevance score from semantic search */
export type TourContentVectorSearchResult = {
  __typename?: 'TourContentVectorSearchResult';
  result: TourContent;
  score: Scalars['Float'];
};

/** Itinerary day content of a Tour */
export type TourDayContent = {
  __typename?: 'TourDayContent';
  /** Day number of the tour. For example, '1' is the first day of tour */
  day?: Maybe<Scalars['Int']>;
  /** Number of days this day spans inclusive of the day itself */
  dayRangeLength?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  excursionIds: Array<Scalars['String']>;
  excursions?: Maybe<Array<TourExcursionContent>>;
  freeTimeSuggestions?: Maybe<Scalars['String']>;
  highlights?: Maybe<Scalars['String']>;
  /** Whether this day spans multiple days */
  isRange?: Maybe<Scalars['Boolean']>;
  kind: Scalars['String'];
  meals: Array<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  physicalActivity?: Maybe<Scalars['String']>;
  /** @deprecated Use day, isRange, and dayRangeLength instead */
  prefix?: Maybe<Scalars['String']>;
};

export type TourDetailSummaryContent = {
  __typename?: 'TourDetailSummaryContent';
  description?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Tour Director */
export type TourDirector = User & {
  __typename?: 'TourDirector';
  _id: Scalars['ObjectId'];
  bio?: Maybe<Scalars['String']>;
  /** Get the chat user ID for the Tour Director for the given business code */
  chatUserId?: Maybe<Scalars['String']>;
  /** The Departures with which the Tour Director is associated */
  departures?: Maybe<Array<Departure>>;
  /** Email, not returned to a customer if hidden by the TD */
  email?: Maybe<Scalars['Email']>;
  entraId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hideEmail?: Maybe<Scalars['Boolean']>;
  hidePhoneNumber?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  /** Phone number, not returned to a customer if hidden by the TD */
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  /** The tour director's profile image asset */
  profileImageAsset?: Maybe<Asset>;
  /** Get a tour director's saved places */
  savedPlaces: Array<SavedPlace>;
  supplierId: Scalars['Int'];
  tourDirectorId: Scalars['ObjectId'];
};


/** Tour Director */
export type TourDirectorChatUserIdArgs = {
  businessCode: BusinessCode;
};


/** Tour Director */
export type TourDirectorDeparturesArgs = {
  businessCodes?: InputMaybe<Array<BusinessCode>>;
};


/** Tour Director */
export type TourDirectorSavedPlacesArgs = {
  businessCode?: InputMaybe<BusinessCode>;
  types?: InputMaybe<Array<Scalars['String']>>;
};

/** Tour director annual evaluation summary */
export type TourDirectorAnnualEvaluationSummary = {
  __typename?: 'TourDirectorAnnualEvaluationSummary';
  /** The average percentage based on the average score and the maximum score */
  averagePercentage: Scalars['Float'];
  /** The average score based on all questions for a give year */
  averageScore: Scalars['Float'];
  /** Departure evaluation statistics */
  departureEvaluationSummaries: Array<DepartureEvaluationSummary>;
  /** List of departures */
  departures: Array<Departure>;
  /** List of score ranges, based on the average score of each departure */
  ranges: Array<EvaluationScoreRange>;
  /** Year of the evaluation */
  year: Scalars['String'];
};

/** Tour director evaluation summary */
export type TourDirectorEvaluationSummary = {
  __typename?: 'TourDirectorEvaluationSummary';
  /** List of annual evaluation summaries */
  annualEvaluationSummaries: Array<TourDirectorAnnualEvaluationSummary>;
  /** Tour director ID */
  tourDirectorId: Scalars['ObjectId'];
};

/** A paginated result of Tour Directors */
export type TourDirectorPaginatedResult = {
  __typename?: 'TourDirectorPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<TourDirector>;
};

export enum TourDirectorSortField {
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName',
  SupplierId = 'supplierId'
}

/** Tour director tour end report */
export type TourDirectorTourEndReport = Evaluation & {
  __typename?: 'TourDirectorTourEndReport';
  _id: Scalars['ObjectId'];
  /** The date that the evaluation is available */
  availabilityDate: Scalars['DateTime'];
  businessCode?: Maybe<BusinessCode>;
  /** The date that the evaluation is due */
  deadlineDate: Scalars['DateTime'];
  /** The departure ID of the departure that this evaluation belong to */
  departureId: Scalars['ObjectId'];
  evaluationType: EvaluationType;
  /** The date that the evaluation was finalized */
  finalizationDate?: Maybe<Scalars['DateTime']>;
  hasAnsweredQuestions: Scalars['Boolean'];
  questions: Array<EvaluationQuestion>;
  /** The date that the evaluation was submitted */
  submissionDate?: Maybe<Scalars['DateTime']>;
  templateId: Scalars['ObjectId'];
  userId: Scalars['ObjectId'];
};

/** Tour director tour end report settings */
export type TourDirectorTourEndReportSettings = {
  __typename?: 'TourDirectorTourEndReportSettings';
  /** List component types to make tour director tour end report questions for. */
  componentTypeCodes: Array<Scalars['String']>;
  /** the number of days before a departure or before a departure end that eval availabilityDate should be set */
  nbDaysUntilEvaluationAvailable?: Maybe<Scalars['Int']>;
  /** the number of days after a departure that an eval is due */
  nbDaysUntilEvaluationDue?: Maybe<Scalars['Int']>;
  /** Determines if component questions should be generated on the tour end report */
  shouldGenerateComponentQuestions?: Maybe<Scalars['Boolean']>;
};

/** A paginated result of Tour Directors */
export type TourEndReportPaginatedResult = {
  __typename?: 'TourEndReportPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<TourDirectorTourEndReport>;
};

export enum TourEndReportSortField {
  AvailabilityDate = 'availabilityDate'
}

export type TourEquipmentContent = {
  __typename?: 'TourEquipmentContent';
  assets: Array<TourAssetUnion>;
  cardImage?: Maybe<ContentAsset>;
  description?: Maybe<Scalars['String']>;
  detailedName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  specs?: Maybe<Scalars['String']>;
};

/** Excursion belonging to either a tour or extension */
export type TourExcursion = PricedTripComponent & TripComponent & {
  __typename?: 'TourExcursion';
  _id: Scalars['ObjectId'];
  /** The deadline past which the status of this Excursion will be REQUESTED when added to a Trip. Null when fully sellable before and during a tour. */
  autoApproveDeadlineDpd?: Maybe<Scalars['Int']>;
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  content?: Maybe<TourExcursionContent>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasPriceRules: Scalars['Boolean'];
  internalName: Scalars['String'];
  /** Whether or not this excursion has a restricted purchase window. */
  isPrebook: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  matchCode: Scalars['String'];
  /** The minimum number of travelers required for this excursion to be confirmed. */
  minNbTravelersRequired: Scalars['Int'];
  nbTourExtensions: Scalars['Int'];
  nbTours: Scalars['Int'];
  placeIds: Array<Scalars['ObjectId']>;
  places: Array<Place>;
  priceRules: Array<PriceRule>;
  priceYear: PriceYear;
  status: TripComponentStatus;
  tagIds: Array<Scalars['ObjectId']>;
  tags: Array<Tag>;
  tourExtensions: Array<TourExtension>;
  tours: Array<Tour>;
  type: TripComponentType;
};


/** Excursion belonging to either a tour or extension */
export type TourExcursionContentArgs = {
  language: Scalars['String'];
};

/** Content describing a tour excursion */
export type TourExcursionContent = {
  __typename?: 'TourExcursionContent';
  departureInfo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<ContentAsset>;
  /** The lowest price for this excursion across all future, SELL departures. */
  lowestPrice?: Maybe<Money>;
  /** An array containing the lowest price for this excursion per tour code. If a tour code is provided, only the lowest price for that tour code is returned. */
  lowestPrices?: Maybe<Array<TourExcursionLowestPricePerTourCode>>;
  matchCode?: Maybe<Scalars['String']>;
  mediaAssets?: Maybe<Array<TourAssetUnion>>;
  name?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
};


/** Content describing a tour excursion */
export type TourExcursionContentLowestPriceArgs = {
  currencyCode: CurrencyCode;
};


/** Content describing a tour excursion */
export type TourExcursionContentLowestPricesArgs = {
  currencyCode: CurrencyCode;
  tourCode?: InputMaybe<Scalars['String']>;
};

export type TourExcursionLineItem = LineItem & {
  __typename?: 'TourExcursionLineItem';
  _id: Scalars['ObjectId'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  departureExcursionId: Scalars['ObjectId'];
  excursionTourType: ExcursionTourType;
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

export type TourExcursionLowestPricePerTourCode = {
  __typename?: 'TourExcursionLowestPricePerTourCode';
  lowestPrice: Money;
  tourCode: Scalars['String'];
};

/** A paginated result of Tour excursions */
export type TourExcursionPaginatedResult = {
  __typename?: 'TourExcursionPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<TourExcursion>;
  totalCount: Scalars['Int'];
};

export enum TourExcursionSortField {
  AutoApproveDeadlineDpd = 'autoApproveDeadlineDpd',
  BasePriceCad = 'basePriceCAD',
  BasePriceUsd = 'basePriceUSD',
  CreatedAt = 'createdAt',
  InternalName = 'internalName',
  LineItemCode = 'lineItemCode',
  MatchCode = 'matchCode',
  MinNbTravelersRequired = 'minNbTravelersRequired',
  PriceYear = 'priceYear'
}

export type TourExcursionSpec = {
  __typename?: 'TourExcursionSpec';
  _id: Scalars['ObjectId'];
  businessCode: BusinessCode;
  internalName: Scalars['String'];
  matchCode: Scalars['String'];
  year: Scalars['Int'];
};

/** A paginated result of Tour Excursion Specs */
export type TourExcursionSpecPaginatedResult = {
  __typename?: 'TourExcursionSpecPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<TourExcursionSpec>;
};

/** Pre or Post extension */
export type TourExtension = PricedTripComponent & TripComponent & {
  __typename?: 'TourExtension';
  _id: Scalars['ObjectId'];
  /** Airport transfer services available for this extension, organized by gateway, direction, and time window */
  airportTransfers: Array<TourAirportTransfer>;
  autoApproveDeadlineDpd: Scalars['Int'];
  basePrice: Amount;
  businessCode?: Maybe<BusinessCode>;
  content?: Maybe<TourExtensionContent>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultCapacity: Scalars['Int'];
  endGatewayCode: Scalars['String'];
  excursionIds: Array<Scalars['ObjectId']>;
  excursions: Array<TourExcursion>;
  extendedFamilyCode: Scalars['String'];
  familyCode: Scalars['String'];
  hasPriceRules: Scalars['Boolean'];
  internalName: Scalars['String'];
  isFlightShoppingAllowed: Scalars['Boolean'];
  isPreExtension: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  minimumCapacity?: Maybe<Scalars['Int']>;
  /** Returns the list of tour extension excursions that are valid for the given tour's extension spec but are not yet associated with it. */
  missingExcursions: Array<TourExcursion>;
  nbTourDays: Scalars['Int'];
  overnightCountries: Array<Country>;
  placeIds: Array<Scalars['ObjectId']>;
  places: Array<Place>;
  postStayCityCodes?: Maybe<Array<Scalars['String']>>;
  preStayCityCodes?: Maybe<Array<Scalars['String']>>;
  priceRules: Array<PriceRule>;
  priceYear: PriceYear;
  rooms: Array<TourRoom>;
  startGatewayCode: Scalars['String'];
  status: TripComponentStatus;
  tagIds: Array<Scalars['ObjectId']>;
  tags: Array<Tag>;
  tour?: Maybe<Tour>;
  tourCode: Scalars['String'];
  tourSpecId: Scalars['Int'];
  tourType: TourType;
  tourTypeCode: TourTypeCode;
  type: TripComponentType;
};


/** Pre or Post extension */
export type TourExtensionContentArgs = {
  language: Scalars['String'];
};

export type TourExtensionContent = {
  __typename?: 'TourExtensionContent';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<ContentAsset>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isPreExtension?: Maybe<Scalars['Boolean']>;
  itineraryItems: Array<TourItineraryElementUnion>;
  name?: Maybe<Scalars['String']>;
  nbDaysOverlap?: Maybe<Scalars['Int']>;
  nbNights?: Maybe<Scalars['Int']>;
  tourCode?: Maybe<Scalars['String']>;
};

/** Line item for the extension of a trip */
export type TourExtensionLineItem = LineItem & {
  __typename?: 'TourExtensionLineItem';
  _id: Scalars['ObjectId'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  departureDate: Scalars['Date'];
  departureExtensionId: Scalars['ObjectId'];
  endDate: Scalars['Date'];
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

/** A paginated result of Tours */
export type TourExtensionPaginatedResult = {
  __typename?: 'TourExtensionPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<TourExtension>;
  totalCount: Scalars['Int'];
};

export enum TourExtensionSortField {
  AutoApproveDeadlineDpd = 'autoApproveDeadlineDpd',
  BasePriceCad = 'basePriceCAD',
  BasePriceUsd = 'basePriceUSD',
  CreatedAt = 'createdAt',
  DefaultCapacity = 'defaultCapacity',
  EndGatewayCode = 'endGatewayCode',
  InternalName = 'internalName',
  LineItemCode = 'lineItemCode',
  NbTourDays = 'nbTourDays',
  PriceYear = 'priceYear',
  StartGatewayCode = 'startGatewayCode',
  TourCode = 'tourCode',
  TourType = 'tourType',
  TourTypeCode = 'tourTypeCode'
}

/** Highlight content of a Tour */
export type TourHighlightContent = {
  __typename?: 'TourHighlightContent';
  isPrintable?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

/** Image asset of a Tour */
export type TourImage = {
  __typename?: 'TourImage';
  caption?: Maybe<Scalars['String']>;
  image?: Maybe<ContentAsset>;
  kind: Scalars['String'];
};

export type TourItineraryElementUnion = TourDayContent | TourItineraryItemContent;

/** Itinerary item content of a Tour */
export type TourItineraryItemContent = {
  __typename?: 'TourItineraryItemContent';
  days: Array<TourDayContent>;
  kind: Scalars['String'];
  nbNights?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** Line item that represents the main tour */
export type TourLineItem = LineItem & {
  __typename?: 'TourLineItem';
  _id: Scalars['ObjectId'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  departureDate: Scalars['Date'];
  departureId: Scalars['ObjectId'];
  endDate: Scalars['Date'];
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

/** Content describing a tour page */
export type TourPageContent = {
  __typename?: 'TourPageContent';
  alternateYears: Array<TourPageContentAlternateYear>;
  breadcrumbParent?: Maybe<TourPageContentBreadcrumbParent>;
  breadcrumbParentId?: Maybe<Scalars['String']>;
  colorPalette?: Maybe<Scalars['String']>;
  firstPublished?: Maybe<Scalars['DateTime']>;
  fullSlug: Scalars['String'];
  id: Scalars['String'];
  isHiddenFromSearch?: Maybe<Scalars['Boolean']>;
  primaryMessageBody?: Maybe<Scalars['String']>;
  primaryMessageStatus?: Maybe<Scalars['String']>;
  primaryMessageTitle?: Maybe<Scalars['String']>;
  reviewAggregate: ReviewAggregate;
  reviewSummary?: Maybe<TourPageReviewSummary>;
  specialDepartures?: Maybe<Array<ContentTextLink>>;
  tourCodes: Array<Scalars['String']>;
  tourContent?: Maybe<TourContent>;
  tourId?: Maybe<Scalars['String']>;
  tourPageSearchHit?: Maybe<TourPageSearchHit>;
  tripBuilderContentId?: Maybe<Scalars['String']>;
  tripBuilderPriceHelpText?: Maybe<Scalars['String']>;
};


/** Content describing a tour page */
export type TourPageContentTourContentArgs = {
  alternateYearTourId?: InputMaybe<Scalars['String']>;
};


/** Content describing a tour page */
export type TourPageContentTourPageSearchHitArgs = {
  market: SearchHitMarket;
};

/** Alternate year for a tour page */
export type TourPageContentAlternateYear = {
  __typename?: 'TourPageContentAlternateYear';
  tourId?: Maybe<Scalars['String']>;
  yearLabel?: Maybe<Scalars['String']>;
};

/** Parent of tour page used to create its ancestry */
export type TourPageContentBreadcrumbParent = {
  __typename?: 'TourPageContentBreadcrumbParent';
  ancestors: Array<ContentAncestor>;
  fullSlug: Scalars['String'];
  name: Scalars['String'];
};

/** A paginated result of TourPageContent */
export type TourPagePaginatedResult = {
  __typename?: 'TourPagePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<TourPageContent>;
};

/** The AI summary of the reviews for a given tour page */
export type TourPageReviewSummary = {
  __typename?: 'TourPageReviewSummary';
  _id: Scalars['ObjectId'];
  businessCode: BusinessCode;
  generatedAt: Scalars['DateTime'];
  summary: Scalars['String'];
  tourPageContentId: Scalars['String'];
};

/** Tour page search hit representing a tour page in search results */
export type TourPageSearchHit = {
  __typename?: 'TourPageSearchHit';
  activityLevel?: Maybe<SearchHitActivityLevel>;
  altText?: Maybe<Scalars['String']>;
  assets?: Maybe<Array<SearchHitTourAssetUnion>>;
  businessCode: Scalars['String'];
  cardImage?: Maybe<SearchHitContentAsset>;
  categorizedTags: Scalars['JSON'];
  cities: Array<Scalars['String']>;
  classLevel?: Maybe<SearchHitClassLevel>;
  continents: Array<Scalars['String']>;
  countries: Array<Scalars['String']>;
  dates: Array<Scalars['Date']>;
  estimatedBiweeklyPayment?: Maybe<Scalars['Float']>;
  extensionName?: Maybe<Scalars['String']>;
  firstPublished?: Maybe<Scalars['DateTime']>;
  hasExtension: Scalars['Boolean'];
  highestDiscount: Scalars['Float'];
  highestDiscountFormatted: Scalars['String'];
  highlights: Array<TourHighlightContent>;
  id: Scalars['String'];
  interestsAndActivities: Array<Scalars['String']>;
  isExtensionHidden: Scalars['Boolean'];
  isFeatured: Scalars['Boolean'];
  isOnSale: Scalars['Boolean'];
  itineraryDays: Array<TourPageSearchHitItineraryDay>;
  lowestEffectivePrice?: Maybe<Scalars['Float']>;
  mapImage?: Maybe<SearchHitContentAsset>;
  market: SearchHitMarket;
  name?: Maybe<Scalars['String']>;
  nbCities?: Maybe<Scalars['Int']>;
  nbDays?: Maybe<Scalars['Int']>;
  nbDaysWithExtension?: Maybe<Scalars['Int']>;
  nbDepartures: Scalars['Int'];
  nbRatings: Scalars['Int'];
  objectID: Scalars['String'];
  overviewDescription?: Maybe<Scalars['String']>;
  places: Array<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  priceBadge?: Maybe<SearchHitPriceBadge>;
  priceFormatted?: Maybe<Scalars['String']>;
  priceRanges: Array<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  salePrice?: Maybe<Scalars['Float']>;
  salePriceFormatted?: Maybe<Scalars['String']>;
  score: Scalars['Float'];
  similarTourPages: Array<TourPageSearchHit>;
  subtitle?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  tourBadge?: Maybe<SearchHitProductBadge>;
  tourCode?: Maybe<Scalars['String']>;
  tourId?: Maybe<Scalars['String']>;
  tourLengthRange: Scalars['String'];
  travelStyles: Array<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

/** Itinerary day information for tour page search hits */
export type TourPageSearchHitItineraryDay = {
  __typename?: 'TourPageSearchHitItineraryDay';
  day?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  freeTimeSuggestions?: Maybe<Scalars['String']>;
  highlights?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sectionTitle?: Maybe<Scalars['String']>;
};

/** Input for searching tour page search hits using semantic search */
export type TourPageSearchHitSearchInput = {
  businessCode: BusinessCode;
  /** Maximum number of results to return (default: 20) */
  limit?: Scalars['Int'];
  /** The market identifier */
  market: SearchHitMarket;
  /** The search query text */
  query: Scalars['String'];
  /** Whether to apply reranking to improve relevance (default: true) */
  rerank?: Scalars['Boolean'];
};

/** A tour page search hit with its relevance score from semantic search */
export type TourPageSearchHitVectorSearchResult = {
  __typename?: 'TourPageSearchHitVectorSearchResult';
  result: TourPageSearchHit;
  score: Scalars['Float'];
};

/** A paginated result of Tours */
export type TourPaginatedResult = {
  __typename?: 'TourPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Tour>;
  totalCount: Scalars['Int'];
};

export type TourPublicUrls = {
  __typename?: 'TourPublicUrls';
  ca?: Maybe<Scalars['String']>;
  us?: Maybe<Scalars['String']>;
};

/** Room belonging to either a tour or extension */
export type TourRoom = PricedTripComponent & TripComponent & {
  __typename?: 'TourRoom';
  _id: Scalars['ObjectId'];
  basePrice: Amount;
  bed: TourBed;
  businessCode?: Maybe<BusinessCode>;
  cabinCode?: Maybe<Scalars['TourCabinCode']>;
  defaultCapacity: Scalars['Int'];
  /** @deprecated Use requiresCompleteRoommates instead. */
  enableRoommateMatching: Scalars['Boolean'];
  hasPriceRules: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  priceRules: Array<PriceRule>;
  priceYear: PriceYear;
  /** Whether or not this room must have complete roommates */
  requiresCompleteRoommates: Scalars['Boolean'];
  status: TripComponentStatus;
  type: TripComponentType;
};

/** Rooming for main tour or extension */
export type TourRoomLineItem = LineItem & {
  __typename?: 'TourRoomLineItem';
  _id: Scalars['ObjectId'];
  cancellationDate?: Maybe<Scalars['Date']>;
  cancellationMeta?: Maybe<LineItemCancellationMeta>;
  isOpen: Scalars['Boolean'];
  isPurchased: Scalars['Boolean'];
  isQuoted: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  price: Money;
  rollsUpToTarget: Scalars['Boolean'];
  roomTourType: RoomTourType;
  roommate?: Maybe<Roommate>;
  status: LineItemStatus;
  targetLineItemId?: Maybe<Scalars['ObjectId']>;
  tripId: Scalars['ObjectId'];
  type: TripComponentType;
};

/** Departure date range of returned results */
export type TourSearchDateRangeInput = {
  /** Earliest departure date */
  from?: InputMaybe<Scalars['Date']>;
  /** Latest departure date */
  to?: InputMaybe<Scalars['Date']>;
};

/** Optional filters for tour search (merged with filters extracted from the query) */
export type TourSearchFiltersInput = {
  departureDate?: InputMaybe<TourSearchDateRangeInput>;
  locations?: InputMaybe<TourSearchLocationsInput>;
  priceRange?: InputMaybe<TourSearchPriceRangeInput>;
};

/** Input for searching tours using semantic search */
export type TourSearchInput = {
  businessCode: BusinessCode;
  /** Optional input filters to apply (merged with filters extracted from the query) */
  filters?: InputMaybe<TourSearchFiltersInput>;
  /** Maximum number of results to return (default: 20) */
  limit?: Scalars['Int'];
  /** The market identifier */
  market: SearchHitMarket;
  /** The search query text */
  query: Scalars['String'];
  /** Whether to apply reranking, a second pass on results from vector search that reranks and reorders results to improve relevance (default: true) */
  rerank?: Scalars['Boolean'];
};

/** Tour search result when using keyword search */
export type TourSearchKeywordResult = {
  __typename?: 'TourSearchKeywordResult';
  reason: Scalars['String'];
  type: Scalars['String'];
};

/** Location filters for tour search */
export type TourSearchLocationsInput = {
  /** Filter by cities */
  cities?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by continents */
  continents?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by countries */
  countries?: InputMaybe<Array<Scalars['String']>>;
};

/** Price range of returned results */
export type TourSearchPriceRangeInput = {
  /** Maximum price filter */
  max?: InputMaybe<Scalars['Int']>;
  /** Minimum price filter */
  min?: InputMaybe<Scalars['Int']>;
};

export type TourSearchResult = TourSearchKeywordResult | TourSearchSemanticResult;

/** Tour search result when using semantic search */
export type TourSearchSemanticResult = {
  __typename?: 'TourSearchSemanticResult';
  results: Array<TourPageSearchHitVectorSearchResult>;
  type: Scalars['String'];
};

/** Tour search specific settings */
export type TourSearchSettings = {
  __typename?: 'TourSearchSettings';
  /** Percentage range for 'around' price queries (e.g., 20 for 20%) */
  aroundPriceRangePercentage: Scalars['Percentage'];
  /** Maximum prices in USD and CAD for budget tours */
  budgetMaxPrice: Amount;
  /** Minimum price in USD and CAD for luxury tours */
  luxuryMinPrice: Amount;
};

export enum TourSortField {
  AutoApproveDeadlineDpd = 'autoApproveDeadlineDpd',
  CreatedAt = 'createdAt',
  DefaultCapacity = 'defaultCapacity',
  FinalPaymentDeadlineDpd = 'finalPaymentDeadlineDpd',
  InternalName = 'internalName',
  LineItemCode = 'lineItemCode',
  NbCruiseNights = 'nbCruiseNights',
  NbDepartureFlightDays = 'nbDepartureFlightDays',
  NbHotelNights = 'nbHotelNights',
  NbReturningFlightDays = 'nbReturningFlightDays',
  NbTourDays = 'nbTourDays',
  PriceYear = 'priceYear',
  TourCode = 'tourCode',
  TourType = 'tourType',
  TourTypeCode = 'tourTypeCode'
}

export type TourSpec = {
  __typename?: 'TourSpec';
  _id: Scalars['ObjectId'];
  businessCode: BusinessCode;
  endGatewayCode: Scalars['String'];
  excursionMatchCodes: Array<Scalars['String']>;
  extendedFamilyCode: Scalars['String'];
  familyCode: Scalars['String'];
  internalName: Scalars['String'];
  isExtension: Scalars['Boolean'];
  nbCruiseNights: Scalars['Int'];
  nbHotelNights: Scalars['Int'];
  nbTourDays: Scalars['Int'];
  overnightCountryCodes: Array<Scalars['String']>;
  startGatewayCode: Scalars['String'];
  tourCode: Scalars['String'];
  tourDivisionSpecId: Scalars['Int'];
  tourSpecId: Scalars['Int'];
  typeCode: Scalars['String'];
  year: Scalars['Int'];
};

/** A paginated result of Tours */
export type TourSpecPaginatedResult = {
  __typename?: 'TourSpecPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<TourSpec>;
};

export enum TourTagAction {
  Add = 'ADD',
  Delete = 'DELETE'
}

export enum TourType {
  Cruise = 'CRUISE',
  Land = 'LAND'
}

export enum TourTypeCode {
  Bro = 'BRO',
  Ctt = 'CTT'
}

/** Video asset of a Tour */
export type TourVideo = {
  __typename?: 'TourVideo';
  caption?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  wistiaVideoId?: Maybe<Scalars['String']>;
};

export type TransactionPaymentMethod = AchPaymentMethod | AffirmPaymentMethod | CardPaymentMethod | CheckPaymentMethod | EfTransferPaymentMethod | TransferPaymentMethod | VoucherPaymentMethod;

/** Settings for transactional emails. */
export type TransactionalEmailSettings = {
  __typename?: 'TransactionalEmailSettings';
  /** Campaign ID for the transactional email service */
  campaignId: Scalars['Int'];
  /** Description of the transactional email purpose */
  description: Scalars['String'];
  /** Internal code identifier for the transactional email */
  internalCode: Scalars['String'];
  /** Whether this transactional email is active */
  isActive: Scalars['Boolean'];
  /** Number of days in advance to send the notification */
  nbNotificationDaysInAdvance?: Maybe<Scalars['Int']>;
};

export type TransferPaymentMethod = {
  __typename?: 'TransferPaymentMethod';
  destinationOrderId: Scalars['ObjectId'];
  reasonCode: TransferReasonCode;
  sourceOrderId: Scalars['ObjectId'];
  sourcePaymentMethod: TransactionPaymentMethod;
};

export type TransferPaymentMethodInput = {
  paymentMethodHash?: InputMaybe<Scalars['String']>;
  /** @deprecated Please begin using paymentMethodHash */
  savedPaymentMethodId?: InputMaybe<Scalars['ObjectId']>;
  transferFromBookingId: Scalars['ObjectId'];
};

/** The reason code for a transfer payment */
export enum TransferReasonCode {
  /** The transfer was the result of a fork. */
  Fork = 'FORK',
  /** The transfer was the result of a merge. */
  Merge = 'MERGE',
  /** The transfer was the result of a rebooking. */
  Rebooking = 'REBOOKING',
  /** The transfer was done adhoc. */
  Transfer = 'TRANSFER'
}

/** Transfer part of all of the balance from one WOJO Voucher to another */
export type TransferVoucherExternalInput = {
  /** The ID of the source voucher to transfer from */
  fromVoucherId: Scalars['ObjectId'];
  /** The product that the voucher is being transferred to */
  transferBusinessUnit: Scalars['String'];
};

export type TransferVoucherExternalResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** Transfer part of all of the balance from one WOJO Voucher to another */
export type TransferVoucherInternalInput = {
  /** The amount to transfer. Cannot exceed the balance of the source voucher */
  amount: MoneyInput;
  /** The ID of the source voucher to transfer from */
  fromVoucherId: Scalars['ObjectId'];
  /** The ID of the target voucher to transfer to */
  toVoucherId: Scalars['ObjectId'];
};

export type TransferVoucherInternalResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | TransferVoucherSuccess | ValidationError;

/** The result of a voucher transfer, consisting of the source and target vouchers */
export type TransferVoucherSuccess = {
  __typename?: 'TransferVoucherSuccess';
  /** The voucher which had its balance transferred */
  fromVoucher: Voucher;
  /** The voucher which the balance was transferred to */
  toVoucher: Voucher;
};

export type TransferableAmount = {
  __typename?: 'TransferableAmount';
  /** The payment methods used in transactions that could be transfered or should retain costs on the original booking */
  paymentMethods: Array<TransferableAmountByPaymentMethod>;
  /** The total non transferable amount for fees and persisted adjustments that stays on the original booking */
  totalNonTransferable: Money;
  /** The total amount of confirmed and pending transactions */
  totalPaid: Money;
  /** The total amount of pending transactions */
  totalPending: Money;
  /** The total amount available to transfer after retaining pending transactions and non transferrable funds. Returns 0 if negative after retention. */
  totalTransferable: Money;
};

export type TransferableAmountByPaymentMethod = {
  __typename?: 'TransferableAmountByPaymentMethod';
  /** The sum of confirmed and pending transactions made with this payment method */
  amountPaid: Money;
  /** The sum of pending transactions made with this payment method */
  amountPending: Money;
  customerId: Scalars['ObjectId'];
  /** The non transferable amount for fees and persisted adjustment on this payment method that stays on the original booking */
  nonTransferableAmount: Money;
  paymentMethod: TransactionPaymentMethod;
  paymentMethodHash: Scalars['String'];
  /** The amount available to transfer for this payment method after retaining pending transactions and non transferrable funds */
  transferableAmount: Money;
};

/** Travel companion request for a trip */
export type TravelCompanionRequest = {
  __typename?: 'TravelCompanionRequest';
  _id: Scalars['ObjectId'];
  requestedTrip?: Maybe<BookingTrip>;
  requestedTripId: Scalars['ObjectId'];
  trip?: Maybe<BookingTrip>;
  tripId: Scalars['ObjectId'];
};

export enum TravelCompanionRequestRestriction {
  DifferentDepartureDate = 'DIFFERENT_DEPARTURE_DATE',
  DifferentDepartureGateway = 'DIFFERENT_DEPARTURE_GATEWAY',
  DifferentReturnDate = 'DIFFERENT_RETURN_DATE',
  DifferentReturnGateway = 'DIFFERENT_RETURN_GATEWAY',
  MissingRequiredInfo = 'MISSING_REQUIRED_INFO'
}

/** Travel Companion Settings */
export type TravelCompanionsSettings = {
  __typename?: 'TravelCompanionsSettings';
  /** Whether travel companion requests are generally enabled */
  requestableTripTypes: Array<TripCustomerType>;
  /** Minimum days prior to departure required to request a travel companion */
  requestsMinimumDpd?: Maybe<Scalars['Int']>;
};

export type TravelerNote = {
  __typename?: 'TravelerNote';
  acknowledged: Scalars['Boolean'];
  text?: Maybe<Scalars['String']>;
};

export type TravelerNoteInput = {
  acknowledged: Scalars['Boolean'];
  text?: InputMaybe<Scalars['String']>;
};

export type TravelerNotes = {
  __typename?: 'TravelerNotes';
  _id: Scalars['ObjectId'];
  dietaryNotes?: Maybe<TravelerNote>;
  generalNotes?: Maybe<TravelerNote>;
  hasCompletedHealthNotes?: Maybe<Scalars['Boolean']>;
  medicalNotes?: Maybe<TravelerNote>;
  mobilityNotes?: Maybe<TravelerNote>;
  roomingNotes?: Maybe<TravelerNote>;
};

export type TravelerNotesInput = {
  dietaryNotes?: InputMaybe<TravelerNoteInput>;
  generalNotes?: InputMaybe<TravelerNoteInput>;
  medicalNotes?: InputMaybe<TravelerNoteInput>;
  mobilityNotes?: InputMaybe<TravelerNoteInput>;
  roomingNotes?: InputMaybe<TravelerNoteInput>;
};

/** Base of QuoteTrip or BookingTrip */
export type Trip = {
  _id: Scalars['ObjectId'];
  /** The address for the trip. */
  address?: Maybe<Address>;
  /** The age of the traveler at departure date, inclusive of any pre-extension */
  ageAtDeparture?: Maybe<Scalars['Int']>;
  /** The applied promos with the number of times they have been applied to the trip. */
  appliedPromosWithCount: Array<AppliedPromoWithCount>;
  /** The exclusivities of promos that can be added to the trip. */
  availablePromoExclusivities: Array<PromoExclusivity>;
  businessCode?: Maybe<BusinessCode>;
  /** The estimated cancellation fee and effective DPD for the trip. */
  cancellationFeeEstimation?: Maybe<CancellationFeeEstimation>;
  /** Offers that can be applied to the trip but are not specific to a single component. Flight package offers are not included. */
  conditionalOffers: Array<ConditionalOffer>;
  /** The currency code of the trip. */
  currencyCode: CurrencyCode;
  customer?: Maybe<Customer>;
  /** The customer id of the trip. */
  customerId?: Maybe<Scalars['ObjectId']>;
  /** The customer's loyalty level for the business matching this trip's order */
  customerLoyaltyLevel?: Maybe<LoyaltyLevel>;
  customerType: TripCustomerType;
  /** Offers for departing flights that can be added to the trip. */
  departingFlightOffers: Array<FlightOffer>;
  departure?: Maybe<Departure>;
  /** The trip's actual departure date, inclusive of any departing flight */
  departureDate: Scalars['Date'];
  /** The net deposit amount for the trip. */
  depositAmount: Money;
  /** The emergency contacts for the trip. */
  emergencyContacts?: Maybe<Array<EmergencyContact>>;
  /** The trip's actual end date, inclusive of any returning flight */
  endDate: Scalars['Date'];
  /** Offers for excursions that can be added to the trip. Includes extension excursions if the trip is booked on the extension. */
  excursionOffers: Array<DepartureExcursionOffer>;
  /** The departure excursions and extension excursions for the open excursion line items on this trip */
  excursions: Array<DepartureExcursion>;
  /** Sum of all open excursion line items */
  excursionsTotal: Money;
  /** The departure extension for the open extension line item on this trip */
  extension?: Maybe<DepartureExtension>;
  /** Offer for an extension that can be added to the trip. */
  extensionOffer?: Maybe<DepartureExtensionOffer>;
  /** The departure room for the open extension room line item on this trip */
  extensionRoom?: Maybe<DepartureRoom>;
  extensionRoommateTrips?: Maybe<Array<Trip>>;
  extensionRoommates?: Maybe<Array<Customer>>;
  /** The total fees amount for the trip. */
  feesTotal: Money;
  /** @deprecated Use grossFlightPackagePrice instead */
  flightPackagePrice?: Maybe<Money>;
  grandTotal: Money;
  /** The total flight package price for the trip. */
  grossFlightPackagePrice?: Maybe<Money>;
  /** The total tour price with flights and private group if applicable. */
  grossTourTotalWithFlights: Money;
  hasAddress: Scalars['Boolean'];
  hasConfirmedDocumentInformation: Scalars['Boolean'];
  hasConfirmedTravelerInformation: Scalars['Boolean'];
  hasDepartingFlightDeviation: Scalars['Boolean'];
  hasEmergencyContacts: Scalars['Boolean'];
  /** Whether the trip has an open line item for an extension */
  hasExtension: Scalars['Boolean'];
  hasInsurance: Scalars['Boolean'];
  hasReturningFlightDeviation: Scalars['Boolean'];
  hasTsaInformation: Scalars['Boolean'];
  /** Available inbound airport transfer offers for the trip, based on the active departure extension when applicable, otherwise on the main tour. */
  inboundAirportTransferOffers: Array<TourAirportTransferOffer>;
  /** The travel companion requests from other trips on the same departure that request this trip. */
  incomingTravelCompanionRequests: Array<TravelCompanionRequest>;
  /** The insurance eligibility status for this trip */
  insuranceEligibilityStatus: InsuranceEligibilityStatus;
  /** The total insurance amount for the trip after adjustments. */
  insuranceTotal?: Maybe<Money>;
  /** Whether the trip is cancelled. */
  isCancelled: Scalars['Boolean'];
  /** Whether the trip is confirmed. */
  isConfirmed: Scalars['Boolean'];
  isEligibleToSubmitTravelCompanionRequests?: Maybe<Scalars['Boolean']>;
  /** Whether the trip is eligible for an inbound airport transfer */
  isInboundAirportTransferEligible: Scalars['Boolean'];
  isLandOnly: Scalars['Boolean'];
  /** Whether the trip is open. */
  isOpen: Scalars['Boolean'];
  /** Whether the trip is eligible for an outbound airport transfer */
  isOutboundAirportTransferEligible: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  /** Whether the proof of insurance document is available for this traveler */
  isProofOfInsuranceDocumentAvailable: Scalars['Boolean'];
  /** Whether the trip is quoted. */
  isQuoted: Scalars['Boolean'];
  /** Whether the trip is rebooked. */
  isRebooked: Scalars['Boolean'];
  /** Whether the trip is requested. */
  isRequested: Scalars['Boolean'];
  /** Whether the trip is waitlisted. */
  isWaitlisted: Scalars['Boolean'];
  /** The latest inbound airport transfer line item for the trip with status REBOOKED, PENDING_CANCELLATION, or CANCELLED. */
  latestRemovedInboundAirportTransferLineItem?: Maybe<TourAirportTransferLineItem>;
  /** The latest outbound airport transfer line item for the trip with status REBOOKED, PENDING_CANCELLATION, or CANCELLED. */
  latestRemovedOutboundAirportTransferLineItem?: Maybe<TourAirportTransferLineItem>;
  /** The line items that compose the trip. */
  lineItems: Array<LineItem>;
  /** The REBOOKED + OPEN line items if the trip is rebooked, the CANCELLED + OPEN line items with PARENT_TRIP_CANCELLED cancellation metadata if the trip is cancelled, or the open line items in all other cases.  */
  lineItemsMatchingTripStatus: Array<LineItem>;
  /** The maximum number of extension roommate requests that can be made for the trip. */
  maximumExtensionRoommateRequests: Scalars['Int'];
  /** The maximum number of main tour roommate requests that can be made for the trip. */
  maximumRoommateRequests: Scalars['Int'];
  openAdjustmentLineItems: Array<AdjustmentLineItem>;
  openAirportTransferLineItems: Array<TourAirportTransferLineItem>;
  openDepartingFlightLineItem?: Maybe<FlightPackageLineItem>;
  openExcursionLineItems: Array<TourExcursionLineItem>;
  openExtensionLineItem?: Maybe<TourExtensionLineItem>;
  openExtensionRoomLineItem?: Maybe<TourRoomLineItem>;
  openFeeLineItems: Array<FeeLineItem>;
  openFlightShopLineItem?: Maybe<FlightShopLineItem>;
  /** The open inbound airport transfer line item for the trip. */
  openInboundAirportTransferLineItem?: Maybe<TourAirportTransferLineItem>;
  openInsuranceAddonLineItems: Array<InsuranceAddonLineItem>;
  openInsuranceLineItem?: Maybe<InsuranceLineItem>;
  /** The line items that compose the trip which are not CANCELLED or REBOOKED */
  openLineItems: Array<LineItem>;
  /** The open outbound airport transfer line item for the trip. */
  openOutboundAirportTransferLineItem?: Maybe<TourAirportTransferLineItem>;
  openPostStayLineItem?: Maybe<ExtendedStayLineItem>;
  openPreStayLineItem?: Maybe<ExtendedStayLineItem>;
  openPrivateGroupLineItem?: Maybe<PrivateGroupLineItem>;
  openPromoLineItems: Array<PromoLineItem>;
  openReturningFlightLineItem?: Maybe<FlightPackageLineItem>;
  openRoomLineItem?: Maybe<TourRoomLineItem>;
  orderId: Scalars['ObjectId'];
  /** Available outbound airport transfer offers for the trip, based on the active departure extension when applicable, otherwise on the main tour. */
  outboundAirportTransferOffers: Array<TourAirportTransferOffer>;
  /** The total persisting adjustments amount for the trip. */
  persistingAdjustmentsTotal: Money;
  /** The trip ID for the trip that this trip was rebooked from. */
  rebookedFromTripId?: Maybe<Scalars['ObjectId']>;
  requestedRoommates?: Maybe<Array<Scalars['String']>>;
  /** @deprecated Use travelCompanionRequests instead */
  requestedTravelCompanions?: Maybe<Array<Scalars['String']>>;
  /** Offers for returning flights that can be added to the trip. */
  returningFlightOffers: Array<FlightOffer>;
  /** The departure room for the open room line item on this trip */
  room?: Maybe<DepartureRoom>;
  /** Offers for rooms that can be added to the trip. Includes extension rooms if the trip is booked on the extension. */
  roomOffers: Array<DepartureRoomOffer>;
  roommateTrips?: Maybe<Array<Trip>>;
  roommates?: Maybe<Array<Customer>>;
  /** The status of the trip */
  status: TripStatus;
  timingStatus: TripTimingStatus;
  /** The date the trip departs for tour, inclusive of any pre-Extension */
  tourDepartureDate: Scalars['Date'];
  /** The date the trip ends, inclusive of any post-Extension */
  tourEndDate: Scalars['Date'];
  tourLineItem?: Maybe<TourLineItem>;
  /** The travel companion requests for the trip. */
  travelCompanionRequests: Array<TravelCompanionRequest>;
  travelerNotes?: Maybe<TravelerNotes>;
  /** The TSA information for the trip. */
  tsaInformation?: Maybe<TsaInformation>;
};

export enum TripCancellationCategory {
  Financial = 'FINANCIAL',
  LifeEvent = 'LIFE_EVENT',
  ProductTransition = 'PRODUCT_TRANSITION',
  StaffOnTour = 'STAFF_ON_TOUR',
  TravelerDiscontent = 'TRAVELER_DISCONTENT',
  TravelRequirementNotMet = 'TRAVEL_REQUIREMENT_NOT_MET',
  Unknown = 'UNKNOWN',
  WojoCancellation = 'WOJO_CANCELLATION',
  WorldEvent = 'WORLD_EVENT'
}

/** Trip cancellation charge with line item code. */
export type TripCancellationCharge = {
  __typename?: 'TripCancellationCharge';
  /** The amount of the cancellation charge. */
  amount: Money;
  /** The line item code associated with the cancellation charge. */
  lineItemCode: Scalars['LineItemCode'];
  /** The tripId associated with the cancellation charge. */
  tripId: Scalars['ObjectId'];
};

/** Adjustments to apply to cancelled trip */
export type TripCancellationChargeInput = {
  /** The estimated price to be applied to a trip. */
  price: Scalars['Float'];
  /** The tripId that the adjustment or fee applies to. */
  tripId: Scalars['ObjectId'];
};

/** Trip cancellation fee charge. */
export type TripCancellationFee = {
  __typename?: 'TripCancellationFee';
  /** The amount of the cancellation fee charge. */
  amount: Money;
  /** Computed effective cancellation DPD for a trip */
  effectiveDpd: Scalars['Int'];
  /** The trip from the rebooking chain used to calculate the effective cancellation DPD */
  lowestDpdRebookingChainTrip?: Maybe<Trip>;
  /** The tripId associated with the cancellation charge. */
  tripId: Scalars['ObjectId'];
};

/** Meta information for a trip cancellation */
export type TripCancellationMeta = {
  __typename?: 'TripCancellationMeta';
  cancellationCategory: TripCancellationCategory;
  cancellationDate: Scalars['DateTime'];
  cancellationReason: Scalars['String'];
  cancelledBy?: Maybe<Scalars['ObjectId']>;
};

export type TripChecklistItem = {
  __typename?: 'TripChecklistItem';
  checklistItemTemplateId: Scalars['ObjectId'];
  description: Scalars['String'];
  dueDate: Scalars['Date'];
  id: Scalars['String'];
  importanceLevel: CheckListItemImportanceLevel;
  internalName: Scalars['String'];
  isChecked: Scalars['Boolean'];
  status: TripChecklistItemStatus;
  title: Scalars['String'];
};

/** Checklist item state */
export type TripChecklistItemState = {
  __typename?: 'TripChecklistItemState';
  _id: Scalars['ObjectId'];
  checklistItemTemplateId: Scalars['ObjectId'];
  isChecked: Scalars['Boolean'];
  tripId: Scalars['ObjectId'];
};

export enum TripChecklistItemStatus {
  Complete = 'COMPLETE',
  DueInFuture = 'DUE_IN_FUTURE',
  Overdue = 'OVERDUE'
}

/** Template for items that appear on trip checklists */
export type TripChecklistItemTemplate = {
  __typename?: 'TripChecklistItemTemplate';
  _id: Scalars['ObjectId'];
  businessCode?: Maybe<BusinessCode>;
  description: Scalars['String'];
  dpd: Scalars['Int'];
  effectiveFrom: Scalars['Date'];
  effectiveTo: Scalars['Date'];
  excludeTourCodes?: Maybe<Array<Scalars['String']>>;
  importanceLevel: CheckListItemImportanceLevel;
  includeTourCodes?: Maybe<Array<Scalars['String']>>;
  internalName: Scalars['String'];
  title: Scalars['String'];
};

export type TripChecklistItemTemplatePaginatedResult = {
  __typename?: 'TripChecklistItemTemplatePaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<TripChecklistItemTemplate>;
};

/** Trip checklist settings */
export type TripChecklistSettings = {
  __typename?: 'TripChecklistSettings';
  /** Days prior to departure when emergency contact information is due */
  emergencyContactDueAtDpd?: Maybe<Scalars['Int']>;
  /** Days prior to departure when health notes are due */
  healthNotesDueAtDpd?: Maybe<Scalars['Int']>;
  /** Days prior to departure when passport information is due */
  passportInformationDueAtDpd?: Maybe<Scalars['Int']>;
  /** Number of days after booking when roommate selection is due. If not set, roommate request is not required. */
  roommateDaysDueAfterBooking?: Maybe<Scalars['Int']>;
  /** Number of days after booking when terms signature is due */
  termsSignatureDaysDueAfterBooking?: Maybe<Scalars['Int']>;
  /**
   * Days prior to departure when traveler information is due (deprecated)
   * @deprecated Use the tsa identifier and passport info settings
   */
  travelerInfoDueAtDpd?: Maybe<Scalars['Int']>;
  /** Days prior to departure when TSA identifiers are due */
  tsaIdentifiersDueAtDpd?: Maybe<Scalars['Int']>;
};

export type TripComponent = {
  _id: Scalars['ObjectId'];
  businessCode?: Maybe<BusinessCode>;
  isPublished: Scalars['Boolean'];
  lineItemCode: Scalars['LineItemCode'];
  status: TripComponentStatus;
  type: TripComponentType;
};

export enum TripComponentStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum TripComponentType {
  Adjustment = 'Adjustment',
  AirportTransfer = 'AirportTransfer',
  ExtendedInsurance = 'ExtendedInsurance',
  ExtendedStay = 'ExtendedStay',
  Fee = 'Fee',
  FlightPackage = 'FlightPackage',
  FlightShop = 'FlightShop',
  Insurance = 'Insurance',
  InsuranceAddon = 'InsuranceAddon',
  PrivateGroup = 'PrivateGroup',
  Promo = 'Promo',
  Tour = 'Tour',
  TourExcursion = 'TourExcursion',
  TourExtension = 'TourExtension',
  TourRoom = 'TourRoom'
}

export type TripCustomer = TripExistingCustomer | TripNewCustomer;

/** The type of customer on the trip. This is as it applies to the trip itself. For example, a GC traveling on their own not leading a group would be an Individual */
export enum TripCustomerType {
  /** This is the trip for the group coordinator. */
  GroupCoordinator = 'GROUP_COORDINATOR',
  /** A member of the group on the tour for a Group Coordinator */
  GroupMember = 'GROUP_MEMBER',
  /** A member of the tour who is not part of the group trip. This does not mean they are a solo traveler. */
  Individual = 'INDIVIDUAL'
}

export type TripExistingCustomer = {
  __typename?: 'TripExistingCustomer';
  customerId: Scalars['ObjectId'];
};

export type TripExistingCustomerInput = {
  customerId: Scalars['ObjectId'];
};

/** The reservation system used to book the PNR this flight belongs to. */
export enum TripFlightReservationSystem {
  /** The flight was booked and provided to World Journeys by Atlas, and was either booked by a staff member manually, or using another system such as the RightRez autobooker */
  Atlas = 'ATLAS',
  /** The flight was booked with Hitchhiker, a sales and service facing system used to help customers select their own flights from 2018-2023 */
  Hitchhiker = 'HITCHHIKER',
  /** The flight was booked with RightFlight, a RightRez product similar to Hitchhiker that allows customers to select their own flights */
  RightFlight = 'RIGHT_FLIGHT'
}

/** Represents an actualized flight with a flight number, departure and arrival gateways, etc. that is booked for a customer on a booking trip */
export type TripFlightSegment = {
  __typename?: 'TripFlightSegment';
  /** The record locator used to check in with the carrier corresponding to this flight segment's carrierCode */
  airlineLocator?: Maybe<Scalars['String']>;
  /** Additional information about the arrival gateway for this flight segment */
  arrivalGateway?: Maybe<Gateway>;
  /** The IATA airport code for the arrival gateway for this flight */
  arrivalGatewayCode: Scalars['String'];
  /** A string representing the time (in local airport time) that the flight arrives at the arrival gateway. This string should be displayed by converting it to a date with no time zone adjustment, before formatting */
  arrivesAtLocalTime: Scalars['String'];
  /** The cabin that was purchased when this flight was reserved. May not be populated depending on the booking system used, so should not be relied upon */
  cabinClass?: Maybe<Scalars['String']>;
  /** Ticketing carrier */
  carrier?: Maybe<Airline>;
  /** The primary airline for this flight */
  carrierCode: Scalars['String'];
  /** The class of service, which is an internal representation of the type of ticket being sold by the airline. If you are looking for ECONOMY, PREMIUM, BUSINESS, please see cabinClass instead */
  classOfService?: Maybe<Scalars['String']>;
  /** A string representing the time (in local airport time) that the flight departs from the departure gateway. This string should be displayed by converting it to a date with no time zone adjustment, before formatting */
  departsAtLocalTime: Scalars['String'];
  /** Additional information about the departure gateway for this flight segment */
  departureGateway?: Maybe<Gateway>;
  /** The IATA airport code for the departure gateway for this flight */
  departureGatewayCode: Scalars['String'];
  /** The flight number for this flight */
  flightNumber: Scalars['String'];
  /** Operating carrier */
  operatedByCarrier?: Maybe<Airline>;
  /** The carrier that is operating this flight in the case of a code share flight */
  operatedByCarrierCode?: Maybe<Scalars['String']>;
  /** The internal record locator issued by the ticketing airline */
  pnrLocator: Scalars['String'];
  /** An ordering tool used to sort flights that share the same pnrLocator. Ordering flights within the same pnrLocator by pnrSegmentNumber will be ordered chronologically, since time-based ordering cannot be done without UTC timestamps */
  pnrSegmentNumber: Scalars['Int'];
  /** The reservation system used to book the PNR that this flight belongs to */
  reservationSystem: TripFlightReservationSystem;
  /** The e-ticket number, populated once this PNR is ticketed. Will usually be nullish until much closer to the departure date */
  ticketNumber?: Maybe<Scalars['String']>;
  /** The type or 'direction' of the flight. Another way of saying, 'Along what leg of the journey does this flight take place' */
  type: TripFlightType;
};

export enum TripFlightType {
  /** The flight happens at the start of tour from the traveler's home gateway to begin their tour */
  Departing = 'DEPARTING',
  /** The flight is 'internal' to the tour, used to move travelers from one country to another as part of the tour's itinerary. e.g. CDG to FCO for a London, Paris, Rome tour */
  Internal = 'INTERNAL',
  /** The flight happens at the end of their tour back to their home gateway */
  Returning = 'RETURNING'
}

/** The top level object containing metadata and information about the flights on a booking trip */
export type TripFlights = {
  __typename?: 'TripFlights';
  _id: Scalars['ObjectId'];
  bookingTrip?: Maybe<BookingTrip>;
  /** The traveler's departing flights from their home gateway to begin their tour, sorted by pnrSegmentNumber and departure date, when possible. This will hide flights or identifiers if they have not released yet. */
  customerDepartingFlights: Array<TripFlightSegment>;
  /** The traveler's flights from their home gateway to begin their tour, sorted by pnrSegmentNumber and departure date, when possible. This will hide flights or identifiers if they have not released yet. */
  customerFlightSegments: Array<TripFlightSegment>;
  /** The traveler's flights from their home gateway to begin their tour, sorted by pnrSegmentNumber and departure date, when possible. This will hide flights or identifiers if they have not released yet. */
  customerInternalFlights: Array<TripFlightSegment>;
  /** The traveler's returning flights from their home gateway to begin their tour, sorted by pnrSegmentNumber and departure date, when possible. This will hide flights or identifiers if they have not released yet. */
  customerReturningFlights: Array<TripFlightSegment>;
  /** The traveler's flights from their home gateway to begin their tour, sorted by pnrSegmentNumber and departure date, when possible */
  departingFlights: Array<TripFlightSegment>;
  /** The unfiltered list of all known flight segments known for this trip. If specific flights are needed, consider using another resolver. Sorted by pnrSegmentNumber and departure date, when possible */
  flightSegments?: Maybe<Array<TripFlightSegment>>;
  /** Returns true if this trip has at least one DEPARTING and at least one RETURNING flight segment */
  hasFullItinerary: Scalars['Boolean'];
  /** Flights that are 'internal' to the tour, used to move travelers from one country to another as part of the tour's itinerary, sorted by pnrSegmentNumber and departure date, when possible. e.g. CDG to FCO for a London, Paris, Rome tour. */
  internalFlights: Array<TripFlightSegment>;
  /** Returns true if every flight segment for this trip has been assigned a ticket number */
  isFullyTicketed: Scalars['Boolean'];
  /** The traveler's flights from the end of their tour back to their home gateway, sorted by pnrSegmentNumber and departure date, when possible */
  returningFlights: Array<TripFlightSegment>;
  /** The status of the trip flights. This is used to determine if the flights have been released and if they have locators */
  tripFlightStatus: TripFlightsFlightsStatus;
  /** The trip ID of the booking trip that these flights belong to */
  tripId: Scalars['ObjectId'];
};

export enum TripFlightsFlightsStatus {
  /** Flights have been released, and identifiers are available. */
  FlightsAndIdentifiersReleased = 'FLIGHTS_AND_IDENTIFIERS_RELEASED',
  /** Trip is missing some flights, due to late add or other EF related changes */
  FlightsNotAvailable = 'FLIGHTS_NOT_AVAILABLE',
  /** Flights have not been released yet. */
  FlightsNotReleased = 'FLIGHTS_NOT_RELEASED',
  /** Flights have been released but we are suppressing identifiers.(airline locators, ticket numbers) */
  FlightsReleasedIdentifiersHidden = 'FLIGHTS_RELEASED_IDENTIFIERS_HIDDEN',
  /** This trip is missing some flights due to a airline schedule change.(has full itinerary is false, and is past flight release date) */
  FlightsScheduleChange = 'FLIGHTS_SCHEDULE_CHANGE'
}

/** A hotel belonging to a trip. */
export type TripHotel = {
  __typename?: 'TripHotel';
  /** The addresses of the hotel. Suppliers can have more than one address. */
  address?: Maybe<Array<Address>>;
  /** The end date of the hotel stay. */
  endDate: Scalars['Date'];
  /** The name of the hotel. */
  name?: Maybe<Scalars['String']>;
  /** The phone numbers of the hotel. Suppliers can have more than one phone number */
  phoneNumber?: Maybe<Array<Scalars['PhoneNumber']>>;
  /** The start date of the hotel stay. */
  startDate: Scalars['Date'];
  /** The type of the hotel. */
  type: TripHotelType;
  /** The website of the hotel. */
  website?: Maybe<Scalars['String']>;
};

export enum TripHotelType {
  Base = 'BASE',
  Layover = 'LAYOVER',
  Poststay = 'POSTSTAY',
  Prestay = 'PRESTAY'
}

export type TripNewCustomer = {
  __typename?: 'TripNewCustomer';
  email?: Maybe<Scalars['Email']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['PhoneNumber']>;
};

export type TripNewCustomerInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export enum TripReadinessStatusFilter {
  CarriedOver = 'CARRIED_OVER',
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED'
}

/** Meta information for a trip rebooking */
export type TripRebookingMeta = {
  __typename?: 'TripRebookingMeta';
  pendingRebookingDate: Scalars['DateTime'];
  rebookedBy?: Maybe<Scalars['ObjectId']>;
  rebookingDate?: Maybe<Scalars['DateTime']>;
  rebookingReasonCategory: RebookingReasonCategory;
  rebookingReasonDescription: Scalars['String'];
};

export enum TripStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  PendingCancellation = 'PENDING_CANCELLATION',
  PendingRebooking = 'PENDING_REBOOKING',
  Quoted = 'QUOTED',
  Rebooked = 'REBOOKED',
  Requested = 'REQUESTED',
  Waitlisted = 'WAITLISTED'
}

export enum TripTimingStatus {
  OnTour = 'OnTour',
  PostTour = 'PostTour',
  PreTour = 'PreTour'
}

/** TSA information update for a specific trip, pairing a trip ID with its TSA data and confirmation flags. */
export type TripTsaInformationInput = {
  confirmDocumentInformation?: Scalars['Boolean'];
  confirmTravelerInformation?: Scalars['Boolean'];
  tripId: Scalars['ObjectId'];
  tsaInformation: TsaInformationInput;
};

export type TsaIdentifiersChecklistItem = SystemChecklistItem & {
  __typename?: 'TsaIdentifiersChecklistItem';
  dueDate?: Maybe<Scalars['Date']>;
  isCompleted: Scalars['Boolean'];
  status?: Maybe<TripChecklistItemStatus>;
};

export type TsaInformationInput = {
  /** The date the traveler confirmed the TSA information. This field is now deprecated in favor of travelerConfirmationDate and documentConfirmationDate. This value is ignored and calculated by the server, and returned as travelerConfirmationDate and documentConfirmationDate. */
  confirmationDate?: InputMaybe<Scalars['DateTime']>;
  countryOfIssue?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  expirationDate?: InputMaybe<Scalars['Date']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<TsaGender>;
  identityDocumentNumber?: InputMaybe<Scalars['String']>;
  issueDate?: InputMaybe<Scalars['Date']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  stateOfIssue?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<IdentityDocumentType>;
};

/** TSA Settings */
export type TsaSettings = {
  __typename?: 'TsaSettings';
  /** Whether date of birth is required to book */
  dateOfBirthRequiredToBook: Scalars['Boolean'];
  /** Number of years in the future relative to the current date for valid date range */
  yearsInTheFuture: Scalars['Int'];
  /** Number of years in the past relative to the current date for valid date range */
  yearsInThePast: Scalars['Int'];
};

/** A list of unassigned travelers and their requested room type */
export type UnassignedTravelers = {
  __typename?: 'UnassignedTravelers';
  requestedBedCode: Scalars['String'];
  trips: Array<BookingTrip>;
};

export type UncheckTripChecklistItemResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTripChecklistItemTemplateError | NotAuthorizedError | NotFoundError | TripChecklistItemState | ValidationError;

export type UnclaimExperimentalLeadResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ExperimentalLead | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UnmatchQuoteRoommatesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Quote | ValidationError;

export type UnmatchRoommatesResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | UnmatchRoommatesSuccess | ValidationError;

export type UnmatchRoommatesSuccess = {
  __typename?: 'UnmatchRoommatesSuccess';
  data: Array<Booking>;
};

export type UnsetDefaultPaymentMethodResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | SavedPaymentMethod | ValidationError;

/** Details about unused incentive rewards. Exactly one of nextExpiringReward or nextEffectiveReward is populated depending on the customer's role. */
export type UnusedIncentiveInfo = {
  __typename?: 'UnusedIncentiveInfo';
  /** The next pending reward that will become available. Present for advocates with pending referral rewards. */
  nextEffectiveReward?: Maybe<NextEffectiveReward>;
  /** The next reward that will expire or has already expired. Present for friends with active or expired rewards. */
  nextExpiringReward?: Maybe<NextExpiringReward>;
};

export type UpdateAdjustmentInput = {
  displayName: Scalars['String'];
  isCompanionDiscount: Scalars['Boolean'];
  isEligibleForRolloverOnRebooking?: InputMaybe<Scalars['Boolean']>;
  isFreePlace: Scalars['Boolean'];
  isRefundable?: InputMaybe<Scalars['Boolean']>;
  isStaffOnTour: Scalars['Boolean'];
  persistsOnCancelAndRebook?: InputMaybe<Scalars['Boolean']>;
  tagIds: Array<Scalars['ObjectId']>;
};

export type UpdateAdjustmentResult = Adjustment | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateAdjustmentStatusInput = {
  status: TripComponentStatus;
};

export type UpdateAdjustmentStatusResult = Adjustment | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateAudienceResult = Audience | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBookingTripInsuranceCoverageStartDateResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidInsurancePlanError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessChatSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessCustomerSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessDepartureSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessEvaluationSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessFeeSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessFlightSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessGcDepartureSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessGroupTripChecklistSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessInsuranceSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessIntegrationSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessOrderPaymentSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessOrderQuoteSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessOrderRoomingSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessOrderSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessPromoSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessReviewSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessSupportTicketSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessTourSearchSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessTripChecklistSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateBusinessTsaSettingsResult = Business | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Update the details of a campaign */
export type UpdateCampaignInput = {
  displayName?: InputMaybe<Scalars['String']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateCampaignResult = BusinessNotSpecifiedError | Campaign | DuplicateUniqueKeyError | InvalidCampaignError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateCampaignStatusInput = {
  status: CampaignStatus;
};

export type UpdateCampaignStatusResult = BusinessNotSpecifiedError | Campaign | DuplicateUniqueKeyError | InvalidCampaignError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Update the basic details of a category */
export type UpdateCategoryInput = {
  /** Passing null, undefined, or empty string will remove the description */
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type UpdateCategoryResult = BusinessNotSpecifiedError | Category | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateChatSettingsInput = {
  /** The DPD in which the chat is open for the departure */
  availabilityDpd?: InputMaybe<Scalars['Int']>;
  /** The DPD in which the tour director is available for direct messages */
  tourDirectorDirectMessageDpd?: InputMaybe<Scalars['Int']>;
};

/** Passing null or undefined will set the address to null */
export type UpdateCustomerAddressInput = {
  address?: InputMaybe<AddressInput>;
};

export type UpdateCustomerAddressResult = BusinessNotSpecifiedError | Customer | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** You must provide a unique email address. */
export type UpdateCustomerEmailInput = {
  email: Scalars['Email'];
};

export type UpdateCustomerEmailResult = BusinessNotSpecifiedError | Customer | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateCustomerEvaluationSettingsInput = {
  /** List of component type codes for evaluation */
  componentTypeCodes?: InputMaybe<Array<Scalars['String']>>;
  /** Whether to generate all questions at once */
  generateAllQuestionsAtOnce?: InputMaybe<Scalars['Boolean']>;
  /** Number of days until evaluation becomes available */
  nbDaysUntilEvaluationAvailable?: InputMaybe<Scalars['Int']>;
  /** Number of days until evaluation is due */
  nbDaysUntilEvaluationDue?: InputMaybe<Scalars['Int']>;
  /** Number of days for pre-departure end questions */
  nbPreDepartureEndQuestionDays?: InputMaybe<Scalars['Int']>;
  /** Number of days for pre-departure questions */
  nbPreDepartureQuestionDays?: InputMaybe<Scalars['Int']>;
  /** Whether to generate pre-departure evaluations */
  shouldGeneratePreDeparture?: InputMaybe<Scalars['Boolean']>;
};

/** Setting a last name to null or undefined will set it to null */
export type UpdateCustomerNameInput = {
  firstName: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerNameResult = BusinessNotSpecifiedError | Customer | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Update customer password input */
export type UpdateCustomerPasswordInput = {
  oldPassword?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  reset?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCustomerPasswordResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidSigninError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | UpdatePasswordResult | ValidationError;

/** Passing null or undefined will set the phone to null */
export type UpdateCustomerPhoneNumberInput = {
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
};

export type UpdateCustomerPhoneNumberResult = BusinessNotSpecifiedError | Customer | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateCustomerProfileSocialMediaInput = {
  facebookUsername: Scalars['String'];
  instagramUsername: Scalars['String'];
  snapchatUsername: Scalars['String'];
  tiktokUsername: Scalars['String'];
  xUsername: Scalars['String'];
};

export type UpdateCustomerSettingsInput = {
  /** The name to use when anonymizing customer data for deletion requests */
  dataDeletionRequestName?: InputMaybe<Scalars['String']>;
};

export type UpdateDepartureDocumentMetadataSettingsInput = {
  /** The type of document */
  documentType: DocumentType;
  /** The url path to download the document */
  downloadPath: Scalars['String'];
  /** The title of the document to be displayed by clients */
  title: Scalars['String'];
};

export type UpdateDepartureExcursionInput = {
  autoApproveDeadline?: InputMaybe<Scalars['Date']>;
  capacity?: InputMaybe<Scalars['Int']>;
  minNbTravelersRequired?: InputMaybe<Scalars['Int']>;
};

export type UpdateDepartureExcursionResult = BusinessNotSpecifiedError | DepartureExcursion | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureExtensionExcursionInput = {
  autoApproveDeadline?: InputMaybe<Scalars['Date']>;
  /** The maximum number of travelers that can reserve this excursion type for this Departure. */
  capacity: Scalars['Int'];
  minNbTravelersRequired?: InputMaybe<Scalars['Int']>;
};

export type UpdateDepartureExtensionExcursionResult = BusinessNotSpecifiedError | DepartureExcursion | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureExtensionInput = {
  autoApproveDeadline?: InputMaybe<Scalars['Date']>;
  capacity?: InputMaybe<Scalars['Int']>;
  endGatewayCode?: InputMaybe<Scalars['String']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']>;
  postStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  preStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  startGatewayCode?: InputMaybe<Scalars['String']>;
};

export type UpdateDepartureExtensionResult = BusinessNotSpecifiedError | DepartureExtension | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureExtensionRoomInput = {
  /** The maximum number of travelers that can reserve this room type for this Departure. */
  capacity: Scalars['Int'];
};

export type UpdateDepartureExtensionRoomResult = BusinessNotSpecifiedError | DepartureRoom | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureInput = {
  addonPrice?: InputMaybe<Array<MoneyInput>>;
  autoApproveDeadline?: InputMaybe<Scalars['Date']>;
  /** Required when setting status to CANCELLED or PENDING_CANCELLATION */
  cancellationReason?: InputMaybe<DepartureItemCancellationReason>;
  capacity?: InputMaybe<Scalars['Int']>;
  endGatewayCode?: InputMaybe<Scalars['String']>;
  exclusivityType?: InputMaybe<DepartureExclusivityType>;
  finalInstallmentDeadline?: InputMaybe<Scalars['Date']>;
  finalPaymentDeadline?: InputMaybe<Scalars['Date']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']>;
  isPostStayAllowed?: InputMaybe<Scalars['Boolean']>;
  isPreStayAllowed?: InputMaybe<Scalars['Boolean']>;
  isWaitlistAllowed?: InputMaybe<Scalars['Boolean']>;
  maxTravelerAge?: InputMaybe<Scalars['Int']>;
  minTravelerAge?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['ObjectId']>;
  postStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  preStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  reservedCapacity?: InputMaybe<Scalars['Int']>;
  startGatewayCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DepartureStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type UpdateDepartureItemStatusInput = {
  _id: Scalars['ObjectId'];
  /** Required when setting status to CANCELLED or PENDING_CANCELLATION */
  cancellationReason?: InputMaybe<DepartureItemCancellationReason>;
  status: DepartureStatus;
};

export type UpdateDepartureItemStatusResult = BusinessNotSpecifiedError | Departure | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureResult = BusinessNotSpecifiedError | Departure | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureRoomInput = {
  /** Required when setting status to CANCELLED or PENDING_CANCELLATION */
  cancellationReason?: InputMaybe<DepartureItemCancellationReason>;
  capacity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<DepartureStatus>;
};

export type UpdateDepartureRoomResult = BusinessNotSpecifiedError | DepartureRoom | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDepartureSettingsInput = {
  /** List document metadata settings */
  documentMetadata?: InputMaybe<Array<UpdateDepartureDocumentMetadataSettingsInput>>;
  eTicketsAvailabilityDpd?: InputMaybe<Scalars['Int']>;
  flightsReleasedDpd?: InputMaybe<Scalars['Int']>;
  flightsRequestDpd?: InputMaybe<Scalars['Int']>;
  flightsRequestMessagingDpd?: InputMaybe<Scalars['Int']>;
  hotelsReleasedDpd?: InputMaybe<Scalars['Int']>;
  hotelsRequestDpd?: InputMaybe<Scalars['Int']>;
  nbEstimatedDaysForFlightRelease?: InputMaybe<Scalars['Int']>;
  publicDepartureMinDpd?: InputMaybe<Scalars['Int']>;
  publicSpotsLeftThreshold?: InputMaybe<Scalars['Int']>;
  tourDirectorFutureToursGateDpd?: InputMaybe<Scalars['Int']>;
};

export type UpdateDraftBookingPaymentSchedulePaymentMethodResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidPaymentError | InvalidPaymentScheduleError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftBookingPaymentScheduleResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidPaymentError | InvalidPaymentScheduleError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftBookingTripLineItemStatusesInput = {
  /** The business reason for the cancellation */
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  /** The line item Id on the draft order to modify the status of. */
  lineItemId: Scalars['ObjectId'];
  /** The new line item status. */
  status: LineItemStatus;
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId'];
};

export type UpdateDraftBookingTripLineItemStatusesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftBookingTripStatusesInput = {
  status: TripStatus;
  /** The tripId on the draft order. */
  tripId: Scalars['ObjectId'];
};

export type UpdateDraftBookingTripStatusesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderAddressResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderAdjustmentPricesInput = {
  /** The adjustment lineItemId to update */
  adjustmentLineItemId: Scalars['ObjectId'];
  /** The adjustment amount. Will override the results of buildPrice(). */
  overrideAmount: Scalars['Float'];
  /** The trip to override the adjustment price on. */
  tripId: Scalars['ObjectId'];
};

export type UpdateDraftOrderAdjustmentPricesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderAirportTransferInput = {
  arriving?: InputMaybe<AirportTransferInput>;
  returning?: InputMaybe<AirportTransferInput>;
  tripId: Scalars['ObjectId'];
};

export type UpdateDraftOrderAirportTransferResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderEmergencyContactsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderExtensionRoomsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidDepartureError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderFeePricesInput = {
  /** The fee lineItemId to update */
  feeLineItemId: Scalars['ObjectId'];
  /** The fee amount. Will override the results of buildPrice(). */
  overrideAmount: Scalars['Float'];
  /** The trip to override the fee price on. */
  tripId: Scalars['ObjectId'];
};

export type UpdateDraftOrderFeePricesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderFinalInstallmentDeadlineResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderFinalPaymentDeadlineResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderFlightPackageInput = {
  /**
   * The reason for updating the flights.
   * @deprecated Use flightPackageCancellationReason instead.
   */
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  /** Departing flight package input */
  departing: UpdateDraftOrderFlightPackageItemInput;
  /** The reason for cancelling the flight package. */
  flightPackageCancellationReason?: InputMaybe<FlightPackageCancellationReason>;
  /** Returning flight package input */
  returning: UpdateDraftOrderFlightPackageItemInput;
  /** Trip to set flight packages on */
  tripId: Scalars['ObjectId'];
};

export type UpdateDraftOrderFlightPackageItemInput = {
  /**
   * Flight departure date. If an extension exists, it defaults to the extension's flight date, otherwise, it defaults to departure's corresponding flight date.
   * @deprecated Use requestedDate instead
   */
  departureDate?: InputMaybe<Scalars['Date']>;
  /** Flight package product code */
  lineItemCode: Scalars['LineItemCode'];
  /** Date to extend the request to. If departing sets the departure date and will default to earlier of the tour or extensions departure date. If returning, sets the end date and will default to the later of the tour or extensions end dates. */
  requestedDate?: InputMaybe<Scalars['Date']>;
  /** Stop over information */
  stopOver?: InputMaybe<StopOverInput>;
};

export type UpdateDraftOrderFlightPackagesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidFlightPackageError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderIncentivesRedemptionAdjustmentInput = {
  customerId: Scalars['ObjectId'];
  draftOrderId: Scalars['ObjectId'];
  /** The desired total redemption amount for this trip. This is the final absolute value for the line item, not an incremental change. */
  totalRedemptionAmount: MoneyInput;
};

export type UpdateDraftOrderIncentivesRedemptionAdjustmentResult = BusinessNotSpecifiedError | DraftOrderWithRedemptionEvaluation | DuplicateUniqueKeyError | IncentivesError | IncentivesIntegrationDisabledError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderInsuranceResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidInsurancePlanError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderMultiTripTsaInformationResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderPrimaryTripResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderPromoPricesInput = {
  /** The promo amount. Will override the results of buildPrice(). */
  overrideAmount: Scalars['Float'];
  /** The promo lineItemId to update */
  promoLineItemId: Scalars['ObjectId'];
  /** The trip to override the fee price on. */
  tripId: Scalars['ObjectId'];
};

export type UpdateDraftOrderPromoPricesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderRequestedRoommatesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderRequestedTravelCompanionsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderRoomInput = {
  /** The reason for cancelling the room */
  cancellationReason?: InputMaybe<LineItemCancellationReason>;
  /** The lineItemCode of the room. */
  lineItemCode: Scalars['LineItemCode'];
  tripId: Scalars['ObjectId'];
};

export type UpdateDraftOrderRoomsResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderTravelerNotesResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftOrderTsaInformationResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateDraftQuoteSavedInput = {
  isSaved: Scalars['Boolean'];
};

export type UpdateDraftQuoteSavedResult = BusinessNotSpecifiedError | DraftOrder | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Update a draft term */
export type UpdateDraftTermInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  content: Scalars['JSON'];
  market: TermMarket;
  termType: TermType;
};

export type UpdateDraftTermResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ImmutableTermError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Term | ValidationError;

export type UpdateEvaluationSettingsInput = {
  /** The default template string for component questions */
  componentQuestionText?: InputMaybe<Scalars['String']>;
  /** Customer evaluation settings */
  customerEvaluationSettings?: InputMaybe<UpdateCustomerEvaluationSettingsInput>;
  /** Tour director tour end report settings */
  tourDirectorTourEndReportSettings?: InputMaybe<UpdateTourDirectorTourEndReportSettingsInput>;
};

export type UpdateExperimentalLeadInput = {
  businessCode?: InputMaybe<BusinessCode>;
  description?: InputMaybe<Scalars['String']>;
  experimentName?: InputMaybe<Scalars['String']>;
  interactionDate?: InputMaybe<Scalars['DateTime']>;
  location?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  talkingPoints?: InputMaybe<Array<TalkingPointInput>>;
  tourCode?: InputMaybe<Scalars['String']>;
};

export type UpdateExperimentalLeadResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ExperimentalLead | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateExtendedStayInput = {
  basePrice: Array<MoneyInput>;
};

export type UpdateExtendedStayResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ExtendedStay | InvalidDateError | InvalidDateRangeError | InvalidFlightPackageError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateExtendedStayStatusInput = {
  status: TripComponentStatus;
};

export type UpdateExtendedStayStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | ExtendedStay | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateFeeCalculationRuleInput = {
  /** Defines the maximum DPD value for this rule to match */
  maxDpd: Scalars['Int'];
  /** The strategy to use when calculating the fee */
  strategy: FeeCalculationStrategy;
  /** The percentage of the trip cost to use for the fee */
  tripPercent: Scalars['Int'];
};

export type UpdateFeeCancellationSettingsInput = {
  /** Category specific rules for calculating the fee */
  categorySpecificRules?: InputMaybe<Array<UpdateFeeCategorySpecificCalculationRuleInput>>;
  /** Default rules for calculating the fee */
  defaultRules?: InputMaybe<Array<UpdateFeeCalculationRuleInput>>;
};

export type UpdateFeeCategorySpecificCalculationRuleInput = {
  /** List of fee category codes that should use the calculation rules */
  categoryCodes: Array<Scalars['FeeCategoryCode']>;
  /** List of calculation rules for the category codes */
  rules: Array<UpdateFeeCalculationRuleInput>;
};

/** Update a fee */
export type UpdateFeeInput = {
  basePrice: Array<MoneyInput>;
  isRefundable?: InputMaybe<Scalars['Boolean']>;
  persistsOnRebooking?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateFeeResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | Fee | InvalidDateError | InvalidDateRangeError | InvalidFeeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateFeeSettingsInput = {
  /** Settings for calculating the cancellation fee amount. */
  cancellationSettings?: InputMaybe<UpdateFeeCancellationSettingsInput>;
  /** When using percentage cancellation fees and this is also set, uses the effective DPD based on all rebooked trips to determine the cancellation fee. */
  useLowestDpdInRebookingChain?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateFeeStatusInput = {
  status: TripComponentStatus;
};

export type UpdateFeeStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | Fee | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateFlightPackageInput = {
  basePrice: Array<MoneyInput>;
  isCustomGateway: Scalars['Boolean'];
};

export type UpdateFlightPackageResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightPackage | InvalidDateError | InvalidDateRangeError | InvalidFlightPackageError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateFlightPackageStatusInput = {
  status: TripComponentStatus;
};

export type UpdateFlightPackageStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightPackage | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateFlightSettingsInput = {
  /** List of allowed remote gateway, those on tour, for flight shopping as IATA airport codes or IATA MAC (city) codes */
  allowedFlightShoppingRemoteGateways?: InputMaybe<Array<Scalars['String']>>;
  /** List of allowed stopover gateway codes */
  allowedStopoverGatewayCodes?: InputMaybe<Array<Scalars['String']>>;
  /** Business level setting if the flight shopping feature is enabled for Canadian origin gateways */
  enableFlightShoppingFromCanadianOriginGateways?: InputMaybe<Scalars['Boolean']>;
  /** Business level setting if the flight shopping feature is enabled for US origin gateways */
  enableFlightShoppingFromUSOriginGateways?: InputMaybe<Scalars['Boolean']>;
  /** Commission percentage applied to the difference in cost between lowest price and user's selection (only if not in included range) */
  flightShoppingAddCollectCommissionPercentage?: InputMaybe<Scalars['Percentage']>;
  /** DPD from which we will allow users to select their flights */
  flightShoppingAllowedFromDpd?: InputMaybe<Scalars['Int']>;
  /** DPD until which we allow users to select their flights if they have immediately purchased their trip */
  flightShoppingAllowedUntilDpd?: InputMaybe<Scalars['Int']>;
  /** Percentage above the lowest price that will be marked as included */
  flightShoppingIncludedPercentage?: InputMaybe<Scalars['Percentage']>;
  /** Optional dollar maximum for the included range */
  flightShoppingMaxIncludedAmount?: InputMaybe<Array<MoneyInput>>;
  /** DPD by which flight tickets are expected to be released for flight shopping */
  flightShoppingTicketsReleaseDpd?: InputMaybe<Scalars['Int']>;
  /** The max percentage of the flight package price that the lowest priced flight option is allowed to be */
  flightsPackageCeilingPercentage?: InputMaybe<Scalars['Percentage']>;
  /** Dollar value to round the total up to */
  flightsShoppingRoundingDollar?: InputMaybe<Scalars['Int']>;
  /** Settings for lost baggage service availability */
  lostBaggageServiceSettings?: InputMaybe<UpdateLostBaggageServiceSettingsInput>;
  /** Number of days after either the shopping window has opened or a user has purchased a flight that we will allow them to enter the Flight Shopping Flow */
  numberOfDaysToAllowFlightShopping?: InputMaybe<Scalars['Int']>;
};

export type UpdateFlightShopInput = {
  addCollectCommissionPercentage?: InputMaybe<Scalars['Float']>;
  includedPercentage?: InputMaybe<Scalars['Float']>;
  maxIncludedAmount?: InputMaybe<Array<MoneyInput>>;
  packageCeilingPercentage?: InputMaybe<Scalars['Float']>;
  roundingAmount?: InputMaybe<Array<MoneyInput>>;
};

export type UpdateFlightShopResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightShop | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateFlightShopStatusInput = {
  status: TripComponentStatus;
};

export type UpdateFlightShopStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | FlightShop | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Used to update the auto applied adjustments, or is passed as empty to remove the adjustments */
export type UpdateGcDepartureAdjustmentInput = {
  amount: Array<MoneyInput>;
  lineItemCode: Scalars['LineItemCode'];
  /** @deprecated Do not use this field. This field is no longer in use and will be removed in a future release. We're keeping it for backward compatibility. Use amount instead. */
  price?: MoneyInput;
};

export type UpdateGcDepartureInput = {
  /** The ID of the GC Departure to update */
  _id: Scalars['ObjectId'];
  /** The adjustments to apply to GM quotes for this GC departure */
  autoAppliedAdjustments?: InputMaybe<Array<UpdateGcDepartureAdjustmentInput>>;
  /** The percentage of the average program price that counts towards a companion discount per qualifying traveler. Limited to 2 decimal places */
  companionDiscountRate: Scalars['Float'];
  /** The expected volume for the GC Departure, used as a stretch goal to track progress by the GC */
  expectedVolume: Scalars['Int'];
  /** The rate at which the GC earns free places for insurance packages based on on the number of paying travelers. Expressed as an integer */
  freeInsuranceRatio: Scalars['FreePlaceRatio'];
  /** The rate at which the GC earns free places for the tour, extension, and excursions based on the number of paying travelers. Expressed as an integer */
  freePlaceRatio: Scalars['FreePlaceRatio'];
  /** An estimate of the number of travelers on the GC Departure, used by account managers to estimate things like the private group fee */
  groupSizeEstimate: Scalars['Int'];
  /** Whether or not trips on this GC Departure should be assessed the private group fee during reconciliation. */
  includePrivateGroupFee?: InputMaybe<Scalars['Boolean']>;
  /** The rules that determine the line items that are available to the GC for the GCDeparture */
  lineItemRules?: InputMaybe<Array<UpdateGcDepartureSettingsLineItemRuleInput>>;
  /** The URL of the microsite where GMs can quote and book */
  micrositeUrl?: InputMaybe<Scalars['String']>;
  /** The date of a recruitment meeting for the GC to promote the GCDeparture to potential group members */
  recruitmentMeetingDate?: InputMaybe<Scalars['Date']>;
  /** The percentage of the average program price that counts towards a GC stipend payment per qualifying traveler. Limited to 2 decimal places */
  stipendRate: Scalars['Float'];
};

export type UpdateGcDepartureMeetingInput = {
  allowsLateRSVP?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  location?: InputMaybe<Scalars['String']>;
  meetingDateEnd: Scalars['DateTime'];
  meetingDateStart: Scalars['DateTime'];
  rsvpDueDate: Scalars['Date'];
  style: MeetingStyle;
  timezone: Scalars['String'];
  virtualMeetingLink?: InputMaybe<Scalars['String']>;
};

export type UpdateGcDepartureMeetingRsvpInput = {
  _id: Scalars['ObjectId'];
  notes?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<GcDepartureMeetingRsvpResponse>;
};

export type UpdateGcDepartureMeetingRsvpResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDepartureMeetingRsvp | InvalidDateError | InvalidDateRangeError | InvalidGcDepartureMeetingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateGcDepartureMeetingResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDepartureMeeting | InvalidDateError | InvalidDateRangeError | InvalidGcDepartureMeetingError | InvalidTimeRangeError | InvalidTimezoneError | NotAuthorizedError | NotFoundError | ValidationError;

/** Input for updating a gc departure prospect */
export type UpdateGcDepartureProspectInput = {
  _id: Scalars['ObjectId'];
  address?: InputMaybe<AddressInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  levelOfInterest?: InputMaybe<GcDepartureProspectLevelOfInterest>;
  notes?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateGcDepartureProspectResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDepartureProspect | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateGcDepartureResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDeparture | InvalidAdjustmentError | InvalidDateError | InvalidDateRangeError | InvalidMoneyError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateGcDepartureSettingsInput = {
  eTicketsAvailabilityDpd?: InputMaybe<Scalars['Int']>;
  enableFreePlace?: InputMaybe<Scalars['Boolean']>;
  flightsReleasedDpd?: InputMaybe<Scalars['Int']>;
  nbEstimatedDaysForFlightRelease?: InputMaybe<Scalars['Int']>;
  reconciliationDpd?: InputMaybe<Scalars['Int']>;
  /** Number of years to look back at a customer's Group Member trips when deciding whether they are still eligible to see referrals. The cutoff is `today - referralLookbackYears`; set to 0 to require a future-booked GM trip. Omit the field to leave the existing value unchanged; pass `null` to explicitly clear it (removes any GM-based referral restriction for this business). */
  referralLookbackYears?: InputMaybe<Scalars['Int']>;
  /** Minimum number of hours after a meeting RSVP in which the prospects can become visible to the Sales team. */
  rsvpProspectVisibilityDelay?: InputMaybe<Scalars['Int']>;
};

/** Used to update GC Departure Line Item Rules */
export type UpdateGcDepartureSettingsLineItemRuleInput = {
  level: GcDepartureRuleLevel;
  lineItemCode: Scalars['LineItemCode'];
  lineItemType: GcDepartureRuleLineItemType;
};

/** Input fields to set GC Departure Stipend detail */
export type UpdateGcDepartureStipendDetailInput = {
  /** The ID of the GC Departure to update */
  _id: Scalars['ObjectId'];
  /** The dollar amount of the check being issued */
  amount?: InputMaybe<MoneyInput>;
  /** A date to record the cancellation of the stipend benefit */
  cancelledDate?: InputMaybe<Scalars['Date']>;
  /** The check number of the issued check */
  checkNumber?: InputMaybe<Scalars['String']>;
  /** The date the check was issued */
  issuedDate?: InputMaybe<Scalars['Date']>;
  /** The current status of the stipend */
  status: GcDepartureStipendDetailStatus;
};

export type UpdateGcDepartureStipendDetailResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | GcDeparture | InvalidDateError | InvalidDateRangeError | InvalidMoneyError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateGroupTripChecklistSettingsInput = {
  emergencyContactDueAtDpd?: InputMaybe<Scalars['Int']>;
  healthNotesDueAtDpd?: InputMaybe<Scalars['Int']>;
  passportInformationDueAtDpd?: InputMaybe<Scalars['Int']>;
  roommateDaysDueAfterBooking?: InputMaybe<Scalars['Int']>;
  termsSignatureDaysDueAfterBooking?: InputMaybe<Scalars['Int']>;
  tsaIdentifiersDueAtDpd?: InputMaybe<Scalars['Int']>;
};

export type UpdateInsuranceExtensionInput = {
  basePrice: Array<MoneyInput>;
};

export type UpdateInsuranceExtensionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsuranceExtension | InvalidDateError | InvalidDateRangeError | InvalidInsurancePlanError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsuranceExtensionStatusInput = {
  status: TripComponentStatus;
};

export type UpdateInsuranceExtensionStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsuranceExtension | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsurancePlanAddonInput = {
  basePrice: Array<MoneyInput>;
  includedWithinDays?: InputMaybe<Scalars['Int']>;
  internalName: Scalars['String'];
  preventPurchaseAfterDays?: InputMaybe<Scalars['Int']>;
};

export type UpdateInsurancePlanAddonResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePlanAddon | InvalidDateError | InvalidDateRangeError | InvalidInsurancePlanError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsurancePlanAddonStatusInput = {
  _id: Scalars['ObjectId'];
  status: TripComponentStatus;
};

export type UpdateInsurancePlanAddonStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePlanAddon | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsurancePlanInput = {
  basePrice: Array<MoneyInput>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']>;
  effectiveTo?: InputMaybe<Scalars['DateTime']>;
  internalName: Scalars['String'];
  isEligibleForRolloverOnRebooking?: InputMaybe<Scalars['Boolean']>;
  /** The insurance plan will become available starting from the specified number of days after the booking date */
  purchasableAfterDays?: InputMaybe<Scalars['Int']>;
  /** The insurance plan will be available during the quote process and for the specified number of days after booking */
  purchasableWithinDays?: InputMaybe<Scalars['Int']>;
};

export type UpdateInsurancePlanResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePlan | InvalidDateError | InvalidDateRangeError | InvalidInsurancePlanError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsurancePlanStatusInput = {
  status: TripComponentStatus;
};

export type UpdateInsurancePlanStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePlan | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsurancePolicyInput = {
  coversPreExistingConditions?: InputMaybe<Scalars['Boolean']>;
  friendlyName?: InputMaybe<Scalars['String']>;
  internalName?: InputMaybe<Scalars['String']>;
  providerName: Scalars['String'];
};

export type UpdateInsurancePolicyResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsurancePolicy | InvalidDateError | InvalidDateRangeError | InvalidInsurancePolicyError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsurancePolicyRevisionInput = {
  carrier?: InputMaybe<Scalars['String']>;
  /** Co-pay amount for the insurance plan */
  copay?: InputMaybe<MoneyInput>;
  /** Deductible amount for the insurance plan */
  deductible?: InputMaybe<MoneyInput>;
  effectiveFrom: Scalars['DateTime'];
  effectiveTo: Scalars['DateTime'];
  /** Maximum coverage for emergency medical evacuation and return of mortal remains */
  emergencyMedicalMaximum?: InputMaybe<MoneyInput>;
  freeLookPeriodDays: Scalars['Int'];
  grossWrittenPremium?: InputMaybe<MoneyInput>;
  /** Maximum coverage amount for medical expenses */
  medicalMaximum?: InputMaybe<MoneyInput>;
  policyNumber: Scalars['String'];
  programCode?: InputMaybe<Scalars['String']>;
  /** Maximum coverage amount for travel delay expenses */
  travelDelayMaximum?: InputMaybe<MoneyInput>;
};

export type UpdateInsurancePolicyRevisionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InsuranceRevision | InvalidDateError | InvalidDateRangeError | InvalidInsurancePolicyError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

export type UpdateInsuranceSettingsInput = {
  defaultAdjustmentLineItemCode?: InputMaybe<Scalars['LineItemCode']>;
  /** List of Canadian province abbreviations where insurance purchase is not allowed */
  ineligibleStatesCA?: InputMaybe<Array<Scalars['String']>>;
  /** List of US state abbreviations where insurance purchase is not allowed */
  ineligibleStatesUS?: InputMaybe<Array<Scalars['String']>>;
  /** Whether insurance is available for customers in Canada */
  isAvailableInCanada?: InputMaybe<Scalars['Boolean']>;
  nbMaximumDaysToExtend?: InputMaybe<Scalars['Int']>;
  removalWindowDays?: InputMaybe<Scalars['Int']>;
  /** List of arrival or departure gateway codes where insurance purchase is not allowed for Canadian customers */
  restrictedDestinationGatewaysCA?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateIntegrationSettingsInput = {
  cybersourceMerchantIdCA?: InputMaybe<Scalars['String']>;
  cybersourceMerchantIdUS?: InputMaybe<Scalars['String']>;
  /** @deprecated This has been deprecated in favor of config values. */
  indiesReferralCampaignId?: InputMaybe<Scalars['String']>;
  isTalonOneEnabled?: InputMaybe<Scalars['Boolean']>;
  mailroom?: InputMaybe<UpdateMailroomSettingsInput>;
  micrositeUrlCA?: InputMaybe<Scalars['String']>;
  micrositeUrlUS?: InputMaybe<Scalars['String']>;
  productMarketBillingCodeCA?: InputMaybe<Scalars['String']>;
  productMarketBillingCodeUS?: InputMaybe<Scalars['String']>;
  productMarketCodeCA?: InputMaybe<Scalars['String']>;
  productMarketCodeUS?: InputMaybe<Scalars['String']>;
  referralIncentiveDiscountLineItemCode?: InputMaybe<Scalars['String']>;
  rightFlightBrandIdCA?: InputMaybe<Scalars['String']>;
  rightFlightBrandIdUS?: InputMaybe<Scalars['String']>;
  rightFlightChannelRemark?: InputMaybe<Scalars['String']>;
  /** @deprecated This has been deprecated in favor of config values. */
  talonOneLoyaltyProgramName?: InputMaybe<Scalars['String']>;
  /** @deprecated This has been deprecated in favor of config values. */
  talonOneReferralSubledgerName?: InputMaybe<Scalars['String']>;
  transactionalEmails?: InputMaybe<Array<UpdateTransactionalEmailSettingsInput>>;
  websiteUrlCA?: InputMaybe<Scalars['String']>;
  websiteUrlUS?: InputMaybe<Scalars['String']>;
};

export type UpdateLostBaggageServiceSettingsInput = {
  bookingDateFrom?: InputMaybe<Scalars['Date']>;
  departureDateFrom?: InputMaybe<Scalars['Date']>;
};

export type UpdateMailroomSettingsInput = {
  isActive: Scalars['Boolean'];
  nbPreDepartureMailDaysFrom: Scalars['Int'];
  nbPreDepartureMailDaysTo: Scalars['Int'];
  preDepartureMailMinimumBalance: Array<MoneyInput>;
};

export type UpdateNoteInput = {
  content: Scalars['String'];
};

export type UpdateNoteResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Note | ValidationError;

export type UpdateOAuthClientInput = {
  clientName?: InputMaybe<Scalars['String']>;
  redirectUris?: InputMaybe<Array<Scalars['String']>>;
  scope?: InputMaybe<Scalars['String']>;
};

export type UpdateOAuthClientResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | OAuthClient | ValidationError;

export type UpdateOrderPaymentSettingsInput = {
  achCheck?: InputMaybe<UpdatePaymentPlanSettingsInput>;
  bypassErrorOnProcessorDown?: InputMaybe<Scalars['Boolean']>;
  creditCard?: InputMaybe<UpdatePaymentPlanSettingsInput>;
  debitCard?: InputMaybe<UpdatePaymentPlanSettingsInput>;
  earliestPaymentScheduleStartDays?: InputMaybe<Scalars['Int']>;
  latestPaymentScheduleStartDays?: InputMaybe<Scalars['Int']>;
  nbMaximumAutopayAttempts?: InputMaybe<Scalars['Int']>;
  physicalCheck?: InputMaybe<UpdatePaymentPlanSettingsInput>;
};

export type UpdateOrderQuoteSettingsInput = {
  expiresInMinutes?: InputMaybe<Scalars['Int']>;
};

export type UpdateOrderRoomingSettingsInput = {
  matchPartialRooms?: InputMaybe<Scalars['Boolean']>;
  selfServiceableBedCodes?: InputMaybe<Array<TourBedCode>>;
};

export type UpdateOrderSettingsInput = {
  departurePriorityWindowDpd?: InputMaybe<Scalars['Int']>;
  emergencyContactSelfServiceDeadlineDpd?: InputMaybe<Scalars['Int']>;
  healthNotesSelfServiceDeadlineDpd?: InputMaybe<Scalars['Int']>;
  maximumAgeForTraveler?: InputMaybe<Scalars['Int']>;
  maximumPerTripPromotionAmount?: InputMaybe<Array<MoneyInput>>;
  minimumAgeForTraveler?: InputMaybe<Scalars['Int']>;
  passportInformationSelfServiceDeadlineDpd?: InputMaybe<Scalars['Int']>;
  riskFreePeriod?: InputMaybe<UpdateRiskFreePeriodSettingsInput>;
  travelCompanionsSettings?: InputMaybe<UpdateTravelCompanionsSettingsInput>;
  tsaIdentifiersSelfServiceDeadlineDpd?: InputMaybe<Scalars['Int']>;
};

export type UpdatePasswordResult = {
  __typename?: 'UpdatePasswordResult';
  success: Scalars['Boolean'];
};

export type UpdatePaymentPlanSettingsInput = {
  isAutopayAllowed?: InputMaybe<Scalars['Boolean']>;
  isManualAllowed?: InputMaybe<Scalars['Boolean']>;
};

/** Input for updating an existing place */
export type UpdatePlaceInput = {
  /** Optional ISO 3166-1 alpha-2 code for the country. If the place type is not COUNTRY, this field is ignored. */
  alpha2Code?: InputMaybe<Scalars['String']>;
  /** Optional ISO 3166-1 alpha-3 code for the country. If the place type is not COUNTRY, this field is ignored. */
  alpha3Code?: InputMaybe<Scalars['String']>;
  /** Optional Google Place ID for the place */
  googlePlaceId?: InputMaybe<Scalars['String']>;
  /** The name of the place */
  name?: InputMaybe<Scalars['String']>;
  /** Optional parent place IDs for hierarchical structure */
  parentIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The unique code for the place, which must be alphanumeric and can contain hyphens and underscores only. */
  placeCode?: InputMaybe<Scalars['String']>;
};

export type UpdatePlaceResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPlaceError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | UpdatePlaceSuccess | ValidationError;

export type UpdatePlaceSuccess = {
  __typename?: 'UpdatePlaceSuccess';
  data: Place;
};

/** Update a private group */
export type UpdatePrivateGroupInput = {
  basePrice: Array<MoneyInput>;
};

export type UpdatePrivateGroupResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPrivateGroupError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type UpdatePrivateGroupStatusInput = {
  status: TripComponentStatus;
};

export type UpdatePrivateGroupStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPrivateGroupError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

/** Update the details of a promo */
export type UpdatePromoInput = {
  displayName: Scalars['String'];
  effectiveFrom: Scalars['DateTime'];
  effectiveTo: Scalars['DateTime'];
  exclusivity: PromoExclusivity;
  isGroupsOnly?: Scalars['Boolean'];
  isHiddenFromSales?: Scalars['Boolean'];
  isIndiesOnly?: Scalars['Boolean'];
  isShareable?: Scalars['Boolean'];
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  promoCategory?: InputMaybe<PromoCategory>;
};

export type UpdatePromoResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type UpdatePromoSettingsInput = {
  /** Promo code to use for the advanced repeat promo feature */
  advancedRepeatPromoCode?: InputMaybe<Scalars['String']>;
  /** Customer facing name for the advanced repeat promo */
  advancedRepeatPromoName?: InputMaybe<Scalars['String']>;
  /** List of trip thresholds for higher repeat promo code discounts */
  repeatThresholds?: InputMaybe<Array<UpdateRepeatThresholdSettingsInput>>;
  /** List of reasons for service recovery promotions. */
  serviceRecoveryReasons?: InputMaybe<Array<Scalars['String']>>;
  /** Enable advanced behavior for the REPEAT promo code. */
  useAdvancedRepeatPromo?: InputMaybe<Scalars['Boolean']>;
};

export type UpdatePromoStatusInput = {
  status: TripComponentStatus;
};

export type UpdatePromoStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

/** Update the targets of a promo */
export type UpdatePromoTargetsInput = {
  targets: Array<CreatePromoTargetInput>;
};

export type UpdatePromoTargetsResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Promo | ValidationError;

export type UpdateQuoteExpiryInput = {
  expirationDate: Scalars['DateTime'];
};

export type UpdateQuoteExpiryResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Quote | ValidationError;

export type UpdateQuoteSavedInput = {
  isSaved: Scalars['Boolean'];
};

export type UpdateQuoteSavedResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidOrderError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Quote | ValidationError;

export type UpdateRepeatThresholdSettingsInput = {
  discount: Array<MoneyInput>;
  /** Number of trips required for discount */
  nbTrips: Scalars['Int'];
  /** Additional amount to discount if applied before repeatBonusExpiresAfterDays */
  repeatBonus: Array<MoneyInput>;
  /** Number of days after the last trip to earn the repeat bonus */
  repeatBonusExpiresAfterDays: Scalars['Int'];
};

/** Updates a review detail */
export type UpdateReviewDetailInput = {
  author?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateReviewDetailResponseInput = {
  author: Scalars['String'];
  body: Scalars['String'];
};

export type UpdateReviewDetailResponseResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidRatingError | InvalidReviewError | InvalidReviewResponseError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Review | ValidationError;

export type UpdateReviewDetailStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidRatingError | InvalidReviewError | InvalidReviewResponseError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Review | ValidationError;

export type UpdateReviewImagesStatusInput = {
  imageId: Scalars['ObjectId'];
  status: ReviewStatus;
};

export type UpdateReviewImagesStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidReviewError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Review | ValidationError;

/** Update a review input. Passing null or undefined will ignore the update */
export type UpdateReviewInput = {
  detail?: InputMaybe<UpdateReviewDetailInput>;
  rating: Scalars['Int'];
};

export type UpdateReviewResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidRatingError | InvalidReviewError | InvalidReviewResponseError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Review | ValidationError;

export type UpdateReviewSettingsInput = {
  /** Whether review auto moderation is enabled */
  reviewAutoModeratorEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Number of days after the departure that reviews are allowed to be submitted */
  reviewCutoffDays?: InputMaybe<Scalars['Int']>;
  /** Whether review image auto moderation (AI) is enabled */
  reviewImageAutoModeratorEnabled?: InputMaybe<Scalars['Boolean']>;
  /** The system prompt used for AI review moderation */
  reviewModerationPrompt?: InputMaybe<Scalars['String']>;
  /** The system prompt used for generating tour page review summaries */
  tourPageReviewSummaryPrompt?: InputMaybe<Scalars['String']>;
};

export type UpdateRiskFreePeriodSettingsInput = {
  minimumEligibleDpd?: InputMaybe<Scalars['Int']>;
  nbAutopayDays?: InputMaybe<Scalars['Int']>;
  nbManualDays?: InputMaybe<Scalars['Int']>;
  nbPayInFullDays?: InputMaybe<Scalars['Int']>;
  preserveRiskFreePeriodOnRebooking?: InputMaybe<Scalars['Boolean']>;
  useMinimumEligibleDpd?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateRoleInput = {
  name: Scalars['String'];
  permissionKeys: Array<PermissionKey>;
};

export type UpdateRoleResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Role | ValidationError;

/** Input for updating a saved place */
export type UpdateSavedPlaceInput = {
  /** The id of the saved place to update */
  id: Scalars['ObjectId'];
  /** Set whether the user has visited the place */
  userHasVisited?: InputMaybe<Scalars['Boolean']>;
  /** Set whether the user wants to visit the place */
  userWantsToVisit?: InputMaybe<Scalars['Boolean']>;
};

/** Update the details of a service recovery promo. */
export type UpdateServiceRecoveryPromoInput = {
  expiryDate: Scalars['DateTime'];
  recoveryReason: Scalars['String'];
};

export type UpdateServiceRecoveryPromoResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ServiceRecovery | ValidationError;

export type UpdateServiceRecoveryPromoStatusInput = {
  status: TripComponentStatus;
};

export type UpdateServiceRecoveryPromoStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ServiceRecovery | ValidationError;

export type UpdateSupportSettingsInput = {
  /** The external ID of support ticket business. */
  businessExternalId?: InputMaybe<Scalars['String']>;
  /** Enable auto approved late add support ticket creation. */
  isAutoApprovedLateAddEnabled?: InputMaybe<Scalars['Boolean']>;
};

/** Update the basic details of a tag */
export type UpdateTagInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type UpdateTagResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Tag | ValidationError;

export type UpdateTourAirportTransferInput = {
  /** The _id of the airport transfer to update. */
  _id: Scalars['ObjectId'];
  /** Days before departure when transfers will still be auto-confirmed. Only valid for STANDARD window types. */
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  /** Internal display name for the airport transfer. */
  internalName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type UpdateTourAirportTransferResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidAirportTransferError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | TourAirportTransfer | ValidationError;

export type UpdateTourDirectorTourEndReportSettingsInput = {
  /** List of component type codes for tour director reports */
  componentTypeCodes?: InputMaybe<Array<Scalars['String']>>;
  /** Number of days until evaluation becomes available */
  nbDaysUntilEvaluationAvailable?: InputMaybe<Scalars['Int']>;
  /** Number of days until evaluation is due */
  nbDaysUntilEvaluationDue?: InputMaybe<Scalars['Int']>;
  /** Whether to generate component questions */
  shouldGenerateComponentQuestions?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateTourExcursionInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  /** The minimum number of travelers required for this excursion to be confirmed. */
  minNbTravelersRequired?: InputMaybe<Scalars['Int']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type UpdateTourExcursionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | TourExcursion | ValidationError;

export type UpdateTourExcursionStatusInput = {
  status: TripComponentStatus;
};

export type UpdateTourExcursionStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | TourExcursion | ValidationError;

export type UpdateTourExtensionAirportTransferInput = {
  /** The _id of the airport transfer to update. */
  _id: Scalars['ObjectId'];
  /** Days before departure when transfers will still be auto-confirmed. Only valid for STANDARD window types. */
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  /** Base price for the airport transfer before any price rules. */
  basePrice?: InputMaybe<Array<MoneyInput>>;
  /** Internal display name for the airport transfer. */
  internalName?: InputMaybe<Scalars['String']>;
  /** Whether the component is published or unpublished. */
  status?: InputMaybe<TripComponentStatus>;
};

export type UpdateTourExtensionAirportTransferResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidAirportTransferError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | TourAirportTransfer | ValidationError;

export type UpdateTourExtensionInput = {
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  /** The default capacity that will set for departures created from this Extension. */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']>;
  isPreExtension?: InputMaybe<Scalars['Boolean']>;
  minimumCapacity?: InputMaybe<Scalars['Int']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  postStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  preStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type UpdateTourExtensionResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | TourExtension | ValidationError;

export type UpdateTourExtensionRoomInput = {
  /** The _id of the tour extension room to update. */
  _id: Scalars['ObjectId'];
  basePrice?: InputMaybe<Array<MoneyInput>>;
  bedCode?: InputMaybe<TourBedCode>;
  cabinCode?: InputMaybe<Scalars['TourCabinCode']>;
  /** The capacity that will set for Departure Rooms created from this Tour Room.  */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  /**
   * Whether or not roommate matching is needed for this room
   * @deprecated Use requiresCompleteRoommates instead.
   */
  enableRoommateMatching?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not this room must have complete roommates */
  requiresCompleteRoommates?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type UpdateTourExtensionRoomResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | TourRoom | ValidationError;

export type UpdateTourExtensionRoomStatusInput = {
  /** The _id of the tour extension room to update. */
  _id: Scalars['ObjectId'];
  status: TripComponentStatus;
};

export type UpdateTourExtensionRoomStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | TourRoom | ValidationError;

export type UpdateTourExtensionStatusInput = {
  /** Include all the extension rooms statuses */
  includeRooms?: Scalars['Boolean'];
  status: TripComponentStatus;
};

export type UpdateTourExtensionStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | TourExtension | ValidationError;

export type UpdateTourInput = {
  activityLevel?: InputMaybe<Scalars['Int']>;
  autoApproveDeadlineDpd?: InputMaybe<Scalars['Int']>;
  basePrice?: InputMaybe<Array<MoneyInput>>;
  classLevel?: InputMaybe<Scalars['Int']>;
  /** The default capacity that will set for Departures created from this Tour. */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  deposit?: InputMaybe<Array<MoneyInput>>;
  depositForAutomaticPlan?: InputMaybe<Array<MoneyInput>>;
  depositForLateAdd?: InputMaybe<Array<MoneyInput>>;
  feeCategoryCode?: InputMaybe<Scalars['FeeCategoryCode']>;
  finalInstallmentDeadlineDpd?: InputMaybe<Scalars['Int']>;
  finalPaymentDeadlineDpd?: InputMaybe<Scalars['Int']>;
  isFlightShoppingAllowed?: InputMaybe<Scalars['Boolean']>;
  isNonRevenueTour?: InputMaybe<Scalars['Boolean']>;
  isPassportRequired?: InputMaybe<Scalars['Boolean']>;
  isPostStayAllowed?: InputMaybe<Scalars['Boolean']>;
  isPreStayAllowed?: InputMaybe<Scalars['Boolean']>;
  isVisaRequired?: InputMaybe<Scalars['Boolean']>;
  isWaitlistAllowed?: InputMaybe<Scalars['Boolean']>;
  maxNbTripsPerSelfServiceOrder?: InputMaybe<Scalars['Int']>;
  maxTravelerAge?: InputMaybe<Scalars['Int']>;
  minTravelerAge?: InputMaybe<Scalars['Int']>;
  minimumCapacity?: InputMaybe<Scalars['Int']>;
  nbDepartureFlightDays?: InputMaybe<Scalars['Int']>;
  nbReturningFlightDays?: InputMaybe<Scalars['Int']>;
  placeIds?: InputMaybe<Array<Scalars['ObjectId']>>;
  postStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  preStayCityCodes?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<TripComponentStatus>;
  tagIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type UpdateTourPricingInput = {
  lineItemCode: Scalars['LineItemCode'];
  priceRules: Array<PriceRuleInput>;
};

export type UpdateTourPricingResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPriceYearError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type UpdateTourProductStatusInput = {
  includeChildProducts?: Scalars['Boolean'];
  lineItemCode: Scalars['String'];
  status: TripComponentStatus;
};

export type UpdateTourResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type UpdateTourRoomDetailsInput = {
  /** The default capacity that will set for Departures Rooms created from this Tour Room. Defaults to the Tour capacity or Tour Extension capacity if the extensionLineItemCode was provided. */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
};

export type UpdateTourRoomInput = {
  /** The _id of the tour room to update. */
  _id: Scalars['ObjectId'];
  basePrice?: InputMaybe<Array<MoneyInput>>;
  /** The capacity that will set for Departure Rooms created from this Tour Room.  */
  defaultCapacity?: InputMaybe<Scalars['Int']>;
  /**
   * Whether or not roommate matching is needed for this room
   * @deprecated Use requiresCompleteRoommates instead.
   */
  enableRoommateMatching?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not this room must have complete roommates */
  requiresCompleteRoommates?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<TripComponentStatus>;
};

export type UpdateTourRoomResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTourError | NotAuthorizedError | NotFoundError | TourRoom | ValidationError;

export type UpdateTourRoomStatusInput = {
  /** The _id of the tour room to update. */
  _id: Scalars['ObjectId'];
  status: TripComponentStatus;
};

export type UpdateTourRoomStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | TourRoom | ValidationError;

export type UpdateTourSearchSettingsInput = {
  /** Percentage range for 'around' price queries (e.g., 20 for 20%) */
  aroundPriceRangePercentage?: InputMaybe<Scalars['Percentage']>;
  /** Maximum prices in USD and CAD for budget tours */
  budgetMaxPrice?: InputMaybe<Array<MoneyInput>>;
  /** Minimum prices in USD and CAD for luxury tours */
  luxuryMinPrice?: InputMaybe<Array<MoneyInput>>;
};

export type UpdateTourStatusInput = {
  /** Include all the tour rooms */
  includeRooms?: Scalars['Boolean'];
  status: TripComponentStatus;
};

export type UpdateTourStatusResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidPricingError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | Tour | ValidationError;

export type UpdateTransactionalEmailSettingsInput = {
  campaignId: Scalars['Int'];
  description: Scalars['String'];
  internalCode: Scalars['String'];
  isActive: Scalars['Boolean'];
  nbNotificationDaysInAdvance?: InputMaybe<Scalars['Int']>;
};

export type UpdateTravelCompanionsSettingsInput = {
  requestableTripTypes?: InputMaybe<Array<TripCustomerType>>;
  requestsMinimumDpd?: InputMaybe<Scalars['Int']>;
};

export type UpdateTripChecklistItemTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  dpd?: InputMaybe<Scalars['Int']>;
  effectiveFrom?: InputMaybe<Scalars['Date']>;
  effectiveTo?: InputMaybe<Scalars['Date']>;
  excludeTourCodes?: InputMaybe<Array<Scalars['String']>>;
  importanceLevel?: InputMaybe<CheckListItemImportanceLevel>;
  includeTourCodes?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateTripChecklistItemTemplateResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidTripChecklistItemTemplateError | NotAuthorizedError | NotFoundError | TripChecklistItemTemplate | ValidationError;

export type UpdateTripChecklistSettingsInput = {
  emergencyContactDueAtDpd?: InputMaybe<Scalars['Int']>;
  healthNotesDueAtDpd?: InputMaybe<Scalars['Int']>;
  passportInformationDueAtDpd?: InputMaybe<Scalars['Int']>;
  roommateDaysDueAfterBooking?: InputMaybe<Scalars['Int']>;
  termsSignatureDaysDueAfterBooking?: InputMaybe<Scalars['Int']>;
  tsaIdentifiersDueAtDpd?: InputMaybe<Scalars['Int']>;
};

export type UpdateTsaSettingsInput = {
  /** Whether date of birth is required to book */
  dateOfBirthRequiredToBook?: InputMaybe<Scalars['Boolean']>;
  /** Number of years in the future relative to the current date for valid date range */
  yearsInTheFuture?: InputMaybe<Scalars['Int']>;
  /** Number of years in the past relative to the current date for valid date range */
  yearsInThePast?: InputMaybe<Scalars['Int']>;
};

export type UpdateVoucherRefundDetailInput = {
  /** The ID of the Voucher */
  _id: Scalars['ObjectId'];
  /** The date the check was issued */
  checkIssuedOn?: InputMaybe<Scalars['Date']>;
  /** The check number */
  checkNumber?: InputMaybe<Scalars['String']>;
  /** Information about the employee who approved the refund check */
  issuedBy?: InputMaybe<Scalars['String']>;
  /** The reason for the refund */
  reason?: InputMaybe<Scalars['String']>;
  /** The ID of the VoucherRefundedTransaction to edit on this Voucher */
  refundTransactionId: Scalars['ObjectId'];
};

export type UpdateVoucherRefundDetailResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** A user */
export type User = {
  _id: Scalars['ObjectId'];
};

/** The input parameters are invalid. */
export type ValidationError = DomainError & {
  __typename?: 'ValidationError';
  allErrors: Array<Scalars['String']>;
  code: Scalars['String'];
  entityId?: Maybe<Scalars['ObjectId']>;
  entityName?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Viewport bounds that frame a place */
export type Viewport = {
  __typename?: 'Viewport';
  /** North-east coordinate */
  high: Coordinate;
  /** South-west coordinate */
  low: Coordinate;
};

export type VoidBookingTransferPaymentResult = Booking | BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | NotAuthorizedError | NotFoundError | ValidationError;

/** Voids a non-expired voucher */
export type VoidVoucherInput = {
  /** The ID of the Voucher */
  _id: Scalars['ObjectId'];
  /** The reason that the voucher is being voided */
  reason: Scalars['String'];
};

export type VoidVoucherResult = BusinessNotSpecifiedError | DuplicateUniqueKeyError | InvalidDateError | InvalidDateRangeError | InvalidTimeRangeError | InvalidVoucherError | NotAuthorizedError | NotFoundError | ValidationError | Voucher;

/** A voucher which contains its rules and transactions */
export type Voucher = {
  __typename?: 'Voucher';
  _id: Scalars['ObjectId'];
  balance: Money;
  booking?: Maybe<Booking>;
  businessCode?: Maybe<BusinessCode>;
  customer?: Maybe<Customer>;
  customerId: Scalars['ObjectId'];
  expirationDate: Scalars['Date'];
  /** Whether the voucher has at least one refund transaction */
  hasRefunds: Scalars['Boolean'];
  isExternal: Scalars['Boolean'];
  isRefundable: Scalars['Boolean'];
  issueDate: Scalars['Date'];
  orderId?: Maybe<Scalars['ObjectId']>;
  reason: VoucherReason;
  status: VoucherStatus;
  transactions: Array<VoucherTransaction>;
  transferBusinessUnit?: Maybe<Scalars['String']>;
};

/** Arbitrary increase of voucher value, usually associated with correcting balance issues */
export type VoucherIncreasedTransaction = VoucherTransaction & {
  __typename?: 'VoucherIncreasedTransaction';
  _id: Scalars['ObjectId'];
  amount: Money;
  approvedBy?: Maybe<Scalars['ObjectId']>;
  reason: Scalars['String'];
  transactionDate: Scalars['DateTime'];
};

/** The initial issuance transaction when the voucher is first created */
export type VoucherIssuedTransaction = VoucherTransaction & {
  __typename?: 'VoucherIssuedTransaction';
  _id: Scalars['ObjectId'];
  amount: Money;
  orderId: Scalars['ObjectId'];
  reason: Scalars['String'];
  transactionDate: Scalars['DateTime'];
};

/** A paginated set of Vouchers and their transactions */
export type VoucherPaginatedResult = {
  __typename?: 'VoucherPaginatedResult';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  results: Array<Voucher>;
};

export type VoucherPaymentMethod = {
  __typename?: 'VoucherPaymentMethod';
  isRefundable: Scalars['Boolean'];
  voucher?: Maybe<Voucher>;
  voucherId: Scalars['ObjectId'];
  voucherTransactionId?: Maybe<Scalars['ObjectId']>;
};

export type VoucherPaymentMethodInput = {
  voucherId: Scalars['ObjectId'];
};

/** Why the voucher was issued */
export enum VoucherReason {
  AnyReasonProtection = 'ANY_REASON_PROTECTION',
  ExternalTransfer = 'EXTERNAL_TRANSFER',
  Other = 'OTHER',
  SevereFlightDisruption = 'SEVERE_FLIGHT_DISRUPTION',
  WorldEvents = 'WORLD_EVENTS'
}

/** Logging that a voucher has been used against an order */
export type VoucherRedeemedTransaction = VoucherTransaction & {
  __typename?: 'VoucherRedeemedTransaction';
  _id: Scalars['ObjectId'];
  amount: Money;
  orderId: Scalars['ObjectId'];
  transactionDate: Scalars['DateTime'];
};

/** Arbitrary reduction used to correct balances */
export type VoucherReducedTransaction = VoucherTransaction & {
  __typename?: 'VoucherReducedTransaction';
  _id: Scalars['ObjectId'];
  amount: Money;
  approvedBy?: Maybe<Scalars['ObjectId']>;
  reason: Scalars['String'];
  transactionDate: Scalars['DateTime'];
};

export type VoucherRefundInput = {
  amount: Scalars['Float'];
  voucherId: Scalars['ObjectId'];
};

/** When a voucher's balance is refunded back to the customer */
export type VoucherRefundedTransaction = VoucherTransaction & {
  __typename?: 'VoucherRefundedTransaction';
  _id: Scalars['ObjectId'];
  amount: Money;
  /** The ID of the employee who recorded the refund */
  approvedBy?: Maybe<Scalars['ObjectId']>;
  /** @deprecated Deprecated, source data does not contain time information. Use checkIssuedOn instead */
  checkIssuedAt?: Maybe<Scalars['DateTime']>;
  /** The date the check was issued */
  checkIssuedOn?: Maybe<Scalars['Date']>;
  /** The check number */
  checkNumber?: Maybe<Scalars['String']>;
  /** Information about the employee or team who issued or approved the refund check */
  issuedBy?: Maybe<Scalars['String']>;
  /** The reason for the refund */
  reason?: Maybe<Scalars['String']>;
  transactionDate: Scalars['DateTime'];
};

/** When the voucher is reinstated, this transaction restores the voided balance */
export type VoucherReinstatedTransaction = VoucherTransaction & {
  __typename?: 'VoucherReinstatedTransaction';
  _id: Scalars['ObjectId'];
  amount: Money;
  approvedBy?: Maybe<Scalars['ObjectId']>;
  reason: Scalars['String'];
  transactionDate: Scalars['DateTime'];
};

export enum VoucherSortField {
  ExpirationDate = 'expirationDate'
}

export enum VoucherStatus {
  Approved = 'APPROVED',
  Voided = 'VOIDED'
}

/** Base type for all voucher transactions */
export type VoucherTransaction = {
  _id: Scalars['ObjectId'];
  amount: Money;
  transactionDate: Scalars['DateTime'];
};

export enum VoucherTransferDirection {
  In = 'IN',
  Out = 'OUT'
}

/** Used when a voucher is transferred from or to a non WOJO EF product */
export type VoucherTransferExternalTransaction = VoucherTransaction & {
  __typename?: 'VoucherTransferExternalTransaction';
  _id: Scalars['ObjectId'];
  amount: Money;
  approvedBy?: Maybe<Scalars['ObjectId']>;
  direction: VoucherTransferDirection;
  transactionDate: Scalars['DateTime'];
  transferBusinessUnit: Scalars['String'];
};

/** When a voucher is transferred to another customer within WOJO */
export type VoucherTransferInternalTransaction = VoucherTransaction & {
  __typename?: 'VoucherTransferInternalTransaction';
  _id: Scalars['ObjectId'];
  amount: Money;
  approvedBy?: Maybe<Scalars['ObjectId']>;
  transactionDate: Scalars['DateTime'];
  transferVoucherId: Scalars['ObjectId'];
};

/** When the voucher is voided, this transaction is clearing the balance */
export type VoucherVoidedTransaction = VoucherTransaction & {
  __typename?: 'VoucherVoidedTransaction';
  _id: Scalars['ObjectId'];
  amount: Money;
  approvedBy?: Maybe<Scalars['ObjectId']>;
  reason: Scalars['String'];
  transactionDate: Scalars['DateTime'];
};

/** A Tour that a Customer has added to their Wishlist */
export type WishlistItem = {
  __typename?: 'WishlistItem';
  _id: Scalars['ObjectId'];
  businessCode?: Maybe<BusinessCode>;
  customerId: Scalars['ObjectId'];
  tourCode: Scalars['String'];
};

export type WishlistItemRemovedResult = {
  __typename?: 'WishlistItemRemovedResult';
  removedId: Scalars['ObjectId'];
};
